//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  citext: any;
  date: any;
  float8: any;
  numeric: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
}


export interface TeacherBbbJoinLink {
  id: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface TeacherBooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

export interface TeacherDelseteResponse {
  data?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface TeacherGroupConversationInput {
  avatar_url: Scalars['String'];
  title: Scalars['String'];
}

export interface TeacherGroupConversationOutput {
  id: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface TeacherIntComparisonExp {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
}

export interface TeacherInviteParentInput {
  class_id?: Maybe<Scalars['String']>;
}

export interface TeacherInviteStudentClassInsertInput {
  class_id: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
}

export interface TeacherMessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface TeacherSession {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface TeacherStringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface TeacherTeacherSkillInsertInput {
  subject_id: Scalars['String'];
}

export interface TeacherUserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface TeacherUserInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}

/** columns and relationships of "assignment_attendee_type" */
export interface TeacherAssignmentAttendeeType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  value: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface TeacherAssignmentAttendeeTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface TeacherAssignmentAttendeeTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_attendee_type". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentAttendeeTypeBoolExp {
  _and?: Maybe<Array<TeacherAssignmentAttendeeTypeBoolExp>>;
  _not?: Maybe<TeacherAssignmentAttendeeTypeBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentAttendeeTypeBoolExp>>;
  assignments?: Maybe<TeacherAssignmentsBoolExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  value?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherAssignmentAttendeeTypeEnum {
  CLASS = 'CLASS',
  USER = 'USER'
};

/** Boolean expression to compare columns of type "assignment_attendee_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherAssignmentAttendeeTypeEnumComparisonExp {
  _eq?: Maybe<TeacherAssignmentAttendeeTypeEnum>;
  _in?: Maybe<Array<TeacherAssignmentAttendeeTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherAssignmentAttendeeTypeEnum>;
  _nin?: Maybe<Array<TeacherAssignmentAttendeeTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_attendee_type". */
export interface TeacherAssignmentAttendeeTypeOrderBy {
  assignments_aggregate?: Maybe<TeacherAssignmentsAggregateOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_attendee_type" */
export const enum TeacherAssignmentAttendeeTypeSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_book_chapter" */
export interface TeacherAssignmentBookChapter {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<TeacherBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_book_chapter" */
export interface TeacherAssignmentBookChapterAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentBookChapterMaxOrderBy>;
  min?: Maybe<TeacherAssignmentBookChapterMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_book_chapter". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentBookChapterBoolExp {
  _and?: Maybe<Array<TeacherAssignmentBookChapterBoolExp>>;
  _not?: Maybe<TeacherAssignmentBookChapterBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentBookChapterBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  book_chapter?: Maybe<TeacherBookChaptersBoolExp>;
  book_chapter_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_book_chapter" */
export interface TeacherAssignmentBookChapterMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_book_chapter" */
export interface TeacherAssignmentBookChapterMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_book_chapter". */
export interface TeacherAssignmentBookChapterOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  book_chapter?: Maybe<TeacherBookChaptersOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_book_chapter" */
export const enum TeacherAssignmentBookChapterSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_discussion" */
export interface TeacherAssignmentDiscussion {
  /** An array relationship */
  assignment_discussion_contents: EntireFieldWrapper<Array<TeacherAssignmentDiscussionContent>>;
  /** An array relationship */
  assignment_discussion_subscriptions: EntireFieldWrapper<Array<TeacherAssignmentDiscussionSubscription>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion" */
export interface TeacherAssignmentDiscussionAssignmentDiscussionContentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
}


/** columns and relationships of "assignment_discussion" */
export interface TeacherAssignmentDiscussionAssignmentDiscussionSubscriptionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion" */
export interface TeacherAssignmentDiscussionAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentDiscussionMaxOrderBy>;
  min?: Maybe<TeacherAssignmentDiscussionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion" */
export interface TeacherAssignmentDiscussionArrRelInsertInput {
  data: Array<TeacherAssignmentDiscussionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentDiscussionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentDiscussionBoolExp {
  _and?: Maybe<Array<TeacherAssignmentDiscussionBoolExp>>;
  _not?: Maybe<TeacherAssignmentDiscussionBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentDiscussionBoolExp>>;
  assignment_discussion_contents?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
  assignment_discussion_subscriptions?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion" */
export const enum TeacherAssignmentDiscussionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_PKEY = 'assignment_discussion_pkey'
};

/** columns and relationships of "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContent {
  /** An object relationship */
  assignment_discussion: EntireFieldWrapper<TeacherAssignmentDiscussion>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  replay_to?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<TeacherTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentDiscussionContentMaxOrderBy>;
  min?: Maybe<TeacherAssignmentDiscussionContentMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentArrRelInsertInput {
  data: Array<TeacherAssignmentDiscussionContentInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentDiscussionContentOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_content". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentDiscussionContentBoolExp {
  _and?: Maybe<Array<TeacherAssignmentDiscussionContentBoolExp>>;
  _not?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentDiscussionContentBoolExp>>;
  assignment_discussion?: Maybe<TeacherAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<TeacherUuidComparisonExp>;
  content?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  parent_id?: Maybe<TeacherUuidComparisonExp>;
  replay_to?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_content" */
export const enum TeacherAssignmentDiscussionContentConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_CONTENT_PKEY = 'assignment_discussion_content_pkey'
};

/** input type for inserting data into table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentInsertInput {
  assignment_discussion?: Maybe<TeacherAssignmentDiscussionObjRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  replay_to?: Maybe<TeacherAssignmentDiscussionContentObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentMaxOrderBy {
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentMinOrderBy {
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentDiscussionContent>>;
}

/** input type for inserting object relation for remote table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentObjRelInsertInput {
  data: TeacherAssignmentDiscussionContentInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentDiscussionContentOnConflict>;
}

/** on conflict condition type for table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentOnConflict {
  constraint: TeacherAssignmentDiscussionContentConstraint;
  update_columns?: Array<TeacherAssignmentDiscussionContentUpdateColumn>;
  where?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_content". */
export interface TeacherAssignmentDiscussionContentOrderBy {
  assignment_discussion?: Maybe<TeacherAssignmentDiscussionOrderBy>;
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  replay_to?: Maybe<TeacherAssignmentDiscussionContentOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  teacher?: Maybe<TeacherTeachersOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion_content */
export interface TeacherAssignmentDiscussionContentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_content" */
export const enum TeacherAssignmentDiscussionContentSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_content" */
export interface TeacherAssignmentDiscussionContentSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_content" */
export const enum TeacherAssignmentDiscussionContentUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for inserting data into table "assignment_discussion" */
export interface TeacherAssignmentDiscussionInsertInput {
  assignment_discussion_contents?: Maybe<TeacherAssignmentDiscussionContentArrRelInsertInput>;
  assignment_discussion_subscriptions?: Maybe<TeacherAssignmentDiscussionSubscriptionArrRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion" */
export interface TeacherAssignmentDiscussionMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion" */
export interface TeacherAssignmentDiscussionMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion" */
export interface TeacherAssignmentDiscussionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentDiscussion>>;
}

/** input type for inserting object relation for remote table "assignment_discussion" */
export interface TeacherAssignmentDiscussionObjRelInsertInput {
  data: TeacherAssignmentDiscussionInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentDiscussionOnConflict>;
}

/** on conflict condition type for table "assignment_discussion" */
export interface TeacherAssignmentDiscussionOnConflict {
  constraint: TeacherAssignmentDiscussionConstraint;
  update_columns?: Array<TeacherAssignmentDiscussionUpdateColumn>;
  where?: Maybe<TeacherAssignmentDiscussionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion". */
export interface TeacherAssignmentDiscussionOrderBy {
  assignment_discussion_contents_aggregate?: Maybe<TeacherAssignmentDiscussionContentAggregateOrderBy>;
  assignment_discussion_subscriptions_aggregate?: Maybe<TeacherAssignmentDiscussionSubscriptionAggregateOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion */
export interface TeacherAssignmentDiscussionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion" */
export const enum TeacherAssignmentDiscussionSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion" */
export interface TeacherAssignmentDiscussionSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscription {
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<TeacherAssignmentDiscussion>>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_notification_enabled: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentDiscussionSubscriptionMaxOrderBy>;
  min?: Maybe<TeacherAssignmentDiscussionSubscriptionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionArrRelInsertInput {
  data: Array<TeacherAssignmentDiscussionSubscriptionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentDiscussionSubscriptionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_subscription". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentDiscussionSubscriptionBoolExp {
  _and?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionBoolExp>>;
  _not?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionBoolExp>>;
  assignment_discussion?: Maybe<TeacherAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_notification_enabled?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_subscription" */
export const enum TeacherAssignmentDiscussionSubscriptionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_SUBSCRIPTION_PKEY = 'assignment_discussion_subscription_pkey'
};

/** input type for inserting data into table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionInsertInput {
  assignment_discussion?: Maybe<TeacherAssignmentDiscussionArrRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionMaxOrderBy {
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionMinOrderBy {
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentDiscussionSubscription>>;
}

/** on conflict condition type for table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionOnConflict {
  constraint: TeacherAssignmentDiscussionSubscriptionConstraint;
  update_columns?: Array<TeacherAssignmentDiscussionSubscriptionUpdateColumn>;
  where?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_subscription". */
export interface TeacherAssignmentDiscussionSubscriptionOrderBy {
  assignment_discussion_aggregate?: Maybe<TeacherAssignmentDiscussionAggregateOrderBy>;
  assignment_discussion_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_notification_enabled?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion_subscription */
export interface TeacherAssignmentDiscussionSubscriptionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_subscription" */
export const enum TeacherAssignmentDiscussionSubscriptionSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_subscription" */
export interface TeacherAssignmentDiscussionSubscriptionSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_subscription" */
export const enum TeacherAssignmentDiscussionSubscriptionUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** update columns of table "assignment_discussion" */
export const enum TeacherAssignmentDiscussionUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_files" */
export interface TeacherAssignmentFiles {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_files" */
export interface TeacherAssignmentFilesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentFilesMaxOrderBy>;
  min?: Maybe<TeacherAssignmentFilesMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_files" */
export interface TeacherAssignmentFilesArrRelInsertInput {
  data: Array<TeacherAssignmentFilesInsertInput>;
}

/** Boolean expression to filter rows from the table "assignment_files". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentFilesBoolExp {
  _and?: Maybe<Array<TeacherAssignmentFilesBoolExp>>;
  _not?: Maybe<TeacherAssignmentFilesBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentFilesBoolExp>>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  hash?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  path?: Maybe<TeacherStringComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** input type for inserting data into table "assignment_files" */
export interface TeacherAssignmentFilesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_files" */
export interface TeacherAssignmentFilesMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_files" */
export interface TeacherAssignmentFilesMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_files" */
export interface TeacherAssignmentFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentFiles>>;
}

/** Ordering options when selecting data from "assignment_files". */
export interface TeacherAssignmentFilesOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_files" */
export const enum TeacherAssignmentFilesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Possible values for assisgment grade weights.
 *
 *
 * columns and relationships of "assignment_grade_weights"
 */
export interface TeacherAssignmentGradeWeights {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  value: EntireFieldWrapper<Scalars['numeric']>;
}

/** aggregated selection of "assignment_grade_weights" */
export interface TeacherAssignmentGradeWeightsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAssignmentGradeWeights>>;
}

/** aggregate fields of "assignment_grade_weights" */
export interface TeacherAssignmentGradeWeightsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeightsVarianceFields>>;
}


/** aggregate fields of "assignment_grade_weights" */
export interface TeacherAssignmentGradeWeightsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAssignmentGradeWeightsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface TeacherAssignmentGradeWeightsAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "assignment_grade_weights". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentGradeWeightsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentGradeWeightsBoolExp>>;
  _not?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentGradeWeightsBoolExp>>;
  comment?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  value?: Maybe<TeacherNumericComparisonExp>;
}

/** aggregate max on columns */
export interface TeacherAssignmentGradeWeightsMaxFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate min on columns */
export interface TeacherAssignmentGradeWeightsMinFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** Ordering options when selecting data from "assignment_grade_weights". */
export interface TeacherAssignmentGradeWeightsOrderBy {
  comment?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_grade_weights" */
export const enum TeacherAssignmentGradeWeightsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  VALUE = 'value'
};

/** aggregate stddev on columns */
export interface TeacherAssignmentGradeWeightsStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface TeacherAssignmentGradeWeightsStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface TeacherAssignmentGradeWeightsStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface TeacherAssignmentGradeWeightsSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate var_pop on columns */
export interface TeacherAssignmentGradeWeightsVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface TeacherAssignmentGradeWeightsVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface TeacherAssignmentGradeWeightsVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** columns and relationships of "assignment_notes" */
export interface TeacherAssignmentNotes {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<TeacherTeachers>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "assignment_notes". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentNotesBoolExp {
  _and?: Maybe<Array<TeacherAssignmentNotesBoolExp>>;
  _not?: Maybe<TeacherAssignmentNotesBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentNotesBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  content?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_notes" */
export const enum TeacherAssignmentNotesConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_NOTES_PKEY = 'assignment_notes_pkey'
};

/** input type for inserting data into table "assignment_notes" */
export interface TeacherAssignmentNotesInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "assignment_notes" */
export interface TeacherAssignmentNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentNotes>>;
}

/** on conflict condition type for table "assignment_notes" */
export interface TeacherAssignmentNotesOnConflict {
  constraint: TeacherAssignmentNotesConstraint;
  update_columns?: Array<TeacherAssignmentNotesUpdateColumn>;
  where?: Maybe<TeacherAssignmentNotesBoolExp>;
}

/** Ordering options when selecting data from "assignment_notes". */
export interface TeacherAssignmentNotesOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  teacher?: Maybe<TeacherTeachersOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_notes */
export interface TeacherAssignmentNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_notes" */
export const enum TeacherAssignmentNotesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_notes" */
export interface TeacherAssignmentNotesSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_notes" */
export const enum TeacherAssignmentNotesUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswers {
  assignment_question_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersAggregateOrderBy {
  avg?: Maybe<TeacherAssignmentQuestionAnswersAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentQuestionAnswersMaxOrderBy>;
  min?: Maybe<TeacherAssignmentQuestionAnswersMinOrderBy>;
  stddev?: Maybe<TeacherAssignmentQuestionAnswersStddevOrderBy>;
  stddev_pop?: Maybe<TeacherAssignmentQuestionAnswersStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherAssignmentQuestionAnswersStddevSampOrderBy>;
  sum?: Maybe<TeacherAssignmentQuestionAnswersSumOrderBy>;
  var_pop?: Maybe<TeacherAssignmentQuestionAnswersVarPopOrderBy>;
  var_samp?: Maybe<TeacherAssignmentQuestionAnswersVarSampOrderBy>;
  variance?: Maybe<TeacherAssignmentQuestionAnswersVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersAvgOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_answers". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuestionAnswersBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuestionAnswersBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuestionAnswersBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuestionAnswersBoolExp>>;
  assignment_question_id?: Maybe<TeacherUuidComparisonExp>;
  assignment_question_option_id?: Maybe<TeacherUuidComparisonExp>;
  content?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_correct?: Maybe<TeacherBooleanComparisonExp>;
  order?: Maybe<TeacherIntComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersMaxOrderBy {
  assignment_question_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersMinOrderBy {
  assignment_question_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_question_answers". */
export interface TeacherAssignmentQuestionAnswersOrderBy {
  assignment_question_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_correct?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_question_answers" */
export const enum TeacherAssignmentQuestionAnswersSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_ID = 'assignment_question_option_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  USER_ID = 'user_id'
};

/** order by stddev() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersStddevOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersStddevPopOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersStddevSampOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersSumOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersVarPopOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersVarSampOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_question_answers" */
export interface TeacherAssignmentQuestionAnswersVarianceOrderBy {
  order?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelations {
  /** An object relationship */
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** An object relationship */
  assignment_question_option?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  assignment_question_option_matched_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_matching_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentQuestionOptionRelationsMaxOrderBy>;
  min?: Maybe<TeacherAssignmentQuestionOptionRelationsMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsArrRelInsertInput {
  data: Array<TeacherAssignmentQuestionOptionRelationsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionRelationsOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_question_option_relations". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuestionOptionRelationsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsBoolExp>>;
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
  assignment_question_option?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
  assignment_question_option_matched_id?: Maybe<TeacherUuidComparisonExp>;
  assignment_question_option_matching_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_question_option_relations" */
export const enum TeacherAssignmentQuestionOptionRelationsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_QUESTION_OPTION_RELATIONS_PKEY = 'assignment_question_option_relations_pkey'
};

/** input type for inserting data into table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsInsertInput {
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<TeacherAssignmentQuestionOptionsObjRelInsertInput>;
  assignment_question_option?: Maybe<TeacherAssignmentQuestionOptionsObjRelInsertInput>;
  assignment_question_option_matched_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_matching_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsMaxOrderBy {
  assignment_question_option_matched_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsMinOrderBy {
  assignment_question_option_matched_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptionRelations>>;
}

/** on conflict condition type for table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsOnConflict {
  constraint: TeacherAssignmentQuestionOptionRelationsConstraint;
  update_columns?: Array<TeacherAssignmentQuestionOptionRelationsUpdateColumn>;
  where?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
}

/** Ordering options when selecting data from "assignment_question_option_relations". */
export interface TeacherAssignmentQuestionOptionRelationsOrderBy {
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<TeacherAssignmentQuestionOptionsOrderBy>;
  assignment_question_option?: Maybe<TeacherAssignmentQuestionOptionsOrderBy>;
  assignment_question_option_matched_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_question_option_relations */
export interface TeacherAssignmentQuestionOptionRelationsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_question_option_relations" */
export const enum TeacherAssignmentQuestionOptionRelationsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHED_ID = 'assignment_question_option_matched_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHING_ID = 'assignment_question_option_matching_id',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "assignment_question_option_relations" */
export interface TeacherAssignmentQuestionOptionRelationsSetInput {
  assignment_question_option_matched_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_matching_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_question_option_relations" */
export const enum TeacherAssignmentQuestionOptionRelationsUpdateColumn {
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHED_ID = 'assignment_question_option_matched_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHING_ID = 'assignment_question_option_matching_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "assignment_question_options" */
export interface TeacherAssignmentQuestionOptions {
  /** An object relationship */
  assignment_question: EntireFieldWrapper<TeacherAssignmentQuestions>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<TeacherAssignmentQuestionAnswers>>;
  assignment_question_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptionRelations>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  group?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  score?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}


/** columns and relationships of "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionAnswersBoolExp>;
}


/** columns and relationships of "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
}

/** order by aggregate values of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsAggregateOrderBy {
  avg?: Maybe<TeacherAssignmentQuestionOptionsAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentQuestionOptionsMaxOrderBy>;
  min?: Maybe<TeacherAssignmentQuestionOptionsMinOrderBy>;
  stddev?: Maybe<TeacherAssignmentQuestionOptionsStddevOrderBy>;
  stddev_pop?: Maybe<TeacherAssignmentQuestionOptionsStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherAssignmentQuestionOptionsStddevSampOrderBy>;
  sum?: Maybe<TeacherAssignmentQuestionOptionsSumOrderBy>;
  var_pop?: Maybe<TeacherAssignmentQuestionOptionsVarPopOrderBy>;
  var_samp?: Maybe<TeacherAssignmentQuestionOptionsVarSampOrderBy>;
  variance?: Maybe<TeacherAssignmentQuestionOptionsVarianceOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsArrRelInsertInput {
  data: Array<TeacherAssignmentQuestionOptionsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionsOnConflict>;
}

/** order by avg() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsAvgOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_options". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuestionOptionsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuestionOptionsBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuestionOptionsBoolExp>>;
  assignment_question?: Maybe<TeacherAssignmentQuestionsBoolExp>;
  assignment_question_answers?: Maybe<TeacherAssignmentQuestionAnswersBoolExp>;
  assignment_question_id?: Maybe<TeacherUuidComparisonExp>;
  assignment_question_option_relations?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  group?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_correct?: Maybe<TeacherBooleanComparisonExp>;
  order?: Maybe<TeacherIntComparisonExp>;
  score?: Maybe<TeacherIntComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "assignment_question_options" */
export const enum TeacherAssignmentQuestionOptionsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_QUESTION_OPTIONS_PKEY = 'assignment_question_options_pkey'
};

/** input type for incrementing numeric columns in table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsIncInput {
  group?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsInsertInput {
  assignment_question?: Maybe<TeacherAssignmentQuestionsObjRelInsertInput>;
  assignment_question_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_relations?: Maybe<TeacherAssignmentQuestionOptionRelationsArrRelInsertInput>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsMaxOrderBy {
  assignment_question_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  group?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsMinOrderBy {
  assignment_question_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  group?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptions>>;
}

/** input type for inserting object relation for remote table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsObjRelInsertInput {
  data: TeacherAssignmentQuestionOptionsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionsOnConflict>;
}

/** on conflict condition type for table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsOnConflict {
  constraint: TeacherAssignmentQuestionOptionsConstraint;
  update_columns?: Array<TeacherAssignmentQuestionOptionsUpdateColumn>;
  where?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
}

/** Ordering options when selecting data from "assignment_question_options". */
export interface TeacherAssignmentQuestionOptionsOrderBy {
  assignment_question?: Maybe<TeacherAssignmentQuestionsOrderBy>;
  assignment_question_answers_aggregate?: Maybe<TeacherAssignmentQuestionAnswersAggregateOrderBy>;
  assignment_question_id?: Maybe<TeacherOrderBy>;
  assignment_question_option_relations_aggregate?: Maybe<TeacherAssignmentQuestionOptionRelationsAggregateOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  group?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_correct?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_question_options */
export interface TeacherAssignmentQuestionOptionsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_question_options" */
export const enum TeacherAssignmentQuestionOptionsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  SCORE = 'score',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsSetInput {
  assignment_question_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by stddev() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsStddevOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsStddevPopOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsStddevSampOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsSumOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** update columns of table "assignment_question_options" */
export const enum TeacherAssignmentQuestionOptionsUpdateColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  SCORE = 'score',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by var_pop() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsVarPopOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsVarSampOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_question_options" */
export interface TeacherAssignmentQuestionOptionsVarianceOrderBy {
  group?: Maybe<TeacherOrderBy>;
  order?: Maybe<TeacherOrderBy>;
  score?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "assignment_question_types" */
export interface TeacherAssignmentQuestionTypes {
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "assignment_question_types". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuestionTypesBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuestionTypesBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuestionTypesBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuestionTypesBoolExp>>;
  text?: Maybe<TeacherStringComparisonExp>;
  value?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherAssignmentQuestionTypesEnum {
  /** quiz.fill_in_black */
  FILL_IN_BLANK = 'FILL_IN_BLANK',
  /** quiz.matching */
  MATCHING = 'MATCHING',
  /** quiz.open_question */
  OPEN_QUESTION = 'OPEN_QUESTION',
  /** quiz.pick_options */
  PICK_OPTIONS = 'PICK_OPTIONS'
};

/** Boolean expression to compare columns of type "assignment_question_types_enum". All fields are combined with logical 'AND'. */
export interface TeacherAssignmentQuestionTypesEnumComparisonExp {
  _eq?: Maybe<TeacherAssignmentQuestionTypesEnum>;
  _in?: Maybe<Array<TeacherAssignmentQuestionTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherAssignmentQuestionTypesEnum>;
  _nin?: Maybe<Array<TeacherAssignmentQuestionTypesEnum>>;
}

/** Ordering options when selecting data from "assignment_question_types". */
export interface TeacherAssignmentQuestionTypesOrderBy {
  text?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_question_types" */
export const enum TeacherAssignmentQuestionTypesSelectColumn {
  /** column name */
  TEXT = 'text',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_questions" */
export interface TeacherAssignmentQuestions {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptions>>;
  /** An object relationship */
  assignment_question_type: EntireFieldWrapper<TeacherAssignmentQuestionTypes>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<TeacherAssignmentQuestionTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "assignment_questions" */
export interface TeacherAssignmentQuestionsAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
}

/** order by aggregate values of table "assignment_questions" */
export interface TeacherAssignmentQuestionsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentQuestionsMaxOrderBy>;
  min?: Maybe<TeacherAssignmentQuestionsMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_questions" */
export interface TeacherAssignmentQuestionsArrRelInsertInput {
  data: Array<TeacherAssignmentQuestionsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuestionsOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_questions". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuestionsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuestionsBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuestionsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuestionsBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  assignment_question_options?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
  assignment_question_type?: Maybe<TeacherAssignmentQuestionTypesBoolExp>;
  content?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type?: Maybe<TeacherAssignmentQuestionTypesEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "assignment_questions" */
export const enum TeacherAssignmentQuestionsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_QUESTIONS_PKEY = 'assignment_questions_pkey'
};

/** input type for inserting data into table "assignment_questions" */
export interface TeacherAssignmentQuestionsInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  assignment_question_options?: Maybe<TeacherAssignmentQuestionOptionsArrRelInsertInput>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TeacherAssignmentQuestionTypesEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_questions" */
export interface TeacherAssignmentQuestionsMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_questions" */
export interface TeacherAssignmentQuestionsMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_questions" */
export interface TeacherAssignmentQuestionsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentQuestions>>;
}

/** input type for inserting object relation for remote table "assignment_questions" */
export interface TeacherAssignmentQuestionsObjRelInsertInput {
  data: TeacherAssignmentQuestionsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuestionsOnConflict>;
}

/** on conflict condition type for table "assignment_questions" */
export interface TeacherAssignmentQuestionsOnConflict {
  constraint: TeacherAssignmentQuestionsConstraint;
  update_columns?: Array<TeacherAssignmentQuestionsUpdateColumn>;
  where?: Maybe<TeacherAssignmentQuestionsBoolExp>;
}

/** Ordering options when selecting data from "assignment_questions". */
export interface TeacherAssignmentQuestionsOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  assignment_question_options_aggregate?: Maybe<TeacherAssignmentQuestionOptionsAggregateOrderBy>;
  assignment_question_type?: Maybe<TeacherAssignmentQuestionTypesOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_questions */
export interface TeacherAssignmentQuestionsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_questions" */
export const enum TeacherAssignmentQuestionsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "assignment_questions" */
export interface TeacherAssignmentQuestionsSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TeacherAssignmentQuestionTypesEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "assignment_questions" */
export const enum TeacherAssignmentQuestionsUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_quiz" */
export interface TeacherAssignmentQuiz {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  attempts?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  pass_percentage: EntireFieldWrapper<Scalars['Int']>;
  time_control: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_quiz" */
export interface TeacherAssignmentQuizAggregateOrderBy {
  avg?: Maybe<TeacherAssignmentQuizAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentQuizMaxOrderBy>;
  min?: Maybe<TeacherAssignmentQuizMinOrderBy>;
  stddev?: Maybe<TeacherAssignmentQuizStddevOrderBy>;
  stddev_pop?: Maybe<TeacherAssignmentQuizStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherAssignmentQuizStddevSampOrderBy>;
  sum?: Maybe<TeacherAssignmentQuizSumOrderBy>;
  var_pop?: Maybe<TeacherAssignmentQuizVarPopOrderBy>;
  var_samp?: Maybe<TeacherAssignmentQuizVarSampOrderBy>;
  variance?: Maybe<TeacherAssignmentQuizVarianceOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_quiz" */
export interface TeacherAssignmentQuizArrRelInsertInput {
  data: Array<TeacherAssignmentQuizInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuizOnConflict>;
}

/** order by avg() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizAvgOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_quiz". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentQuizBoolExp {
  _and?: Maybe<Array<TeacherAssignmentQuizBoolExp>>;
  _not?: Maybe<TeacherAssignmentQuizBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentQuizBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  attempts?: Maybe<TeacherIntComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  pass_percentage?: Maybe<TeacherIntComparisonExp>;
  time_control?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "assignment_quiz" */
export const enum TeacherAssignmentQuizConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_QUIZ_PKEY = 'assignment_quiz_pkey'
};

/** input type for incrementing numeric columns in table "assignment_quiz" */
export interface TeacherAssignmentQuizIncInput {
  attempts?: Maybe<Scalars['Int']>;
  pass_percentage?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "assignment_quiz" */
export interface TeacherAssignmentQuizInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  attempts?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pass_percentage?: Maybe<Scalars['Int']>;
  time_control?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  attempts?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  attempts?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_quiz" */
export interface TeacherAssignmentQuizMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentQuiz>>;
}

/** input type for inserting object relation for remote table "assignment_quiz" */
export interface TeacherAssignmentQuizObjRelInsertInput {
  data: TeacherAssignmentQuizInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentQuizOnConflict>;
}

/** on conflict condition type for table "assignment_quiz" */
export interface TeacherAssignmentQuizOnConflict {
  constraint: TeacherAssignmentQuizConstraint;
  update_columns?: Array<TeacherAssignmentQuizUpdateColumn>;
  where?: Maybe<TeacherAssignmentQuizBoolExp>;
}

/** Ordering options when selecting data from "assignment_quiz". */
export interface TeacherAssignmentQuizOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  attempts?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
  time_control?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_quiz */
export interface TeacherAssignmentQuizPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_quiz" */
export const enum TeacherAssignmentQuizSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  ATTEMPTS = 'attempts',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PASS_PERCENTAGE = 'pass_percentage',
  /** column name */
  TIME_CONTROL = 'time_control',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "assignment_quiz" */
export interface TeacherAssignmentQuizSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  attempts?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  pass_percentage?: Maybe<Scalars['Int']>;
  time_control?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by stddev() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizStddevOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizStddevPopOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizStddevSampOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizSumOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** update columns of table "assignment_quiz" */
export const enum TeacherAssignmentQuizUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  ATTEMPTS = 'attempts',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PASS_PERCENTAGE = 'pass_percentage',
  /** column name */
  TIME_CONTROL = 'time_control',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by var_pop() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizVarPopOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizVarSampOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_quiz" */
export interface TeacherAssignmentQuizVarianceOrderBy {
  attempts?: Maybe<TeacherOrderBy>;
  pass_percentage?: Maybe<TeacherOrderBy>;
}

/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface TeacherAssignmentSubmits {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  completed_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamp']>;
  file?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<TeacherFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_submited: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface TeacherAssignmentSubmitsFilesArgs {
  distinct_on?: Maybe<Array<TeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherFilesOrderBy>>;
  where?: Maybe<TeacherFilesBoolExp>;
}

/** order by aggregate values of table "assignment_submits" */
export interface TeacherAssignmentSubmitsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentSubmitsMaxOrderBy>;
  min?: Maybe<TeacherAssignmentSubmitsMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_submits" */
export interface TeacherAssignmentSubmitsArrRelInsertInput {
  data: Array<TeacherAssignmentSubmitsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentSubmitsOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_submits". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentSubmitsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentSubmitsBoolExp>>;
  _not?: Maybe<TeacherAssignmentSubmitsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentSubmitsBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  completed_at?: Maybe<TeacherTimestamptzComparisonExp>;
  content?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestampComparisonExp>;
  file?: Maybe<TeacherStringComparisonExp>;
  files?: Maybe<TeacherFilesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_submited?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_submits" */
export const enum TeacherAssignmentSubmitsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_SUBMITS_ASSIGNMENT_ID_USER_ID_KEY = 'assignment_submits_assignment_id_user_id_key',
  /** unique or primary key constraint */
  ASSIGNMENT_USER_PKEY = 'assignment_user_pkey'
};

/** input type for inserting data into table "assignment_submits" */
export interface TeacherAssignmentSubmitsInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_submits" */
export interface TeacherAssignmentSubmitsMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  completed_at?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  file?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_submits" */
export interface TeacherAssignmentSubmitsMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  completed_at?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  file?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_submits" */
export interface TeacherAssignmentSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentSubmits>>;
}

/** on conflict condition type for table "assignment_submits" */
export interface TeacherAssignmentSubmitsOnConflict {
  constraint: TeacherAssignmentSubmitsConstraint;
  update_columns?: Array<TeacherAssignmentSubmitsUpdateColumn>;
  where?: Maybe<TeacherAssignmentSubmitsBoolExp>;
}

/** Ordering options when selecting data from "assignment_submits". */
export interface TeacherAssignmentSubmitsOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  completed_at?: Maybe<TeacherOrderBy>;
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  file?: Maybe<TeacherOrderBy>;
  files_aggregate?: Maybe<TeacherFilesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_submited?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_submits */
export interface TeacherAssignmentSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_submits" */
export const enum TeacherAssignmentSubmitsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_submits" */
export interface TeacherAssignmentSubmitsSetInput {
  completed_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "assignment_submits" */
export const enum TeacherAssignmentSubmitsUpdateColumn {
  /** column name */
  COMPLETED_AT = 'completed_at'
};

/** columns and relationships of "assignment_type" */
export interface TeacherAssignmentType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_type" */
export interface TeacherAssignmentTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_type" */
export interface TeacherAssignmentTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentTypeBoolExp {
  _and?: Maybe<Array<TeacherAssignmentTypeBoolExp>>;
  _not?: Maybe<TeacherAssignmentTypeBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentTypeBoolExp>>;
  assignments?: Maybe<TeacherAssignmentsBoolExp>;
  icon?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherAssignmentTypeEnum {
  HAUSAUFGABE = 'HAUSAUFGABE',
  KLASSENARBEIT = 'KLASSENARBEIT',
  MATERIAL = 'MATERIAL',
  ONLINE = 'ONLINE',
  PRUFUNG = 'PRUFUNG',
  QUIZ = 'QUIZ',
  STUDY = 'STUDY',
  TASK = 'TASK'
};

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherAssignmentTypeEnumComparisonExp {
  _eq?: Maybe<TeacherAssignmentTypeEnum>;
  _in?: Maybe<Array<TeacherAssignmentTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherAssignmentTypeEnum>;
  _nin?: Maybe<Array<TeacherAssignmentTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_type". */
export interface TeacherAssignmentTypeOrderBy {
  assignments_aggregate?: Maybe<TeacherAssignmentsAggregateOrderBy>;
  icon?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "assignment_type" */
export const enum TeacherAssignmentTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/**
 * All users that assignment is assigned to and the table that teachers insert grades for each of them
 *
 *
 * columns and relationships of "assignment_user"
 */
export interface TeacherAssignmentUser {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_user" */
export interface TeacherAssignmentUserAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentUserMaxOrderBy>;
  min?: Maybe<TeacherAssignmentUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_user" */
export interface TeacherAssignmentUserArrRelInsertInput {
  data: Array<TeacherAssignmentUserInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentUserOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_user". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentUserBoolExp {
  _and?: Maybe<Array<TeacherAssignmentUserBoolExp>>;
  _not?: Maybe<TeacherAssignmentUserBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentUserBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_completed?: Maybe<TeacherBooleanComparisonExp>;
  mark?: Maybe<TeacherMarksBoolExp>;
  mark_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_user" */
export const enum TeacherAssignmentUserConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_STUDENT_PKEY = 'assignment_student_pkey'
};

/** input type for inserting data into table "assignment_user" */
export interface TeacherAssignmentUserInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_user" */
export interface TeacherAssignmentUserMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "assignment_user" */
export interface TeacherAssignmentUserMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignment_user" */
export interface TeacherAssignmentUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignmentUser>>;
}

/** on conflict condition type for table "assignment_user" */
export interface TeacherAssignmentUserOnConflict {
  constraint: TeacherAssignmentUserConstraint;
  update_columns?: Array<TeacherAssignmentUserUpdateColumn>;
  where?: Maybe<TeacherAssignmentUserBoolExp>;
}

/** Ordering options when selecting data from "assignment_user". */
export interface TeacherAssignmentUserOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_completed?: Maybe<TeacherOrderBy>;
  mark?: Maybe<TeacherMarksOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignment_user */
export interface TeacherAssignmentUserPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_user" */
export const enum TeacherAssignmentUserSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_user" */
export interface TeacherAssignmentUserSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  mark_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_user" */
export const enum TeacherAssignmentUserUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignments" */
export interface TeacherAssignments {
  /** An object relationship */
  assignmentAttendeeType?: EntireFieldWrapper<Maybe<TeacherAssignmentAttendeeType>>;
  assignment_attendee_type?: EntireFieldWrapper<Maybe<TeacherAssignmentAttendeeTypeEnum>>;
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<TeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<TeacherAssignmentFiles>>;
  /** An object relationship */
  assignment_grade_weight?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeights>>;
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<TeacherAssignmentQuestions>>;
  /** An object relationship */
  assignment_quiz?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_quizzes: EntireFieldWrapper<Array<TeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<TeacherAssignmentSubmits>>;
  /** An object relationship */
  assignment_type: EntireFieldWrapper<TeacherAssignmentType>;
  /** An array relationship */
  assignment_users: EntireFieldWrapper<Array<TeacherAssignmentUser>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<TeacherChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherViewAssignmentClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** A computed field, executes function "assignment_due_at_filter" */
  due_at_filter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<TeacherFiles>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "assignment_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_gradeable: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  lesson?: EntireFieldWrapper<Maybe<TeacherLessons>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<TeacherAssignmentTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<TeacherAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentFilesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentFilesOrderBy>>;
  where?: Maybe<TeacherAssignmentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentQuizzesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuizOrderBy>>;
  where?: Maybe<TeacherAssignmentQuizBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<TeacherAssignmentSubmitsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsAssignmentUsersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentUserOrderBy>>;
  where?: Maybe<TeacherAssignmentUserBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsClassesArgs {
  distinct_on?: Maybe<Array<TeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<TeacherViewAssignmentClassBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsFilesArgs {
  distinct_on?: Maybe<Array<TeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherFilesOrderBy>>;
  where?: Maybe<TeacherFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface TeacherAssignmentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}

/** aggregated selection of "assignments" */
export interface TeacherAssignmentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAssignmentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAssignments>>;
}

/** aggregate fields of "assignments" */
export interface TeacherAssignmentsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherAssignmentsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAssignmentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAssignmentsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherAssignmentsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherAssignmentsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherAssignmentsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherAssignmentsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherAssignmentsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherAssignmentsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherAssignmentsVarianceFields>>;
}


/** aggregate fields of "assignments" */
export interface TeacherAssignmentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "assignments" */
export interface TeacherAssignmentsAggregateOrderBy {
  avg?: Maybe<TeacherAssignmentsAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAssignmentsMaxOrderBy>;
  min?: Maybe<TeacherAssignmentsMinOrderBy>;
  stddev?: Maybe<TeacherAssignmentsStddevOrderBy>;
  stddev_pop?: Maybe<TeacherAssignmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherAssignmentsStddevSampOrderBy>;
  sum?: Maybe<TeacherAssignmentsSumOrderBy>;
  var_pop?: Maybe<TeacherAssignmentsVarPopOrderBy>;
  var_samp?: Maybe<TeacherAssignmentsVarSampOrderBy>;
  variance?: Maybe<TeacherAssignmentsVarianceOrderBy>;
}

/** input type for inserting array relation for remote table "assignments" */
export interface TeacherAssignmentsArrRelInsertInput {
  data: Array<TeacherAssignmentsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentsOnConflict>;
}

/** aggregate avg on columns */
export interface TeacherAssignmentsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "assignments" */
export interface TeacherAssignmentsAvgOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export interface TeacherAssignmentsBoolExp {
  _and?: Maybe<Array<TeacherAssignmentsBoolExp>>;
  _not?: Maybe<TeacherAssignmentsBoolExp>;
  _or?: Maybe<Array<TeacherAssignmentsBoolExp>>;
  assignmentAttendeeType?: Maybe<TeacherAssignmentAttendeeTypeBoolExp>;
  assignment_attendee_type?: Maybe<TeacherAssignmentAttendeeTypeEnumComparisonExp>;
  assignment_book_chapters?: Maybe<TeacherAssignmentBookChapterBoolExp>;
  assignment_files?: Maybe<TeacherAssignmentFilesBoolExp>;
  assignment_grade_weight?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
  assignment_grade_weight_id?: Maybe<TeacherUuidComparisonExp>;
  assignment_questions?: Maybe<TeacherAssignmentQuestionsBoolExp>;
  assignment_quiz?: Maybe<TeacherAssignmentQuizBoolExp>;
  assignment_quizzes?: Maybe<TeacherAssignmentQuizBoolExp>;
  assignment_submits?: Maybe<TeacherAssignmentSubmitsBoolExp>;
  assignment_type?: Maybe<TeacherAssignmentTypeBoolExp>;
  assignment_users?: Maybe<TeacherAssignmentUserBoolExp>;
  chat?: Maybe<TeacherChatsBoolExp>;
  chat_id?: Maybe<TeacherUuidComparisonExp>;
  classes?: Maybe<TeacherViewAssignmentClassBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  due_at?: Maybe<TeacherTimestamptzComparisonExp>;
  due_at_filter?: Maybe<TeacherStringComparisonExp>;
  duration?: Maybe<TeacherIntComparisonExp>;
  files?: Maybe<TeacherFilesBoolExp>;
  grades?: Maybe<TeacherGradesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_completed?: Maybe<TeacherBooleanComparisonExp>;
  is_everybody?: Maybe<TeacherBooleanComparisonExp>;
  is_gradeable?: Maybe<TeacherBooleanComparisonExp>;
  lesson?: Maybe<TeacherLessonsBoolExp>;
  lesson_id?: Maybe<TeacherUuidComparisonExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  teaching_structure?: Maybe<TeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type?: Maybe<TeacherAssignmentTypeEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignments" */
export const enum TeacherAssignmentsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENTS_PKEY = 'assignments_pkey'
};

/** input type for incrementing numeric columns in table "assignments" */
export interface TeacherAssignmentsIncInput {
  duration?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "assignments" */
export interface TeacherAssignmentsInsertInput {
  assignment_files?: Maybe<TeacherAssignmentFilesArrRelInsertInput>;
  assignment_grade_weight_id?: Maybe<Scalars['uuid']>;
  assignment_questions?: Maybe<TeacherAssignmentQuestionsArrRelInsertInput>;
  assignment_quiz?: Maybe<TeacherAssignmentQuizObjRelInsertInput>;
  assignment_quizzes?: Maybe<TeacherAssignmentQuizArrRelInsertInput>;
  assignment_submits?: Maybe<TeacherAssignmentSubmitsArrRelInsertInput>;
  assignment_users?: Maybe<TeacherAssignmentUserArrRelInsertInput>;
  chat?: Maybe<TeacherChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  grades?: Maybe<TeacherGradesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_everybody?: Maybe<Scalars['Boolean']>;
  is_gradeable?: Maybe<Scalars['Boolean']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  teaching_structure?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  teaching_structure_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TeacherAssignmentTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherAssignmentsMaxFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "assignments" */
export interface TeacherAssignmentsMaxOrderBy {
  assignment_grade_weight_id?: Maybe<TeacherOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherAssignmentsMinFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "assignments" */
export interface TeacherAssignmentsMinOrderBy {
  assignment_grade_weight_id?: Maybe<TeacherOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "assignments" */
export interface TeacherAssignmentsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAssignments>>;
}

/** input type for inserting object relation for remote table "assignments" */
export interface TeacherAssignmentsObjRelInsertInput {
  data: TeacherAssignmentsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAssignmentsOnConflict>;
}

/** on conflict condition type for table "assignments" */
export interface TeacherAssignmentsOnConflict {
  constraint: TeacherAssignmentsConstraint;
  update_columns?: Array<TeacherAssignmentsUpdateColumn>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}

/** Ordering options when selecting data from "assignments". */
export interface TeacherAssignmentsOrderBy {
  assignmentAttendeeType?: Maybe<TeacherAssignmentAttendeeTypeOrderBy>;
  assignment_attendee_type?: Maybe<TeacherOrderBy>;
  assignment_book_chapters_aggregate?: Maybe<TeacherAssignmentBookChapterAggregateOrderBy>;
  assignment_files_aggregate?: Maybe<TeacherAssignmentFilesAggregateOrderBy>;
  assignment_grade_weight?: Maybe<TeacherAssignmentGradeWeightsOrderBy>;
  assignment_grade_weight_id?: Maybe<TeacherOrderBy>;
  assignment_questions_aggregate?: Maybe<TeacherAssignmentQuestionsAggregateOrderBy>;
  assignment_quiz?: Maybe<TeacherAssignmentQuizOrderBy>;
  assignment_quizzes_aggregate?: Maybe<TeacherAssignmentQuizAggregateOrderBy>;
  assignment_submits_aggregate?: Maybe<TeacherAssignmentSubmitsAggregateOrderBy>;
  assignment_type?: Maybe<TeacherAssignmentTypeOrderBy>;
  assignment_users_aggregate?: Maybe<TeacherAssignmentUserAggregateOrderBy>;
  chat?: Maybe<TeacherChatsOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  classes_aggregate?: Maybe<TeacherViewAssignmentClassAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  due_at_filter?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  files_aggregate?: Maybe<TeacherFilesAggregateOrderBy>;
  grades_aggregate?: Maybe<TeacherGradesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_completed?: Maybe<TeacherOrderBy>;
  is_everybody?: Maybe<TeacherOrderBy>;
  is_gradeable?: Maybe<TeacherOrderBy>;
  lesson?: Maybe<TeacherLessonsOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teaching_structure?: Maybe<TeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: assignments */
export interface TeacherAssignmentsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignments" */
export const enum TeacherAssignmentsSelectColumn {
  /** column name */
  ASSIGNMENT_ATTENDEE_TYPE = 'assignment_attendee_type',
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignments" */
export interface TeacherAssignmentsSetInput {
  assignment_grade_weight_id?: Maybe<Scalars['uuid']>;
  chat_id?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  is_everybody?: Maybe<Scalars['Boolean']>;
  is_gradeable?: Maybe<Scalars['Boolean']>;
  teaching_structure_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TeacherAssignmentTypeEnum>;
}

/** aggregate stddev on columns */
export interface TeacherAssignmentsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "assignments" */
export interface TeacherAssignmentsStddevOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeacherAssignmentsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "assignments" */
export interface TeacherAssignmentsStddevPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeacherAssignmentsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "assignments" */
export interface TeacherAssignmentsStddevSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate sum on columns */
export interface TeacherAssignmentsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "assignments" */
export interface TeacherAssignmentsSumOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** update columns of table "assignments" */
export const enum TeacherAssignmentsUpdateColumn {
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type'
};

/** aggregate var_pop on columns */
export interface TeacherAssignmentsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "assignments" */
export interface TeacherAssignmentsVarPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface TeacherAssignmentsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "assignments" */
export interface TeacherAssignmentsVarSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate variance on columns */
export interface TeacherAssignmentsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "assignments" */
export interface TeacherAssignmentsVarianceOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "attendance_types" */
export interface TeacherAttendanceTypes {
  icon: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "attendance_types". All fields are combined with a logical 'AND'. */
export interface TeacherAttendanceTypesBoolExp {
  _and?: Maybe<Array<TeacherAttendanceTypesBoolExp>>;
  _not?: Maybe<TeacherAttendanceTypesBoolExp>;
  _or?: Maybe<Array<TeacherAttendanceTypesBoolExp>>;
  icon?: Maybe<TeacherStringComparisonExp>;
  text?: Maybe<TeacherStringComparisonExp>;
  value?: Maybe<TeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "attendance_types". */
export interface TeacherAttendanceTypesOrderBy {
  icon?: Maybe<TeacherOrderBy>;
  text?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
}

/** select columns of table "attendance_types" */
export const enum TeacherAttendanceTypesSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  TEXT = 'text',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "attendances" */
export interface TeacherAttendances {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  class: EntireFieldWrapper<TeacherTeachingStructures>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  semester: EntireFieldWrapper<TeacherTeachingStructures>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<TeacherTeachingStructures>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  teacher?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  type?: EntireFieldWrapper<Maybe<TeacherAttendanceTypes>>;
}

/** aggregated selection of "attendances" */
export interface TeacherAttendancesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAttendancesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAttendances>>;
}

/** aggregate fields of "attendances" */
export interface TeacherAttendancesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAttendancesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAttendancesMinFields>>;
}


/** aggregate fields of "attendances" */
export interface TeacherAttendancesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAttendancesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "attendances". All fields are combined with a logical 'AND'. */
export interface TeacherAttendancesBoolExp {
  _and?: Maybe<Array<TeacherAttendancesBoolExp>>;
  _not?: Maybe<TeacherAttendancesBoolExp>;
  _or?: Maybe<Array<TeacherAttendancesBoolExp>>;
  attendance_type?: Maybe<TeacherStringComparisonExp>;
  class?: Maybe<TeacherTeachingStructuresBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  date?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  semester?: Maybe<TeacherTeachingStructuresBoolExp>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  subject?: Maybe<TeacherTeachingStructuresBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
  type?: Maybe<TeacherAttendanceTypesBoolExp>;
}

/** unique or primary key constraints on table "attendances" */
export const enum TeacherAttendancesConstraint {
  /** unique or primary key constraint */
  ATTENDANCES_PKEY = 'attendances_pkey'
};

/** input type for inserting data into table "attendances" */
export interface TeacherAttendancesInsertInput {
  attendance_type?: Maybe<Scalars['String']>;
  class?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  class_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  semester?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  semester_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
  subject?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  subject_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherAttendancesMaxFields {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherAttendancesMinFields {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "attendances" */
export interface TeacherAttendancesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAttendances>>;
}

/** on conflict condition type for table "attendances" */
export interface TeacherAttendancesOnConflict {
  constraint: TeacherAttendancesConstraint;
  update_columns?: Array<TeacherAttendancesUpdateColumn>;
  where?: Maybe<TeacherAttendancesBoolExp>;
}

/** Ordering options when selecting data from "attendances". */
export interface TeacherAttendancesOrderBy {
  attendance_type?: Maybe<TeacherOrderBy>;
  class?: Maybe<TeacherTeachingStructuresOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  date?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  semester?: Maybe<TeacherTeachingStructuresOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherTeachingStructuresOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherAttendanceTypesOrderBy>;
}

/** primary key columns input for table: attendances */
export interface TeacherAttendancesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "attendances" */
export const enum TeacherAttendancesSelectColumn {
  /** column name */
  ATTENDANCE_TYPE = 'attendance_type',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** input type for updating data in table "attendances" */
export interface TeacherAttendancesSetInput {
  attendance_type?: Maybe<Scalars['String']>;
  class_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
  semester_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
  subject_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "attendances" */
export const enum TeacherAttendancesUpdateColumn {
  /** column name */
  ATTENDANCE_TYPE = 'attendance_type',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  DATE = 'date',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "auth.account_providers" */
export interface TeacherAuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<TeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<TeacherAuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface TeacherAuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface TeacherAuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface TeacherAuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface TeacherAuthAccountProvidersAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAuthAccountProvidersMaxOrderBy>;
  min?: Maybe<TeacherAuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface TeacherAuthAccountProvidersArrRelInsertInput {
  data: Array<TeacherAuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface TeacherAuthAccountProvidersBoolExp {
  _and?: Maybe<Array<TeacherAuthAccountProvidersBoolExp>>;
  _not?: Maybe<TeacherAuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<TeacherAuthAccountProvidersBoolExp>>;
  account?: Maybe<TeacherAuthAccountsBoolExp>;
  account_id?: Maybe<TeacherUuidComparisonExp>;
  auth_provider?: Maybe<TeacherStringComparisonExp>;
  auth_provider_unique_id?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  provider?: Maybe<TeacherAuthProvidersBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum TeacherAuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface TeacherAuthAccountProvidersInsertInput {
  account?: Maybe<TeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<TeacherAuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherAuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface TeacherAuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  auth_provider?: Maybe<TeacherOrderBy>;
  auth_provider_unique_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherAuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface TeacherAuthAccountProvidersMinOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  auth_provider?: Maybe<TeacherOrderBy>;
  auth_provider_unique_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface TeacherAuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface TeacherAuthAccountProvidersOnConflict {
  constraint: TeacherAuthAccountProvidersConstraint;
  update_columns?: Array<TeacherAuthAccountProvidersUpdateColumn>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface TeacherAuthAccountProvidersOrderBy {
  account?: Maybe<TeacherAuthAccountsOrderBy>;
  account_id?: Maybe<TeacherOrderBy>;
  auth_provider?: Maybe<TeacherOrderBy>;
  auth_provider_unique_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  provider?: Maybe<TeacherAuthProvidersOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface TeacherAuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum TeacherAuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface TeacherAuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum TeacherAuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface TeacherAuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<TeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<TeacherAuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface TeacherAuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface TeacherAuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface TeacherAuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface TeacherAuthAccountRolesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAuthAccountRolesMaxOrderBy>;
  min?: Maybe<TeacherAuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface TeacherAuthAccountRolesArrRelInsertInput {
  data: Array<TeacherAuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface TeacherAuthAccountRolesBoolExp {
  _and?: Maybe<Array<TeacherAuthAccountRolesBoolExp>>;
  _not?: Maybe<TeacherAuthAccountRolesBoolExp>;
  _or?: Maybe<Array<TeacherAuthAccountRolesBoolExp>>;
  account?: Maybe<TeacherAuthAccountsBoolExp>;
  account_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  role?: Maybe<TeacherStringComparisonExp>;
  roleByRole?: Maybe<TeacherAuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum TeacherAuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface TeacherAuthAccountRolesInsertInput {
  account?: Maybe<TeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<TeacherAuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface TeacherAuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface TeacherAuthAccountRolesMaxOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherAuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface TeacherAuthAccountRolesMinOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface TeacherAuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface TeacherAuthAccountRolesOnConflict {
  constraint: TeacherAuthAccountRolesConstraint;
  update_columns?: Array<TeacherAuthAccountRolesUpdateColumn>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface TeacherAuthAccountRolesOrderBy {
  account?: Maybe<TeacherAuthAccountsOrderBy>;
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
  roleByRole?: Maybe<TeacherAuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface TeacherAuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum TeacherAuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface TeacherAuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum TeacherAuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<TeacherAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<TeacherAuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<TeacherAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<TeacherAuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<TeacherAuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<TeacherAuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<TeacherAuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<TeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<TeacherAuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface TeacherAuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<TeacherAuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface TeacherAuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface TeacherAuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface TeacherAuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface TeacherAuthAccountsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAuthAccountsMaxOrderBy>;
  min?: Maybe<TeacherAuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface TeacherAuthAccountsArrRelInsertInput {
  data: Array<TeacherAuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface TeacherAuthAccountsBoolExp {
  _and?: Maybe<Array<TeacherAuthAccountsBoolExp>>;
  _not?: Maybe<TeacherAuthAccountsBoolExp>;
  _or?: Maybe<Array<TeacherAuthAccountsBoolExp>>;
  account_providers?: Maybe<TeacherAuthAccountProvidersBoolExp>;
  account_roles?: Maybe<TeacherAuthAccountRolesBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  default_role?: Maybe<TeacherStringComparisonExp>;
  email?: Maybe<TeacherCitextComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<TeacherBooleanComparisonExp>;
  new_email?: Maybe<TeacherCitextComparisonExp>;
  password_hash?: Maybe<TeacherStringComparisonExp>;
  refresh_tokens?: Maybe<TeacherAuthRefreshTokensBoolExp>;
  role?: Maybe<TeacherAuthRolesBoolExp>;
  ticket?: Maybe<TeacherUuidComparisonExp>;
  ticket_expires_at?: Maybe<TeacherTimestamptzComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user?: Maybe<TeacherUsersBoolExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum TeacherAuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface TeacherAuthAccountsInsertInput {
  account_providers?: Maybe<TeacherAuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<TeacherAuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<TeacherAuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<TeacherAuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<TeacherUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherAuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface TeacherAuthAccountsMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  default_role?: Maybe<TeacherOrderBy>;
  email?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  new_email?: Maybe<TeacherOrderBy>;
  password_hash?: Maybe<TeacherOrderBy>;
  ticket?: Maybe<TeacherOrderBy>;
  ticket_expires_at?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherAuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface TeacherAuthAccountsMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  default_role?: Maybe<TeacherOrderBy>;
  email?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  new_email?: Maybe<TeacherOrderBy>;
  password_hash?: Maybe<TeacherOrderBy>;
  ticket?: Maybe<TeacherOrderBy>;
  ticket_expires_at?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface TeacherAuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface TeacherAuthAccountsObjRelInsertInput {
  data: TeacherAuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface TeacherAuthAccountsOnConflict {
  constraint: TeacherAuthAccountsConstraint;
  update_columns?: Array<TeacherAuthAccountsUpdateColumn>;
  where?: Maybe<TeacherAuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface TeacherAuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<TeacherAuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<TeacherAuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  default_role?: Maybe<TeacherOrderBy>;
  email?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<TeacherOrderBy>;
  new_email?: Maybe<TeacherOrderBy>;
  password_hash?: Maybe<TeacherOrderBy>;
  refresh_tokens_aggregate?: Maybe<TeacherAuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<TeacherAuthRolesOrderBy>;
  ticket?: Maybe<TeacherOrderBy>;
  ticket_expires_at?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user?: Maybe<TeacherUsersOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface TeacherAuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum TeacherAuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface TeacherAuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum TeacherAuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface TeacherAuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<TeacherAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<TeacherAuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface TeacherAuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface TeacherAuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface TeacherAuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface TeacherAuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface TeacherAuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface TeacherAuthProvidersBoolExp {
  _and?: Maybe<Array<TeacherAuthProvidersBoolExp>>;
  _not?: Maybe<TeacherAuthProvidersBoolExp>;
  _or?: Maybe<Array<TeacherAuthProvidersBoolExp>>;
  account_providers?: Maybe<TeacherAuthAccountProvidersBoolExp>;
  provider?: Maybe<TeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum TeacherAuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface TeacherAuthProvidersInsertInput {
  account_providers?: Maybe<TeacherAuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface TeacherAuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface TeacherAuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface TeacherAuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface TeacherAuthProvidersObjRelInsertInput {
  data: TeacherAuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface TeacherAuthProvidersOnConflict {
  constraint: TeacherAuthProvidersConstraint;
  update_columns?: Array<TeacherAuthProvidersUpdateColumn>;
  where?: Maybe<TeacherAuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface TeacherAuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<TeacherAuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface TeacherAuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum TeacherAuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface TeacherAuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum TeacherAuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<TeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherAuthRefreshTokensMaxOrderBy>;
  min?: Maybe<TeacherAuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensArrRelInsertInput {
  data: Array<TeacherAuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface TeacherAuthRefreshTokensBoolExp {
  _and?: Maybe<Array<TeacherAuthRefreshTokensBoolExp>>;
  _not?: Maybe<TeacherAuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<TeacherAuthRefreshTokensBoolExp>>;
  account?: Maybe<TeacherAuthAccountsBoolExp>;
  account_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  expires_at?: Maybe<TeacherTimestamptzComparisonExp>;
  refresh_token?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum TeacherAuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensInsertInput {
  account?: Maybe<TeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherAuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  expires_at?: Maybe<TeacherOrderBy>;
  refresh_token?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherAuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensMinOrderBy {
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  expires_at?: Maybe<TeacherOrderBy>;
  refresh_token?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensOnConflict {
  constraint: TeacherAuthRefreshTokensConstraint;
  update_columns?: Array<TeacherAuthRefreshTokensUpdateColumn>;
  where?: Maybe<TeacherAuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface TeacherAuthRefreshTokensOrderBy {
  account?: Maybe<TeacherAuthAccountsOrderBy>;
  account_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  expires_at?: Maybe<TeacherOrderBy>;
  refresh_token?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface TeacherAuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum TeacherAuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface TeacherAuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum TeacherAuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface TeacherAuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<TeacherAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<TeacherAuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<TeacherAuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<TeacherAuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface TeacherAuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface TeacherAuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface TeacherAuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountsOrderBy>>;
  where?: Maybe<TeacherAuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface TeacherAuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountsOrderBy>>;
  where?: Maybe<TeacherAuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface TeacherAuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherAuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherAuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface TeacherAuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherAuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherAuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface TeacherAuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherAuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface TeacherAuthRolesBoolExp {
  _and?: Maybe<Array<TeacherAuthRolesBoolExp>>;
  _not?: Maybe<TeacherAuthRolesBoolExp>;
  _or?: Maybe<Array<TeacherAuthRolesBoolExp>>;
  account_roles?: Maybe<TeacherAuthAccountRolesBoolExp>;
  accounts?: Maybe<TeacherAuthAccountsBoolExp>;
  role?: Maybe<TeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum TeacherAuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface TeacherAuthRolesInsertInput {
  account_roles?: Maybe<TeacherAuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<TeacherAuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface TeacherAuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface TeacherAuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface TeacherAuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherAuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface TeacherAuthRolesObjRelInsertInput {
  data: TeacherAuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherAuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface TeacherAuthRolesOnConflict {
  constraint: TeacherAuthRolesConstraint;
  update_columns?: Array<TeacherAuthRolesUpdateColumn>;
  where?: Maybe<TeacherAuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface TeacherAuthRolesOrderBy {
  account_roles_aggregate?: Maybe<TeacherAuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<TeacherAuthAccountsAggregateOrderBy>;
  role?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface TeacherAuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum TeacherAuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface TeacherAuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum TeacherAuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export interface TeacherBigintComparisonExp {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
}

/** columns and relationships of "book_chapter_type" */
export interface TeacherBookChapterType {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<TeacherBookChapters>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "book_chapter_type" */
export interface TeacherBookChapterTypeBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChaptersOrderBy>>;
  where?: Maybe<TeacherBookChaptersBoolExp>;
}

/** Boolean expression to filter rows from the table "book_chapter_type". All fields are combined with a logical 'AND'. */
export interface TeacherBookChapterTypeBoolExp {
  _and?: Maybe<Array<TeacherBookChapterTypeBoolExp>>;
  _not?: Maybe<TeacherBookChapterTypeBoolExp>;
  _or?: Maybe<Array<TeacherBookChapterTypeBoolExp>>;
  book_chapters?: Maybe<TeacherBookChaptersBoolExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherBookChapterTypeEnum {
  HTML = 'HTML',
  QUIZZ = 'QUIZZ'
};

/** Boolean expression to compare columns of type "book_chapter_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherBookChapterTypeEnumComparisonExp {
  _eq?: Maybe<TeacherBookChapterTypeEnum>;
  _in?: Maybe<Array<TeacherBookChapterTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherBookChapterTypeEnum>;
  _nin?: Maybe<Array<TeacherBookChapterTypeEnum>>;
}

/** Ordering options when selecting data from "book_chapter_type". */
export interface TeacherBookChapterTypeOrderBy {
  book_chapters_aggregate?: Maybe<TeacherBookChaptersAggregateOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "book_chapter_type" */
export const enum TeacherBookChapterTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "book_chapters" */
export interface TeacherBookChapters {
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<TeacherAssignmentBookChapter>>;
  /** An object relationship */
  book: EntireFieldWrapper<TeacherBooks>;
  /** An object relationship */
  book_chapter_type: EntireFieldWrapper<TeacherBookChapterType>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<TeacherChapterSections>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  due_at: EntireFieldWrapper<Scalars['date']>;
  /** A computed field, executes function "book_chapter_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<TeacherBookChapterTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "book_chapters" */
export interface TeacherBookChaptersAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<TeacherAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "book_chapters" */
export interface TeacherBookChaptersChapterSectionsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionsOrderBy>>;
  where?: Maybe<TeacherChapterSectionsBoolExp>;
}

/** order by aggregate values of table "book_chapters" */
export interface TeacherBookChaptersAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherBookChaptersMaxOrderBy>;
  min?: Maybe<TeacherBookChaptersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_chapters". All fields are combined with a logical 'AND'. */
export interface TeacherBookChaptersBoolExp {
  _and?: Maybe<Array<TeacherBookChaptersBoolExp>>;
  _not?: Maybe<TeacherBookChaptersBoolExp>;
  _or?: Maybe<Array<TeacherBookChaptersBoolExp>>;
  assignment_book_chapters?: Maybe<TeacherAssignmentBookChapterBoolExp>;
  book?: Maybe<TeacherBooksBoolExp>;
  book_chapter_type?: Maybe<TeacherBookChapterTypeBoolExp>;
  book_id?: Maybe<TeacherUuidComparisonExp>;
  chapter_sections?: Maybe<TeacherChapterSectionsBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  due_at?: Maybe<TeacherDateComparisonExp>;
  duration_left?: Maybe<TeacherBigintComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  status?: Maybe<TeacherStringComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type?: Maybe<TeacherBookChapterTypeEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "book_chapters" */
export interface TeacherBookChaptersMaxOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "book_chapters" */
export interface TeacherBookChaptersMinOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "book_chapters". */
export interface TeacherBookChaptersOrderBy {
  assignment_book_chapters_aggregate?: Maybe<TeacherAssignmentBookChapterAggregateOrderBy>;
  book?: Maybe<TeacherBooksOrderBy>;
  book_chapter_type?: Maybe<TeacherBookChapterTypeOrderBy>;
  book_id?: Maybe<TeacherOrderBy>;
  chapter_sections_aggregate?: Maybe<TeacherChapterSectionsAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  due_at?: Maybe<TeacherOrderBy>;
  duration_left?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "book_chapters" */
export const enum TeacherBookChaptersSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "book_course" */
export interface TeacherBookCourse {
  /** An object relationship */
  book: EntireFieldWrapper<TeacherBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_course" */
export interface TeacherBookCourseAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherBookCourseMaxOrderBy>;
  min?: Maybe<TeacherBookCourseMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_course". All fields are combined with a logical 'AND'. */
export interface TeacherBookCourseBoolExp {
  _and?: Maybe<Array<TeacherBookCourseBoolExp>>;
  _not?: Maybe<TeacherBookCourseBoolExp>;
  _or?: Maybe<Array<TeacherBookCourseBoolExp>>;
  book?: Maybe<TeacherBooksBoolExp>;
  book_id?: Maybe<TeacherUuidComparisonExp>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "book_course" */
export interface TeacherBookCourseMaxOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "book_course" */
export interface TeacherBookCourseMinOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "book_course". */
export interface TeacherBookCourseOrderBy {
  book?: Maybe<TeacherBooksOrderBy>;
  book_id?: Maybe<TeacherOrderBy>;
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "book_course" */
export const enum TeacherBookCourseSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "book_user" */
export interface TeacherBookUser {
  /** An object relationship */
  book: EntireFieldWrapper<TeacherBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_user" */
export interface TeacherBookUserAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherBookUserMaxOrderBy>;
  min?: Maybe<TeacherBookUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_user". All fields are combined with a logical 'AND'. */
export interface TeacherBookUserBoolExp {
  _and?: Maybe<Array<TeacherBookUserBoolExp>>;
  _not?: Maybe<TeacherBookUserBoolExp>;
  _or?: Maybe<Array<TeacherBookUserBoolExp>>;
  book?: Maybe<TeacherBooksBoolExp>;
  book_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "book_user" */
export interface TeacherBookUserMaxOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "book_user" */
export interface TeacherBookUserMinOrderBy {
  book_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "book_user". */
export interface TeacherBookUserOrderBy {
  book?: Maybe<TeacherBooksOrderBy>;
  book_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "book_user" */
export const enum TeacherBookUserSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "books" */
export interface TeacherBooks {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<TeacherBookChapters>>;
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<TeacherBookCourse>>;
  /** An array relationship */
  book_users: EntireFieldWrapper<Array<TeacherBookUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  subject: EntireFieldWrapper<TeacherSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "books" */
export interface TeacherBooksBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChaptersOrderBy>>;
  where?: Maybe<TeacherBookChaptersBoolExp>;
}


/** columns and relationships of "books" */
export interface TeacherBooksBookCoursesArgs {
  distinct_on?: Maybe<Array<TeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookCourseOrderBy>>;
  where?: Maybe<TeacherBookCourseBoolExp>;
}


/** columns and relationships of "books" */
export interface TeacherBooksBookUsersArgs {
  distinct_on?: Maybe<Array<TeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookUserOrderBy>>;
  where?: Maybe<TeacherBookUserBoolExp>;
}

/** order by aggregate values of table "books" */
export interface TeacherBooksAggregateOrderBy {
  avg?: Maybe<TeacherBooksAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherBooksMaxOrderBy>;
  min?: Maybe<TeacherBooksMinOrderBy>;
  stddev?: Maybe<TeacherBooksStddevOrderBy>;
  stddev_pop?: Maybe<TeacherBooksStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherBooksStddevSampOrderBy>;
  sum?: Maybe<TeacherBooksSumOrderBy>;
  var_pop?: Maybe<TeacherBooksVarPopOrderBy>;
  var_samp?: Maybe<TeacherBooksVarSampOrderBy>;
  variance?: Maybe<TeacherBooksVarianceOrderBy>;
}

/** order by avg() on columns of table "books" */
export interface TeacherBooksAvgOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export interface TeacherBooksBoolExp {
  _and?: Maybe<Array<TeacherBooksBoolExp>>;
  _not?: Maybe<TeacherBooksBoolExp>;
  _or?: Maybe<Array<TeacherBooksBoolExp>>;
  book_chapters?: Maybe<TeacherBookChaptersBoolExp>;
  book_courses?: Maybe<TeacherBookCourseBoolExp>;
  book_users?: Maybe<TeacherBookUserBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  sort?: Maybe<TeacherIntComparisonExp>;
  status?: Maybe<TeacherStringComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "books" */
export interface TeacherBooksMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "books" */
export interface TeacherBooksMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "books". */
export interface TeacherBooksOrderBy {
  book_chapters_aggregate?: Maybe<TeacherBookChaptersAggregateOrderBy>;
  book_courses_aggregate?: Maybe<TeacherBookCourseAggregateOrderBy>;
  book_users_aggregate?: Maybe<TeacherBookUserAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "books" */
export const enum TeacherBooksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "books" */
export interface TeacherBooksStddevOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "books" */
export interface TeacherBooksStddevPopOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "books" */
export interface TeacherBooksStddevSampOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "books" */
export interface TeacherBooksSumOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by var_pop() on columns of table "books" */
export interface TeacherBooksVarPopOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "books" */
export interface TeacherBooksVarSampOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "books" */
export interface TeacherBooksVarianceOrderBy {
  sort?: Maybe<TeacherOrderBy>;
}

/**
 * DEPRECATED - change to assignments_notes
 *
 *
 * columns and relationships of "chapter_section_notes"
 */
export interface TeacherChapterSectionNotes {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chapter_section: EntireFieldWrapper<TeacherChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<TeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
}

/** order by aggregate values of table "chapter_section_notes" */
export interface TeacherChapterSectionNotesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChapterSectionNotesMaxOrderBy>;
  min?: Maybe<TeacherChapterSectionNotesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_notes". All fields are combined with a logical 'AND'. */
export interface TeacherChapterSectionNotesBoolExp {
  _and?: Maybe<Array<TeacherChapterSectionNotesBoolExp>>;
  _not?: Maybe<TeacherChapterSectionNotesBoolExp>;
  _or?: Maybe<Array<TeacherChapterSectionNotesBoolExp>>;
  body?: Maybe<TeacherStringComparisonExp>;
  chapter_section?: Maybe<TeacherChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_section_notes" */
export interface TeacherChapterSectionNotesMaxOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chapter_section_notes" */
export interface TeacherChapterSectionNotesMinOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "chapter_section_notes". */
export interface TeacherChapterSectionNotesOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chapter_section?: Maybe<TeacherChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chapter_section_notes" */
export const enum TeacherChapterSectionNotesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "chapter_section_submits" */
export interface TeacherChapterSectionSubmits {
  /** An object relationship */
  chapter_section: EntireFieldWrapper<TeacherChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration_spent: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  student: EntireFieldWrapper<TeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsAggregateOrderBy {
  avg?: Maybe<TeacherChapterSectionSubmitsAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChapterSectionSubmitsMaxOrderBy>;
  min?: Maybe<TeacherChapterSectionSubmitsMinOrderBy>;
  stddev?: Maybe<TeacherChapterSectionSubmitsStddevOrderBy>;
  stddev_pop?: Maybe<TeacherChapterSectionSubmitsStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherChapterSectionSubmitsStddevSampOrderBy>;
  sum?: Maybe<TeacherChapterSectionSubmitsSumOrderBy>;
  var_pop?: Maybe<TeacherChapterSectionSubmitsVarPopOrderBy>;
  var_samp?: Maybe<TeacherChapterSectionSubmitsVarSampOrderBy>;
  variance?: Maybe<TeacherChapterSectionSubmitsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsAvgOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_submits". All fields are combined with a logical 'AND'. */
export interface TeacherChapterSectionSubmitsBoolExp {
  _and?: Maybe<Array<TeacherChapterSectionSubmitsBoolExp>>;
  _not?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
  _or?: Maybe<Array<TeacherChapterSectionSubmitsBoolExp>>;
  chapter_section?: Maybe<TeacherChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  duration_spent?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_completed?: Maybe<TeacherBooleanComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsMaxOrderBy {
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration_spent?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsMinOrderBy {
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration_spent?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "chapter_section_submits". */
export interface TeacherChapterSectionSubmitsOrderBy {
  chapter_section?: Maybe<TeacherChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration_spent?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_completed?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chapter_section_submits" */
export const enum TeacherChapterSectionSubmitsSelectColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsStddevOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsStddevPopOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsStddevSampOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsSumOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by var_pop() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsVarPopOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsVarSampOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "chapter_section_submits" */
export interface TeacherChapterSectionSubmitsVarianceOrderBy {
  duration_spent?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "chapter_section_type" */
export interface TeacherChapterSectionType {
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<TeacherChapterSections>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chapter_section_type" */
export interface TeacherChapterSectionTypeChapterSectionsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionsOrderBy>>;
  where?: Maybe<TeacherChapterSectionsBoolExp>;
}

/** Boolean expression to filter rows from the table "chapter_section_type". All fields are combined with a logical 'AND'. */
export interface TeacherChapterSectionTypeBoolExp {
  _and?: Maybe<Array<TeacherChapterSectionTypeBoolExp>>;
  _not?: Maybe<TeacherChapterSectionTypeBoolExp>;
  _or?: Maybe<Array<TeacherChapterSectionTypeBoolExp>>;
  chapter_sections?: Maybe<TeacherChapterSectionsBoolExp>;
  icon?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherChapterSectionTypeEnum {
  HTML = 'HTML',
  INFORMATION = 'Information',
  QUIZZ = 'Quizz'
};

/** Boolean expression to compare columns of type "chapter_section_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherChapterSectionTypeEnumComparisonExp {
  _eq?: Maybe<TeacherChapterSectionTypeEnum>;
  _in?: Maybe<Array<TeacherChapterSectionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherChapterSectionTypeEnum>;
  _nin?: Maybe<Array<TeacherChapterSectionTypeEnum>>;
}

/** Ordering options when selecting data from "chapter_section_type". */
export interface TeacherChapterSectionTypeOrderBy {
  chapter_sections_aggregate?: Maybe<TeacherChapterSectionsAggregateOrderBy>;
  icon?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chapter_section_type" */
export const enum TeacherChapterSectionTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chapter_sections" */
export interface TeacherChapterSections {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<TeacherBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<TeacherChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<TeacherChapterSectionSubmits>>;
  /** An object relationship */
  chapter_section_type: EntireFieldWrapper<TeacherChapterSectionType>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** A computed field, executes function "section_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "section_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<TeacherChapterSectionTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "chapter_sections" */
export interface TeacherChapterSectionsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<TeacherChapterSectionNotesBoolExp>;
}


/** columns and relationships of "chapter_sections" */
export interface TeacherChapterSectionsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
}

/** order by aggregate values of table "chapter_sections" */
export interface TeacherChapterSectionsAggregateOrderBy {
  avg?: Maybe<TeacherChapterSectionsAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChapterSectionsMaxOrderBy>;
  min?: Maybe<TeacherChapterSectionsMinOrderBy>;
  stddev?: Maybe<TeacherChapterSectionsStddevOrderBy>;
  stddev_pop?: Maybe<TeacherChapterSectionsStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherChapterSectionsStddevSampOrderBy>;
  sum?: Maybe<TeacherChapterSectionsSumOrderBy>;
  var_pop?: Maybe<TeacherChapterSectionsVarPopOrderBy>;
  var_samp?: Maybe<TeacherChapterSectionsVarSampOrderBy>;
  variance?: Maybe<TeacherChapterSectionsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsAvgOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_sections". All fields are combined with a logical 'AND'. */
export interface TeacherChapterSectionsBoolExp {
  _and?: Maybe<Array<TeacherChapterSectionsBoolExp>>;
  _not?: Maybe<TeacherChapterSectionsBoolExp>;
  _or?: Maybe<Array<TeacherChapterSectionsBoolExp>>;
  body?: Maybe<TeacherStringComparisonExp>;
  book_chapter?: Maybe<TeacherBookChaptersBoolExp>;
  book_chapter_id?: Maybe<TeacherUuidComparisonExp>;
  chapter_section_notes?: Maybe<TeacherChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
  chapter_section_type?: Maybe<TeacherChapterSectionTypeBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  duration?: Maybe<TeacherIntComparisonExp>;
  duration_left?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_completed?: Maybe<TeacherBooleanComparisonExp>;
  sort?: Maybe<TeacherIntComparisonExp>;
  status?: Maybe<TeacherStringComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type?: Maybe<TeacherChapterSectionTypeEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsMaxOrderBy {
  body?: Maybe<TeacherOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsMinOrderBy {
  body?: Maybe<TeacherOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "chapter_sections". */
export interface TeacherChapterSectionsOrderBy {
  body?: Maybe<TeacherOrderBy>;
  book_chapter?: Maybe<TeacherBookChaptersOrderBy>;
  book_chapter_id?: Maybe<TeacherOrderBy>;
  chapter_section_notes_aggregate?: Maybe<TeacherChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<TeacherChapterSectionSubmitsAggregateOrderBy>;
  chapter_section_type?: Maybe<TeacherChapterSectionTypeOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  duration_left?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_completed?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chapter_sections" */
export const enum TeacherChapterSectionsSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsStddevOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsStddevPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsStddevSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsSumOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by var_pop() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsVarPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsVarSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "chapter_sections" */
export interface TeacherChapterSectionsVarianceOrderBy {
  duration?: Maybe<TeacherOrderBy>;
  sort?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "chat_message_likes" */
export interface TeacherChatMessageLikes {
  chat_like_user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "chat_message_likes" */
export interface TeacherChatMessageLikesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherChatMessageLikesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherChatMessageLikes>>;
}

/** aggregate fields of "chat_message_likes" */
export interface TeacherChatMessageLikesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherChatMessageLikesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherChatMessageLikesMinFields>>;
}


/** aggregate fields of "chat_message_likes" */
export interface TeacherChatMessageLikesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_message_likes" */
export interface TeacherChatMessageLikesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChatMessageLikesMaxOrderBy>;
  min?: Maybe<TeacherChatMessageLikesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_likes" */
export interface TeacherChatMessageLikesArrRelInsertInput {
  data: Array<TeacherChatMessageLikesInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_message_likes". All fields are combined with a logical 'AND'. */
export interface TeacherChatMessageLikesBoolExp {
  _and?: Maybe<Array<TeacherChatMessageLikesBoolExp>>;
  _not?: Maybe<TeacherChatMessageLikesBoolExp>;
  _or?: Maybe<Array<TeacherChatMessageLikesBoolExp>>;
  chat_message?: Maybe<TeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** input type for inserting data into table "chat_message_likes" */
export interface TeacherChatMessageLikesInsertInput {
  chat_message?: Maybe<TeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherChatMessageLikesMaxFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_message_likes" */
export interface TeacherChatMessageLikesMaxOrderBy {
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherChatMessageLikesMinFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_message_likes" */
export interface TeacherChatMessageLikesMinOrderBy {
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "chat_message_likes" */
export interface TeacherChatMessageLikesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherChatMessageLikes>>;
}

/** Ordering options when selecting data from "chat_message_likes". */
export interface TeacherChatMessageLikesOrderBy {
  chat_message?: Maybe<TeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chat_message_likes" */
export const enum TeacherChatMessageLikesSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chat_message_reads" */
export interface TeacherChatMessageReads {
  /** An object relationship */
  chat_message: EntireFieldWrapper<TeacherChatMessages>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_message_reads" */
export interface TeacherChatMessageReadsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChatMessageReadsMaxOrderBy>;
  min?: Maybe<TeacherChatMessageReadsMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_reads" */
export interface TeacherChatMessageReadsArrRelInsertInput {
  data: Array<TeacherChatMessageReadsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherChatMessageReadsOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_message_reads". All fields are combined with a logical 'AND'. */
export interface TeacherChatMessageReadsBoolExp {
  _and?: Maybe<Array<TeacherChatMessageReadsBoolExp>>;
  _not?: Maybe<TeacherChatMessageReadsBoolExp>;
  _or?: Maybe<Array<TeacherChatMessageReadsBoolExp>>;
  chat_message?: Maybe<TeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_read?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_message_reads" */
export const enum TeacherChatMessageReadsConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGE_USER_PKEY = 'chat_message_user_pkey'
};

/** input type for inserting data into table "chat_message_reads" */
export interface TeacherChatMessageReadsInsertInput {
  chat_message?: Maybe<TeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
}

/** order by max() on columns of table "chat_message_reads" */
export interface TeacherChatMessageReadsMaxOrderBy {
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chat_message_reads" */
export interface TeacherChatMessageReadsMinOrderBy {
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "chat_message_reads" */
export interface TeacherChatMessageReadsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherChatMessageReads>>;
}

/** on conflict condition type for table "chat_message_reads" */
export interface TeacherChatMessageReadsOnConflict {
  constraint: TeacherChatMessageReadsConstraint;
  update_columns?: Array<TeacherChatMessageReadsUpdateColumn>;
  where?: Maybe<TeacherChatMessageReadsBoolExp>;
}

/** Ordering options when selecting data from "chat_message_reads". */
export interface TeacherChatMessageReadsOrderBy {
  chat_message?: Maybe<TeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_read?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: chat_message_reads */
export interface TeacherChatMessageReadsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_message_reads" */
export const enum TeacherChatMessageReadsSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_message_reads" */
export interface TeacherChatMessageReadsSetInput {
  is_read?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_message_reads" */
export const enum TeacherChatMessageReadsUpdateColumn {
  /** column name */
  IS_READ = 'is_read'
};

/** columns and relationships of "chat_messages" */
export interface TeacherChatMessages {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chat: EntireFieldWrapper<TeacherChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<TeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<TeacherChatMessageLikesAggregate>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<TeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<TeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<TeacherChatMessagesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<TeacherFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_pinned: EntireFieldWrapper<Scalars['Boolean']>;
  /** A computed field, executes function "chat_message_replys" */
  replys?: EntireFieldWrapper<Maybe<Array<TeacherChatMessages>>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesChatMessageLikesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesChatMessageReadsArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageReadsOrderBy>>;
  where?: Maybe<TeacherChatMessageReadsBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesFilesArgs {
  distinct_on?: Maybe<Array<TeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherFilesOrderBy>>;
  where?: Maybe<TeacherFilesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface TeacherChatMessagesReplysArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}

/** aggregated selection of "chat_messages" */
export interface TeacherChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherChatMessages>>;
}

/** aggregate fields of "chat_messages" */
export interface TeacherChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherChatMessagesMinFields>>;
}


/** aggregate fields of "chat_messages" */
export interface TeacherChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_messages" */
export interface TeacherChatMessagesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChatMessagesMaxOrderBy>;
  min?: Maybe<TeacherChatMessagesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_messages" */
export interface TeacherChatMessagesArrRelInsertInput {
  data: Array<TeacherChatMessagesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherChatMessagesOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export interface TeacherChatMessagesBoolExp {
  _and?: Maybe<Array<TeacherChatMessagesBoolExp>>;
  _not?: Maybe<TeacherChatMessagesBoolExp>;
  _or?: Maybe<Array<TeacherChatMessagesBoolExp>>;
  body?: Maybe<TeacherStringComparisonExp>;
  chat?: Maybe<TeacherChatsBoolExp>;
  chat_id?: Maybe<TeacherUuidComparisonExp>;
  chat_message?: Maybe<TeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<TeacherUuidComparisonExp>;
  chat_message_likes?: Maybe<TeacherChatMessageLikesBoolExp>;
  chat_message_reads?: Maybe<TeacherChatMessageReadsBoolExp>;
  chat_messages?: Maybe<TeacherChatMessagesBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  files?: Maybe<TeacherFilesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_pinned?: Maybe<TeacherBooleanComparisonExp>;
  replys?: Maybe<TeacherChatMessagesBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_messages" */
export const enum TeacherChatMessagesConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
};

/** input type for inserting data into table "chat_messages" */
export interface TeacherChatMessagesInsertInput {
  body?: Maybe<Scalars['String']>;
  chat?: Maybe<TeacherChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message?: Maybe<TeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  chat_message_likes?: Maybe<TeacherChatMessageLikesArrRelInsertInput>;
  chat_message_reads?: Maybe<TeacherChatMessageReadsArrRelInsertInput>;
  chat_messages?: Maybe<TeacherChatMessagesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_messages" */
export interface TeacherChatMessagesMaxOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_messages" */
export interface TeacherChatMessagesMinOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  chat_message_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "chat_messages" */
export interface TeacherChatMessagesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherChatMessages>>;
}

/** input type for inserting object relation for remote table "chat_messages" */
export interface TeacherChatMessagesObjRelInsertInput {
  data: TeacherChatMessagesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherChatMessagesOnConflict>;
}

/** on conflict condition type for table "chat_messages" */
export interface TeacherChatMessagesOnConflict {
  constraint: TeacherChatMessagesConstraint;
  update_columns?: Array<TeacherChatMessagesUpdateColumn>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}

/** Ordering options when selecting data from "chat_messages". */
export interface TeacherChatMessagesOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chat?: Maybe<TeacherChatsOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  chat_message?: Maybe<TeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<TeacherOrderBy>;
  chat_message_likes_aggregate?: Maybe<TeacherChatMessageLikesAggregateOrderBy>;
  chat_message_reads_aggregate?: Maybe<TeacherChatMessageReadsAggregateOrderBy>;
  chat_messages_aggregate?: Maybe<TeacherChatMessagesAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  files_aggregate?: Maybe<TeacherFilesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_pinned?: Maybe<TeacherOrderBy>;
  replys_aggregate?: Maybe<TeacherChatMessagesAggregateOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: chat_messages */
export interface TeacherChatMessagesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_messages" */
export const enum TeacherChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_messages" */
export interface TeacherChatMessagesSetInput {
  body?: Maybe<Scalars['String']>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_messages" */
export const enum TeacherChatMessagesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned'
};

/** columns and relationships of "chat_type" */
export interface TeacherChatType {
  /** An array relationship */
  chats: EntireFieldWrapper<Array<TeacherChats>>;
  description: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chat_type" */
export interface TeacherChatTypeChatsArgs {
  distinct_on?: Maybe<Array<TeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatsOrderBy>>;
  where?: Maybe<TeacherChatsBoolExp>;
}

/** Boolean expression to filter rows from the table "chat_type". All fields are combined with a logical 'AND'. */
export interface TeacherChatTypeBoolExp {
  _and?: Maybe<Array<TeacherChatTypeBoolExp>>;
  _not?: Maybe<TeacherChatTypeBoolExp>;
  _or?: Maybe<Array<TeacherChatTypeBoolExp>>;
  chats?: Maybe<TeacherChatsBoolExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherChatTypeEnum {
  /** Group conversation */
  GROUP = 'GROUP',
  /** Private conversation */
  PRIVATE = 'PRIVATE'
};

/** Boolean expression to compare columns of type "chat_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherChatTypeEnumComparisonExp {
  _eq?: Maybe<TeacherChatTypeEnum>;
  _in?: Maybe<Array<TeacherChatTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherChatTypeEnum>;
  _nin?: Maybe<Array<TeacherChatTypeEnum>>;
}

/** Ordering options when selecting data from "chat_type". */
export interface TeacherChatTypeOrderBy {
  chats_aggregate?: Maybe<TeacherChatsAggregateOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chat_type" */
export const enum TeacherChatTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chat_user" */
export interface TeacherChatUser {
  /** An object relationship */
  chat: EntireFieldWrapper<TeacherChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_user" */
export interface TeacherChatUserAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChatUserMaxOrderBy>;
  min?: Maybe<TeacherChatUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_user" */
export interface TeacherChatUserArrRelInsertInput {
  data: Array<TeacherChatUserInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_user". All fields are combined with a logical 'AND'. */
export interface TeacherChatUserBoolExp {
  _and?: Maybe<Array<TeacherChatUserBoolExp>>;
  _not?: Maybe<TeacherChatUserBoolExp>;
  _or?: Maybe<Array<TeacherChatUserBoolExp>>;
  chat?: Maybe<TeacherChatsBoolExp>;
  chat_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** input type for inserting data into table "chat_user" */
export interface TeacherChatUserInsertInput {
  chat?: Maybe<TeacherChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "chat_user" */
export interface TeacherChatUserMaxOrderBy {
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chat_user" */
export interface TeacherChatUserMinOrderBy {
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "chat_user" */
export interface TeacherChatUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherChatUser>>;
}

/** Ordering options when selecting data from "chat_user". */
export interface TeacherChatUserOrderBy {
  chat?: Maybe<TeacherChatsOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "chat_user" */
export const enum TeacherChatUserSelectColumn {
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chats" */
export interface TeacherChats {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<TeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<TeacherChatMessagesAggregate>;
  /** An object relationship */
  chat_type: EntireFieldWrapper<TeacherChatType>;
  /** An array relationship */
  chat_users: EntireFieldWrapper<Array<TeacherChatUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<TeacherChatTypeEnum>;
  /** A computed field, executes function "unread_messages" */
  unread_messages?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chats" */
export interface TeacherChatsChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface TeacherChatsChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface TeacherChatsChatUsersArgs {
  distinct_on?: Maybe<Array<TeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatUserOrderBy>>;
  where?: Maybe<TeacherChatUserBoolExp>;
}

/** order by aggregate values of table "chats" */
export interface TeacherChatsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherChatsMaxOrderBy>;
  min?: Maybe<TeacherChatsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface TeacherChatsBoolExp {
  _and?: Maybe<Array<TeacherChatsBoolExp>>;
  _not?: Maybe<TeacherChatsBoolExp>;
  _or?: Maybe<Array<TeacherChatsBoolExp>>;
  avatar_url?: Maybe<TeacherStringComparisonExp>;
  chat_messages?: Maybe<TeacherChatMessagesBoolExp>;
  chat_type?: Maybe<TeacherChatTypeBoolExp>;
  chat_users?: Maybe<TeacherChatUserBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type?: Maybe<TeacherChatTypeEnumComparisonExp>;
  unread_messages?: Maybe<TeacherBigintComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chats" */
export const enum TeacherChatsConstraint {
  /** unique or primary key constraint */
  CHATS_PKEY = 'chats_pkey'
};

/** input type for inserting data into table "chats" */
export interface TeacherChatsInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  chat_messages?: Maybe<TeacherChatMessagesArrRelInsertInput>;
  chat_users?: Maybe<TeacherChatUserArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<TeacherChatTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chats" */
export interface TeacherChatsMaxOrderBy {
  avatar_url?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "chats" */
export interface TeacherChatsMinOrderBy {
  avatar_url?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "chats" */
export interface TeacherChatsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherChats>>;
}

/** input type for inserting object relation for remote table "chats" */
export interface TeacherChatsObjRelInsertInput {
  data: TeacherChatsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherChatsOnConflict>;
}

/** on conflict condition type for table "chats" */
export interface TeacherChatsOnConflict {
  constraint: TeacherChatsConstraint;
  update_columns?: Array<TeacherChatsUpdateColumn>;
  where?: Maybe<TeacherChatsBoolExp>;
}

/** Ordering options when selecting data from "chats". */
export interface TeacherChatsOrderBy {
  avatar_url?: Maybe<TeacherOrderBy>;
  chat_messages_aggregate?: Maybe<TeacherChatMessagesAggregateOrderBy>;
  chat_type?: Maybe<TeacherChatTypeOrderBy>;
  chat_users_aggregate?: Maybe<TeacherChatUserAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  unread_messages?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: chats */
export interface TeacherChatsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chats" */
export const enum TeacherChatsSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chats" */
export interface TeacherChatsSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "chats" */
export const enum TeacherChatsUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  TITLE = 'title'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface TeacherCitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}

/** columns and relationships of "class_levels" */
export interface TeacherClassLevels {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherClasses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  number: EntireFieldWrapper<Scalars['Int']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "class_levels" */
export interface TeacherClassLevelsClassesArgs {
  distinct_on?: Maybe<Array<TeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassesOrderBy>>;
  where?: Maybe<TeacherClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export interface TeacherClassLevelsBoolExp {
  _and?: Maybe<Array<TeacherClassLevelsBoolExp>>;
  _not?: Maybe<TeacherClassLevelsBoolExp>;
  _or?: Maybe<Array<TeacherClassLevelsBoolExp>>;
  classes?: Maybe<TeacherClassesBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  number?: Maybe<TeacherIntComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "class_levels". */
export interface TeacherClassLevelsOrderBy {
  classes_aggregate?: Maybe<TeacherClassesAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  number?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "class_levels" */
export const enum TeacherClassLevelsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "class_type" */
export interface TeacherClassType {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherClasses>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "class_type" */
export interface TeacherClassTypeClassesArgs {
  distinct_on?: Maybe<Array<TeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassesOrderBy>>;
  where?: Maybe<TeacherClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_type". All fields are combined with a logical 'AND'. */
export interface TeacherClassTypeBoolExp {
  _and?: Maybe<Array<TeacherClassTypeBoolExp>>;
  _not?: Maybe<TeacherClassTypeBoolExp>;
  _or?: Maybe<Array<TeacherClassTypeBoolExp>>;
  classes?: Maybe<TeacherClassesBoolExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
}

export const enum TeacherClassTypeEnum {
  C = 'C',
  GEISTESWISSENSCHAFTEN = 'Geisteswissenschaften',
  TECHNOLOGIE = 'Technologie'
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export interface TeacherClassTypeEnumComparisonExp {
  _eq?: Maybe<TeacherClassTypeEnum>;
  _in?: Maybe<Array<TeacherClassTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherClassTypeEnum>;
  _nin?: Maybe<Array<TeacherClassTypeEnum>>;
}

/** Ordering options when selecting data from "class_type". */
export interface TeacherClassTypeOrderBy {
  classes_aggregate?: Maybe<TeacherClassesAggregateOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "class_type" */
export const enum TeacherClassTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "classes" */
export interface TeacherClasses {
  /** An object relationship */
  class_type: EntireFieldWrapper<TeacherClassType>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<TeacherCourseClass>>;
  /** An aggregate relationship */
  course_classes_aggregate: EntireFieldWrapper<TeacherCourseClassAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  identifier?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  level: EntireFieldWrapper<TeacherClassLevels>;
  level_id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "class_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<TeacherStudents>>;
  /** An object relationship */
  teacher: EntireFieldWrapper<TeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<TeacherClassTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classes" */
export interface TeacherClassesCourseClassesArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface TeacherClassesCourseClassesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface TeacherClassesStudentsArgs {
  distinct_on?: Maybe<Array<TeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentsOrderBy>>;
  where?: Maybe<TeacherStudentsBoolExp>;
}

/** order by aggregate values of table "classes" */
export interface TeacherClassesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherClassesMaxOrderBy>;
  min?: Maybe<TeacherClassesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export interface TeacherClassesBoolExp {
  _and?: Maybe<Array<TeacherClassesBoolExp>>;
  _not?: Maybe<TeacherClassesBoolExp>;
  _or?: Maybe<Array<TeacherClassesBoolExp>>;
  class_type?: Maybe<TeacherClassTypeBoolExp>;
  course_classes?: Maybe<TeacherCourseClassBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  identifier?: Maybe<TeacherStringComparisonExp>;
  level?: Maybe<TeacherClassLevelsBoolExp>;
  level_id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  students?: Maybe<TeacherStudentsBoolExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
  type?: Maybe<TeacherClassTypeEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classes" */
export interface TeacherClassesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  identifier?: Maybe<TeacherOrderBy>;
  level_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "classes" */
export interface TeacherClassesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  identifier?: Maybe<TeacherOrderBy>;
  level_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "classes". */
export interface TeacherClassesOrderBy {
  class_type?: Maybe<TeacherClassTypeOrderBy>;
  course_classes_aggregate?: Maybe<TeacherCourseClassAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  identifier?: Maybe<TeacherOrderBy>;
  level?: Maybe<TeacherClassLevelsOrderBy>;
  level_id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  students_aggregate?: Maybe<TeacherStudentsAggregateOrderBy>;
  teacher?: Maybe<TeacherTeachersOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "classes" */
export const enum TeacherClassesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IDENTIFIER = 'identifier',
  /** column name */
  LEVEL_ID = 'level_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "classrooms" */
export interface TeacherClassrooms {
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<TeacherCourseClassroom>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  floor: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<TeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<TeacherLessonsAggregate>;
  name: EntireFieldWrapper<Scalars['String']>;
  room: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<TeacherTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classrooms" */
export interface TeacherClassroomsCourseClassroomsArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassroomOrderBy>>;
  where?: Maybe<TeacherCourseClassroomBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface TeacherClassroomsLessonsArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface TeacherClassroomsLessonsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface TeacherClassroomsTeachersArgs {
  distinct_on?: Maybe<Array<TeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachersOrderBy>>;
  where?: Maybe<TeacherTeachersBoolExp>;
}

/** order by aggregate values of table "classrooms" */
export interface TeacherClassroomsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherClassroomsMaxOrderBy>;
  min?: Maybe<TeacherClassroomsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export interface TeacherClassroomsBoolExp {
  _and?: Maybe<Array<TeacherClassroomsBoolExp>>;
  _not?: Maybe<TeacherClassroomsBoolExp>;
  _or?: Maybe<Array<TeacherClassroomsBoolExp>>;
  course_classrooms?: Maybe<TeacherCourseClassroomBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  floor?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  lessons?: Maybe<TeacherLessonsBoolExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  room?: Maybe<TeacherStringComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  teachers?: Maybe<TeacherTeachersBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classrooms" */
export interface TeacherClassroomsMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  floor?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  room?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "classrooms" */
export interface TeacherClassroomsMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  floor?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  room?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "classrooms". */
export interface TeacherClassroomsOrderBy {
  course_classrooms_aggregate?: Maybe<TeacherCourseClassroomAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  floor?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lessons_aggregate?: Maybe<TeacherLessonsAggregateOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  room?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teachers_aggregate?: Maybe<TeacherTeachersAggregateOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "classrooms" */
export const enum TeacherClassroomsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FLOOR = 'floor',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ROOM = 'room',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_class" */
export interface TeacherCourseClass {
  /** An object relationship */
  class: EntireFieldWrapper<TeacherClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "course_class" */
export interface TeacherCourseClassAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherCourseClassAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherCourseClass>>;
}

/** aggregate fields of "course_class" */
export interface TeacherCourseClassAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherCourseClassMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherCourseClassMinFields>>;
}


/** aggregate fields of "course_class" */
export interface TeacherCourseClassAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "course_class" */
export interface TeacherCourseClassAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherCourseClassMaxOrderBy>;
  min?: Maybe<TeacherCourseClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_class". All fields are combined with a logical 'AND'. */
export interface TeacherCourseClassBoolExp {
  _and?: Maybe<Array<TeacherCourseClassBoolExp>>;
  _not?: Maybe<TeacherCourseClassBoolExp>;
  _or?: Maybe<Array<TeacherCourseClassBoolExp>>;
  class?: Maybe<TeacherClassesBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface TeacherCourseClassMaxFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "course_class" */
export interface TeacherCourseClassMaxOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherCourseClassMinFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "course_class" */
export interface TeacherCourseClassMinOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "course_class". */
export interface TeacherCourseClassOrderBy {
  class?: Maybe<TeacherClassesOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "course_class" */
export const enum TeacherCourseClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_classroom" */
export interface TeacherCourseClassroom {
  /** An object relationship */
  classroom: EntireFieldWrapper<TeacherClassrooms>;
  classroom_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_classroom" */
export interface TeacherCourseClassroomAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherCourseClassroomMaxOrderBy>;
  min?: Maybe<TeacherCourseClassroomMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_classroom". All fields are combined with a logical 'AND'. */
export interface TeacherCourseClassroomBoolExp {
  _and?: Maybe<Array<TeacherCourseClassroomBoolExp>>;
  _not?: Maybe<TeacherCourseClassroomBoolExp>;
  _or?: Maybe<Array<TeacherCourseClassroomBoolExp>>;
  classroom?: Maybe<TeacherClassroomsBoolExp>;
  classroom_id?: Maybe<TeacherUuidComparisonExp>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_classroom" */
export interface TeacherCourseClassroomMaxOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "course_classroom" */
export interface TeacherCourseClassroomMinOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "course_classroom". */
export interface TeacherCourseClassroomOrderBy {
  classroom?: Maybe<TeacherClassroomsOrderBy>;
  classroom_id?: Maybe<TeacherOrderBy>;
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "course_classroom" */
export const enum TeacherCourseClassroomSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_student" */
export interface TeacherCourseStudent {
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<TeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_student" */
export interface TeacherCourseStudentAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherCourseStudentMaxOrderBy>;
  min?: Maybe<TeacherCourseStudentMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_student". All fields are combined with a logical 'AND'. */
export interface TeacherCourseStudentBoolExp {
  _and?: Maybe<Array<TeacherCourseStudentBoolExp>>;
  _not?: Maybe<TeacherCourseStudentBoolExp>;
  _or?: Maybe<Array<TeacherCourseStudentBoolExp>>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_student" */
export interface TeacherCourseStudentMaxOrderBy {
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "course_student" */
export interface TeacherCourseStudentMinOrderBy {
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "course_student". */
export interface TeacherCourseStudentOrderBy {
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "course_student" */
export const enum TeacherCourseStudentSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_teacher" */
export interface TeacherCourseTeacher {
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_primary: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<TeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_teacher" */
export interface TeacherCourseTeacherAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherCourseTeacherMaxOrderBy>;
  min?: Maybe<TeacherCourseTeacherMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_teacher". All fields are combined with a logical 'AND'. */
export interface TeacherCourseTeacherBoolExp {
  _and?: Maybe<Array<TeacherCourseTeacherBoolExp>>;
  _not?: Maybe<TeacherCourseTeacherBoolExp>;
  _or?: Maybe<Array<TeacherCourseTeacherBoolExp>>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_primary?: Maybe<TeacherBooleanComparisonExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_teacher" */
export interface TeacherCourseTeacherMaxOrderBy {
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "course_teacher" */
export interface TeacherCourseTeacherMinOrderBy {
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "course_teacher". */
export interface TeacherCourseTeacherOrderBy {
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_primary?: Maybe<TeacherOrderBy>;
  teacher?: Maybe<TeacherTeachersOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "course_teacher" */
export const enum TeacherCourseTeacherSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRIMARY = 'is_primary',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "courses" */
export interface TeacherCourses {
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<TeacherBookCourse>>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<TeacherCourseClass>>;
  /** An aggregate relationship */
  course_classes_aggregate: EntireFieldWrapper<TeacherCourseClassAggregate>;
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<TeacherCourseClassroom>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<TeacherCourseTeacher>>;
  /** An array relationship */
  course_users: EntireFieldWrapper<Array<TeacherCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_mandatory: EntireFieldWrapper<Scalars['Boolean']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<TeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<TeacherLessonsAggregate>;
  /** An object relationship */
  semester: EntireFieldWrapper<TeacherSemesters>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<TeacherSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesBookCoursesArgs {
  distinct_on?: Maybe<Array<TeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookCourseOrderBy>>;
  where?: Maybe<TeacherBookCourseBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesCourseClassesArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesCourseClassesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesCourseClassroomsArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassroomOrderBy>>;
  where?: Maybe<TeacherCourseClassroomBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesCourseTeachersArgs {
  distinct_on?: Maybe<Array<TeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseTeacherOrderBy>>;
  where?: Maybe<TeacherCourseTeacherBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesCourseUsersArgs {
  distinct_on?: Maybe<Array<TeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseStudentOrderBy>>;
  where?: Maybe<TeacherCourseStudentBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesLessonsArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


/** columns and relationships of "courses" */
export interface TeacherCoursesLessonsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}

/** order by aggregate values of table "courses" */
export interface TeacherCoursesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherCoursesMaxOrderBy>;
  min?: Maybe<TeacherCoursesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export interface TeacherCoursesBoolExp {
  _and?: Maybe<Array<TeacherCoursesBoolExp>>;
  _not?: Maybe<TeacherCoursesBoolExp>;
  _or?: Maybe<Array<TeacherCoursesBoolExp>>;
  book_courses?: Maybe<TeacherBookCourseBoolExp>;
  course_classes?: Maybe<TeacherCourseClassBoolExp>;
  course_classrooms?: Maybe<TeacherCourseClassroomBoolExp>;
  course_teachers?: Maybe<TeacherCourseTeacherBoolExp>;
  course_users?: Maybe<TeacherCourseStudentBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_everybody?: Maybe<TeacherBooleanComparisonExp>;
  is_mandatory?: Maybe<TeacherBooleanComparisonExp>;
  lessons?: Maybe<TeacherLessonsBoolExp>;
  semester?: Maybe<TeacherSemestersBoolExp>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "courses" */
export interface TeacherCoursesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "courses" */
export interface TeacherCoursesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "courses". */
export interface TeacherCoursesOrderBy {
  book_courses_aggregate?: Maybe<TeacherBookCourseAggregateOrderBy>;
  course_classes_aggregate?: Maybe<TeacherCourseClassAggregateOrderBy>;
  course_classrooms_aggregate?: Maybe<TeacherCourseClassroomAggregateOrderBy>;
  course_teachers_aggregate?: Maybe<TeacherCourseTeacherAggregateOrderBy>;
  course_users_aggregate?: Maybe<TeacherCourseStudentAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_everybody?: Maybe<TeacherOrderBy>;
  is_mandatory?: Maybe<TeacherOrderBy>;
  lessons_aggregate?: Maybe<TeacherLessonsAggregateOrderBy>;
  semester?: Maybe<TeacherSemestersOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "courses" */
export const enum TeacherCoursesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_MANDATORY = 'is_mandatory',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface TeacherDateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** columns and relationships of "event_users" */
export interface TeacherEventUsers {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  event: EntireFieldWrapper<TeacherEvents>;
  event_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  paid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "event_users" */
export interface TeacherEventUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherEventUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherEventUsers>>;
}

/** aggregate fields of "event_users" */
export interface TeacherEventUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherEventUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherEventUsersMinFields>>;
}


/** aggregate fields of "event_users" */
export interface TeacherEventUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherEventUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export interface TeacherEventUsersBoolExp {
  _and?: Maybe<Array<TeacherEventUsersBoolExp>>;
  _not?: Maybe<TeacherEventUsersBoolExp>;
  _or?: Maybe<Array<TeacherEventUsersBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  event?: Maybe<TeacherEventsBoolExp>;
  event_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  paid?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "event_users" */
export const enum TeacherEventUsersConstraint {
  /** unique or primary key constraint */
  EVENT_USERS_PKEY = 'event_users_pkey'
};

/** input type for inserting data into table "event_users" */
export interface TeacherEventUsersInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<TeacherEventsObjRelInsertInput>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paid?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherEventUsersMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  event_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherEventUsersMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  event_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "event_users" */
export interface TeacherEventUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherEventUsers>>;
}

/** on conflict condition type for table "event_users" */
export interface TeacherEventUsersOnConflict {
  constraint: TeacherEventUsersConstraint;
  update_columns?: Array<TeacherEventUsersUpdateColumn>;
  where?: Maybe<TeacherEventUsersBoolExp>;
}

/** Ordering options when selecting data from "event_users". */
export interface TeacherEventUsersOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  event?: Maybe<TeacherEventsOrderBy>;
  event_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  paid?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: event_users */
export interface TeacherEventUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "event_users" */
export const enum TeacherEventUsersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "event_users" */
export interface TeacherEventUsersSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  paid?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "event_users" */
export const enum TeacherEventUsersUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "events" */
export interface TeacherEvents {
  cost: EntireFieldWrapper<Scalars['float8']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "events" */
export interface TeacherEventsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherEventsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherEvents>>;
}

/** aggregate fields of "events" */
export interface TeacherEventsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherEventsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherEventsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherEventsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherEventsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherEventsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherEventsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherEventsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherEventsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherEventsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherEventsVarianceFields>>;
}


/** aggregate fields of "events" */
export interface TeacherEventsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherEventsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface TeacherEventsAvgFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export interface TeacherEventsBoolExp {
  _and?: Maybe<Array<TeacherEventsBoolExp>>;
  _not?: Maybe<TeacherEventsBoolExp>;
  _or?: Maybe<Array<TeacherEventsBoolExp>>;
  cost?: Maybe<TeacherFloat8ComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  date?: Maybe<TeacherTimestamptzComparisonExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  status?: Maybe<TeacherStringComparisonExp>;
  time?: Maybe<TeacherIntComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "events" */
export const enum TeacherEventsConstraint {
  /** unique or primary key constraint */
  EVENTS_PKEY = 'events_pkey'
};

/** input type for incrementing numeric columns in table "events" */
export interface TeacherEventsIncInput {
  cost?: Maybe<Scalars['float8']>;
  time?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "events" */
export interface TeacherEventsInsertInput {
  cost?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface TeacherEventsMaxFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['float8']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherEventsMinFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['float8']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "events" */
export interface TeacherEventsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherEvents>>;
}

/** input type for inserting object relation for remote table "events" */
export interface TeacherEventsObjRelInsertInput {
  data: TeacherEventsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherEventsOnConflict>;
}

/** on conflict condition type for table "events" */
export interface TeacherEventsOnConflict {
  constraint: TeacherEventsConstraint;
  update_columns?: Array<TeacherEventsUpdateColumn>;
  where?: Maybe<TeacherEventsBoolExp>;
}

/** Ordering options when selecting data from "events". */
export interface TeacherEventsOrderBy {
  cost?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  date?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  time?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: events */
export interface TeacherEventsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "events" */
export const enum TeacherEventsSelectColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "events" */
export interface TeacherEventsSetInput {
  cost?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate stddev on columns */
export interface TeacherEventsStddevFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface TeacherEventsStddevPopFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface TeacherEventsStddevSampFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface TeacherEventsSumFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['float8']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** update columns of table "events" */
export const enum TeacherEventsUpdateColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate var_pop on columns */
export interface TeacherEventsVarPopFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface TeacherEventsVarSampFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface TeacherEventsVarianceFields {
  cost?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** input type for inserting data into table "example" */
export interface TeacherExampleInsertInput {
  hello_one?: Maybe<Scalars['Int']>;
}

/** response of any mutation on the table "example" */
export interface TeacherExampleMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
}

export const enum TeacherFileTableTypesEnum {
  ASSIGNMENT_SUBMITS = 'assignment_submits',
  ASSIGNMENTS = 'assignments',
  CHATS = 'chats',
  PROFILE_PICTURES = 'profile_pictures'
};

/** Boolean expression to compare columns of type "file_table_types_enum". All fields are combined with logical 'AND'. */
export interface TeacherFileTableTypesEnumComparisonExp {
  _eq?: Maybe<TeacherFileTableTypesEnum>;
  _in?: Maybe<Array<TeacherFileTableTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<TeacherFileTableTypesEnum>;
  _nin?: Maybe<Array<TeacherFileTableTypesEnum>>;
}

/** columns and relationships of "files" */
export interface TeacherFiles {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  file_name: EntireFieldWrapper<Scalars['String']>;
  foreign_id: EntireFieldWrapper<Scalars['uuid']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  table: EntireFieldWrapper<TeacherFileTableTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "files" */
export interface TeacherFilesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherFilesMaxOrderBy>;
  min?: Maybe<TeacherFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface TeacherFilesBoolExp {
  _and?: Maybe<Array<TeacherFilesBoolExp>>;
  _not?: Maybe<TeacherFilesBoolExp>;
  _or?: Maybe<Array<TeacherFilesBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  file_name?: Maybe<TeacherStringComparisonExp>;
  foreign_id?: Maybe<TeacherUuidComparisonExp>;
  hash?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  path?: Maybe<TeacherStringComparisonExp>;
  table?: Maybe<TeacherFileTableTypesEnumComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "files" */
export interface TeacherFilesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  file_name?: Maybe<TeacherOrderBy>;
  foreign_id?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "files" */
export interface TeacherFilesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  file_name?: Maybe<TeacherOrderBy>;
  foreign_id?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "files" */
export interface TeacherFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherFiles>>;
}

/** Ordering options when selecting data from "files". */
export interface TeacherFilesOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  file_name?: Maybe<TeacherOrderBy>;
  foreign_id?: Maybe<TeacherOrderBy>;
  hash?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  table?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "files" */
export const enum TeacherFilesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE_NAME = 'file_name',
  /** column name */
  FOREIGN_ID = 'foreign_id',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TABLE = 'table',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface TeacherFloat8ComparisonExp {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
}

/** columns and relationships of "grade_types" */
export interface TeacherGradeTypes {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<TeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<TeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<TeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<TeacherViewGradesAggregate>;
}


/** columns and relationships of "grade_types" */
export interface TeacherGradeTypesGradeTypesArgs {
  distinct_on?: Maybe<Array<TeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradeTypesOrderBy>>;
  where?: Maybe<TeacherGradeTypesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface TeacherGradeTypesGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface TeacherGradeTypesGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface TeacherGradeTypesViewGradesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface TeacherGradeTypesViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}

/** order by aggregate values of table "grade_types" */
export interface TeacherGradeTypesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherGradeTypesMaxOrderBy>;
  min?: Maybe<TeacherGradeTypesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "grade_types". All fields are combined with a logical 'AND'. */
export interface TeacherGradeTypesBoolExp {
  _and?: Maybe<Array<TeacherGradeTypesBoolExp>>;
  _not?: Maybe<TeacherGradeTypesBoolExp>;
  _or?: Maybe<Array<TeacherGradeTypesBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grade_type?: Maybe<TeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<TeacherUuidComparisonExp>;
  grade_types?: Maybe<TeacherGradeTypesBoolExp>;
  grades?: Maybe<TeacherGradesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  view_grades?: Maybe<TeacherViewGradesBoolExp>;
}

/** order by max() on columns of table "grade_types" */
export interface TeacherGradeTypesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "grade_types" */
export interface TeacherGradeTypesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "grade_types". */
export interface TeacherGradeTypesOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  grade_type?: Maybe<TeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  grade_types_aggregate?: Maybe<TeacherGradeTypesAggregateOrderBy>;
  grades_aggregate?: Maybe<TeacherGradesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  view_grades_aggregate?: Maybe<TeacherViewGradesAggregateOrderBy>;
}

/** select columns of table "grade_types" */
export const enum TeacherGradeTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "grades" */
export interface TeacherGrades {
  /** An object relationship */
  assignment: EntireFieldWrapper<TeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<TeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student: EntireFieldWrapper<TeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  weight: EntireFieldWrapper<Scalars['Int']>;
}

/** aggregated selection of "grades" */
export interface TeacherGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherGrades>>;
}

/** aggregate fields of "grades" */
export interface TeacherGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherGradesVarianceFields>>;
}


/** aggregate fields of "grades" */
export interface TeacherGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "grades" */
export interface TeacherGradesAggregateOrderBy {
  avg?: Maybe<TeacherGradesAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherGradesMaxOrderBy>;
  min?: Maybe<TeacherGradesMinOrderBy>;
  stddev?: Maybe<TeacherGradesStddevOrderBy>;
  stddev_pop?: Maybe<TeacherGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherGradesStddevSampOrderBy>;
  sum?: Maybe<TeacherGradesSumOrderBy>;
  var_pop?: Maybe<TeacherGradesVarPopOrderBy>;
  var_samp?: Maybe<TeacherGradesVarSampOrderBy>;
  variance?: Maybe<TeacherGradesVarianceOrderBy>;
}

/** input type for inserting array relation for remote table "grades" */
export interface TeacherGradesArrRelInsertInput {
  data: Array<TeacherGradesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherGradesOnConflict>;
}

/** aggregate avg on columns */
export interface TeacherGradesAvgFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "grades" */
export interface TeacherGradesAvgOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "grades". All fields are combined with a logical 'AND'. */
export interface TeacherGradesBoolExp {
  _and?: Maybe<Array<TeacherGradesBoolExp>>;
  _not?: Maybe<TeacherGradesBoolExp>;
  _or?: Maybe<Array<TeacherGradesBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grade_type?: Maybe<TeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  mark?: Maybe<TeacherMarksBoolExp>;
  mark_id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  weight?: Maybe<TeacherIntComparisonExp>;
}

/** unique or primary key constraints on table "grades" */
export const enum TeacherGradesConstraint {
  /** unique or primary key constraint */
  GRADES_PKEY = 'grades_pkey'
};

/** input type for incrementing numeric columns in table "grades" */
export interface TeacherGradesIncInput {
  weight?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "grades" */
export interface TeacherGradesInsertInput {
  assignment?: Maybe<TeacherAssignmentsObjRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mark_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
}

/** aggregate max on columns */
export interface TeacherGradesMaxFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "grades" */
export interface TeacherGradesMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherGradesMinFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "grades" */
export interface TeacherGradesMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "grades" */
export interface TeacherGradesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherGrades>>;
}

/** on conflict condition type for table "grades" */
export interface TeacherGradesOnConflict {
  constraint: TeacherGradesConstraint;
  update_columns?: Array<TeacherGradesUpdateColumn>;
  where?: Maybe<TeacherGradesBoolExp>;
}

/** Ordering options when selecting data from "grades". */
export interface TeacherGradesOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grade_type?: Maybe<TeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark?: Maybe<TeacherMarksOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: grades */
export interface TeacherGradesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "grades" */
export const enum TeacherGradesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** input type for updating data in table "grades" */
export interface TeacherGradesSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grade_type_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mark_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight?: Maybe<Scalars['Int']>;
}

/** aggregate stddev on columns */
export interface TeacherGradesStddevFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "grades" */
export interface TeacherGradesStddevOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeacherGradesStddevPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "grades" */
export interface TeacherGradesStddevPopOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeacherGradesStddevSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "grades" */
export interface TeacherGradesStddevSampOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate sum on columns */
export interface TeacherGradesSumFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "grades" */
export interface TeacherGradesSumOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** update columns of table "grades" */
export const enum TeacherGradesUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate var_pop on columns */
export interface TeacherGradesVarPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "grades" */
export interface TeacherGradesVarPopOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface TeacherGradesVarSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "grades" */
export interface TeacherGradesVarSampOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate variance on columns */
export interface TeacherGradesVarianceFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "grades" */
export interface TeacherGradesVarianceOrderBy {
  weight?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "latest_activities" */
export interface TeacherLatestActivities {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  message: EntireFieldWrapper<Scalars['String']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "latest_activities". All fields are combined with a logical 'AND'. */
export interface TeacherLatestActivitiesBoolExp {
  _and?: Maybe<Array<TeacherLatestActivitiesBoolExp>>;
  _not?: Maybe<TeacherLatestActivitiesBoolExp>;
  _or?: Maybe<Array<TeacherLatestActivitiesBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  message?: Maybe<TeacherStringComparisonExp>;
  path?: Maybe<TeacherStringComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "latest_activities". */
export interface TeacherLatestActivitiesOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  message?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "latest_activities" */
export const enum TeacherLatestActivitiesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  PATH = 'path',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lesson_attendace_type" */
export interface TeacherLessonAttendaceType {
  name: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "lesson_attendace_type". All fields are combined with a logical 'AND'. */
export interface TeacherLessonAttendaceTypeBoolExp {
  _and?: Maybe<Array<TeacherLessonAttendaceTypeBoolExp>>;
  _not?: Maybe<TeacherLessonAttendaceTypeBoolExp>;
  _or?: Maybe<Array<TeacherLessonAttendaceTypeBoolExp>>;
  name?: Maybe<TeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "lesson_attendace_type". */
export interface TeacherLessonAttendaceTypeOrderBy {
  name?: Maybe<TeacherOrderBy>;
}

/** select columns of table "lesson_attendace_type" */
export const enum TeacherLessonAttendaceTypeSelectColumn {
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "lesson_attendances" */
export interface TeacherLessonAttendances {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  lesson: EntireFieldWrapper<TeacherLessons>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "lesson_attendances" */
export interface TeacherLessonAttendancesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherLessonAttendancesMaxOrderBy>;
  min?: Maybe<TeacherLessonAttendancesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "lesson_attendances". All fields are combined with a logical 'AND'. */
export interface TeacherLessonAttendancesBoolExp {
  _and?: Maybe<Array<TeacherLessonAttendancesBoolExp>>;
  _not?: Maybe<TeacherLessonAttendancesBoolExp>;
  _or?: Maybe<Array<TeacherLessonAttendancesBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  lesson?: Maybe<TeacherLessonsBoolExp>;
  lesson_id?: Maybe<TeacherUuidComparisonExp>;
  type?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "lesson_attendances" */
export const enum TeacherLessonAttendancesConstraint {
  /** unique or primary key constraint */
  ATTENDACES_PKEY = 'attendaces_pkey'
};

/** input type for inserting data into table "lesson_attendances" */
export interface TeacherLessonAttendancesInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "lesson_attendances" */
export interface TeacherLessonAttendancesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "lesson_attendances" */
export interface TeacherLessonAttendancesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "lesson_attendances" */
export interface TeacherLessonAttendancesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherLessonAttendances>>;
}

/** on conflict condition type for table "lesson_attendances" */
export interface TeacherLessonAttendancesOnConflict {
  constraint: TeacherLessonAttendancesConstraint;
  update_columns?: Array<TeacherLessonAttendancesUpdateColumn>;
  where?: Maybe<TeacherLessonAttendancesBoolExp>;
}

/** Ordering options when selecting data from "lesson_attendances". */
export interface TeacherLessonAttendancesOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson?: Maybe<TeacherLessonsOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: lesson_attendances */
export interface TeacherLessonAttendancesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "lesson_attendances" */
export const enum TeacherLessonAttendancesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "lesson_attendances" */
export interface TeacherLessonAttendancesSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "lesson_attendances" */
export const enum TeacherLessonAttendancesUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lessons" */
export interface TeacherLessons {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  /** An array relationship */
  attendaces: EntireFieldWrapper<Array<TeacherLessonAttendances>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<TeacherClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  course: EntireFieldWrapper<TeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_online: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_classes?: EntireFieldWrapper<Maybe<TeacherLiveClasses>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "lessons" */
export interface TeacherLessonsAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface TeacherLessonsAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface TeacherLessonsAttendacesArgs {
  distinct_on?: Maybe<Array<TeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonAttendancesOrderBy>>;
  where?: Maybe<TeacherLessonAttendancesBoolExp>;
}

/** aggregated selection of "lessons" */
export interface TeacherLessonsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherLessonsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherLessons>>;
}

/** aggregate fields of "lessons" */
export interface TeacherLessonsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherLessonsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherLessonsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherLessonsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherLessonsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherLessonsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherLessonsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherLessonsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherLessonsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherLessonsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherLessonsVarianceFields>>;
}


/** aggregate fields of "lessons" */
export interface TeacherLessonsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherLessonsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "lessons" */
export interface TeacherLessonsAggregateOrderBy {
  avg?: Maybe<TeacherLessonsAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherLessonsMaxOrderBy>;
  min?: Maybe<TeacherLessonsMinOrderBy>;
  stddev?: Maybe<TeacherLessonsStddevOrderBy>;
  stddev_pop?: Maybe<TeacherLessonsStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherLessonsStddevSampOrderBy>;
  sum?: Maybe<TeacherLessonsSumOrderBy>;
  var_pop?: Maybe<TeacherLessonsVarPopOrderBy>;
  var_samp?: Maybe<TeacherLessonsVarSampOrderBy>;
  variance?: Maybe<TeacherLessonsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface TeacherLessonsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "lessons" */
export interface TeacherLessonsAvgOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export interface TeacherLessonsBoolExp {
  _and?: Maybe<Array<TeacherLessonsBoolExp>>;
  _not?: Maybe<TeacherLessonsBoolExp>;
  _or?: Maybe<Array<TeacherLessonsBoolExp>>;
  assignments?: Maybe<TeacherAssignmentsBoolExp>;
  attendaces?: Maybe<TeacherLessonAttendancesBoolExp>;
  classroom?: Maybe<TeacherClassroomsBoolExp>;
  classroom_id?: Maybe<TeacherUuidComparisonExp>;
  course?: Maybe<TeacherCoursesBoolExp>;
  course_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  duration?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_online?: Maybe<TeacherBooleanComparisonExp>;
  live_classes?: Maybe<TeacherLiveClassesBoolExp>;
  start_at?: Maybe<TeacherTimetzComparisonExp>;
  start_date?: Maybe<TeacherDateComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface TeacherLessonsMaxFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "lessons" */
export interface TeacherLessonsMaxOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  start_at?: Maybe<TeacherOrderBy>;
  start_date?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherLessonsMinFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "lessons" */
export interface TeacherLessonsMinOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  start_at?: Maybe<TeacherOrderBy>;
  start_date?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "lessons". */
export interface TeacherLessonsOrderBy {
  assignments_aggregate?: Maybe<TeacherAssignmentsAggregateOrderBy>;
  attendaces_aggregate?: Maybe<TeacherLessonAttendancesAggregateOrderBy>;
  classroom?: Maybe<TeacherClassroomsOrderBy>;
  classroom_id?: Maybe<TeacherOrderBy>;
  course?: Maybe<TeacherCoursesOrderBy>;
  course_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_online?: Maybe<TeacherOrderBy>;
  live_classes?: Maybe<TeacherLiveClassesOrderBy>;
  start_at?: Maybe<TeacherOrderBy>;
  start_date?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "lessons" */
export const enum TeacherLessonsSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ONLINE = 'is_online',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface TeacherLessonsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "lessons" */
export interface TeacherLessonsStddevOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeacherLessonsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "lessons" */
export interface TeacherLessonsStddevPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeacherLessonsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "lessons" */
export interface TeacherLessonsStddevSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate sum on columns */
export interface TeacherLessonsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "lessons" */
export interface TeacherLessonsSumOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface TeacherLessonsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "lessons" */
export interface TeacherLessonsVarPopOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface TeacherLessonsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "lessons" */
export interface TeacherLessonsVarSampOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** aggregate variance on columns */
export interface TeacherLessonsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "lessons" */
export interface TeacherLessonsVarianceOrderBy {
  duration?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "live_class_attendees" */
export interface TeacherLiveClassAttendees {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_present: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_class: EntireFieldWrapper<TeacherLiveClasses>;
  live_class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  students?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "live_class_attendees" */
export interface TeacherLiveClassAttendeesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherLiveClassAttendees>>;
}

/** aggregate fields of "live_class_attendees" */
export interface TeacherLiveClassAttendeesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesMinFields>>;
}


/** aggregate fields of "live_class_attendees" */
export interface TeacherLiveClassAttendeesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "live_class_attendees" */
export interface TeacherLiveClassAttendeesAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherLiveClassAttendeesMaxOrderBy>;
  min?: Maybe<TeacherLiveClassAttendeesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "live_class_attendees". All fields are combined with a logical 'AND'. */
export interface TeacherLiveClassAttendeesBoolExp {
  _and?: Maybe<Array<TeacherLiveClassAttendeesBoolExp>>;
  _not?: Maybe<TeacherLiveClassAttendeesBoolExp>;
  _or?: Maybe<Array<TeacherLiveClassAttendeesBoolExp>>;
  group_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_present?: Maybe<TeacherBooleanComparisonExp>;
  live_class?: Maybe<TeacherLiveClassesBoolExp>;
  live_class_id?: Maybe<TeacherUuidComparisonExp>;
  students?: Maybe<TeacherStudentsBoolExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "live_class_attendees" */
export const enum TeacherLiveClassAttendeesConstraint {
  /** unique or primary key constraint */
  LIVE_CLASS_ATTENDEES_PKEY = 'live_class_attendees_pkey'
};

/** input type for inserting data into table "live_class_attendees" */
export interface TeacherLiveClassAttendeesInsertInput {
  group_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_present?: Maybe<Scalars['Boolean']>;
  live_class_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherLiveClassAttendeesMaxFields {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  live_class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "live_class_attendees" */
export interface TeacherLiveClassAttendeesMaxOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  live_class_id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherLiveClassAttendeesMinFields {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  live_class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "live_class_attendees" */
export interface TeacherLiveClassAttendeesMinOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  live_class_id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "live_class_attendees" */
export interface TeacherLiveClassAttendeesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherLiveClassAttendees>>;
}

/** on conflict condition type for table "live_class_attendees" */
export interface TeacherLiveClassAttendeesOnConflict {
  constraint: TeacherLiveClassAttendeesConstraint;
  update_columns?: Array<TeacherLiveClassAttendeesUpdateColumn>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}

/** Ordering options when selecting data from "live_class_attendees". */
export interface TeacherLiveClassAttendeesOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_present?: Maybe<TeacherOrderBy>;
  live_class?: Maybe<TeacherLiveClassesOrderBy>;
  live_class_id?: Maybe<TeacherOrderBy>;
  students?: Maybe<TeacherStudentsOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: live_class_attendees */
export interface TeacherLiveClassAttendeesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "live_class_attendees" */
export const enum TeacherLiveClassAttendeesSelectColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRESENT = 'is_present',
  /** column name */
  LIVE_CLASS_ID = 'live_class_id',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "live_class_attendees" */
export interface TeacherLiveClassAttendeesSetInput {
  group_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_present?: Maybe<Scalars['Boolean']>;
  live_class_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "live_class_attendees" */
export const enum TeacherLiveClassAttendeesUpdateColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRESENT = 'is_present',
  /** column name */
  LIVE_CLASS_ID = 'live_class_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "live_classes" */
export interface TeacherLiveClasses {
  attendeePW: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<TeacherLiveClassAttendees>>;
  /** An aggregate relationship */
  live_class_attendees_aggregate: EntireFieldWrapper<TeacherLiveClassAttendeesAggregate>;
  meetingID: EntireFieldWrapper<Scalars['String']>;
  moderatorPW: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}


/** columns and relationships of "live_classes" */
export interface TeacherLiveClassesLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}


/** columns and relationships of "live_classes" */
export interface TeacherLiveClassesLiveClassAttendeesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}

/** aggregated selection of "live_classes" */
export interface TeacherLiveClassesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherLiveClassesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherLiveClasses>>;
}

/** aggregate fields of "live_classes" */
export interface TeacherLiveClassesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherLiveClassesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherLiveClassesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherLiveClassesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherLiveClassesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherLiveClassesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherLiveClassesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherLiveClassesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherLiveClassesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherLiveClassesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherLiveClassesVarianceFields>>;
}


/** aggregate fields of "live_classes" */
export interface TeacherLiveClassesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherLiveClassesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface TeacherLiveClassesAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "live_classes". All fields are combined with a logical 'AND'. */
export interface TeacherLiveClassesBoolExp {
  _and?: Maybe<Array<TeacherLiveClassesBoolExp>>;
  _not?: Maybe<TeacherLiveClassesBoolExp>;
  _or?: Maybe<Array<TeacherLiveClassesBoolExp>>;
  attendeePW?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  description?: Maybe<TeacherStringComparisonExp>;
  duration?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  lesson_id?: Maybe<TeacherUuidComparisonExp>;
  live_class_attendees?: Maybe<TeacherLiveClassAttendeesBoolExp>;
  meetingID?: Maybe<TeacherStringComparisonExp>;
  moderatorPW?: Maybe<TeacherStringComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  recording_private_id?: Maybe<TeacherIntComparisonExp>;
  starting_at?: Maybe<TeacherTimestamptzComparisonExp>;
  status?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  voice_bridge?: Maybe<TeacherStringComparisonExp>;
}

/** input type for incrementing numeric columns in table "live_classes" */
export interface TeacherLiveClassesIncInput {
  duration?: Maybe<Scalars['Int']>;
  recording_private_id?: Maybe<Scalars['Int']>;
}

/** aggregate max on columns */
export interface TeacherLiveClassesMaxFields {
  attendeePW?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meetingID?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  moderatorPW?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface TeacherLiveClassesMinFields {
  attendeePW?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meetingID?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  moderatorPW?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "live_classes" */
export interface TeacherLiveClassesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherLiveClasses>>;
}

/** Ordering options when selecting data from "live_classes". */
export interface TeacherLiveClassesOrderBy {
  attendeePW?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  description?: Maybe<TeacherOrderBy>;
  duration?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  live_class_attendees_aggregate?: Maybe<TeacherLiveClassAttendeesAggregateOrderBy>;
  meetingID?: Maybe<TeacherOrderBy>;
  moderatorPW?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  recording_private_id?: Maybe<TeacherOrderBy>;
  starting_at?: Maybe<TeacherOrderBy>;
  status?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  voice_bridge?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: live_classes */
export interface TeacherLiveClassesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "live_classes" */
export const enum TeacherLiveClassesSelectColumn {
  /** column name */
  ATTENDEEPW = 'attendeePW',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  MEETINGID = 'meetingID',
  /** column name */
  MODERATORPW = 'moderatorPW',
  /** column name */
  NAME = 'name',
  /** column name */
  RECORDING_PRIVATE_ID = 'recording_private_id',
  /** column name */
  STARTING_AT = 'starting_at',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VOICE_BRIDGE = 'voice_bridge'
};

/** input type for updating data in table "live_classes" */
export interface TeacherLiveClassesSetInput {
  attendeePW?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  meetingID?: Maybe<Scalars['String']>;
  moderatorPW?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  recording_private_id?: Maybe<Scalars['Int']>;
  starting_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  voice_bridge?: Maybe<Scalars['String']>;
}

/** aggregate stddev on columns */
export interface TeacherLiveClassesStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface TeacherLiveClassesStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface TeacherLiveClassesStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface TeacherLiveClassesSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregate var_pop on columns */
export interface TeacherLiveClassesVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface TeacherLiveClassesVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface TeacherLiveClassesVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** columns and relationships of "marks" */
export interface TeacherMarks {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  value: EntireFieldWrapper<Scalars['Int']>;
}


/** columns and relationships of "marks" */
export interface TeacherMarksGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


/** columns and relationships of "marks" */
export interface TeacherMarksGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "marks". All fields are combined with a logical 'AND'. */
export interface TeacherMarksBoolExp {
  _and?: Maybe<Array<TeacherMarksBoolExp>>;
  _not?: Maybe<TeacherMarksBoolExp>;
  _or?: Maybe<Array<TeacherMarksBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grades?: Maybe<TeacherGradesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  value?: Maybe<TeacherIntComparisonExp>;
}

/** Ordering options when selecting data from "marks". */
export interface TeacherMarksOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  grades_aggregate?: Maybe<TeacherGradesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
}

/** select columns of table "marks" */
export const enum TeacherMarksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "meeting_groups" */
export interface TeacherMeetingGroups {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  meeting_groups_students: EntireFieldWrapper<Array<TeacherMeetingGroupsStudent>>;
  name: EntireFieldWrapper<Scalars['String']>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "meeting_groups" */
export interface TeacherMeetingGroupsMeetingGroupsStudentsArgs {
  distinct_on?: Maybe<Array<TeacherMeetingGroupsStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingGroupsStudentOrderBy>>;
  where?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
}

/** Boolean expression to filter rows from the table "meeting_groups". All fields are combined with a logical 'AND'. */
export interface TeacherMeetingGroupsBoolExp {
  _and?: Maybe<Array<TeacherMeetingGroupsBoolExp>>;
  _not?: Maybe<TeacherMeetingGroupsBoolExp>;
  _or?: Maybe<Array<TeacherMeetingGroupsBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  meeting_groups_students?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "meeting_groups" */
export const enum TeacherMeetingGroupsConstraint {
  /** unique or primary key constraint */
  LIVE_CLASS_GROUPS_PKEY = 'live_class_groups_pkey'
};

/** input type for inserting data into table "meeting_groups" */
export interface TeacherMeetingGroupsInsertInput {
  meeting_groups_students?: Maybe<TeacherMeetingGroupsStudentArrRelInsertInput>;
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "meeting_groups" */
export interface TeacherMeetingGroupsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherMeetingGroups>>;
}

/** input type for inserting object relation for remote table "meeting_groups" */
export interface TeacherMeetingGroupsObjRelInsertInput {
  data: TeacherMeetingGroupsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherMeetingGroupsOnConflict>;
}

/** on conflict condition type for table "meeting_groups" */
export interface TeacherMeetingGroupsOnConflict {
  constraint: TeacherMeetingGroupsConstraint;
  update_columns?: Array<TeacherMeetingGroupsUpdateColumn>;
  where?: Maybe<TeacherMeetingGroupsBoolExp>;
}

/** Ordering options when selecting data from "meeting_groups". */
export interface TeacherMeetingGroupsOrderBy {
  id?: Maybe<TeacherOrderBy>;
  meeting_groups_students_aggregate?: Maybe<TeacherMeetingGroupsStudentAggregateOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: meeting_groups */
export interface TeacherMeetingGroupsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "meeting_groups" */
export const enum TeacherMeetingGroupsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** input type for updating data in table "meeting_groups" */
export interface TeacherMeetingGroupsSetInput {
  name?: Maybe<Scalars['String']>;
  teacher_id?: Maybe<Scalars['uuid']>;
}

/**
 * I would suggest to name the table as user_group. As it's not related at all with a meeting and also it's not related to a student. Please respect the naming.
 *
 *
 * columns and relationships of "meeting_groups_student"
 */
export interface TeacherMeetingGroupsStudent {
  group_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  meeting_group: EntireFieldWrapper<TeacherMeetingGroups>;
  /** An object relationship */
  student: EntireFieldWrapper<TeacherStudents>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherMeetingGroupsStudentMaxOrderBy>;
  min?: Maybe<TeacherMeetingGroupsStudentMinOrderBy>;
}

/** input type for inserting array relation for remote table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentArrRelInsertInput {
  data: Array<TeacherMeetingGroupsStudentInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherMeetingGroupsStudentOnConflict>;
}

/** Boolean expression to filter rows from the table "meeting_groups_student". All fields are combined with a logical 'AND'. */
export interface TeacherMeetingGroupsStudentBoolExp {
  _and?: Maybe<Array<TeacherMeetingGroupsStudentBoolExp>>;
  _not?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
  _or?: Maybe<Array<TeacherMeetingGroupsStudentBoolExp>>;
  group_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  meeting_group?: Maybe<TeacherMeetingGroupsBoolExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "meeting_groups_student" */
export const enum TeacherMeetingGroupsStudentConstraint {
  /** unique or primary key constraint */
  MEETING_GROUPS_STUDENT_PKEY = 'meeting_groups_student_pkey'
};

/** input type for inserting data into table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentInsertInput {
  group_id?: Maybe<Scalars['uuid']>;
  meeting_group?: Maybe<TeacherMeetingGroupsObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentMaxOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentMinOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherMeetingGroupsStudent>>;
}

/** on conflict condition type for table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentOnConflict {
  constraint: TeacherMeetingGroupsStudentConstraint;
  update_columns?: Array<TeacherMeetingGroupsStudentUpdateColumn>;
  where?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
}

/** Ordering options when selecting data from "meeting_groups_student". */
export interface TeacherMeetingGroupsStudentOrderBy {
  group_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  meeting_group?: Maybe<TeacherMeetingGroupsOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: meeting_groups_student */
export interface TeacherMeetingGroupsStudentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "meeting_groups_student" */
export const enum TeacherMeetingGroupsStudentSelectColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "meeting_groups_student" */
export interface TeacherMeetingGroupsStudentSetInput {
  group_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "meeting_groups_student" */
export const enum TeacherMeetingGroupsStudentUpdateColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** update columns of table "meeting_groups" */
export const enum TeacherMeetingGroupsUpdateColumn {
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "meeting_user" */
export interface TeacherMeetingUser {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  meeting_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "meeting_user" */
export interface TeacherMeetingUserAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherMeetingUserAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherMeetingUser>>;
}

/** aggregate fields of "meeting_user" */
export interface TeacherMeetingUserAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherMeetingUserMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherMeetingUserMinFields>>;
}


/** aggregate fields of "meeting_user" */
export interface TeacherMeetingUserAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherMeetingUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "meeting_user". All fields are combined with a logical 'AND'. */
export interface TeacherMeetingUserBoolExp {
  _and?: Maybe<Array<TeacherMeetingUserBoolExp>>;
  _not?: Maybe<TeacherMeetingUserBoolExp>;
  _or?: Maybe<Array<TeacherMeetingUserBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  meeting_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** input type for inserting data into table "meeting_user" */
export interface TeacherMeetingUserInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  meeting_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherMeetingUserMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherMeetingUserMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "meeting_user" */
export interface TeacherMeetingUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherMeetingUser>>;
}

/** Ordering options when selecting data from "meeting_user". */
export interface TeacherMeetingUserOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  meeting_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "meeting_user" */
export const enum TeacherMeetingUserSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MEETING_ID = 'meeting_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** mutation root */
export interface TeacherMutationRoot {
  change_password?: EntireFieldWrapper<Maybe<TeacherMessageResponse>>;
  create_live_class?: EntireFieldWrapper<Maybe<TeacherBbbJoinLink>>;
  /** delete data from the table: "assignment_discussion" */
  delete_assignment_discussion?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionMutationResponse>>;
  /** delete single row from the table: "assignment_discussion" */
  delete_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussion>>;
  /** delete data from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContentMutationResponse>>;
  /** delete single row from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** delete data from the table: "assignment_files" */
  delete_assignment_files?: EntireFieldWrapper<Maybe<TeacherAssignmentFilesMutationResponse>>;
  /** delete single row from the table: "assignment_files" */
  delete_assignment_files_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentFiles>>;
  /** delete data from the table: "assignment_notes" */
  delete_assignment_notes?: EntireFieldWrapper<Maybe<TeacherAssignmentNotesMutationResponse>>;
  /** delete single row from the table: "assignment_notes" */
  delete_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentNotes>>;
  /** delete data from the table: "assignment_question_option_relations" */
  delete_assignment_question_option_relations?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelationsMutationResponse>>;
  /** delete single row from the table: "assignment_question_option_relations" */
  delete_assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelations>>;
  /** delete data from the table: "assignment_question_options" */
  delete_assignment_question_options?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionsMutationResponse>>;
  /** delete single row from the table: "assignment_question_options" */
  delete_assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** delete data from the table: "assignment_questions" */
  delete_assignment_questions?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionsMutationResponse>>;
  /** delete single row from the table: "assignment_questions" */
  delete_assignment_questions_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestions>>;
  /** delete data from the table: "assignment_quiz" */
  delete_assignment_quiz?: EntireFieldWrapper<Maybe<TeacherAssignmentQuizMutationResponse>>;
  /** delete single row from the table: "assignment_quiz" */
  delete_assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** delete data from the table: "assignment_user" */
  delete_assignment_user?: EntireFieldWrapper<Maybe<TeacherAssignmentUserMutationResponse>>;
  /** delete single row from the table: "assignment_user" */
  delete_assignment_user_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentUser>>;
  /** delete data from the table: "assignments" */
  delete_assignments?: EntireFieldWrapper<Maybe<TeacherAssignmentsMutationResponse>>;
  /** delete single row from the table: "assignments" */
  delete_assignments_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  /** delete data from the table: "attendances" */
  delete_attendances?: EntireFieldWrapper<Maybe<TeacherAttendancesMutationResponse>>;
  /** delete single row from the table: "attendances" */
  delete_attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendances>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<TeacherAuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<TeacherAuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<TeacherAuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRoles>>;
  /** delete data from the table: "chat_message_likes" */
  delete_chat_message_likes?: EntireFieldWrapper<Maybe<TeacherChatMessageLikesMutationResponse>>;
  /** delete single row from the table: "chat_message_likes" */
  delete_chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageLikes>>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: EntireFieldWrapper<Maybe<TeacherChatMessagesMutationResponse>>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  /** delete data from the table: "chats" */
  delete_chats?: EntireFieldWrapper<Maybe<TeacherChatsMutationResponse>>;
  /** delete single row from the table: "chats" */
  delete_chats_by_pk?: EntireFieldWrapper<Maybe<TeacherChats>>;
  /** delete data from the table: "event_users" */
  delete_event_users?: EntireFieldWrapper<Maybe<TeacherEventUsersMutationResponse>>;
  /** delete single row from the table: "event_users" */
  delete_event_users_by_pk?: EntireFieldWrapper<Maybe<TeacherEventUsers>>;
  /** delete data from the table: "events" */
  delete_events?: EntireFieldWrapper<Maybe<TeacherEventsMutationResponse>>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: EntireFieldWrapper<Maybe<TeacherEvents>>;
  /** delete data from the table: "files" */
  delete_files?: EntireFieldWrapper<Maybe<TeacherFilesMutationResponse>>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: EntireFieldWrapper<Maybe<TeacherFiles>>;
  delete_live_class?: EntireFieldWrapper<Maybe<TeacherDelseteResponse>>;
  /** delete data from the table: "live_class_attendees" */
  delete_live_class_attendees?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesMutationResponse>>;
  /** delete single row from the table: "live_class_attendees" */
  delete_live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendees>>;
  /** delete data from the table: "live_classes" */
  delete_live_classes?: EntireFieldWrapper<Maybe<TeacherLiveClassesMutationResponse>>;
  /** delete single row from the table: "live_classes" */
  delete_live_classes_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClasses>>;
  /** delete data from the table: "meeting_groups" */
  delete_meeting_groups?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsMutationResponse>>;
  /** delete single row from the table: "meeting_groups" */
  delete_meeting_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroups>>;
  /** delete data from the table: "meeting_groups_student" */
  delete_meeting_groups_student?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudentMutationResponse>>;
  /** delete single row from the table: "meeting_groups_student" */
  delete_meeting_groups_student_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudent>>;
  /** delete data from the table: "parent_student" */
  delete_parent_student?: EntireFieldWrapper<Maybe<TeacherParentStudentMutationResponse>>;
  /** delete single row from the table: "parent_student" */
  delete_parent_student_by_pk?: EntireFieldWrapper<Maybe<TeacherParentStudent>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<TeacherRelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<TeacherRelationships>>;
  /** delete data from the table: "roles" */
  delete_roles?: EntireFieldWrapper<Maybe<TeacherRolesMutationResponse>>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<TeacherSchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<TeacherSchools>>;
  /** delete data from the table: "student_group_users" */
  delete_student_group_users?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersMutationResponse>>;
  /** delete single row from the table: "student_group_users" */
  delete_student_group_users_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsers>>;
  /** delete data from the table: "student_groups" */
  delete_student_groups?: EntireFieldWrapper<Maybe<TeacherStudentGroupsMutationResponse>>;
  /** delete single row from the table: "student_groups" */
  delete_student_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroups>>;
  /** delete data from the table: "tasks" */
  delete_tasks?: EntireFieldWrapper<Maybe<TeacherTasksMutationResponse>>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: EntireFieldWrapper<Maybe<TeacherTasks>>;
  /** delete data from the table: "teaching_structures" */
  delete_teaching_structures?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresMutationResponse>>;
  /** delete single row from the table: "teaching_structures" */
  delete_teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<TeacherUsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  /** insert data into the table: "assignment_discussion" */
  insert_assignment_discussion?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionMutationResponse>>;
  /** insert data into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContentMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content_one?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** insert a single row into the table: "assignment_discussion" */
  insert_assignment_discussion_one?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussion>>;
  /** insert data into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscriptionMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription_one?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscription>>;
  /** insert data into the table: "assignment_files" */
  insert_assignment_files?: EntireFieldWrapper<Maybe<TeacherAssignmentFilesMutationResponse>>;
  /** insert a single row into the table: "assignment_files" */
  insert_assignment_files_one?: EntireFieldWrapper<Maybe<TeacherAssignmentFiles>>;
  /** insert data into the table: "assignment_notes" */
  insert_assignment_notes?: EntireFieldWrapper<Maybe<TeacherAssignmentNotesMutationResponse>>;
  /** insert a single row into the table: "assignment_notes" */
  insert_assignment_notes_one?: EntireFieldWrapper<Maybe<TeacherAssignmentNotes>>;
  /** insert data into the table: "assignment_question_option_relations" */
  insert_assignment_question_option_relations?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelationsMutationResponse>>;
  /** insert a single row into the table: "assignment_question_option_relations" */
  insert_assignment_question_option_relations_one?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelations>>;
  /** insert data into the table: "assignment_question_options" */
  insert_assignment_question_options?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionsMutationResponse>>;
  /** insert a single row into the table: "assignment_question_options" */
  insert_assignment_question_options_one?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** insert data into the table: "assignment_questions" */
  insert_assignment_questions?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionsMutationResponse>>;
  /** insert a single row into the table: "assignment_questions" */
  insert_assignment_questions_one?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestions>>;
  /** insert data into the table: "assignment_quiz" */
  insert_assignment_quiz?: EntireFieldWrapper<Maybe<TeacherAssignmentQuizMutationResponse>>;
  /** insert a single row into the table: "assignment_quiz" */
  insert_assignment_quiz_one?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** insert data into the table: "assignment_submits" */
  insert_assignment_submits?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmitsMutationResponse>>;
  /** insert a single row into the table: "assignment_submits" */
  insert_assignment_submits_one?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmits>>;
  /** insert data into the table: "assignment_user" */
  insert_assignment_user?: EntireFieldWrapper<Maybe<TeacherAssignmentUserMutationResponse>>;
  /** insert a single row into the table: "assignment_user" */
  insert_assignment_user_one?: EntireFieldWrapper<Maybe<TeacherAssignmentUser>>;
  /** insert data into the table: "assignments" */
  insert_assignments?: EntireFieldWrapper<Maybe<TeacherAssignmentsMutationResponse>>;
  /** insert a single row into the table: "assignments" */
  insert_assignments_one?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  /** insert data into the table: "attendances" */
  insert_attendances?: EntireFieldWrapper<Maybe<TeacherAttendancesMutationResponse>>;
  /** insert a single row into the table: "attendances" */
  insert_attendances_one?: EntireFieldWrapper<Maybe<TeacherAttendances>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<TeacherAuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<TeacherAuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<TeacherAuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<TeacherAuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<TeacherAuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<TeacherAuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<TeacherAuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<TeacherAuthRoles>>;
  /** insert data into the table: "chat_message_likes" */
  insert_chat_message_likes?: EntireFieldWrapper<Maybe<TeacherChatMessageLikesMutationResponse>>;
  /** insert a single row into the table: "chat_message_likes" */
  insert_chat_message_likes_one?: EntireFieldWrapper<Maybe<TeacherChatMessageLikes>>;
  /** insert data into the table: "chat_message_reads" */
  insert_chat_message_reads?: EntireFieldWrapper<Maybe<TeacherChatMessageReadsMutationResponse>>;
  /** insert a single row into the table: "chat_message_reads" */
  insert_chat_message_reads_one?: EntireFieldWrapper<Maybe<TeacherChatMessageReads>>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: EntireFieldWrapper<Maybe<TeacherChatMessagesMutationResponse>>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  /** insert data into the table: "chat_user" */
  insert_chat_user?: EntireFieldWrapper<Maybe<TeacherChatUserMutationResponse>>;
  /** insert a single row into the table: "chat_user" */
  insert_chat_user_one?: EntireFieldWrapper<Maybe<TeacherChatUser>>;
  /** insert data into the table: "chats" */
  insert_chats?: EntireFieldWrapper<Maybe<TeacherChatsMutationResponse>>;
  /** insert a single row into the table: "chats" */
  insert_chats_one?: EntireFieldWrapper<Maybe<TeacherChats>>;
  /** insert data into the table: "event_users" */
  insert_event_users?: EntireFieldWrapper<Maybe<TeacherEventUsersMutationResponse>>;
  /** insert a single row into the table: "event_users" */
  insert_event_users_one?: EntireFieldWrapper<Maybe<TeacherEventUsers>>;
  /** insert data into the table: "events" */
  insert_events?: EntireFieldWrapper<Maybe<TeacherEventsMutationResponse>>;
  /** insert a single row into the table: "events" */
  insert_events_one?: EntireFieldWrapper<Maybe<TeacherEvents>>;
  /** insert data into the table: "example" */
  insert_example?: EntireFieldWrapper<Maybe<TeacherExampleMutationResponse>>;
  /** insert data into the table: "grades" */
  insert_grades?: EntireFieldWrapper<Maybe<TeacherGradesMutationResponse>>;
  /** insert a single row into the table: "grades" */
  insert_grades_one?: EntireFieldWrapper<Maybe<TeacherGrades>>;
  insert_group_conversation?: EntireFieldWrapper<Maybe<TeacherGroupConversationOutput>>;
  /** insert data into the table: "lesson_attendances" */
  insert_lesson_attendances?: EntireFieldWrapper<Maybe<TeacherLessonAttendancesMutationResponse>>;
  /** insert a single row into the table: "lesson_attendances" */
  insert_lesson_attendances_one?: EntireFieldWrapper<Maybe<TeacherLessonAttendances>>;
  /** insert data into the table: "live_class_attendees" */
  insert_live_class_attendees?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesMutationResponse>>;
  /** insert a single row into the table: "live_class_attendees" */
  insert_live_class_attendees_one?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendees>>;
  /** insert data into the table: "meeting_groups" */
  insert_meeting_groups?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsMutationResponse>>;
  /** insert a single row into the table: "meeting_groups" */
  insert_meeting_groups_one?: EntireFieldWrapper<Maybe<TeacherMeetingGroups>>;
  /** insert data into the table: "meeting_groups_student" */
  insert_meeting_groups_student?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudentMutationResponse>>;
  /** insert a single row into the table: "meeting_groups_student" */
  insert_meeting_groups_student_one?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudent>>;
  /** insert data into the table: "meeting_user" */
  insert_meeting_user?: EntireFieldWrapper<Maybe<TeacherMeetingUserMutationResponse>>;
  /** insert a single row into the table: "meeting_user" */
  insert_meeting_user_one?: EntireFieldWrapper<Maybe<TeacherMeetingUser>>;
  /** insert data into the table: "notifications" */
  insert_notifications?: EntireFieldWrapper<Maybe<TeacherNotificationsMutationResponse>>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: EntireFieldWrapper<Maybe<TeacherNotifications>>;
  /** insert data into the table: "parent_student" */
  insert_parent_student?: EntireFieldWrapper<Maybe<TeacherParentStudentMutationResponse>>;
  /** insert a single row into the table: "parent_student" */
  insert_parent_student_one?: EntireFieldWrapper<Maybe<TeacherParentStudent>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<TeacherPrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<TeacherRelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<TeacherRelationships>>;
  /** insert data into the table: "roles" */
  insert_roles?: EntireFieldWrapper<Maybe<TeacherRolesMutationResponse>>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<TeacherSchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<TeacherSchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<TeacherSchools>>;
  /** insert data into the table: "student_group_users" */
  insert_student_group_users?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersMutationResponse>>;
  /** insert a single row into the table: "student_group_users" */
  insert_student_group_users_one?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsers>>;
  /** insert data into the table: "student_groups" */
  insert_student_groups?: EntireFieldWrapper<Maybe<TeacherStudentGroupsMutationResponse>>;
  /** insert a single row into the table: "student_groups" */
  insert_student_groups_one?: EntireFieldWrapper<Maybe<TeacherStudentGroups>>;
  /** insert data into the table: "tasks" */
  insert_tasks?: EntireFieldWrapper<Maybe<TeacherTasksMutationResponse>>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: EntireFieldWrapper<Maybe<TeacherTasks>>;
  /** insert data into the table: "teacher_subject" */
  insert_teacher_subject?: EntireFieldWrapper<Maybe<TeacherTeacherSubjectMutationResponse>>;
  /** insert a single row into the table: "teacher_subject" */
  insert_teacher_subject_one?: EntireFieldWrapper<Maybe<TeacherTeacherSubject>>;
  /** insert data into the table: "teaching_structure_students" */
  insert_teaching_structure_students?: EntireFieldWrapper<Maybe<TeacherTeachingStructureStudentsMutationResponse>>;
  /** insert data into the table: "teaching_structures" */
  insert_teaching_structures?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresMutationResponse>>;
  /** insert a single row into the table: "teaching_structures" */
  insert_teaching_structures_one?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<TeacherUsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  invite_parent?: EntireFieldWrapper<Maybe<TeacherSession>>;
  invite_student?: EntireFieldWrapper<Maybe<TeacherSession>>;
  invite_teacher?: EntireFieldWrapper<Maybe<TeacherSession>>;
  lost_password?: EntireFieldWrapper<Maybe<TeacherMessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<TeacherSession>>;
  reset_password?: EntireFieldWrapper<Maybe<TeacherMessageResponse>>;
  revoke_token?: EntireFieldWrapper<Maybe<TeacherMessageResponse>>;
  teacherJoin?: EntireFieldWrapper<Maybe<TeacherBbbJoinLink>>;
  /** update data of the table: "assignment_discussion" */
  update_assignment_discussion?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionMutationResponse>>;
  /** update single row of the table: "assignment_discussion" */
  update_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussion>>;
  /** update data of the table: "assignment_discussion_content" */
  update_assignment_discussion_content?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContentMutationResponse>>;
  /** update single row of the table: "assignment_discussion_content" */
  update_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** update data of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscriptionMutationResponse>>;
  /** update single row of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscription>>;
  /** update data of the table: "assignment_notes" */
  update_assignment_notes?: EntireFieldWrapper<Maybe<TeacherAssignmentNotesMutationResponse>>;
  /** update single row of the table: "assignment_notes" */
  update_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentNotes>>;
  /** update data of the table: "assignment_question_option_relations" */
  update_assignment_question_option_relations?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelationsMutationResponse>>;
  /** update single row of the table: "assignment_question_option_relations" */
  update_assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelations>>;
  /** update data of the table: "assignment_question_options" */
  update_assignment_question_options?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionsMutationResponse>>;
  /** update single row of the table: "assignment_question_options" */
  update_assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** update data of the table: "assignment_questions" */
  update_assignment_questions?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionsMutationResponse>>;
  /** update single row of the table: "assignment_questions" */
  update_assignment_questions_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestions>>;
  /** update data of the table: "assignment_quiz" */
  update_assignment_quiz?: EntireFieldWrapper<Maybe<TeacherAssignmentQuizMutationResponse>>;
  /** update single row of the table: "assignment_quiz" */
  update_assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** update data of the table: "assignment_submits" */
  update_assignment_submits?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmitsMutationResponse>>;
  /** update single row of the table: "assignment_submits" */
  update_assignment_submits_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmits>>;
  /** update data of the table: "assignment_user" */
  update_assignment_user?: EntireFieldWrapper<Maybe<TeacherAssignmentUserMutationResponse>>;
  /** update single row of the table: "assignment_user" */
  update_assignment_user_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentUser>>;
  /** update data of the table: "assignments" */
  update_assignments?: EntireFieldWrapper<Maybe<TeacherAssignmentsMutationResponse>>;
  /** update single row of the table: "assignments" */
  update_assignments_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  /** update data of the table: "attendances" */
  update_attendances?: EntireFieldWrapper<Maybe<TeacherAttendancesMutationResponse>>;
  /** update single row of the table: "attendances" */
  update_attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendances>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<TeacherAuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<TeacherAuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<TeacherAuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<TeacherAuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<TeacherAuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRoles>>;
  /** update data of the table: "chat_message_reads" */
  update_chat_message_reads?: EntireFieldWrapper<Maybe<TeacherChatMessageReadsMutationResponse>>;
  /** update single row of the table: "chat_message_reads" */
  update_chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageReads>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: EntireFieldWrapper<Maybe<TeacherChatMessagesMutationResponse>>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  /** update data of the table: "chats" */
  update_chats?: EntireFieldWrapper<Maybe<TeacherChatsMutationResponse>>;
  /** update single row of the table: "chats" */
  update_chats_by_pk?: EntireFieldWrapper<Maybe<TeacherChats>>;
  /** update data of the table: "event_users" */
  update_event_users?: EntireFieldWrapper<Maybe<TeacherEventUsersMutationResponse>>;
  /** update single row of the table: "event_users" */
  update_event_users_by_pk?: EntireFieldWrapper<Maybe<TeacherEventUsers>>;
  /** update data of the table: "events" */
  update_events?: EntireFieldWrapper<Maybe<TeacherEventsMutationResponse>>;
  /** update single row of the table: "events" */
  update_events_by_pk?: EntireFieldWrapper<Maybe<TeacherEvents>>;
  /** update data of the table: "grades" */
  update_grades?: EntireFieldWrapper<Maybe<TeacherGradesMutationResponse>>;
  /** update single row of the table: "grades" */
  update_grades_by_pk?: EntireFieldWrapper<Maybe<TeacherGrades>>;
  /** update data of the table: "lesson_attendances" */
  update_lesson_attendances?: EntireFieldWrapper<Maybe<TeacherLessonAttendancesMutationResponse>>;
  /** update single row of the table: "lesson_attendances" */
  update_lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherLessonAttendances>>;
  /** update data of the table: "live_class_attendees" */
  update_live_class_attendees?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendeesMutationResponse>>;
  /** update single row of the table: "live_class_attendees" */
  update_live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendees>>;
  /** update data of the table: "live_classes" */
  update_live_classes?: EntireFieldWrapper<Maybe<TeacherLiveClassesMutationResponse>>;
  /** update single row of the table: "live_classes" */
  update_live_classes_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClasses>>;
  /** update data of the table: "meeting_groups" */
  update_meeting_groups?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsMutationResponse>>;
  /** update single row of the table: "meeting_groups" */
  update_meeting_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroups>>;
  /** update data of the table: "meeting_groups_student" */
  update_meeting_groups_student?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudentMutationResponse>>;
  /** update single row of the table: "meeting_groups_student" */
  update_meeting_groups_student_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudent>>;
  /** update data of the table: "notifications" */
  update_notifications?: EntireFieldWrapper<Maybe<TeacherNotificationsMutationResponse>>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: EntireFieldWrapper<Maybe<TeacherNotifications>>;
  /** update data of the table: "parent_student" */
  update_parent_student?: EntireFieldWrapper<Maybe<TeacherParentStudentMutationResponse>>;
  /** update single row of the table: "parent_student" */
  update_parent_student_by_pk?: EntireFieldWrapper<Maybe<TeacherParentStudent>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<TeacherRelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<TeacherRelationships>>;
  /** update data of the table: "roles" */
  update_roles?: EntireFieldWrapper<Maybe<TeacherRolesMutationResponse>>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<TeacherSchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<TeacherSchools>>;
  /** update data of the table: "student_group_users" */
  update_student_group_users?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersMutationResponse>>;
  /** update single row of the table: "student_group_users" */
  update_student_group_users_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsers>>;
  /** update data of the table: "student_groups" */
  update_student_groups?: EntireFieldWrapper<Maybe<TeacherStudentGroupsMutationResponse>>;
  /** update single row of the table: "student_groups" */
  update_student_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroups>>;
  /** update data of the table: "tasks" */
  update_tasks?: EntireFieldWrapper<Maybe<TeacherTasksMutationResponse>>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: EntireFieldWrapper<Maybe<TeacherTasks>>;
  /** update data of the table: "teaching_structures" */
  update_teaching_structures?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresMutationResponse>>;
  /** update single row of the table: "teaching_structures" */
  update_teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<TeacherUsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<TeacherUsers>>;
}


/** mutation root */
export interface TeacherMutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootCreateLiveClassArgs {
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  lesson_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  starting_at?: Maybe<Scalars['String']>;
  students?: Maybe<Array<Maybe<Scalars['String']>>>;
  teacher_name?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentDiscussionArgs {
  where: TeacherAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentDiscussionContentArgs {
  where: TeacherAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentFilesArgs {
  where: TeacherAssignmentFilesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentNotesArgs {
  where: TeacherAssignmentNotesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionOptionRelationsArgs {
  where: TeacherAssignmentQuestionOptionRelationsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionOptionsArgs {
  where: TeacherAssignmentQuestionOptionsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionsArgs {
  where: TeacherAssignmentQuestionsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuizArgs {
  where: TeacherAssignmentQuizBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentUserArgs {
  where: TeacherAssignmentUserBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentsArgs {
  where: TeacherAssignmentsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAttendancesArgs {
  where: TeacherAttendancesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAttendancesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountProvidersArgs {
  where: TeacherAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountRolesArgs {
  where: TeacherAuthAccountRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountsArgs {
  where: TeacherAuthAccountsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthProvidersArgs {
  where: TeacherAuthProvidersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthRefreshTokensArgs {
  where: TeacherAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthRolesArgs {
  where: TeacherAuthRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootDeleteChatMessageLikesArgs {
  where: TeacherChatMessageLikesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteChatMessagesArgs {
  where: TeacherChatMessagesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteChatsArgs {
  where: TeacherChatsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteChatsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteEventUsersArgs {
  where: TeacherEventUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteEventUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteEventsArgs {
  where: TeacherEventsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteEventsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteFilesArgs {
  where: TeacherFilesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteLiveClassArgs {
  lesson_id?: Maybe<Scalars['uuid']>;
}


/** mutation root */
export interface TeacherMutationRootDeleteLiveClassAttendeesArgs {
  where: TeacherLiveClassAttendeesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteLiveClassesArgs {
  where: TeacherLiveClassesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteMeetingGroupsArgs {
  where: TeacherMeetingGroupsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteMeetingGroupsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteMeetingGroupsStudentArgs {
  where: TeacherMeetingGroupsStudentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteMeetingGroupsStudentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteParentStudentArgs {
  where: TeacherParentStudentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteParentStudentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateAdressesArgs {
  where: TeacherPrivateAdressesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateBirthdaysArgs {
  where: TeacherPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateInsuranceNumbersArgs {
  where: TeacherPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeletePrivatePhoneNumbersArgs {
  where: TeacherPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteRelationshipsArgs {
  where: TeacherRelationshipsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteRolesArgs {
  where: TeacherRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolSettingsArgs {
  where: TeacherSchoolSettingsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolSettingsModulesArgs {
  where: TeacherSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolsArgs {
  where: TeacherSchoolsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteStudentGroupUsersArgs {
  where: TeacherStudentGroupUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteStudentGroupsArgs {
  where: TeacherStudentGroupsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteTasksArgs {
  where: TeacherTasksBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteTasksByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteTeachingStructuresArgs {
  where: TeacherTeachingStructuresBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootDeleteUsersArgs {
  where: TeacherUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionArgs {
  objects: Array<TeacherAssignmentDiscussionInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionContentArgs {
  objects: Array<TeacherAssignmentDiscussionContentInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionContentOneArgs {
  object: TeacherAssignmentDiscussionContentInsertInput;
  on_conflict?: Maybe<TeacherAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionOneArgs {
  object: TeacherAssignmentDiscussionInsertInput;
  on_conflict?: Maybe<TeacherAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionSubscriptionArgs {
  objects: Array<TeacherAssignmentDiscussionSubscriptionInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentDiscussionSubscriptionOneArgs {
  object: TeacherAssignmentDiscussionSubscriptionInsertInput;
  on_conflict?: Maybe<TeacherAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentFilesArgs {
  objects: Array<TeacherAssignmentFilesInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentFilesOneArgs {
  object: TeacherAssignmentFilesInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentNotesArgs {
  objects: Array<TeacherAssignmentNotesInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentNotesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentNotesOneArgs {
  object: TeacherAssignmentNotesInsertInput;
  on_conflict?: Maybe<TeacherAssignmentNotesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionOptionRelationsArgs {
  objects: Array<TeacherAssignmentQuestionOptionRelationsInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionRelationsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionOptionRelationsOneArgs {
  object: TeacherAssignmentQuestionOptionRelationsInsertInput;
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionRelationsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionOptionsArgs {
  objects: Array<TeacherAssignmentQuestionOptionsInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionOptionsOneArgs {
  object: TeacherAssignmentQuestionOptionsInsertInput;
  on_conflict?: Maybe<TeacherAssignmentQuestionOptionsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionsArgs {
  objects: Array<TeacherAssignmentQuestionsInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentQuestionsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuestionsOneArgs {
  object: TeacherAssignmentQuestionsInsertInput;
  on_conflict?: Maybe<TeacherAssignmentQuestionsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuizArgs {
  objects: Array<TeacherAssignmentQuizInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentQuizOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentQuizOneArgs {
  object: TeacherAssignmentQuizInsertInput;
  on_conflict?: Maybe<TeacherAssignmentQuizOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentSubmitsArgs {
  objects: Array<TeacherAssignmentSubmitsInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentSubmitsOneArgs {
  object: TeacherAssignmentSubmitsInsertInput;
  on_conflict?: Maybe<TeacherAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentUserArgs {
  objects: Array<TeacherAssignmentUserInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentUserOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentUserOneArgs {
  object: TeacherAssignmentUserInsertInput;
  on_conflict?: Maybe<TeacherAssignmentUserOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentsArgs {
  objects: Array<TeacherAssignmentsInsertInput>;
  on_conflict?: Maybe<TeacherAssignmentsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAssignmentsOneArgs {
  object: TeacherAssignmentsInsertInput;
  on_conflict?: Maybe<TeacherAssignmentsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAttendancesArgs {
  objects: Array<TeacherAttendancesInsertInput>;
  on_conflict?: Maybe<TeacherAttendancesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAttendancesOneArgs {
  object: TeacherAttendancesInsertInput;
  on_conflict?: Maybe<TeacherAttendancesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountProvidersArgs {
  objects: Array<TeacherAuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<TeacherAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountProvidersOneArgs {
  object: TeacherAuthAccountProvidersInsertInput;
  on_conflict?: Maybe<TeacherAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountRolesArgs {
  objects: Array<TeacherAuthAccountRolesInsertInput>;
  on_conflict?: Maybe<TeacherAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountRolesOneArgs {
  object: TeacherAuthAccountRolesInsertInput;
  on_conflict?: Maybe<TeacherAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountsArgs {
  objects: Array<TeacherAuthAccountsInsertInput>;
  on_conflict?: Maybe<TeacherAuthAccountsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthAccountsOneArgs {
  object: TeacherAuthAccountsInsertInput;
  on_conflict?: Maybe<TeacherAuthAccountsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthProvidersArgs {
  objects: Array<TeacherAuthProvidersInsertInput>;
  on_conflict?: Maybe<TeacherAuthProvidersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthProvidersOneArgs {
  object: TeacherAuthProvidersInsertInput;
  on_conflict?: Maybe<TeacherAuthProvidersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthRefreshTokensArgs {
  objects: Array<TeacherAuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<TeacherAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthRefreshTokensOneArgs {
  object: TeacherAuthRefreshTokensInsertInput;
  on_conflict?: Maybe<TeacherAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthRolesArgs {
  objects: Array<TeacherAuthRolesInsertInput>;
  on_conflict?: Maybe<TeacherAuthRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertAuthRolesOneArgs {
  object: TeacherAuthRolesInsertInput;
  on_conflict?: Maybe<TeacherAuthRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessageLikesArgs {
  objects: Array<TeacherChatMessageLikesInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessageLikesOneArgs {
  object: TeacherChatMessageLikesInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessageReadsArgs {
  objects: Array<TeacherChatMessageReadsInsertInput>;
  on_conflict?: Maybe<TeacherChatMessageReadsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessageReadsOneArgs {
  object: TeacherChatMessageReadsInsertInput;
  on_conflict?: Maybe<TeacherChatMessageReadsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessagesArgs {
  objects: Array<TeacherChatMessagesInsertInput>;
  on_conflict?: Maybe<TeacherChatMessagesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatMessagesOneArgs {
  object: TeacherChatMessagesInsertInput;
  on_conflict?: Maybe<TeacherChatMessagesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatUserArgs {
  objects: Array<TeacherChatUserInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatUserOneArgs {
  object: TeacherChatUserInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInsertChatsArgs {
  objects: Array<TeacherChatsInsertInput>;
  on_conflict?: Maybe<TeacherChatsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertChatsOneArgs {
  object: TeacherChatsInsertInput;
  on_conflict?: Maybe<TeacherChatsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertEventUsersArgs {
  objects: Array<TeacherEventUsersInsertInput>;
  on_conflict?: Maybe<TeacherEventUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertEventUsersOneArgs {
  object: TeacherEventUsersInsertInput;
  on_conflict?: Maybe<TeacherEventUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertEventsArgs {
  objects: Array<TeacherEventsInsertInput>;
  on_conflict?: Maybe<TeacherEventsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertEventsOneArgs {
  object: TeacherEventsInsertInput;
  on_conflict?: Maybe<TeacherEventsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertExampleArgs {
  objects: Array<TeacherExampleInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertGradesArgs {
  objects: Array<TeacherGradesInsertInput>;
  on_conflict?: Maybe<TeacherGradesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertGradesOneArgs {
  object: TeacherGradesInsertInput;
  on_conflict?: Maybe<TeacherGradesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertGroupConversationArgs {
  data: TeacherGroupConversationInput;
}


/** mutation root */
export interface TeacherMutationRootInsertLessonAttendancesArgs {
  objects: Array<TeacherLessonAttendancesInsertInput>;
  on_conflict?: Maybe<TeacherLessonAttendancesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertLessonAttendancesOneArgs {
  object: TeacherLessonAttendancesInsertInput;
  on_conflict?: Maybe<TeacherLessonAttendancesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertLiveClassAttendeesArgs {
  objects: Array<TeacherLiveClassAttendeesInsertInput>;
  on_conflict?: Maybe<TeacherLiveClassAttendeesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertLiveClassAttendeesOneArgs {
  object: TeacherLiveClassAttendeesInsertInput;
  on_conflict?: Maybe<TeacherLiveClassAttendeesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingGroupsArgs {
  objects: Array<TeacherMeetingGroupsInsertInput>;
  on_conflict?: Maybe<TeacherMeetingGroupsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingGroupsOneArgs {
  object: TeacherMeetingGroupsInsertInput;
  on_conflict?: Maybe<TeacherMeetingGroupsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingGroupsStudentArgs {
  objects: Array<TeacherMeetingGroupsStudentInsertInput>;
  on_conflict?: Maybe<TeacherMeetingGroupsStudentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingGroupsStudentOneArgs {
  object: TeacherMeetingGroupsStudentInsertInput;
  on_conflict?: Maybe<TeacherMeetingGroupsStudentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingUserArgs {
  objects: Array<TeacherMeetingUserInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertMeetingUserOneArgs {
  object: TeacherMeetingUserInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInsertNotificationsArgs {
  objects: Array<TeacherNotificationsInsertInput>;
  on_conflict?: Maybe<TeacherNotificationsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertNotificationsOneArgs {
  object: TeacherNotificationsInsertInput;
  on_conflict?: Maybe<TeacherNotificationsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertParentStudentArgs {
  objects: Array<TeacherParentStudentInsertInput>;
  on_conflict?: Maybe<TeacherParentStudentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertParentStudentOneArgs {
  object: TeacherParentStudentInsertInput;
  on_conflict?: Maybe<TeacherParentStudentOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateAdressesArgs {
  objects: Array<TeacherPrivateAdressesInsertInput>;
  on_conflict?: Maybe<TeacherPrivateAdressesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateAdressesOneArgs {
  object: TeacherPrivateAdressesInsertInput;
  on_conflict?: Maybe<TeacherPrivateAdressesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateBirthdaysArgs {
  objects: Array<TeacherPrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<TeacherPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateBirthdaysOneArgs {
  object: TeacherPrivateBirthdaysInsertInput;
  on_conflict?: Maybe<TeacherPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<TeacherPrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<TeacherPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: TeacherPrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<TeacherPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<TeacherPrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<TeacherPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertPrivatePhoneNumbersOneArgs {
  object: TeacherPrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<TeacherPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertRelationshipsArgs {
  objects: Array<TeacherRelationshipsInsertInput>;
  on_conflict?: Maybe<TeacherRelationshipsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertRelationshipsOneArgs {
  object: TeacherRelationshipsInsertInput;
  on_conflict?: Maybe<TeacherRelationshipsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertRolesArgs {
  objects: Array<TeacherRolesInsertInput>;
  on_conflict?: Maybe<TeacherRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertRolesOneArgs {
  object: TeacherRolesInsertInput;
  on_conflict?: Maybe<TeacherRolesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolSettingsArgs {
  objects: Array<TeacherSchoolSettingsInsertInput>;
  on_conflict?: Maybe<TeacherSchoolSettingsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<TeacherSchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<TeacherSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolSettingsModulesOneArgs {
  object: TeacherSchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<TeacherSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolSettingsOneArgs {
  object: TeacherSchoolSettingsInsertInput;
  on_conflict?: Maybe<TeacherSchoolSettingsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolsArgs {
  objects: Array<TeacherSchoolsInsertInput>;
  on_conflict?: Maybe<TeacherSchoolsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertSchoolsOneArgs {
  object: TeacherSchoolsInsertInput;
  on_conflict?: Maybe<TeacherSchoolsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertStudentGroupUsersArgs {
  objects: Array<TeacherStudentGroupUsersInsertInput>;
  on_conflict?: Maybe<TeacherStudentGroupUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertStudentGroupUsersOneArgs {
  object: TeacherStudentGroupUsersInsertInput;
  on_conflict?: Maybe<TeacherStudentGroupUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertStudentGroupsArgs {
  objects: Array<TeacherStudentGroupsInsertInput>;
  on_conflict?: Maybe<TeacherStudentGroupsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertStudentGroupsOneArgs {
  object: TeacherStudentGroupsInsertInput;
  on_conflict?: Maybe<TeacherStudentGroupsOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertTasksArgs {
  objects: Array<TeacherTasksInsertInput>;
  on_conflict?: Maybe<TeacherTasksOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertTasksOneArgs {
  object: TeacherTasksInsertInput;
  on_conflict?: Maybe<TeacherTasksOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertTeacherSubjectArgs {
  objects: Array<TeacherTeacherSubjectInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertTeacherSubjectOneArgs {
  object: TeacherTeacherSubjectInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInsertTeachingStructureStudentsArgs {
  objects: Array<TeacherTeachingStructureStudentsInsertInput>;
}


/** mutation root */
export interface TeacherMutationRootInsertTeachingStructuresArgs {
  objects: Array<TeacherTeachingStructuresInsertInput>;
  on_conflict?: Maybe<TeacherTeachingStructuresOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertTeachingStructuresOneArgs {
  object: TeacherTeachingStructuresInsertInput;
  on_conflict?: Maybe<TeacherTeachingStructuresOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertUsersArgs {
  objects: Array<TeacherUsersInsertInput>;
  on_conflict?: Maybe<TeacherUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInsertUsersOneArgs {
  object: TeacherUsersInsertInput;
  on_conflict?: Maybe<TeacherUsersOnConflict>;
}


/** mutation root */
export interface TeacherMutationRootInviteParentArgs {
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options?: Maybe<TeacherInviteParentInput>;
  user_data: TeacherUserInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInviteStudentArgs {
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options: TeacherInviteStudentClassInsertInput;
  user_data: TeacherUserInsertInput;
}


/** mutation root */
export interface TeacherMutationRootInviteTeacherArgs {
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options: TeacherTeacherSkillInsertInput;
  user_data: TeacherUserInsertInput;
}


/** mutation root */
export interface TeacherMutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootRevokeTokenArgs {
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface TeacherMutationRootTeacherJoinArgs {
  meeting_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionArgs {
  _set?: Maybe<TeacherAssignmentDiscussionSetInput>;
  where: TeacherAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionByPkArgs {
  _set?: Maybe<TeacherAssignmentDiscussionSetInput>;
  pk_columns: TeacherAssignmentDiscussionPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionContentArgs {
  _set?: Maybe<TeacherAssignmentDiscussionContentSetInput>;
  where: TeacherAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionContentByPkArgs {
  _set?: Maybe<TeacherAssignmentDiscussionContentSetInput>;
  pk_columns: TeacherAssignmentDiscussionContentPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionSubscriptionArgs {
  _set?: Maybe<TeacherAssignmentDiscussionSubscriptionSetInput>;
  where: TeacherAssignmentDiscussionSubscriptionBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentDiscussionSubscriptionByPkArgs {
  _set?: Maybe<TeacherAssignmentDiscussionSubscriptionSetInput>;
  pk_columns: TeacherAssignmentDiscussionSubscriptionPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentNotesArgs {
  _set?: Maybe<TeacherAssignmentNotesSetInput>;
  where: TeacherAssignmentNotesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentNotesByPkArgs {
  _set?: Maybe<TeacherAssignmentNotesSetInput>;
  pk_columns: TeacherAssignmentNotesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionOptionRelationsArgs {
  _set?: Maybe<TeacherAssignmentQuestionOptionRelationsSetInput>;
  where: TeacherAssignmentQuestionOptionRelationsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionOptionRelationsByPkArgs {
  _set?: Maybe<TeacherAssignmentQuestionOptionRelationsSetInput>;
  pk_columns: TeacherAssignmentQuestionOptionRelationsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionOptionsArgs {
  _inc?: Maybe<TeacherAssignmentQuestionOptionsIncInput>;
  _set?: Maybe<TeacherAssignmentQuestionOptionsSetInput>;
  where: TeacherAssignmentQuestionOptionsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionOptionsByPkArgs {
  _inc?: Maybe<TeacherAssignmentQuestionOptionsIncInput>;
  _set?: Maybe<TeacherAssignmentQuestionOptionsSetInput>;
  pk_columns: TeacherAssignmentQuestionOptionsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionsArgs {
  _set?: Maybe<TeacherAssignmentQuestionsSetInput>;
  where: TeacherAssignmentQuestionsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuestionsByPkArgs {
  _set?: Maybe<TeacherAssignmentQuestionsSetInput>;
  pk_columns: TeacherAssignmentQuestionsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuizArgs {
  _inc?: Maybe<TeacherAssignmentQuizIncInput>;
  _set?: Maybe<TeacherAssignmentQuizSetInput>;
  where: TeacherAssignmentQuizBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentQuizByPkArgs {
  _inc?: Maybe<TeacherAssignmentQuizIncInput>;
  _set?: Maybe<TeacherAssignmentQuizSetInput>;
  pk_columns: TeacherAssignmentQuizPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentSubmitsArgs {
  _set?: Maybe<TeacherAssignmentSubmitsSetInput>;
  where: TeacherAssignmentSubmitsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentSubmitsByPkArgs {
  _set?: Maybe<TeacherAssignmentSubmitsSetInput>;
  pk_columns: TeacherAssignmentSubmitsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentUserArgs {
  _set?: Maybe<TeacherAssignmentUserSetInput>;
  where: TeacherAssignmentUserBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentUserByPkArgs {
  _set?: Maybe<TeacherAssignmentUserSetInput>;
  pk_columns: TeacherAssignmentUserPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentsArgs {
  _inc?: Maybe<TeacherAssignmentsIncInput>;
  _set?: Maybe<TeacherAssignmentsSetInput>;
  where: TeacherAssignmentsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAssignmentsByPkArgs {
  _inc?: Maybe<TeacherAssignmentsIncInput>;
  _set?: Maybe<TeacherAssignmentsSetInput>;
  pk_columns: TeacherAssignmentsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAttendancesArgs {
  _set?: Maybe<TeacherAttendancesSetInput>;
  where: TeacherAttendancesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAttendancesByPkArgs {
  _set?: Maybe<TeacherAttendancesSetInput>;
  pk_columns: TeacherAttendancesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<TeacherAuthAccountProvidersSetInput>;
  where: TeacherAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<TeacherAuthAccountProvidersSetInput>;
  pk_columns: TeacherAuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<TeacherAuthAccountRolesSetInput>;
  where: TeacherAuthAccountRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<TeacherAuthAccountRolesSetInput>;
  pk_columns: TeacherAuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<TeacherAuthAccountsSetInput>;
  where: TeacherAuthAccountsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<TeacherAuthAccountsSetInput>;
  pk_columns: TeacherAuthAccountsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<TeacherAuthProvidersSetInput>;
  where: TeacherAuthProvidersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<TeacherAuthProvidersSetInput>;
  pk_columns: TeacherAuthProvidersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<TeacherAuthRefreshTokensSetInput>;
  where: TeacherAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<TeacherAuthRefreshTokensSetInput>;
  pk_columns: TeacherAuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthRolesArgs {
  _set?: Maybe<TeacherAuthRolesSetInput>;
  where: TeacherAuthRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<TeacherAuthRolesSetInput>;
  pk_columns: TeacherAuthRolesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatMessageReadsArgs {
  _set?: Maybe<TeacherChatMessageReadsSetInput>;
  where: TeacherChatMessageReadsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatMessageReadsByPkArgs {
  _set?: Maybe<TeacherChatMessageReadsSetInput>;
  pk_columns: TeacherChatMessageReadsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatMessagesArgs {
  _set?: Maybe<TeacherChatMessagesSetInput>;
  where: TeacherChatMessagesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatMessagesByPkArgs {
  _set?: Maybe<TeacherChatMessagesSetInput>;
  pk_columns: TeacherChatMessagesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatsArgs {
  _set?: Maybe<TeacherChatsSetInput>;
  where: TeacherChatsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateChatsByPkArgs {
  _set?: Maybe<TeacherChatsSetInput>;
  pk_columns: TeacherChatsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateEventUsersArgs {
  _set?: Maybe<TeacherEventUsersSetInput>;
  where: TeacherEventUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateEventUsersByPkArgs {
  _set?: Maybe<TeacherEventUsersSetInput>;
  pk_columns: TeacherEventUsersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateEventsArgs {
  _inc?: Maybe<TeacherEventsIncInput>;
  _set?: Maybe<TeacherEventsSetInput>;
  where: TeacherEventsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateEventsByPkArgs {
  _inc?: Maybe<TeacherEventsIncInput>;
  _set?: Maybe<TeacherEventsSetInput>;
  pk_columns: TeacherEventsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateGradesArgs {
  _inc?: Maybe<TeacherGradesIncInput>;
  _set?: Maybe<TeacherGradesSetInput>;
  where: TeacherGradesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateGradesByPkArgs {
  _inc?: Maybe<TeacherGradesIncInput>;
  _set?: Maybe<TeacherGradesSetInput>;
  pk_columns: TeacherGradesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateLessonAttendancesArgs {
  _set?: Maybe<TeacherLessonAttendancesSetInput>;
  where: TeacherLessonAttendancesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateLessonAttendancesByPkArgs {
  _set?: Maybe<TeacherLessonAttendancesSetInput>;
  pk_columns: TeacherLessonAttendancesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateLiveClassAttendeesArgs {
  _set?: Maybe<TeacherLiveClassAttendeesSetInput>;
  where: TeacherLiveClassAttendeesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateLiveClassAttendeesByPkArgs {
  _set?: Maybe<TeacherLiveClassAttendeesSetInput>;
  pk_columns: TeacherLiveClassAttendeesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateLiveClassesArgs {
  _inc?: Maybe<TeacherLiveClassesIncInput>;
  _set?: Maybe<TeacherLiveClassesSetInput>;
  where: TeacherLiveClassesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateLiveClassesByPkArgs {
  _inc?: Maybe<TeacherLiveClassesIncInput>;
  _set?: Maybe<TeacherLiveClassesSetInput>;
  pk_columns: TeacherLiveClassesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateMeetingGroupsArgs {
  _set?: Maybe<TeacherMeetingGroupsSetInput>;
  where: TeacherMeetingGroupsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateMeetingGroupsByPkArgs {
  _set?: Maybe<TeacherMeetingGroupsSetInput>;
  pk_columns: TeacherMeetingGroupsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateMeetingGroupsStudentArgs {
  _set?: Maybe<TeacherMeetingGroupsStudentSetInput>;
  where: TeacherMeetingGroupsStudentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateMeetingGroupsStudentByPkArgs {
  _set?: Maybe<TeacherMeetingGroupsStudentSetInput>;
  pk_columns: TeacherMeetingGroupsStudentPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateNotificationsArgs {
  _set?: Maybe<TeacherNotificationsSetInput>;
  where: TeacherNotificationsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateNotificationsByPkArgs {
  _set?: Maybe<TeacherNotificationsSetInput>;
  pk_columns: TeacherNotificationsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateParentStudentArgs {
  _set?: Maybe<TeacherParentStudentSetInput>;
  where: TeacherParentStudentBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateParentStudentByPkArgs {
  _set?: Maybe<TeacherParentStudentSetInput>;
  pk_columns: TeacherParentStudentPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<TeacherPrivateAdressesSetInput>;
  where: TeacherPrivateAdressesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<TeacherPrivateAdressesSetInput>;
  pk_columns: TeacherPrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<TeacherPrivateBirthdaysSetInput>;
  where: TeacherPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<TeacherPrivateBirthdaysSetInput>;
  pk_columns: TeacherPrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<TeacherPrivateInsuranceNumbersSetInput>;
  where: TeacherPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<TeacherPrivateInsuranceNumbersSetInput>;
  pk_columns: TeacherPrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<TeacherPrivatePhoneNumbersSetInput>;
  where: TeacherPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<TeacherPrivatePhoneNumbersSetInput>;
  pk_columns: TeacherPrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateRelationshipsArgs {
  _set?: Maybe<TeacherRelationshipsSetInput>;
  where: TeacherRelationshipsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<TeacherRelationshipsSetInput>;
  pk_columns: TeacherRelationshipsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateRolesArgs {
  _set?: Maybe<TeacherRolesSetInput>;
  where: TeacherRolesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateRolesByPkArgs {
  _set?: Maybe<TeacherRolesSetInput>;
  pk_columns: TeacherRolesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<TeacherSchoolSettingsSetInput>;
  where: TeacherSchoolSettingsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<TeacherSchoolSettingsSetInput>;
  pk_columns: TeacherSchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<TeacherSchoolSettingsModulesSetInput>;
  where: TeacherSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<TeacherSchoolSettingsModulesSetInput>;
  pk_columns: TeacherSchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolsArgs {
  _set?: Maybe<TeacherSchoolsSetInput>;
  where: TeacherSchoolsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<TeacherSchoolsSetInput>;
  pk_columns: TeacherSchoolsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateStudentGroupUsersArgs {
  _set?: Maybe<TeacherStudentGroupUsersSetInput>;
  where: TeacherStudentGroupUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateStudentGroupUsersByPkArgs {
  _set?: Maybe<TeacherStudentGroupUsersSetInput>;
  pk_columns: TeacherStudentGroupUsersPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateStudentGroupsArgs {
  _set?: Maybe<TeacherStudentGroupsSetInput>;
  where: TeacherStudentGroupsBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateStudentGroupsByPkArgs {
  _set?: Maybe<TeacherStudentGroupsSetInput>;
  pk_columns: TeacherStudentGroupsPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateTasksArgs {
  _set?: Maybe<TeacherTasksSetInput>;
  where: TeacherTasksBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateTasksByPkArgs {
  _set?: Maybe<TeacherTasksSetInput>;
  pk_columns: TeacherTasksPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateTeachingStructuresArgs {
  _inc?: Maybe<TeacherTeachingStructuresIncInput>;
  _set?: Maybe<TeacherTeachingStructuresSetInput>;
  where: TeacherTeachingStructuresBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateTeachingStructuresByPkArgs {
  _inc?: Maybe<TeacherTeachingStructuresIncInput>;
  _set?: Maybe<TeacherTeachingStructuresSetInput>;
  pk_columns: TeacherTeachingStructuresPkColumnsInput;
}


/** mutation root */
export interface TeacherMutationRootUpdateUsersArgs {
  _set?: Maybe<TeacherUsersSetInput>;
  where: TeacherUsersBoolExp;
}


/** mutation root */
export interface TeacherMutationRootUpdateUsersByPkArgs {
  _set?: Maybe<TeacherUsersSetInput>;
  pk_columns: TeacherUsersPkColumnsInput;
}

/** columns and relationships of "notifications" */
export interface TeacherNotifications {
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "notifications" */
export interface TeacherNotificationsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherNotificationsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherNotifications>>;
}

/** aggregate fields of "notifications" */
export interface TeacherNotificationsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherNotificationsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherNotificationsMinFields>>;
}


/** aggregate fields of "notifications" */
export interface TeacherNotificationsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherNotificationsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export interface TeacherNotificationsBoolExp {
  _and?: Maybe<Array<TeacherNotificationsBoolExp>>;
  _not?: Maybe<TeacherNotificationsBoolExp>;
  _or?: Maybe<Array<TeacherNotificationsBoolExp>>;
  content?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_read?: Maybe<TeacherBooleanComparisonExp>;
  path?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "notifications" */
export const enum TeacherNotificationsConstraint {
  /** unique or primary key constraint */
  NOTIFICATIONS_PKEY = 'notifications_pkey'
};

/** input type for inserting data into table "notifications" */
export interface TeacherNotificationsInsertInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherNotificationsMaxFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherNotificationsMinFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "notifications" */
export interface TeacherNotificationsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherNotifications>>;
}

/** on conflict condition type for table "notifications" */
export interface TeacherNotificationsOnConflict {
  constraint: TeacherNotificationsConstraint;
  update_columns?: Array<TeacherNotificationsUpdateColumn>;
  where?: Maybe<TeacherNotificationsBoolExp>;
}

/** Ordering options when selecting data from "notifications". */
export interface TeacherNotificationsOrderBy {
  content?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_read?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: notifications */
export interface TeacherNotificationsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "notifications" */
export const enum TeacherNotificationsSelectColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "notifications" */
export interface TeacherNotificationsSetInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "notifications" */
export const enum TeacherNotificationsUpdateColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface TeacherNumericComparisonExp {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
}

/** column ordering options */
export const enum TeacherOrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "parent_student" */
export interface TeacherParentStudent {
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "parent_student". All fields are combined with a logical 'AND'. */
export interface TeacherParentStudentBoolExp {
  _and?: Maybe<Array<TeacherParentStudentBoolExp>>;
  _not?: Maybe<TeacherParentStudentBoolExp>;
  _or?: Maybe<Array<TeacherParentStudentBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  parent_id?: Maybe<TeacherUuidComparisonExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "parent_student" */
export const enum TeacherParentStudentConstraint {
  /** unique or primary key constraint */
  PARENT_STUDENT_PKEY = 'parent_student_pkey',
  /** unique or primary key constraint */
  PARENT_STUDENT_STUDENT_ID_KEY = 'parent_student_student_id_key'
};

/** input type for inserting data into table "parent_student" */
export interface TeacherParentStudentInsertInput {
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "parent_student" */
export interface TeacherParentStudentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherParentStudent>>;
}

/** on conflict condition type for table "parent_student" */
export interface TeacherParentStudentOnConflict {
  constraint: TeacherParentStudentConstraint;
  update_columns?: Array<TeacherParentStudentUpdateColumn>;
  where?: Maybe<TeacherParentStudentBoolExp>;
}

/** Ordering options when selecting data from "parent_student". */
export interface TeacherParentStudentOrderBy {
  id?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: parent_student */
export interface TeacherParentStudentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "parent_student" */
export const enum TeacherParentStudentSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** input type for updating data in table "parent_student" */
export interface TeacherParentStudentSetInput {
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "parent_student" */
export const enum TeacherParentStudentUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "parents" */
export interface TeacherParents {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "parents". All fields are combined with a logical 'AND'. */
export interface TeacherParentsBoolExp {
  _and?: Maybe<Array<TeacherParentsBoolExp>>;
  _not?: Maybe<TeacherParentsBoolExp>;
  _or?: Maybe<Array<TeacherParentsBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "parents". */
export interface TeacherParentsOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "parents" */
export const enum TeacherParentsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "permission_role" */
export interface TeacherPermissionRole {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  permission?: EntireFieldWrapper<Maybe<TeacherPermissions>>;
  permission_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  role?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  role_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "permission_role" */
export interface TeacherPermissionRoleAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherPermissionRoleMaxOrderBy>;
  min?: Maybe<TeacherPermissionRoleMinOrderBy>;
}

/** Boolean expression to filter rows from the table "permission_role". All fields are combined with a logical 'AND'. */
export interface TeacherPermissionRoleBoolExp {
  _and?: Maybe<Array<TeacherPermissionRoleBoolExp>>;
  _not?: Maybe<TeacherPermissionRoleBoolExp>;
  _or?: Maybe<Array<TeacherPermissionRoleBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  permission?: Maybe<TeacherPermissionsBoolExp>;
  permission_id?: Maybe<TeacherUuidComparisonExp>;
  role?: Maybe<TeacherRolesBoolExp>;
  role_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "permission_role" */
export interface TeacherPermissionRoleMaxOrderBy {
  id?: Maybe<TeacherOrderBy>;
  permission_id?: Maybe<TeacherOrderBy>;
  role_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "permission_role" */
export interface TeacherPermissionRoleMinOrderBy {
  id?: Maybe<TeacherOrderBy>;
  permission_id?: Maybe<TeacherOrderBy>;
  role_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "permission_role". */
export interface TeacherPermissionRoleOrderBy {
  id?: Maybe<TeacherOrderBy>;
  permission?: Maybe<TeacherPermissionsOrderBy>;
  permission_id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherRolesOrderBy>;
  role_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "permission_role" */
export const enum TeacherPermissionRoleSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  PERMISSION_ID = 'permission_id',
  /** column name */
  ROLE_ID = 'role_id'
};

/** columns and relationships of "permissions" */
export interface TeacherPermissions {
  id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export interface TeacherPermissionsBoolExp {
  _and?: Maybe<Array<TeacherPermissionsBoolExp>>;
  _not?: Maybe<TeacherPermissionsBoolExp>;
  _or?: Maybe<Array<TeacherPermissionsBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "permissions". */
export interface TeacherPermissionsOrderBy {
  id?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
}

/** select columns of table "permissions" */
export const enum TeacherPermissionsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title'
};

/** columns and relationships of "private.adresses" */
export interface TeacherPrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<TeacherUsers>;
}

/** aggregated selection of "private.adresses" */
export interface TeacherPrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherPrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface TeacherPrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherPrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface TeacherPrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherPrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface TeacherPrivateAdressesBoolExp {
  _and?: Maybe<Array<TeacherPrivateAdressesBoolExp>>;
  _not?: Maybe<TeacherPrivateAdressesBoolExp>;
  _or?: Maybe<Array<TeacherPrivateAdressesBoolExp>>;
  area?: Maybe<TeacherStringComparisonExp>;
  city?: Maybe<TeacherStringComparisonExp>;
  country?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  postal_code?: Maybe<TeacherStringComparisonExp>;
  street?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user?: Maybe<TeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum TeacherPrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface TeacherPrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<TeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface TeacherPrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherPrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface TeacherPrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherPrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface TeacherPrivateAdressesObjRelInsertInput {
  data: TeacherPrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherPrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface TeacherPrivateAdressesOnConflict {
  constraint: TeacherPrivateAdressesConstraint;
  update_columns?: Array<TeacherPrivateAdressesUpdateColumn>;
  where?: Maybe<TeacherPrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface TeacherPrivateAdressesOrderBy {
  area?: Maybe<TeacherOrderBy>;
  city?: Maybe<TeacherOrderBy>;
  country?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  postal_code?: Maybe<TeacherOrderBy>;
  street?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user?: Maybe<TeacherUsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface TeacherPrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum TeacherPrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface TeacherPrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum TeacherPrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface TeacherPrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface TeacherPrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherPrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface TeacherPrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface TeacherPrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherPrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface TeacherPrivateBirthdaysBoolExp {
  _and?: Maybe<Array<TeacherPrivateBirthdaysBoolExp>>;
  _not?: Maybe<TeacherPrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<TeacherPrivateBirthdaysBoolExp>>;
  date?: Maybe<TeacherDateComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum TeacherPrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface TeacherPrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherPrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherPrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface TeacherPrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherPrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface TeacherPrivateBirthdaysObjRelInsertInput {
  data: TeacherPrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherPrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface TeacherPrivateBirthdaysOnConflict {
  constraint: TeacherPrivateBirthdaysConstraint;
  update_columns?: Array<TeacherPrivateBirthdaysUpdateColumn>;
  where?: Maybe<TeacherPrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface TeacherPrivateBirthdaysOrderBy {
  date?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface TeacherPrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum TeacherPrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface TeacherPrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum TeacherPrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<TeacherUsers>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherPrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherPrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface TeacherPrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<TeacherPrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<TeacherPrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  user?: Maybe<TeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum TeacherPrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<TeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface TeacherPrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface TeacherPrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherPrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersObjRelInsertInput {
  data: TeacherPrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherPrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersOnConflict {
  constraint: TeacherPrivateInsuranceNumbersConstraint;
  update_columns?: Array<TeacherPrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface TeacherPrivateInsuranceNumbersOrderBy {
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  user?: Maybe<TeacherUsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface TeacherPrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum TeacherPrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface TeacherPrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum TeacherPrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<TeacherUsers>;
}

/** aggregated selection of "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherPrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherPrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface TeacherPrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<TeacherPrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<TeacherPrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  number?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user?: Maybe<TeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum TeacherPrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<TeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface TeacherPrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherPrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherPrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersObjRelInsertInput {
  data: TeacherPrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherPrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersOnConflict {
  constraint: TeacherPrivatePhoneNumbersConstraint;
  update_columns?: Array<TeacherPrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface TeacherPrivatePhoneNumbersOrderBy {
  country_code?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  number?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user?: Maybe<TeacherUsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface TeacherPrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum TeacherPrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface TeacherPrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum TeacherPrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "promotions" */
export interface TeacherPromotions {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_promoted: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  year: EntireFieldWrapper<TeacherYears>;
  year_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "promotions" */
export interface TeacherPromotionsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherPromotionsMaxOrderBy>;
  min?: Maybe<TeacherPromotionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export interface TeacherPromotionsBoolExp {
  _and?: Maybe<Array<TeacherPromotionsBoolExp>>;
  _not?: Maybe<TeacherPromotionsBoolExp>;
  _or?: Maybe<Array<TeacherPromotionsBoolExp>>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_promoted?: Maybe<TeacherBooleanComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  year?: Maybe<TeacherYearsBoolExp>;
  year_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "promotions" */
export interface TeacherPromotionsMaxOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  year_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "promotions" */
export interface TeacherPromotionsMinOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  year_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "promotions". */
export interface TeacherPromotionsOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_promoted?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  year?: Maybe<TeacherYearsOrderBy>;
  year_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "promotions" */
export const enum TeacherPromotionsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PROMOTED = 'is_promoted',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  YEAR_ID = 'year_id'
};

export interface TeacherQueryRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<TeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<TeacherAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<TeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<TeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<TeacherAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<TeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<TeacherAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<TeacherAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<TeacherAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<TeacherAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_types" */
  assignment_question_types: EntireFieldWrapper<Array<TeacherAssignmentQuestionTypes>>;
  /** fetch data from the table: "assignment_question_types" using primary key columns */
  assignment_question_types_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionTypes>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<TeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<TeacherAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<TeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<TeacherAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<TeacherAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<TeacherAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<TeacherAttendances>>;
  /** fetch aggregated fields from the table: "attendances" */
  attendances_aggregate: EntireFieldWrapper<TeacherAttendancesAggregate>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendances>>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<TeacherAuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<TeacherAuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<TeacherAuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<TeacherAuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<TeacherAuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<TeacherAuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<TeacherAuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<TeacherAuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<TeacherAuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<TeacherAuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<TeacherAuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<TeacherAuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<TeacherAuthRoles>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<TeacherBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<TeacherBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<TeacherBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<TeacherBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<TeacherBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<TeacherBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<TeacherBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<TeacherBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<TeacherBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<TeacherBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<TeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<TeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<TeacherChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<TeacherChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<TeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<TeacherChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<TeacherChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<TeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<TeacherChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<TeacherChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<TeacherChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<TeacherChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<TeacherChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<TeacherChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<TeacherChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<TeacherClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<TeacherClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<TeacherClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<TeacherClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<TeacherClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<TeacherClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<TeacherClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<TeacherCourseClass>>;
  /** fetch aggregated fields from the table: "course_class" */
  course_class_aggregate: EntireFieldWrapper<TeacherCourseClassAggregate>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<TeacherCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<TeacherCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<TeacherCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<TeacherCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<TeacherCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<TeacherEventUsers>>;
  /** fetch aggregated fields from the table: "event_users" */
  event_users_aggregate: EntireFieldWrapper<TeacherEventUsersAggregate>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<TeacherEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<TeacherEvents>>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: EntireFieldWrapper<TeacherEventsAggregate>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<TeacherEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<TeacherFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<TeacherFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<TeacherGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<TeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<TeacherGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<TeacherLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<TeacherLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<TeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<TeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<TeacherLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<TeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<TeacherLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<TeacherLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<TeacherLiveClassAttendees>>;
  /** An aggregate relationship */
  live_class_attendees_aggregate: EntireFieldWrapper<TeacherLiveClassAttendeesAggregate>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<TeacherLiveClasses>>;
  /** fetch aggregated fields from the table: "live_classes" */
  live_classes_aggregate: EntireFieldWrapper<TeacherLiveClassesAggregate>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<TeacherMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  me?: EntireFieldWrapper<Maybe<TeacherUserData>>;
  /** fetch data from the table: "meeting_groups" */
  meeting_groups: EntireFieldWrapper<Array<TeacherMeetingGroups>>;
  /** fetch data from the table: "meeting_groups" using primary key columns */
  meeting_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroups>>;
  /** fetch data from the table: "meeting_groups_student" */
  meeting_groups_student: EntireFieldWrapper<Array<TeacherMeetingGroupsStudent>>;
  /** fetch data from the table: "meeting_groups_student" using primary key columns */
  meeting_groups_student_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudent>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<TeacherMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<TeacherMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<TeacherNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<TeacherNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<TeacherNotifications>>;
  /** fetch data from the table: "parent_student" */
  parent_student: EntireFieldWrapper<Array<TeacherParentStudent>>;
  /** fetch data from the table: "parent_student" using primary key columns */
  parent_student_by_pk?: EntireFieldWrapper<Maybe<TeacherParentStudent>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<TeacherParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<TeacherParents>>;
  /** fetch data from the table: "permission_role" */
  permission_role: EntireFieldWrapper<Array<TeacherPermissionRole>>;
  /** fetch data from the table: "permission_role" using primary key columns */
  permission_role_by_pk?: EntireFieldWrapper<Maybe<TeacherPermissionRole>>;
  /** fetch data from the table: "permissions" */
  permissions: EntireFieldWrapper<Array<TeacherPermissions>>;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: EntireFieldWrapper<Maybe<TeacherPermissions>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<TeacherPrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<TeacherPrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<TeacherPrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<TeacherPrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<TeacherPrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<TeacherPrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<TeacherPrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<TeacherPrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbers>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<TeacherPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<TeacherPromotions>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<TeacherRelationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<TeacherRelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<TeacherRelationships>>;
  /** fetch data from the table: "roles" */
  roles: EntireFieldWrapper<Array<TeacherRoles>>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<TeacherSchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<TeacherSchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<TeacherSchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<TeacherSchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<TeacherSchools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<TeacherSchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<TeacherSchools>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<TeacherSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<TeacherSemesters>>;
  /** fetch data from the table: "student_class" */
  student_class: EntireFieldWrapper<Array<TeacherStudentClass>>;
  /** fetch data from the table: "student_class" using primary key columns */
  student_class_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentClass>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<TeacherStudentGroupUsers>>;
  /** fetch aggregated fields from the table: "student_group_users" */
  student_group_users_aggregate: EntireFieldWrapper<TeacherStudentGroupUsersAggregate>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<TeacherStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<TeacherStudents>>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<TeacherSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<TeacherTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<TeacherTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<TeacherTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
  /** fetch data from the table: "teacher_subject" using primary key columns */
  teacher_subject_by_pk?: EntireFieldWrapper<Maybe<TeacherTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<TeacherTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structure_types" */
  teaching_structure_types: EntireFieldWrapper<Array<TeacherTeachingStructureTypes>>;
  /** fetch data from the table: "teaching_structure_types" using primary key columns */
  teaching_structure_types_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructureTypes>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<TeacherUsers>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<TeacherUsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<TeacherViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<TeacherViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<TeacherViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<TeacherViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<TeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<TeacherViewGradesAggregate>;
  /** fetch data from the table: "view.grades_by_subjects_and_classes" */
  view_grades_by_subjects_and_classes: EntireFieldWrapper<Array<TeacherViewGradesBySubjectsAndClasses>>;
  /** fetch data from the table: "view.grades_by_subjects_classes_semester_year" */
  view_grades_by_subjects_classes_semester_year: EntireFieldWrapper<Array<TeacherViewGradesBySubjectsClassesSemesterYear>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<TeacherViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<TeacherViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<TeacherViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<TeacherViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<TeacherViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<TeacherYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<TeacherYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<TeacherYears>>;
}


export interface TeacherQueryRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<TeacherAssignmentAttendeeTypeBoolExp>;
}


export interface TeacherQueryRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface TeacherQueryRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<TeacherAssignmentBookChapterBoolExp>;
}


export interface TeacherQueryRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionBoolExp>;
}


export interface TeacherQueryRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
}


export interface TeacherQueryRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
}


export interface TeacherQueryRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentFilesOrderBy>>;
  where?: Maybe<TeacherAssignmentFilesBoolExp>;
}


export interface TeacherQueryRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
}


export interface TeacherQueryRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
}


export interface TeacherQueryRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentNotesOrderBy>>;
  where?: Maybe<TeacherAssignmentNotesBoolExp>;
}


export interface TeacherQueryRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionAnswersBoolExp>;
}


export interface TeacherQueryRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
}


export interface TeacherQueryRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
}


export interface TeacherQueryRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentQuestionTypesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionTypesOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionTypesBoolExp>;
}


export interface TeacherQueryRootAssignmentQuestionTypesByPkArgs {
  value: Scalars['String'];
}


export interface TeacherQueryRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionsBoolExp>;
}


export interface TeacherQueryRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuizOrderBy>>;
  where?: Maybe<TeacherAssignmentQuizBoolExp>;
}


export interface TeacherQueryRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<TeacherAssignmentSubmitsBoolExp>;
}


export interface TeacherQueryRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentTypeOrderBy>>;
  where?: Maybe<TeacherAssignmentTypeBoolExp>;
}


export interface TeacherQueryRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentUserOrderBy>>;
  where?: Maybe<TeacherAssignmentUserBoolExp>;
}


export interface TeacherQueryRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


export interface TeacherQueryRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


export interface TeacherQueryRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<TeacherAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendanceTypesOrderBy>>;
  where?: Maybe<TeacherAttendanceTypesBoolExp>;
}


export interface TeacherQueryRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface TeacherQueryRootAttendancesArgs {
  distinct_on?: Maybe<Array<TeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendancesOrderBy>>;
  where?: Maybe<TeacherAttendancesBoolExp>;
}


export interface TeacherQueryRootAttendancesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendancesOrderBy>>;
  where?: Maybe<TeacherAttendancesBoolExp>;
}


export interface TeacherQueryRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}


export interface TeacherQueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<TeacherAuthAccountProvidersBoolExp>;
}


export interface TeacherQueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


export interface TeacherQueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<TeacherAuthAccountRolesBoolExp>;
}


export interface TeacherQueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountsOrderBy>>;
  where?: Maybe<TeacherAuthAccountsBoolExp>;
}


export interface TeacherQueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthAccountsOrderBy>>;
  where?: Maybe<TeacherAuthAccountsBoolExp>;
}


export interface TeacherQueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<TeacherAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthProvidersOrderBy>>;
  where?: Maybe<TeacherAuthProvidersBoolExp>;
}


export interface TeacherQueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthProvidersOrderBy>>;
  where?: Maybe<TeacherAuthProvidersBoolExp>;
}


export interface TeacherQueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface TeacherQueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<TeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<TeacherAuthRefreshTokensBoolExp>;
}


export interface TeacherQueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<TeacherAuthRefreshTokensBoolExp>;
}


export interface TeacherQueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface TeacherQueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<TeacherAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRolesOrderBy>>;
  where?: Maybe<TeacherAuthRolesBoolExp>;
}


export interface TeacherQueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAuthRolesOrderBy>>;
  where?: Maybe<TeacherAuthRolesBoolExp>;
}


export interface TeacherQueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface TeacherQueryRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<TeacherBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChapterTypeOrderBy>>;
  where?: Maybe<TeacherBookChapterTypeBoolExp>;
}


export interface TeacherQueryRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChaptersOrderBy>>;
  where?: Maybe<TeacherBookChaptersBoolExp>;
}


export interface TeacherQueryRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootBookCourseArgs {
  distinct_on?: Maybe<Array<TeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookCourseOrderBy>>;
  where?: Maybe<TeacherBookCourseBoolExp>;
}


export interface TeacherQueryRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootBookUserArgs {
  distinct_on?: Maybe<Array<TeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookUserOrderBy>>;
  where?: Maybe<TeacherBookUserBoolExp>;
}


export interface TeacherQueryRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootBooksArgs {
  distinct_on?: Maybe<Array<TeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBooksOrderBy>>;
  where?: Maybe<TeacherBooksBoolExp>;
}


export interface TeacherQueryRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<TeacherChapterSectionNotesBoolExp>;
}


export interface TeacherQueryRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
}


export interface TeacherQueryRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionTypeOrderBy>>;
  where?: Maybe<TeacherChapterSectionTypeBoolExp>;
}


export interface TeacherQueryRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionsOrderBy>>;
  where?: Maybe<TeacherChapterSectionsBoolExp>;
}


export interface TeacherQueryRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


export interface TeacherQueryRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


export interface TeacherQueryRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageReadsOrderBy>>;
  where?: Maybe<TeacherChatMessageReadsBoolExp>;
}


export interface TeacherQueryRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


export interface TeacherQueryRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


export interface TeacherQueryRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChatTypeArgs {
  distinct_on?: Maybe<Array<TeacherChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatTypeOrderBy>>;
  where?: Maybe<TeacherChatTypeBoolExp>;
}


export interface TeacherQueryRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootChatUserArgs {
  distinct_on?: Maybe<Array<TeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatUserOrderBy>>;
  where?: Maybe<TeacherChatUserBoolExp>;
}


export interface TeacherQueryRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootChatsArgs {
  distinct_on?: Maybe<Array<TeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatsOrderBy>>;
  where?: Maybe<TeacherChatsBoolExp>;
}


export interface TeacherQueryRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootClassLevelsArgs {
  distinct_on?: Maybe<Array<TeacherClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassLevelsOrderBy>>;
  where?: Maybe<TeacherClassLevelsBoolExp>;
}


export interface TeacherQueryRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootClassTypeArgs {
  distinct_on?: Maybe<Array<TeacherClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassTypeOrderBy>>;
  where?: Maybe<TeacherClassTypeBoolExp>;
}


export interface TeacherQueryRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootClassesArgs {
  distinct_on?: Maybe<Array<TeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassesOrderBy>>;
  where?: Maybe<TeacherClassesBoolExp>;
}


export interface TeacherQueryRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootClassroomsArgs {
  distinct_on?: Maybe<Array<TeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassroomsOrderBy>>;
  where?: Maybe<TeacherClassroomsBoolExp>;
}


export interface TeacherQueryRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootCourseClassArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


export interface TeacherQueryRootCourseClassAggregateArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


export interface TeacherQueryRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassroomOrderBy>>;
  where?: Maybe<TeacherCourseClassroomBoolExp>;
}


export interface TeacherQueryRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootCourseStudentArgs {
  distinct_on?: Maybe<Array<TeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseStudentOrderBy>>;
  where?: Maybe<TeacherCourseStudentBoolExp>;
}


export interface TeacherQueryRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<TeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseTeacherOrderBy>>;
  where?: Maybe<TeacherCourseTeacherBoolExp>;
}


export interface TeacherQueryRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootCoursesArgs {
  distinct_on?: Maybe<Array<TeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCoursesOrderBy>>;
  where?: Maybe<TeacherCoursesBoolExp>;
}


export interface TeacherQueryRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootEventUsersArgs {
  distinct_on?: Maybe<Array<TeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventUsersOrderBy>>;
  where?: Maybe<TeacherEventUsersBoolExp>;
}


export interface TeacherQueryRootEventUsersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventUsersOrderBy>>;
  where?: Maybe<TeacherEventUsersBoolExp>;
}


export interface TeacherQueryRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootEventsArgs {
  distinct_on?: Maybe<Array<TeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventsOrderBy>>;
  where?: Maybe<TeacherEventsBoolExp>;
}


export interface TeacherQueryRootEventsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventsOrderBy>>;
  where?: Maybe<TeacherEventsBoolExp>;
}


export interface TeacherQueryRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootFilesArgs {
  distinct_on?: Maybe<Array<TeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherFilesOrderBy>>;
  where?: Maybe<TeacherFilesBoolExp>;
}


export interface TeacherQueryRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootGradeTypesArgs {
  distinct_on?: Maybe<Array<TeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradeTypesOrderBy>>;
  where?: Maybe<TeacherGradeTypesBoolExp>;
}


export interface TeacherQueryRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


export interface TeacherQueryRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


export interface TeacherQueryRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<TeacherLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLatestActivitiesOrderBy>>;
  where?: Maybe<TeacherLatestActivitiesBoolExp>;
}


export interface TeacherQueryRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<TeacherLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonAttendaceTypeOrderBy>>;
  where?: Maybe<TeacherLessonAttendaceTypeBoolExp>;
}


export interface TeacherQueryRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherQueryRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<TeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonAttendancesOrderBy>>;
  where?: Maybe<TeacherLessonAttendancesBoolExp>;
}


export interface TeacherQueryRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootLessonsArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


export interface TeacherQueryRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


export interface TeacherQueryRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}


export interface TeacherQueryRootLiveClassAttendeesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}


export interface TeacherQueryRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootLiveClassesArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassesOrderBy>>;
  where?: Maybe<TeacherLiveClassesBoolExp>;
}


export interface TeacherQueryRootLiveClassesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassesOrderBy>>;
  where?: Maybe<TeacherLiveClassesBoolExp>;
}


export interface TeacherQueryRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootMarksArgs {
  distinct_on?: Maybe<Array<TeacherMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMarksOrderBy>>;
  where?: Maybe<TeacherMarksBoolExp>;
}


export interface TeacherQueryRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootMeetingGroupsArgs {
  distinct_on?: Maybe<Array<TeacherMeetingGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingGroupsOrderBy>>;
  where?: Maybe<TeacherMeetingGroupsBoolExp>;
}


export interface TeacherQueryRootMeetingGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootMeetingGroupsStudentArgs {
  distinct_on?: Maybe<Array<TeacherMeetingGroupsStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingGroupsStudentOrderBy>>;
  where?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
}


export interface TeacherQueryRootMeetingGroupsStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootMeetingUserArgs {
  distinct_on?: Maybe<Array<TeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingUserOrderBy>>;
  where?: Maybe<TeacherMeetingUserBoolExp>;
}


export interface TeacherQueryRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<TeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingUserOrderBy>>;
  where?: Maybe<TeacherMeetingUserBoolExp>;
}


export interface TeacherQueryRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootNotificationsArgs {
  distinct_on?: Maybe<Array<TeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherNotificationsOrderBy>>;
  where?: Maybe<TeacherNotificationsBoolExp>;
}


export interface TeacherQueryRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherNotificationsOrderBy>>;
  where?: Maybe<TeacherNotificationsBoolExp>;
}


export interface TeacherQueryRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootParentStudentArgs {
  distinct_on?: Maybe<Array<TeacherParentStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherParentStudentOrderBy>>;
  where?: Maybe<TeacherParentStudentBoolExp>;
}


export interface TeacherQueryRootParentStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootParentsArgs {
  distinct_on?: Maybe<Array<TeacherParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherParentsOrderBy>>;
  where?: Maybe<TeacherParentsBoolExp>;
}


export interface TeacherQueryRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPermissionRoleArgs {
  distinct_on?: Maybe<Array<TeacherPermissionRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPermissionRoleOrderBy>>;
  where?: Maybe<TeacherPermissionRoleBoolExp>;
}


export interface TeacherQueryRootPermissionRoleByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPermissionsArgs {
  distinct_on?: Maybe<Array<TeacherPermissionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPermissionsOrderBy>>;
  where?: Maybe<TeacherPermissionsBoolExp>;
}


export interface TeacherQueryRootPermissionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<TeacherPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateAdressesOrderBy>>;
  where?: Maybe<TeacherPrivateAdressesBoolExp>;
}


export interface TeacherQueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateAdressesOrderBy>>;
  where?: Maybe<TeacherPrivateAdressesBoolExp>;
}


export interface TeacherQueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<TeacherPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateBirthdaysOrderBy>>;
  where?: Maybe<TeacherPrivateBirthdaysBoolExp>;
}


export interface TeacherQueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<TeacherPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateBirthdaysOrderBy>>;
  where?: Maybe<TeacherPrivateBirthdaysBoolExp>;
}


export interface TeacherQueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<TeacherPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
}


export interface TeacherQueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
}


export interface TeacherQueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<TeacherPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
}


export interface TeacherQueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
}


export interface TeacherQueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootPromotionsArgs {
  distinct_on?: Maybe<Array<TeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPromotionsOrderBy>>;
  where?: Maybe<TeacherPromotionsBoolExp>;
}


export interface TeacherQueryRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}


export interface TeacherQueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}


export interface TeacherQueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootRolesArgs {
  distinct_on?: Maybe<Array<TeacherRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRolesOrderBy>>;
  where?: Maybe<TeacherRolesBoolExp>;
}


export interface TeacherQueryRootRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<TeacherSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolSettingsOrderBy>>;
  where?: Maybe<TeacherSchoolSettingsBoolExp>;
}


export interface TeacherQueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolSettingsOrderBy>>;
  where?: Maybe<TeacherSchoolSettingsBoolExp>;
}


export interface TeacherQueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<TeacherSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolSettingsModulesOrderBy>>;
  where?: Maybe<TeacherSchoolSettingsModulesBoolExp>;
}


export interface TeacherQueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolSettingsModulesOrderBy>>;
  where?: Maybe<TeacherSchoolSettingsModulesBoolExp>;
}


export interface TeacherQueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<TeacherSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolsOrderBy>>;
  where?: Maybe<TeacherSchoolsBoolExp>;
}


export interface TeacherQueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSchoolsOrderBy>>;
  where?: Maybe<TeacherSchoolsBoolExp>;
}


export interface TeacherQueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootSemestersArgs {
  distinct_on?: Maybe<Array<TeacherSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSemestersOrderBy>>;
  where?: Maybe<TeacherSemestersBoolExp>;
}


export interface TeacherQueryRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootStudentClassArgs {
  distinct_on?: Maybe<Array<TeacherStudentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentClassOrderBy>>;
  where?: Maybe<TeacherStudentClassBoolExp>;
}


export interface TeacherQueryRootStudentClassByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


export interface TeacherQueryRootStudentGroupUsersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


export interface TeacherQueryRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupsOrderBy>>;
  where?: Maybe<TeacherStudentGroupsBoolExp>;
}


export interface TeacherQueryRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootStudentsArgs {
  distinct_on?: Maybe<Array<TeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentsOrderBy>>;
  where?: Maybe<TeacherStudentsBoolExp>;
}


export interface TeacherQueryRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectsOrderBy>>;
  where?: Maybe<TeacherSubjectsBoolExp>;
}


export interface TeacherQueryRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootTasksArgs {
  distinct_on?: Maybe<Array<TeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTasksOrderBy>>;
  where?: Maybe<TeacherTasksBoolExp>;
}


export interface TeacherQueryRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTasksOrderBy>>;
  where?: Maybe<TeacherTasksBoolExp>;
}


export interface TeacherQueryRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<TeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeacherSubjectOrderBy>>;
  where?: Maybe<TeacherTeacherSubjectBoolExp>;
}


export interface TeacherQueryRootTeacherSubjectByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootTeachersArgs {
  distinct_on?: Maybe<Array<TeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachersOrderBy>>;
  where?: Maybe<TeacherTeachersBoolExp>;
}


export interface TeacherQueryRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootTeachingStructureLeafsArgs {
  args: TeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructureLeafsAggregateArgs {
  args: TeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructureParentsArgs {
  args: TeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructureParentsAggregateArgs {
  args: TeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructureTypesArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructureTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructureTypesOrderBy>>;
  where?: Maybe<TeacherTeachingStructureTypesBoolExp>;
}


export interface TeacherQueryRootTeachingStructureTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherQueryRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootUsersArgs {
  distinct_on?: Maybe<Array<TeacherUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherUsersOrderBy>>;
  where?: Maybe<TeacherUsersBoolExp>;
}


export interface TeacherQueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherUsersOrderBy>>;
  where?: Maybe<TeacherUsersBoolExp>;
}


export interface TeacherQueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherQueryRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<TeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<TeacherViewAssignmentClassBoolExp>;
}


export interface TeacherQueryRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<TeacherViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<TeacherViewAssignmentStudentGradeBoolExp>;
}


export interface TeacherQueryRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<TeacherViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewClassStudentOrderBy>>;
  where?: Maybe<TeacherViewClassStudentBoolExp>;
}


export interface TeacherQueryRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<TeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<TeacherViewGradeTypeSubjectBoolExp>;
}


export interface TeacherQueryRootViewGradesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


export interface TeacherQueryRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


export interface TeacherQueryRootViewGradesBySubjectsAndClassesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesOrderBy>>;
  where?: Maybe<TeacherViewGradesBySubjectsAndClassesBoolExp>;
}


export interface TeacherQueryRootViewGradesBySubjectsClassesSemesterYearArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearOrderBy>>;
  where?: Maybe<TeacherViewGradesBySubjectsClassesSemesterYearBoolExp>;
}


export interface TeacherQueryRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<TeacherViewLatestChatMessagesBoolExp>;
}


export interface TeacherQueryRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<TeacherViewLatestChatMessagesBoolExp>;
}


export interface TeacherQueryRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<TeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface TeacherQueryRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<TeacherViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewSubjectSemesterOrderBy>>;
  where?: Maybe<TeacherViewSubjectSemesterBoolExp>;
}


export interface TeacherQueryRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<TeacherViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<TeacherViewTeacherClassSubjectBoolExp>;
}


export interface TeacherQueryRootYearsArgs {
  distinct_on?: Maybe<Array<TeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherYearsOrderBy>>;
  where?: Maybe<TeacherYearsBoolExp>;
}


export interface TeacherQueryRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherYearsOrderBy>>;
  where?: Maybe<TeacherYearsBoolExp>;
}


export interface TeacherQueryRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface TeacherRelationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<TeacherUsers>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<TeacherAuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<TeacherUsers>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface TeacherRelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherRelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherRelationships>>;
}

/** aggregate fields of "relationships" */
export interface TeacherRelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherRelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherRelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface TeacherRelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface TeacherRelationshipsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherRelationshipsMaxOrderBy>;
  min?: Maybe<TeacherRelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface TeacherRelationshipsArrRelInsertInput {
  data: Array<TeacherRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherRelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface TeacherRelationshipsBoolExp {
  _and?: Maybe<Array<TeacherRelationshipsBoolExp>>;
  _not?: Maybe<TeacherRelationshipsBoolExp>;
  _or?: Maybe<Array<TeacherRelationshipsBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  related?: Maybe<TeacherUsersBoolExp>;
  related_id?: Maybe<TeacherUuidComparisonExp>;
  role?: Maybe<TeacherStringComparisonExp>;
  roleByRole?: Maybe<TeacherAuthRolesBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user?: Maybe<TeacherUsersBoolExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum TeacherRelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface TeacherRelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<TeacherUsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<TeacherAuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<TeacherUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherRelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface TeacherRelationshipsMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  related_id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherRelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface TeacherRelationshipsMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  related_id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface TeacherRelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherRelationships>>;
}

/** on conflict condition type for table "relationships" */
export interface TeacherRelationshipsOnConflict {
  constraint: TeacherRelationshipsConstraint;
  update_columns?: Array<TeacherRelationshipsUpdateColumn>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface TeacherRelationshipsOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  related?: Maybe<TeacherUsersOrderBy>;
  related_id?: Maybe<TeacherOrderBy>;
  role?: Maybe<TeacherOrderBy>;
  roleByRole?: Maybe<TeacherAuthRolesOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user?: Maybe<TeacherUsersOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: relationships */
export interface TeacherRelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum TeacherRelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface TeacherRelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum TeacherRelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "roles" */
export interface TeacherRoles {
  colour?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  permissions: EntireFieldWrapper<Array<TeacherPermissionRole>>;
  title: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "roles" */
export interface TeacherRolesPermissionsArgs {
  distinct_on?: Maybe<Array<TeacherPermissionRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPermissionRoleOrderBy>>;
  where?: Maybe<TeacherPermissionRoleBoolExp>;
}

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export interface TeacherRolesBoolExp {
  _and?: Maybe<Array<TeacherRolesBoolExp>>;
  _not?: Maybe<TeacherRolesBoolExp>;
  _or?: Maybe<Array<TeacherRolesBoolExp>>;
  colour?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  permissions?: Maybe<TeacherPermissionRoleBoolExp>;
  title?: Maybe<TeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "roles" */
export const enum TeacherRolesConstraint {
  /** unique or primary key constraint */
  ROLE_PKEY = 'role_pkey'
};

/** input type for inserting data into table "roles" */
export interface TeacherRolesInsertInput {
  colour?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
}

/** response of any mutation on the table "roles" */
export interface TeacherRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherRoles>>;
}

/** on conflict condition type for table "roles" */
export interface TeacherRolesOnConflict {
  constraint: TeacherRolesConstraint;
  update_columns?: Array<TeacherRolesUpdateColumn>;
  where?: Maybe<TeacherRolesBoolExp>;
}

/** Ordering options when selecting data from "roles". */
export interface TeacherRolesOrderBy {
  colour?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  permissions_aggregate?: Maybe<TeacherPermissionRoleAggregateOrderBy>;
  title?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: roles */
export interface TeacherRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "roles" */
export const enum TeacherRolesSelectColumn {
  /** column name */
  COLOUR = 'colour',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title'
};

/** input type for updating data in table "roles" */
export interface TeacherRolesSetInput {
  colour?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "roles" */
export const enum TeacherRolesUpdateColumn {
  /** column name */
  COLOUR = 'colour',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface TeacherSchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<TeacherSchools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface TeacherSchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherSchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface TeacherSchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface TeacherSchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherSchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface TeacherSchoolSettingsBoolExp {
  _and?: Maybe<Array<TeacherSchoolSettingsBoolExp>>;
  _not?: Maybe<TeacherSchoolSettingsBoolExp>;
  _or?: Maybe<Array<TeacherSchoolSettingsBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  school?: Maybe<TeacherSchoolsBoolExp>;
  school_id?: Maybe<TeacherUuidComparisonExp>;
  school_settings_module?: Maybe<TeacherSchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum TeacherSchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface TeacherSchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<TeacherSchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<TeacherSchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherSchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherSchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface TeacherSchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<TeacherSchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface TeacherSchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherSchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface TeacherSchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherSchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface TeacherSchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherSchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface TeacherSchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<TeacherSchoolSettingsModulesBoolExp>>;
  _not?: Maybe<TeacherSchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<TeacherSchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<TeacherBooleanComparisonExp>;
  chat?: Maybe<TeacherBooleanComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grading?: Maybe<TeacherBooleanComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  live_class?: Maybe<TeacherBooleanComparisonExp>;
  school_setting?: Maybe<TeacherSchoolSettingsBoolExp>;
  school_settings_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum TeacherSchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface TeacherSchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<TeacherSchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherSchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherSchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface TeacherSchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherSchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface TeacherSchoolSettingsModulesObjRelInsertInput {
  data: TeacherSchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherSchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface TeacherSchoolSettingsModulesOnConflict {
  constraint: TeacherSchoolSettingsModulesConstraint;
  update_columns?: Array<TeacherSchoolSettingsModulesUpdateColumn>;
  where?: Maybe<TeacherSchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface TeacherSchoolSettingsModulesOrderBy {
  assignments?: Maybe<TeacherOrderBy>;
  chat?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grading?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  live_class?: Maybe<TeacherOrderBy>;
  school_setting?: Maybe<TeacherSchoolSettingsOrderBy>;
  school_settings_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface TeacherSchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum TeacherSchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface TeacherSchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum TeacherSchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface TeacherSchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherSchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface TeacherSchoolSettingsObjRelInsertInput {
  data: TeacherSchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherSchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface TeacherSchoolSettingsOnConflict {
  constraint: TeacherSchoolSettingsConstraint;
  update_columns?: Array<TeacherSchoolSettingsUpdateColumn>;
  where?: Maybe<TeacherSchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface TeacherSchoolSettingsOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  school?: Maybe<TeacherSchoolsOrderBy>;
  school_id?: Maybe<TeacherOrderBy>;
  school_settings_module?: Maybe<TeacherSchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: school_settings */
export interface TeacherSchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum TeacherSchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface TeacherSchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum TeacherSchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface TeacherSchools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<TeacherSchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface TeacherSchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherSchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherSchools>>;
}

/** aggregate fields of "schools" */
export interface TeacherSchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherSchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherSchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface TeacherSchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherSchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface TeacherSchoolsBoolExp {
  _and?: Maybe<Array<TeacherSchoolsBoolExp>>;
  _not?: Maybe<TeacherSchoolsBoolExp>;
  _or?: Maybe<Array<TeacherSchoolsBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  path?: Maybe<TeacherStringComparisonExp>;
  school_setting?: Maybe<TeacherSchoolSettingsBoolExp>;
  serial?: Maybe<TeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum TeacherSchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface TeacherSchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<TeacherSchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface TeacherSchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface TeacherSchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface TeacherSchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherSchools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface TeacherSchoolsObjRelInsertInput {
  data: TeacherSchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherSchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface TeacherSchoolsOnConflict {
  constraint: TeacherSchoolsConstraint;
  update_columns?: Array<TeacherSchoolsUpdateColumn>;
  where?: Maybe<TeacherSchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface TeacherSchoolsOrderBy {
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  path?: Maybe<TeacherOrderBy>;
  school_setting?: Maybe<TeacherSchoolSettingsOrderBy>;
  serial?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: schools */
export interface TeacherSchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum TeacherSchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface TeacherSchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum TeacherSchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** columns and relationships of "semesters" */
export interface TeacherSemesters {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_at: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  start_at: EntireFieldWrapper<Scalars['date']>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "semesters". All fields are combined with a logical 'AND'. */
export interface TeacherSemestersBoolExp {
  _and?: Maybe<Array<TeacherSemestersBoolExp>>;
  _not?: Maybe<TeacherSemestersBoolExp>;
  _or?: Maybe<Array<TeacherSemestersBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  end_at?: Maybe<TeacherDateComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  start_at?: Maybe<TeacherDateComparisonExp>;
  teaching_structure?: Maybe<TeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "semesters". */
export interface TeacherSemestersOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  end_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  start_at?: Maybe<TeacherOrderBy>;
  teaching_structure?: Maybe<TeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "semesters" */
export const enum TeacherSemestersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_AT = 'end_at',
  /** column name */
  ID = 'id',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "student_class" */
export interface TeacherStudentClass {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user: EntireFieldWrapper<Array<TeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_class" */
export interface TeacherStudentClassUserArgs {
  distinct_on?: Maybe<Array<TeacherUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherUsersOrderBy>>;
  where?: Maybe<TeacherUsersBoolExpRemoteRelStudentClassuser>;
}

/** Boolean expression to filter rows from the table "student_class". All fields are combined with a logical 'AND'. */
export interface TeacherStudentClassBoolExp {
  _and?: Maybe<Array<TeacherStudentClassBoolExp>>;
  _not?: Maybe<TeacherStudentClassBoolExp>;
  _or?: Maybe<Array<TeacherStudentClassBoolExp>>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "student_class". */
export interface TeacherStudentClassOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "student_class" */
export const enum TeacherStudentClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "student_group_users" */
export interface TeacherStudentGroupUsers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  live_class_group: EntireFieldWrapper<Array<TeacherStudentGroups>>;
  student_group_id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_group_users" */
export interface TeacherStudentGroupUsersLiveClassGroupArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupsOrderBy>>;
  where?: Maybe<TeacherStudentGroupsBoolExp>;
}

/** aggregated selection of "student_group_users" */
export interface TeacherStudentGroupUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherStudentGroupUsers>>;
}

/** aggregate fields of "student_group_users" */
export interface TeacherStudentGroupUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsersMinFields>>;
}


/** aggregate fields of "student_group_users" */
export interface TeacherStudentGroupUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "student_group_users" */
export interface TeacherStudentGroupUsersAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherStudentGroupUsersMaxOrderBy>;
  min?: Maybe<TeacherStudentGroupUsersMinOrderBy>;
}

/** input type for inserting array relation for remote table "student_group_users" */
export interface TeacherStudentGroupUsersArrRelInsertInput {
  data: Array<TeacherStudentGroupUsersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherStudentGroupUsersOnConflict>;
}

/** Boolean expression to filter rows from the table "student_group_users". All fields are combined with a logical 'AND'. */
export interface TeacherStudentGroupUsersBoolExp {
  _and?: Maybe<Array<TeacherStudentGroupUsersBoolExp>>;
  _not?: Maybe<TeacherStudentGroupUsersBoolExp>;
  _or?: Maybe<Array<TeacherStudentGroupUsersBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  live_class_group?: Maybe<TeacherStudentGroupsBoolExp>;
  student_group_id?: Maybe<TeacherUuidComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "student_group_users" */
export const enum TeacherStudentGroupUsersConstraint {
  /** unique or primary key constraint */
  LIVE_CLASS_USER_IN_GROUPS_PKEY = 'live_class_user_in_groups_pkey'
};

/** input type for inserting data into table "student_group_users" */
export interface TeacherStudentGroupUsersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  live_class_group?: Maybe<TeacherStudentGroupsArrRelInsertInput>;
  student_group_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface TeacherStudentGroupUsersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "student_group_users" */
export interface TeacherStudentGroupUsersMaxOrderBy {
  id?: Maybe<TeacherOrderBy>;
  student_group_id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherStudentGroupUsersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "student_group_users" */
export interface TeacherStudentGroupUsersMinOrderBy {
  id?: Maybe<TeacherOrderBy>;
  student_group_id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "student_group_users" */
export interface TeacherStudentGroupUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherStudentGroupUsers>>;
}

/** on conflict condition type for table "student_group_users" */
export interface TeacherStudentGroupUsersOnConflict {
  constraint: TeacherStudentGroupUsersConstraint;
  update_columns?: Array<TeacherStudentGroupUsersUpdateColumn>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}

/** Ordering options when selecting data from "student_group_users". */
export interface TeacherStudentGroupUsersOrderBy {
  id?: Maybe<TeacherOrderBy>;
  live_class_group_aggregate?: Maybe<TeacherStudentGroupsAggregateOrderBy>;
  student_group_id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: student_group_users */
export interface TeacherStudentGroupUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "student_group_users" */
export const enum TeacherStudentGroupUsersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_GROUP_ID = 'student_group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "student_group_users" */
export interface TeacherStudentGroupUsersSetInput {
  id?: Maybe<Scalars['uuid']>;
  student_group_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "student_group_users" */
export const enum TeacherStudentGroupUsersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_GROUP_ID = 'student_group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "student_groups" */
export interface TeacherStudentGroups {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lesson: EntireFieldWrapper<Array<TeacherLessons>>;
  /** An aggregate relationship */
  lesson_aggregate: EntireFieldWrapper<TeacherLessonsAggregate>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<TeacherStudentGroupUsers>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<TeacherStudentGroupUsersAggregate>;
  /** An array relationship */
  teacher: EntireFieldWrapper<Array<TeacherTeachers>>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_groups" */
export interface TeacherStudentGroupsLessonArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface TeacherStudentGroupsLessonAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface TeacherStudentGroupsStudentsArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface TeacherStudentGroupsStudentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface TeacherStudentGroupsTeacherArgs {
  distinct_on?: Maybe<Array<TeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachersOrderBy>>;
  where?: Maybe<TeacherTeachersBoolExp>;
}

/** order by aggregate values of table "student_groups" */
export interface TeacherStudentGroupsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherStudentGroupsMaxOrderBy>;
  min?: Maybe<TeacherStudentGroupsMinOrderBy>;
}

/** input type for inserting array relation for remote table "student_groups" */
export interface TeacherStudentGroupsArrRelInsertInput {
  data: Array<TeacherStudentGroupsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherStudentGroupsOnConflict>;
}

/** Boolean expression to filter rows from the table "student_groups". All fields are combined with a logical 'AND'. */
export interface TeacherStudentGroupsBoolExp {
  _and?: Maybe<Array<TeacherStudentGroupsBoolExp>>;
  _not?: Maybe<TeacherStudentGroupsBoolExp>;
  _or?: Maybe<Array<TeacherStudentGroupsBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  lesson?: Maybe<TeacherLessonsBoolExp>;
  lesson_id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  students?: Maybe<TeacherStudentGroupUsersBoolExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "student_groups" */
export const enum TeacherStudentGroupsConstraint {
  /** unique or primary key constraint */
  LIVE_CLASS_GROUP_PKEY = 'live_class_group_pkey'
};

/** input type for inserting data into table "student_groups" */
export interface TeacherStudentGroupsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  students?: Maybe<TeacherStudentGroupUsersArrRelInsertInput>;
  teacher_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "student_groups" */
export interface TeacherStudentGroupsMaxOrderBy {
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "student_groups" */
export interface TeacherStudentGroupsMinOrderBy {
  id?: Maybe<TeacherOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "student_groups" */
export interface TeacherStudentGroupsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherStudentGroups>>;
}

/** on conflict condition type for table "student_groups" */
export interface TeacherStudentGroupsOnConflict {
  constraint: TeacherStudentGroupsConstraint;
  update_columns?: Array<TeacherStudentGroupsUpdateColumn>;
  where?: Maybe<TeacherStudentGroupsBoolExp>;
}

/** Ordering options when selecting data from "student_groups". */
export interface TeacherStudentGroupsOrderBy {
  id?: Maybe<TeacherOrderBy>;
  lesson_aggregate?: Maybe<TeacherLessonsAggregateOrderBy>;
  lesson_id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  students_aggregate?: Maybe<TeacherStudentGroupUsersAggregateOrderBy>;
  teacher_aggregate?: Maybe<TeacherTeachersAggregateOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: student_groups */
export interface TeacherStudentGroupsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "student_groups" */
export const enum TeacherStudentGroupsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** input type for updating data in table "student_groups" */
export interface TeacherStudentGroupsSetInput {
  id?: Maybe<Scalars['uuid']>;
  lesson_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "student_groups" */
export const enum TeacherStudentGroupsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "students" */
export interface TeacherStudents {
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<TeacherChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<TeacherChapterSectionSubmits>>;
  /** An object relationship */
  class: EntireFieldWrapper<TeacherClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  course_students: EntireFieldWrapper<Array<TeacherCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
}


/** columns and relationships of "students" */
export interface TeacherStudentsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<TeacherChapterSectionNotesBoolExp>;
}


/** columns and relationships of "students" */
export interface TeacherStudentsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
}


/** columns and relationships of "students" */
export interface TeacherStudentsCourseStudentsArgs {
  distinct_on?: Maybe<Array<TeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseStudentOrderBy>>;
  where?: Maybe<TeacherCourseStudentBoolExp>;
}


/** columns and relationships of "students" */
export interface TeacherStudentsGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


/** columns and relationships of "students" */
export interface TeacherStudentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}

/** order by aggregate values of table "students" */
export interface TeacherStudentsAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherStudentsMaxOrderBy>;
  min?: Maybe<TeacherStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export interface TeacherStudentsBoolExp {
  _and?: Maybe<Array<TeacherStudentsBoolExp>>;
  _not?: Maybe<TeacherStudentsBoolExp>;
  _or?: Maybe<Array<TeacherStudentsBoolExp>>;
  chapter_section_notes?: Maybe<TeacherChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
  class?: Maybe<TeacherClassesBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  course_students?: Maybe<TeacherCourseStudentBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grades?: Maybe<TeacherGradesBoolExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "students" */
export interface TeacherStudentsMaxOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "students" */
export interface TeacherStudentsMinOrderBy {
  class_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "students". */
export interface TeacherStudentsOrderBy {
  chapter_section_notes_aggregate?: Maybe<TeacherChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<TeacherChapterSectionSubmitsAggregateOrderBy>;
  class?: Maybe<TeacherClassesOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  course_students_aggregate?: Maybe<TeacherCourseStudentAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grades_aggregate?: Maybe<TeacherGradesAggregateOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "students" */
export const enum TeacherStudentsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "subjects" */
export interface TeacherSubjects {
  /** An array relationship */
  books: EntireFieldWrapper<Array<TeacherBooks>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<TeacherClassrooms>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<TeacherCourses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<TeacherViewGradeTypeSubject>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  statistics: EntireFieldWrapper<Array<TeacherViewStatisticsSemesterSubjectMark>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<TeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<TeacherViewGradesAggregate>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsBooksArgs {
  distinct_on?: Maybe<Array<TeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBooksOrderBy>>;
  where?: Maybe<TeacherBooksBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsClassroomsArgs {
  distinct_on?: Maybe<Array<TeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassroomsOrderBy>>;
  where?: Maybe<TeacherClassroomsBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsCoursesArgs {
  distinct_on?: Maybe<Array<TeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCoursesOrderBy>>;
  where?: Maybe<TeacherCoursesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsGradeTypesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<TeacherViewGradeTypeSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsStatisticsArgs {
  distinct_on?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<TeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeacherSubjectOrderBy>>;
  where?: Maybe<TeacherTeacherSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsViewGradesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface TeacherSubjectsViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export interface TeacherSubjectsBoolExp {
  _and?: Maybe<Array<TeacherSubjectsBoolExp>>;
  _not?: Maybe<TeacherSubjectsBoolExp>;
  _or?: Maybe<Array<TeacherSubjectsBoolExp>>;
  books?: Maybe<TeacherBooksBoolExp>;
  classrooms?: Maybe<TeacherClassroomsBoolExp>;
  courses?: Maybe<TeacherCoursesBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  grade_types?: Maybe<TeacherViewGradeTypeSubjectBoolExp>;
  icon?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  statistics?: Maybe<TeacherViewStatisticsSemesterSubjectMarkBoolExp>;
  teacher_subjects?: Maybe<TeacherTeacherSubjectBoolExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  view_grades?: Maybe<TeacherViewGradesBoolExp>;
}

/** Ordering options when selecting data from "subjects". */
export interface TeacherSubjectsOrderBy {
  books_aggregate?: Maybe<TeacherBooksAggregateOrderBy>;
  classrooms_aggregate?: Maybe<TeacherClassroomsAggregateOrderBy>;
  courses_aggregate?: Maybe<TeacherCoursesAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  grade_types_aggregate?: Maybe<TeacherViewGradeTypeSubjectAggregateOrderBy>;
  icon?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  statistics_aggregate?: Maybe<TeacherViewStatisticsSemesterSubjectMarkAggregateOrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherTeacherSubjectAggregateOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  view_grades_aggregate?: Maybe<TeacherViewGradesAggregateOrderBy>;
}

/** select columns of table "subjects" */
export const enum TeacherSubjectsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface TeacherSubscriptionRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<TeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<TeacherAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<TeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<TeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<TeacherAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<TeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<TeacherAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<TeacherAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<TeacherAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<TeacherAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<TeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_types" */
  assignment_question_types: EntireFieldWrapper<Array<TeacherAssignmentQuestionTypes>>;
  /** fetch data from the table: "assignment_question_types" using primary key columns */
  assignment_question_types_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestionTypes>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<TeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<TeacherAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<TeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<TeacherAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<TeacherAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<TeacherAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<TeacherAttendances>>;
  /** fetch aggregated fields from the table: "attendances" */
  attendances_aggregate: EntireFieldWrapper<TeacherAttendancesAggregate>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherAttendances>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<TeacherBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<TeacherBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<TeacherBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<TeacherBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<TeacherBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<TeacherBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<TeacherBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<TeacherBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<TeacherBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<TeacherBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<TeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<TeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<TeacherChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<TeacherChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<TeacherChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<TeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<TeacherChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<TeacherChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<TeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<TeacherChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<TeacherChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<TeacherChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<TeacherChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<TeacherChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<TeacherChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<TeacherChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<TeacherChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<TeacherClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<TeacherClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<TeacherClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<TeacherClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<TeacherClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<TeacherClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<TeacherClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<TeacherCourseClass>>;
  /** fetch aggregated fields from the table: "course_class" */
  course_class_aggregate: EntireFieldWrapper<TeacherCourseClassAggregate>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<TeacherCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<TeacherCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<TeacherCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<TeacherCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<TeacherCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<TeacherCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<TeacherEventUsers>>;
  /** fetch aggregated fields from the table: "event_users" */
  event_users_aggregate: EntireFieldWrapper<TeacherEventUsersAggregate>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<TeacherEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<TeacherEvents>>;
  /** fetch aggregated fields from the table: "events" */
  events_aggregate: EntireFieldWrapper<TeacherEventsAggregate>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<TeacherEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<TeacherFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<TeacherFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<TeacherGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<TeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<TeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<TeacherGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<TeacherGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<TeacherLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<TeacherLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<TeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<TeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<TeacherLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<TeacherLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<TeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<TeacherLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<TeacherLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<TeacherLiveClassAttendees>>;
  /** An aggregate relationship */
  live_class_attendees_aggregate: EntireFieldWrapper<TeacherLiveClassAttendeesAggregate>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<TeacherLiveClasses>>;
  /** fetch aggregated fields from the table: "live_classes" */
  live_classes_aggregate: EntireFieldWrapper<TeacherLiveClassesAggregate>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<TeacherLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<TeacherMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  /** fetch data from the table: "meeting_groups" */
  meeting_groups: EntireFieldWrapper<Array<TeacherMeetingGroups>>;
  /** fetch data from the table: "meeting_groups" using primary key columns */
  meeting_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroups>>;
  /** fetch data from the table: "meeting_groups_student" */
  meeting_groups_student: EntireFieldWrapper<Array<TeacherMeetingGroupsStudent>>;
  /** fetch data from the table: "meeting_groups_student" using primary key columns */
  meeting_groups_student_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingGroupsStudent>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<TeacherMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<TeacherMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<TeacherMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<TeacherNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<TeacherNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<TeacherNotifications>>;
  /** fetch data from the table: "parent_student" */
  parent_student: EntireFieldWrapper<Array<TeacherParentStudent>>;
  /** fetch data from the table: "parent_student" using primary key columns */
  parent_student_by_pk?: EntireFieldWrapper<Maybe<TeacherParentStudent>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<TeacherParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<TeacherParents>>;
  /** fetch data from the table: "permission_role" */
  permission_role: EntireFieldWrapper<Array<TeacherPermissionRole>>;
  /** fetch data from the table: "permission_role" using primary key columns */
  permission_role_by_pk?: EntireFieldWrapper<Maybe<TeacherPermissionRole>>;
  /** fetch data from the table: "permissions" */
  permissions: EntireFieldWrapper<Array<TeacherPermissions>>;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: EntireFieldWrapper<Maybe<TeacherPermissions>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<TeacherPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<TeacherPromotions>>;
  /** fetch data from the table: "roles" */
  roles: EntireFieldWrapper<Array<TeacherRoles>>;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: EntireFieldWrapper<Maybe<TeacherRoles>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<TeacherSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<TeacherSemesters>>;
  /** fetch data from the table: "student_class" */
  student_class: EntireFieldWrapper<Array<TeacherStudentClass>>;
  /** fetch data from the table: "student_class" using primary key columns */
  student_class_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentClass>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<TeacherStudentGroupUsers>>;
  /** fetch aggregated fields from the table: "student_group_users" */
  student_group_users_aggregate: EntireFieldWrapper<TeacherStudentGroupUsersAggregate>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<TeacherStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<TeacherStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<TeacherStudents>>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<TeacherSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<TeacherTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<TeacherTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<TeacherTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
  /** fetch data from the table: "teacher_subject" using primary key columns */
  teacher_subject_by_pk?: EntireFieldWrapper<Maybe<TeacherTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<TeacherTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structure_types" */
  teaching_structure_types: EntireFieldWrapper<Array<TeacherTeachingStructureTypes>>;
  /** fetch data from the table: "teaching_structure_types" using primary key columns */
  teaching_structure_types_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructureTypes>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<TeacherViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<TeacherViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<TeacherViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<TeacherViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<TeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<TeacherViewGradesAggregate>;
  /** fetch data from the table: "view.grades_by_subjects_and_classes" */
  view_grades_by_subjects_and_classes: EntireFieldWrapper<Array<TeacherViewGradesBySubjectsAndClasses>>;
  /** fetch data from the table: "view.grades_by_subjects_classes_semester_year" */
  view_grades_by_subjects_classes_semester_year: EntireFieldWrapper<Array<TeacherViewGradesBySubjectsClassesSemesterYear>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<TeacherViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<TeacherViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<TeacherViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<TeacherViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<TeacherViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<TeacherYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<TeacherYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<TeacherYears>>;
}


export interface TeacherSubscriptionRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<TeacherAssignmentAttendeeTypeBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface TeacherSubscriptionRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<TeacherAssignmentBookChapterBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionContentBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<TeacherAssignmentDiscussionSubscriptionBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentFilesOrderBy>>;
  where?: Maybe<TeacherAssignmentFilesBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<TeacherAssignmentGradeWeightsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentNotesOrderBy>>;
  where?: Maybe<TeacherAssignmentNotesBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionAnswersBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionRelationsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionOptionsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentQuestionTypesArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionTypesOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionTypesBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuestionTypesByPkArgs {
  value: Scalars['String'];
}


export interface TeacherSubscriptionRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<TeacherAssignmentQuestionsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentQuizOrderBy>>;
  where?: Maybe<TeacherAssignmentQuizBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<TeacherAssignmentSubmitsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentTypeOrderBy>>;
  where?: Maybe<TeacherAssignmentTypeBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentUserOrderBy>>;
  where?: Maybe<TeacherAssignmentUserBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


export interface TeacherSubscriptionRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<TeacherAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendanceTypesOrderBy>>;
  where?: Maybe<TeacherAttendanceTypesBoolExp>;
}


export interface TeacherSubscriptionRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface TeacherSubscriptionRootAttendancesArgs {
  distinct_on?: Maybe<Array<TeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendancesOrderBy>>;
  where?: Maybe<TeacherAttendancesBoolExp>;
}


export interface TeacherSubscriptionRootAttendancesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAttendancesOrderBy>>;
  where?: Maybe<TeacherAttendancesBoolExp>;
}


export interface TeacherSubscriptionRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<TeacherBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChapterTypeOrderBy>>;
  where?: Maybe<TeacherBookChapterTypeBoolExp>;
}


export interface TeacherSubscriptionRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootBookChaptersArgs {
  distinct_on?: Maybe<Array<TeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookChaptersOrderBy>>;
  where?: Maybe<TeacherBookChaptersBoolExp>;
}


export interface TeacherSubscriptionRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootBookCourseArgs {
  distinct_on?: Maybe<Array<TeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookCourseOrderBy>>;
  where?: Maybe<TeacherBookCourseBoolExp>;
}


export interface TeacherSubscriptionRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootBookUserArgs {
  distinct_on?: Maybe<Array<TeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBookUserOrderBy>>;
  where?: Maybe<TeacherBookUserBoolExp>;
}


export interface TeacherSubscriptionRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootBooksArgs {
  distinct_on?: Maybe<Array<TeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherBooksOrderBy>>;
  where?: Maybe<TeacherBooksBoolExp>;
}


export interface TeacherSubscriptionRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<TeacherChapterSectionNotesBoolExp>;
}


export interface TeacherSubscriptionRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<TeacherChapterSectionSubmitsBoolExp>;
}


export interface TeacherSubscriptionRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionTypeOrderBy>>;
  where?: Maybe<TeacherChapterSectionTypeBoolExp>;
}


export interface TeacherSubscriptionRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<TeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChapterSectionsOrderBy>>;
  where?: Maybe<TeacherChapterSectionsBoolExp>;
}


export interface TeacherSubscriptionRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


export interface TeacherSubscriptionRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageLikesOrderBy>>;
  where?: Maybe<TeacherChatMessageLikesBoolExp>;
}


export interface TeacherSubscriptionRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<TeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessageReadsOrderBy>>;
  where?: Maybe<TeacherChatMessageReadsBoolExp>;
}


export interface TeacherSubscriptionRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


export interface TeacherSubscriptionRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatMessagesOrderBy>>;
  where?: Maybe<TeacherChatMessagesBoolExp>;
}


export interface TeacherSubscriptionRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChatTypeArgs {
  distinct_on?: Maybe<Array<TeacherChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatTypeOrderBy>>;
  where?: Maybe<TeacherChatTypeBoolExp>;
}


export interface TeacherSubscriptionRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootChatUserArgs {
  distinct_on?: Maybe<Array<TeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatUserOrderBy>>;
  where?: Maybe<TeacherChatUserBoolExp>;
}


export interface TeacherSubscriptionRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootChatsArgs {
  distinct_on?: Maybe<Array<TeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherChatsOrderBy>>;
  where?: Maybe<TeacherChatsBoolExp>;
}


export interface TeacherSubscriptionRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootClassLevelsArgs {
  distinct_on?: Maybe<Array<TeacherClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassLevelsOrderBy>>;
  where?: Maybe<TeacherClassLevelsBoolExp>;
}


export interface TeacherSubscriptionRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootClassTypeArgs {
  distinct_on?: Maybe<Array<TeacherClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassTypeOrderBy>>;
  where?: Maybe<TeacherClassTypeBoolExp>;
}


export interface TeacherSubscriptionRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootClassesArgs {
  distinct_on?: Maybe<Array<TeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassesOrderBy>>;
  where?: Maybe<TeacherClassesBoolExp>;
}


export interface TeacherSubscriptionRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootClassroomsArgs {
  distinct_on?: Maybe<Array<TeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassroomsOrderBy>>;
  where?: Maybe<TeacherClassroomsBoolExp>;
}


export interface TeacherSubscriptionRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootCourseClassArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


export interface TeacherSubscriptionRootCourseClassAggregateArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassOrderBy>>;
  where?: Maybe<TeacherCourseClassBoolExp>;
}


export interface TeacherSubscriptionRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<TeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseClassroomOrderBy>>;
  where?: Maybe<TeacherCourseClassroomBoolExp>;
}


export interface TeacherSubscriptionRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootCourseStudentArgs {
  distinct_on?: Maybe<Array<TeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseStudentOrderBy>>;
  where?: Maybe<TeacherCourseStudentBoolExp>;
}


export interface TeacherSubscriptionRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<TeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseTeacherOrderBy>>;
  where?: Maybe<TeacherCourseTeacherBoolExp>;
}


export interface TeacherSubscriptionRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootCoursesArgs {
  distinct_on?: Maybe<Array<TeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCoursesOrderBy>>;
  where?: Maybe<TeacherCoursesBoolExp>;
}


export interface TeacherSubscriptionRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootEventUsersArgs {
  distinct_on?: Maybe<Array<TeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventUsersOrderBy>>;
  where?: Maybe<TeacherEventUsersBoolExp>;
}


export interface TeacherSubscriptionRootEventUsersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventUsersOrderBy>>;
  where?: Maybe<TeacherEventUsersBoolExp>;
}


export interface TeacherSubscriptionRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootEventsArgs {
  distinct_on?: Maybe<Array<TeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventsOrderBy>>;
  where?: Maybe<TeacherEventsBoolExp>;
}


export interface TeacherSubscriptionRootEventsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherEventsOrderBy>>;
  where?: Maybe<TeacherEventsBoolExp>;
}


export interface TeacherSubscriptionRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootFilesArgs {
  distinct_on?: Maybe<Array<TeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherFilesOrderBy>>;
  where?: Maybe<TeacherFilesBoolExp>;
}


export interface TeacherSubscriptionRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootGradeTypesArgs {
  distinct_on?: Maybe<Array<TeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradeTypesOrderBy>>;
  where?: Maybe<TeacherGradeTypesBoolExp>;
}


export interface TeacherSubscriptionRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootGradesArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


export interface TeacherSubscriptionRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradesOrderBy>>;
  where?: Maybe<TeacherGradesBoolExp>;
}


export interface TeacherSubscriptionRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<TeacherLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLatestActivitiesOrderBy>>;
  where?: Maybe<TeacherLatestActivitiesBoolExp>;
}


export interface TeacherSubscriptionRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<TeacherLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonAttendaceTypeOrderBy>>;
  where?: Maybe<TeacherLessonAttendaceTypeBoolExp>;
}


export interface TeacherSubscriptionRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface TeacherSubscriptionRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<TeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonAttendancesOrderBy>>;
  where?: Maybe<TeacherLessonAttendancesBoolExp>;
}


export interface TeacherSubscriptionRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootLessonsArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


export interface TeacherSubscriptionRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLessonsOrderBy>>;
  where?: Maybe<TeacherLessonsBoolExp>;
}


export interface TeacherSubscriptionRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}


export interface TeacherSubscriptionRootLiveClassAttendeesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<TeacherLiveClassAttendeesBoolExp>;
}


export interface TeacherSubscriptionRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootLiveClassesArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassesOrderBy>>;
  where?: Maybe<TeacherLiveClassesBoolExp>;
}


export interface TeacherSubscriptionRootLiveClassesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherLiveClassesOrderBy>>;
  where?: Maybe<TeacherLiveClassesBoolExp>;
}


export interface TeacherSubscriptionRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootMarksArgs {
  distinct_on?: Maybe<Array<TeacherMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMarksOrderBy>>;
  where?: Maybe<TeacherMarksBoolExp>;
}


export interface TeacherSubscriptionRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootMeetingGroupsArgs {
  distinct_on?: Maybe<Array<TeacherMeetingGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingGroupsOrderBy>>;
  where?: Maybe<TeacherMeetingGroupsBoolExp>;
}


export interface TeacherSubscriptionRootMeetingGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootMeetingGroupsStudentArgs {
  distinct_on?: Maybe<Array<TeacherMeetingGroupsStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingGroupsStudentOrderBy>>;
  where?: Maybe<TeacherMeetingGroupsStudentBoolExp>;
}


export interface TeacherSubscriptionRootMeetingGroupsStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootMeetingUserArgs {
  distinct_on?: Maybe<Array<TeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingUserOrderBy>>;
  where?: Maybe<TeacherMeetingUserBoolExp>;
}


export interface TeacherSubscriptionRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<TeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherMeetingUserOrderBy>>;
  where?: Maybe<TeacherMeetingUserBoolExp>;
}


export interface TeacherSubscriptionRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootNotificationsArgs {
  distinct_on?: Maybe<Array<TeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherNotificationsOrderBy>>;
  where?: Maybe<TeacherNotificationsBoolExp>;
}


export interface TeacherSubscriptionRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherNotificationsOrderBy>>;
  where?: Maybe<TeacherNotificationsBoolExp>;
}


export interface TeacherSubscriptionRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootParentStudentArgs {
  distinct_on?: Maybe<Array<TeacherParentStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherParentStudentOrderBy>>;
  where?: Maybe<TeacherParentStudentBoolExp>;
}


export interface TeacherSubscriptionRootParentStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootParentsArgs {
  distinct_on?: Maybe<Array<TeacherParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherParentsOrderBy>>;
  where?: Maybe<TeacherParentsBoolExp>;
}


export interface TeacherSubscriptionRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootPermissionRoleArgs {
  distinct_on?: Maybe<Array<TeacherPermissionRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPermissionRoleOrderBy>>;
  where?: Maybe<TeacherPermissionRoleBoolExp>;
}


export interface TeacherSubscriptionRootPermissionRoleByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootPermissionsArgs {
  distinct_on?: Maybe<Array<TeacherPermissionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPermissionsOrderBy>>;
  where?: Maybe<TeacherPermissionsBoolExp>;
}


export interface TeacherSubscriptionRootPermissionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootPromotionsArgs {
  distinct_on?: Maybe<Array<TeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPromotionsOrderBy>>;
  where?: Maybe<TeacherPromotionsBoolExp>;
}


export interface TeacherSubscriptionRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootRolesArgs {
  distinct_on?: Maybe<Array<TeacherRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRolesOrderBy>>;
  where?: Maybe<TeacherRolesBoolExp>;
}


export interface TeacherSubscriptionRootRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootSemestersArgs {
  distinct_on?: Maybe<Array<TeacherSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSemestersOrderBy>>;
  where?: Maybe<TeacherSemestersBoolExp>;
}


export interface TeacherSubscriptionRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootStudentClassArgs {
  distinct_on?: Maybe<Array<TeacherStudentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentClassOrderBy>>;
  where?: Maybe<TeacherStudentClassBoolExp>;
}


export interface TeacherSubscriptionRootStudentClassByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


export interface TeacherSubscriptionRootStudentGroupUsersAggregateArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<TeacherStudentGroupUsersBoolExp>;
}


export interface TeacherSubscriptionRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<TeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentGroupsOrderBy>>;
  where?: Maybe<TeacherStudentGroupsBoolExp>;
}


export interface TeacherSubscriptionRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootStudentsArgs {
  distinct_on?: Maybe<Array<TeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherStudentsOrderBy>>;
  where?: Maybe<TeacherStudentsBoolExp>;
}


export interface TeacherSubscriptionRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectsOrderBy>>;
  where?: Maybe<TeacherSubjectsBoolExp>;
}


export interface TeacherSubscriptionRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootTasksArgs {
  distinct_on?: Maybe<Array<TeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTasksOrderBy>>;
  where?: Maybe<TeacherTasksBoolExp>;
}


export interface TeacherSubscriptionRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTasksOrderBy>>;
  where?: Maybe<TeacherTasksBoolExp>;
}


export interface TeacherSubscriptionRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<TeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeacherSubjectOrderBy>>;
  where?: Maybe<TeacherTeacherSubjectBoolExp>;
}


export interface TeacherSubscriptionRootTeacherSubjectByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootTeachersArgs {
  distinct_on?: Maybe<Array<TeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachersOrderBy>>;
  where?: Maybe<TeacherTeachersBoolExp>;
}


export interface TeacherSubscriptionRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootTeachingStructureLeafsArgs {
  args: TeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructureLeafsAggregateArgs {
  args: TeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructureParentsArgs {
  args: TeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructureParentsAggregateArgs {
  args: TeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructureTypesArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructureTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructureTypesOrderBy>>;
  where?: Maybe<TeacherTeachingStructureTypesBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructureTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


export interface TeacherSubscriptionRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface TeacherSubscriptionRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<TeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<TeacherViewAssignmentClassBoolExp>;
}


export interface TeacherSubscriptionRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<TeacherViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<TeacherViewAssignmentStudentGradeBoolExp>;
}


export interface TeacherSubscriptionRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<TeacherViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewClassStudentOrderBy>>;
  where?: Maybe<TeacherViewClassStudentBoolExp>;
}


export interface TeacherSubscriptionRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<TeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<TeacherViewGradeTypeSubjectBoolExp>;
}


export interface TeacherSubscriptionRootViewGradesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


export interface TeacherSubscriptionRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesOrderBy>>;
  where?: Maybe<TeacherViewGradesBoolExp>;
}


export interface TeacherSubscriptionRootViewGradesBySubjectsAndClassesArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesOrderBy>>;
  where?: Maybe<TeacherViewGradesBySubjectsAndClassesBoolExp>;
}


export interface TeacherSubscriptionRootViewGradesBySubjectsClassesSemesterYearArgs {
  distinct_on?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearOrderBy>>;
  where?: Maybe<TeacherViewGradesBySubjectsClassesSemesterYearBoolExp>;
}


export interface TeacherSubscriptionRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<TeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<TeacherViewLatestChatMessagesBoolExp>;
}


export interface TeacherSubscriptionRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<TeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<TeacherViewLatestChatMessagesBoolExp>;
}


export interface TeacherSubscriptionRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<TeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface TeacherSubscriptionRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<TeacherViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewSubjectSemesterOrderBy>>;
  where?: Maybe<TeacherViewSubjectSemesterBoolExp>;
}


export interface TeacherSubscriptionRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<TeacherViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<TeacherViewTeacherClassSubjectBoolExp>;
}


export interface TeacherSubscriptionRootYearsArgs {
  distinct_on?: Maybe<Array<TeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherYearsOrderBy>>;
  where?: Maybe<TeacherYearsBoolExp>;
}


export interface TeacherSubscriptionRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherYearsOrderBy>>;
  where?: Maybe<TeacherYearsBoolExp>;
}


export interface TeacherSubscriptionRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "tasks" */
export interface TeacherTasks {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** The user this tasks belongs. */
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "tasks" */
export interface TeacherTasksAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherTasksAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherTasks>>;
}

/** aggregate fields of "tasks" */
export interface TeacherTasksAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherTasksMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherTasksMinFields>>;
}


/** aggregate fields of "tasks" */
export interface TeacherTasksAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherTasksSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export interface TeacherTasksBoolExp {
  _and?: Maybe<Array<TeacherTasksBoolExp>>;
  _not?: Maybe<TeacherTasksBoolExp>;
  _or?: Maybe<Array<TeacherTasksBoolExp>>;
  body?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  is_completed?: Maybe<TeacherBooleanComparisonExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "tasks" */
export const enum TeacherTasksConstraint {
  /** unique or primary key constraint */
  TASKS_PKEY = 'tasks_pkey'
};

/** input type for inserting data into table "tasks" */
export interface TeacherTasksInsertInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherTasksMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherTasksMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "tasks" */
export interface TeacherTasksMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherTasks>>;
}

/** on conflict condition type for table "tasks" */
export interface TeacherTasksOnConflict {
  constraint: TeacherTasksConstraint;
  update_columns?: Array<TeacherTasksUpdateColumn>;
  where?: Maybe<TeacherTasksBoolExp>;
}

/** Ordering options when selecting data from "tasks". */
export interface TeacherTasksOrderBy {
  body?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  is_completed?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: tasks */
export interface TeacherTasksPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "tasks" */
export const enum TeacherTasksSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "tasks" */
export interface TeacherTasksSetInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "tasks" */
export const enum TeacherTasksUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Connection between teachers and subjects with relevant teaching structure
 *
 *
 * columns and relationships of "teacher_subject"
 */
export interface TeacherTeacherSubject {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<TeacherSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<TeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<TeacherTeachingStructures>;
  teaching_structure_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "teacher_subject" */
export interface TeacherTeacherSubjectAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherTeacherSubjectMaxOrderBy>;
  min?: Maybe<TeacherTeacherSubjectMinOrderBy>;
}

/** input type for inserting array relation for remote table "teacher_subject" */
export interface TeacherTeacherSubjectArrRelInsertInput {
  data: Array<TeacherTeacherSubjectInsertInput>;
}

/** Boolean expression to filter rows from the table "teacher_subject". All fields are combined with a logical 'AND'. */
export interface TeacherTeacherSubjectBoolExp {
  _and?: Maybe<Array<TeacherTeacherSubjectBoolExp>>;
  _not?: Maybe<TeacherTeacherSubjectBoolExp>;
  _or?: Maybe<Array<TeacherTeacherSubjectBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  teacher?: Maybe<TeacherTeachersBoolExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
  teaching_structure?: Maybe<TeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<TeacherUuidComparisonExp>;
}

/** input type for inserting data into table "teacher_subject" */
export interface TeacherTeacherSubjectInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  subject_id?: Maybe<Scalars['uuid']>;
  teacher_id?: Maybe<Scalars['uuid']>;
  teaching_structure?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  teaching_structure_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "teacher_subject" */
export interface TeacherTeacherSubjectMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "teacher_subject" */
export interface TeacherTeacherSubjectMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "teacher_subject" */
export interface TeacherTeacherSubjectMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
}

/** Ordering options when selecting data from "teacher_subject". */
export interface TeacherTeacherSubjectOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teacher?: Maybe<TeacherTeachersOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
  teaching_structure?: Maybe<TeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "teacher_subject" */
export const enum TeacherTeacherSubjectSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id'
};

/** columns and relationships of "teachers" */
export interface TeacherTeachers {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<TeacherClasses>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<TeacherClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<TeacherCourseTeacher>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
}


/** columns and relationships of "teachers" */
export interface TeacherTeachersClassesArgs {
  distinct_on?: Maybe<Array<TeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherClassesOrderBy>>;
  where?: Maybe<TeacherClassesBoolExp>;
}


/** columns and relationships of "teachers" */
export interface TeacherTeachersCourseTeachersArgs {
  distinct_on?: Maybe<Array<TeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherCourseTeacherOrderBy>>;
  where?: Maybe<TeacherCourseTeacherBoolExp>;
}


/** columns and relationships of "teachers" */
export interface TeacherTeachersTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeacherSubjectOrderBy>>;
  where?: Maybe<TeacherTeacherSubjectBoolExp>;
}

/** order by aggregate values of table "teachers" */
export interface TeacherTeachersAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherTeachersMaxOrderBy>;
  min?: Maybe<TeacherTeachersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export interface TeacherTeachersBoolExp {
  _and?: Maybe<Array<TeacherTeachersBoolExp>>;
  _not?: Maybe<TeacherTeachersBoolExp>;
  _or?: Maybe<Array<TeacherTeachersBoolExp>>;
  classes?: Maybe<TeacherClassesBoolExp>;
  classroom?: Maybe<TeacherClassroomsBoolExp>;
  classroom_id?: Maybe<TeacherUuidComparisonExp>;
  course_teachers?: Maybe<TeacherCourseTeacherBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  teacher_subjects?: Maybe<TeacherTeacherSubjectBoolExp>;
  type?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "teachers" */
export interface TeacherTeachersMaxOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "teachers" */
export interface TeacherTeachersMinOrderBy {
  classroom_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "teachers". */
export interface TeacherTeachersOrderBy {
  classes_aggregate?: Maybe<TeacherClassesAggregateOrderBy>;
  classroom?: Maybe<TeacherClassroomsOrderBy>;
  classroom_id?: Maybe<TeacherOrderBy>;
  course_teachers_aggregate?: Maybe<TeacherCourseTeacherAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherTeacherSubjectAggregateOrderBy>;
  type?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "teachers" */
export const enum TeacherTeachersSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface TeacherTeachingStructureLeafsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

export interface TeacherTeachingStructureParentsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

/** input type for inserting array relation for remote table "teaching_structure_students" */
export interface TeacherTeachingStructureStudentsArrRelInsertInput {
  data: Array<TeacherTeachingStructureStudentsInsertInput>;
}

/** input type for inserting data into table "teaching_structure_students" */
export interface TeacherTeachingStructureStudentsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
  subject_id?: Maybe<Scalars['uuid']>;
  teaching_structure?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  teaching_structure_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "teaching_structure_students" */
export interface TeacherTeachingStructureStudentsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
}

/**
 * Type for the teaching structure
 *
 *
 * columns and relationships of "teaching_structure_types"
 */
export interface TeacherTeachingStructureTypes {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
}


/**
 * Type for the teaching structure
 *
 *
 * columns and relationships of "teaching_structure_types"
 */
export interface TeacherTeachingStructureTypesTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


/**
 * Type for the teaching structure
 *
 *
 * columns and relationships of "teaching_structure_types"
 */
export interface TeacherTeachingStructureTypesTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}

/** Boolean expression to filter rows from the table "teaching_structure_types". All fields are combined with a logical 'AND'. */
export interface TeacherTeachingStructureTypesBoolExp {
  _and?: Maybe<Array<TeacherTeachingStructureTypesBoolExp>>;
  _not?: Maybe<TeacherTeachingStructureTypesBoolExp>;
  _or?: Maybe<Array<TeacherTeachingStructureTypesBoolExp>>;
  id?: Maybe<TeacherUuidComparisonExp>;
  teaching_structures?: Maybe<TeacherTeachingStructuresBoolExp>;
  title?: Maybe<TeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "teaching_structure_types". */
export interface TeacherTeachingStructureTypesOrderBy {
  id?: Maybe<TeacherOrderBy>;
  teaching_structures_aggregate?: Maybe<TeacherTeachingStructuresAggregateOrderBy>;
  title?: Maybe<TeacherOrderBy>;
}

/** select columns of table "teaching_structure_types" */
export const enum TeacherTeachingStructureTypesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title'
};

/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructures {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<TeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<TeacherAssignmentsAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  depth: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  ltr: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  parent?: EntireFieldWrapper<Maybe<TeacherTeachingStructures>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<TeacherSemesters>>;
  /** A computed field, executes function "subject_icon" */
  subject_icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherTeacherSubject>>;
  /** An object relationship */
  teaching_structure_type?: EntireFieldWrapper<Maybe<TeacherTeachingStructureTypes>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeacherTeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructuresAssignmentsArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructuresAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherAssignmentsOrderBy>>;
  where?: Maybe<TeacherAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructuresTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeacherSubjectOrderBy>>;
  where?: Maybe<TeacherTeacherSubjectBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructuresTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeacherTeachingStructuresTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherTeachingStructuresOrderBy>>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}

/** aggregated selection of "teaching_structures" */
export interface TeacherTeachingStructuresAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
}

/** aggregate fields of "teaching_structures" */
export interface TeacherTeachingStructuresAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherTeachingStructuresVarianceFields>>;
}


/** aggregate fields of "teaching_structures" */
export interface TeacherTeachingStructuresAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherTeachingStructuresSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "teaching_structures" */
export interface TeacherTeachingStructuresAggregateOrderBy {
  avg?: Maybe<TeacherTeachingStructuresAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherTeachingStructuresMaxOrderBy>;
  min?: Maybe<TeacherTeachingStructuresMinOrderBy>;
  stddev?: Maybe<TeacherTeachingStructuresStddevOrderBy>;
  stddev_pop?: Maybe<TeacherTeachingStructuresStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherTeachingStructuresStddevSampOrderBy>;
  sum?: Maybe<TeacherTeachingStructuresSumOrderBy>;
  var_pop?: Maybe<TeacherTeachingStructuresVarPopOrderBy>;
  var_samp?: Maybe<TeacherTeachingStructuresVarSampOrderBy>;
  variance?: Maybe<TeacherTeachingStructuresVarianceOrderBy>;
}

/** input type for inserting array relation for remote table "teaching_structures" */
export interface TeacherTeachingStructuresArrRelInsertInput {
  data: Array<TeacherTeachingStructuresInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherTeachingStructuresOnConflict>;
}

/** aggregate avg on columns */
export interface TeacherTeachingStructuresAvgFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresAvgOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structures". All fields are combined with a logical 'AND'. */
export interface TeacherTeachingStructuresBoolExp {
  _and?: Maybe<Array<TeacherTeachingStructuresBoolExp>>;
  _not?: Maybe<TeacherTeachingStructuresBoolExp>;
  _or?: Maybe<Array<TeacherTeachingStructuresBoolExp>>;
  assignments?: Maybe<TeacherAssignmentsBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  depth?: Maybe<TeacherIntComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  ltr?: Maybe<TeacherIntComparisonExp>;
  parent?: Maybe<TeacherTeachingStructuresBoolExp>;
  parent_id?: Maybe<TeacherUuidComparisonExp>;
  rtl?: Maybe<TeacherIntComparisonExp>;
  semester?: Maybe<TeacherSemestersBoolExp>;
  subject_icon?: Maybe<TeacherStringComparisonExp>;
  teacher_subjects?: Maybe<TeacherTeacherSubjectBoolExp>;
  teaching_structure_type?: Maybe<TeacherTeachingStructureTypesBoolExp>;
  teaching_structures?: Maybe<TeacherTeachingStructuresBoolExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  type_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "teaching_structures" */
export const enum TeacherTeachingStructuresConstraint {
  /** unique or primary key constraint */
  TEACHING_STRUCTURES_PKEY = 'teaching_structures_pkey'
};

/** input type for incrementing numeric columns in table "teaching_structures" */
export interface TeacherTeachingStructuresIncInput {
  depth?: Maybe<Scalars['Int']>;
  ltr?: Maybe<Scalars['Int']>;
  rtl?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "teaching_structures" */
export interface TeacherTeachingStructuresInsertInput {
  assignments?: Maybe<TeacherAssignmentsArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  ltr?: Maybe<Scalars['Int']>;
  parent?: Maybe<TeacherTeachingStructuresObjRelInsertInput>;
  parent_id?: Maybe<Scalars['uuid']>;
  rtl?: Maybe<Scalars['Int']>;
  teacher_subjects?: Maybe<TeacherTeacherSubjectArrRelInsertInput>;
  teaching_structure_students?: Maybe<TeacherTeachingStructureStudentsArrRelInsertInput>;
  teaching_structures?: Maybe<TeacherTeachingStructuresArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherTeachingStructuresMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  depth?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherTeachingStructuresMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  depth?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** response of any mutation on the table "teaching_structures" */
export interface TeacherTeachingStructuresMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherTeachingStructures>>;
}

/** input type for inserting object relation for remote table "teaching_structures" */
export interface TeacherTeachingStructuresObjRelInsertInput {
  data: TeacherTeachingStructuresInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherTeachingStructuresOnConflict>;
}

/** on conflict condition type for table "teaching_structures" */
export interface TeacherTeachingStructuresOnConflict {
  constraint: TeacherTeachingStructuresConstraint;
  update_columns?: Array<TeacherTeachingStructuresUpdateColumn>;
  where?: Maybe<TeacherTeachingStructuresBoolExp>;
}

/** Ordering options when selecting data from "teaching_structures". */
export interface TeacherTeachingStructuresOrderBy {
  assignments_aggregate?: Maybe<TeacherAssignmentsAggregateOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  depth?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  parent?: Maybe<TeacherTeachingStructuresOrderBy>;
  parent_id?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
  semester?: Maybe<TeacherSemestersOrderBy>;
  subject_icon?: Maybe<TeacherOrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherTeacherSubjectAggregateOrderBy>;
  teaching_structure_type?: Maybe<TeacherTeachingStructureTypesOrderBy>;
  teaching_structures_aggregate?: Maybe<TeacherTeachingStructuresAggregateOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  type_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: teaching_structures */
export interface TeacherTeachingStructuresPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "teaching_structures" */
export const enum TeacherTeachingStructuresSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "teaching_structures" */
export interface TeacherTeachingStructuresSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  depth?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  ltr?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['uuid']>;
  rtl?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate stddev on columns */
export interface TeacherTeachingStructuresStddevFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresStddevOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeacherTeachingStructuresStddevPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresStddevPopOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeacherTeachingStructuresStddevSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresStddevSampOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** aggregate sum on columns */
export interface TeacherTeachingStructuresSumFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresSumOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** update columns of table "teaching_structures" */
export const enum TeacherTeachingStructuresUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate var_pop on columns */
export interface TeacherTeachingStructuresVarPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresVarPopOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface TeacherTeachingStructuresVarSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresVarSampOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}

/** aggregate variance on columns */
export interface TeacherTeachingStructuresVarianceFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "teaching_structures" */
export interface TeacherTeachingStructuresVarianceOrderBy {
  depth?: Maybe<TeacherOrderBy>;
  ltr?: Maybe<TeacherOrderBy>;
  rtl?: Maybe<TeacherOrderBy>;
}


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface TeacherTimestampComparisonExp {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
}


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface TeacherTimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export interface TeacherTimetzComparisonExp {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
}

/** columns and relationships of "users" */
export interface TeacherUsers {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<TeacherAuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<TeacherPrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<TeacherPrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<TeacherPrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<TeacherPrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<TeacherRelationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<TeacherRelationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<TeacherRelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<TeacherRelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface TeacherUsersRelationshipsArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface TeacherUsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface TeacherUsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface TeacherUsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<TeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherRelationshipsOrderBy>>;
  where?: Maybe<TeacherRelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface TeacherUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherUsers>>;
}

/** aggregate fields of "users" */
export interface TeacherUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherUsersMinFields>>;
}


/** aggregate fields of "users" */
export interface TeacherUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface TeacherUsersBoolExp {
  _and?: Maybe<Array<TeacherUsersBoolExp>>;
  _not?: Maybe<TeacherUsersBoolExp>;
  _or?: Maybe<Array<TeacherUsersBoolExp>>;
  account?: Maybe<TeacherAuthAccountsBoolExp>;
  address?: Maybe<TeacherPrivateAdressesBoolExp>;
  avatar_url?: Maybe<TeacherStringComparisonExp>;
  birthday?: Maybe<TeacherPrivateBirthdaysBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  first_name?: Maybe<TeacherStringComparisonExp>;
  full_name?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<TeacherStringComparisonExp>;
  phone_number?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<TeacherRelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<TeacherRelationshipsBoolExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface TeacherUsersBoolExpRemoteRelStudentClassuser {
  _and?: Maybe<Array<TeacherUsersBoolExp>>;
  _not?: Maybe<TeacherUsersBoolExp>;
  _or?: Maybe<Array<TeacherUsersBoolExp>>;
  account?: Maybe<TeacherAuthAccountsBoolExp>;
  address?: Maybe<TeacherPrivateAdressesBoolExp>;
  avatar_url?: Maybe<TeacherStringComparisonExp>;
  birthday?: Maybe<TeacherPrivateBirthdaysBoolExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  first_name?: Maybe<TeacherStringComparisonExp>;
  full_name?: Maybe<TeacherStringComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExpRemoteRelStudentClassuser>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<TeacherStringComparisonExp>;
  phone_number?: Maybe<TeacherPrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<TeacherRelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<TeacherRelationshipsBoolExp>;
  title?: Maybe<TeacherStringComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum TeacherUsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface TeacherUsersInsertInput {
  account?: Maybe<TeacherAuthAccountsObjRelInsertInput>;
  address?: Maybe<TeacherPrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<TeacherPrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<TeacherPrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<TeacherRelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<TeacherRelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TeacherUsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherUsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface TeacherUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<TeacherUsers>>;
}

/** input type for inserting object relation for remote table "users" */
export interface TeacherUsersObjRelInsertInput {
  data: TeacherUsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<TeacherUsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface TeacherUsersOnConflict {
  constraint: TeacherUsersConstraint;
  update_columns?: Array<TeacherUsersUpdateColumn>;
  where?: Maybe<TeacherUsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface TeacherUsersOrderBy {
  account?: Maybe<TeacherAuthAccountsOrderBy>;
  address?: Maybe<TeacherPrivateAdressesOrderBy>;
  avatar_url?: Maybe<TeacherOrderBy>;
  birthday?: Maybe<TeacherPrivateBirthdaysOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  first_name?: Maybe<TeacherOrderBy>;
  full_name?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  insurance_number?: Maybe<TeacherPrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<TeacherOrderBy>;
  phone_number?: Maybe<TeacherPrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<TeacherRelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<TeacherRelationshipsAggregateOrderBy>;
  title?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** primary key columns input for table: users */
export interface TeacherUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum TeacherUsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface TeacherUsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum TeacherUsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface TeacherUuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface TeacherUuidComparisonExpRemoteRelStudentClassuser {
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** columns and relationships of "view.assignment_class" */
export interface TeacherViewAssignmentClass {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<TeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.assignment_class" */
export interface TeacherViewAssignmentClassAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherViewAssignmentClassMaxOrderBy>;
  min?: Maybe<TeacherViewAssignmentClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.assignment_class". All fields are combined with a logical 'AND'. */
export interface TeacherViewAssignmentClassBoolExp {
  _and?: Maybe<Array<TeacherViewAssignmentClassBoolExp>>;
  _not?: Maybe<TeacherViewAssignmentClassBoolExp>;
  _or?: Maybe<Array<TeacherViewAssignmentClassBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  class?: Maybe<TeacherClassesBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.assignment_class" */
export interface TeacherViewAssignmentClassMaxOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "view.assignment_class" */
export interface TeacherViewAssignmentClassMinOrderBy {
  assignment_id?: Maybe<TeacherOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "view.assignment_class". */
export interface TeacherViewAssignmentClassOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  class?: Maybe<TeacherClassesOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.assignment_class" */
export const enum TeacherViewAssignmentClassSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id'
};

/** columns and relationships of "view.assignment_student_grade" */
export interface TeacherViewAssignmentStudentGrade {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  grade?: EntireFieldWrapper<Maybe<TeacherGrades>>;
  grade_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.assignment_student_grade". All fields are combined with a logical 'AND'. */
export interface TeacherViewAssignmentStudentGradeBoolExp {
  _and?: Maybe<Array<TeacherViewAssignmentStudentGradeBoolExp>>;
  _not?: Maybe<TeacherViewAssignmentStudentGradeBoolExp>;
  _or?: Maybe<Array<TeacherViewAssignmentStudentGradeBoolExp>>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  grade?: Maybe<TeacherGradesBoolExp>;
  grade_id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.assignment_student_grade". */
export interface TeacherViewAssignmentStudentGradeOrderBy {
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  grade?: Maybe<TeacherGradesOrderBy>;
  grade_id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.assignment_student_grade" */
export const enum TeacherViewAssignmentStudentGradeSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  GRADE_ID = 'grade_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.class_student" */
export interface TeacherViewClassStudent {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<TeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.class_student". All fields are combined with a logical 'AND'. */
export interface TeacherViewClassStudentBoolExp {
  _and?: Maybe<Array<TeacherViewClassStudentBoolExp>>;
  _not?: Maybe<TeacherViewClassStudentBoolExp>;
  _or?: Maybe<Array<TeacherViewClassStudentBoolExp>>;
  class?: Maybe<TeacherClassesBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.class_student". */
export interface TeacherViewClassStudentOrderBy {
  class?: Maybe<TeacherClassesOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.class_student" */
export const enum TeacherViewClassStudentSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.grade_type_subject" */
export interface TeacherViewGradeTypeSubject {
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<TeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<TeacherGradeTypes>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "view.grade_type_subject" */
export interface TeacherViewGradeTypeSubjectGradeTypesArgs {
  distinct_on?: Maybe<Array<TeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherGradeTypesOrderBy>>;
  where?: Maybe<TeacherGradeTypesBoolExp>;
}

/** order by aggregate values of table "view.grade_type_subject" */
export interface TeacherViewGradeTypeSubjectAggregateOrderBy {
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherViewGradeTypeSubjectMaxOrderBy>;
  min?: Maybe<TeacherViewGradeTypeSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grade_type_subject". All fields are combined with a logical 'AND'. */
export interface TeacherViewGradeTypeSubjectBoolExp {
  _and?: Maybe<Array<TeacherViewGradeTypeSubjectBoolExp>>;
  _not?: Maybe<TeacherViewGradeTypeSubjectBoolExp>;
  _or?: Maybe<Array<TeacherViewGradeTypeSubjectBoolExp>>;
  grade_type?: Maybe<TeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<TeacherUuidComparisonExp>;
  grade_types?: Maybe<TeacherGradeTypesBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.grade_type_subject" */
export interface TeacherViewGradeTypeSubjectMaxOrderBy {
  grade_type_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "view.grade_type_subject" */
export interface TeacherViewGradeTypeSubjectMinOrderBy {
  grade_type_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "view.grade_type_subject". */
export interface TeacherViewGradeTypeSubjectOrderBy {
  grade_type?: Maybe<TeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  grade_types_aggregate?: Maybe<TeacherGradeTypesAggregateOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.grade_type_subject" */
export const enum TeacherViewGradeTypeSubjectSelectColumn {
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.grades" */
export interface TeacherViewGrades {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<TeacherSemesters>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregated selection of "view.grades" */
export interface TeacherViewGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherViewGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherViewGrades>>;
}

/** aggregate fields of "view.grades" */
export interface TeacherViewGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeacherViewGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherViewGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherViewGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeacherViewGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeacherViewGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeacherViewGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeacherViewGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeacherViewGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeacherViewGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeacherViewGradesVarianceFields>>;
}


/** aggregate fields of "view.grades" */
export interface TeacherViewGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherViewGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "view.grades" */
export interface TeacherViewGradesAggregateOrderBy {
  avg?: Maybe<TeacherViewGradesAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherViewGradesMaxOrderBy>;
  min?: Maybe<TeacherViewGradesMinOrderBy>;
  stddev?: Maybe<TeacherViewGradesStddevOrderBy>;
  stddev_pop?: Maybe<TeacherViewGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherViewGradesStddevSampOrderBy>;
  sum?: Maybe<TeacherViewGradesSumOrderBy>;
  var_pop?: Maybe<TeacherViewGradesVarPopOrderBy>;
  var_samp?: Maybe<TeacherViewGradesVarSampOrderBy>;
  variance?: Maybe<TeacherViewGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface TeacherViewGradesAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "view.grades" */
export interface TeacherViewGradesAvgOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grades". All fields are combined with a logical 'AND'. */
export interface TeacherViewGradesBoolExp {
  _and?: Maybe<Array<TeacherViewGradesBoolExp>>;
  _not?: Maybe<TeacherViewGradesBoolExp>;
  _or?: Maybe<Array<TeacherViewGradesBoolExp>>;
  created_at?: Maybe<TeacherTimetzComparisonExp>;
  created_date?: Maybe<TeacherDateComparisonExp>;
  grade_type?: Maybe<TeacherStringComparisonExp>;
  grade_type_id?: Maybe<TeacherUuidComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  semester?: Maybe<TeacherSemestersBoolExp>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  student_id?: Maybe<TeacherUuidComparisonExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  value?: Maybe<TeacherIntComparisonExp>;
  weight?: Maybe<TeacherIntComparisonExp>;
}

/** columns and relationships of "view.grades_by_subjects_and_classes" */
export interface TeacherViewGradesBySubjectsAndClasses {
  assigment_date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  subject?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.grades_by_subjects_and_classes". All fields are combined with a logical 'AND'. */
export interface TeacherViewGradesBySubjectsAndClassesBoolExp {
  _and?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesBoolExp>>;
  _not?: Maybe<TeacherViewGradesBySubjectsAndClassesBoolExp>;
  _or?: Maybe<Array<TeacherViewGradesBySubjectsAndClassesBoolExp>>;
  assigment_date?: Maybe<TeacherTimestamptzComparisonExp>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  mark?: Maybe<TeacherMarksBoolExp>;
  mark_id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  subject?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.grades_by_subjects_and_classes". */
export interface TeacherViewGradesBySubjectsAndClassesOrderBy {
  assigment_date?: Maybe<TeacherOrderBy>;
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark?: Maybe<TeacherMarksOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  subject?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.grades_by_subjects_and_classes" */
export const enum TeacherViewGradesBySubjectsAndClassesSelectColumn {
  /** column name */
  ASSIGMENT_DATE = 'assigment_date',
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  SUBJECT = 'subject',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.grades_by_subjects_classes_semester_year" */
export interface TeacherViewGradesBySubjectsClassesSemesterYear {
  assigment_date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<TeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<TeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<TeacherStudents>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  year_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.grades_by_subjects_classes_semester_year". All fields are combined with a logical 'AND'. */
export interface TeacherViewGradesBySubjectsClassesSemesterYearBoolExp {
  _and?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearBoolExp>>;
  _not?: Maybe<TeacherViewGradesBySubjectsClassesSemesterYearBoolExp>;
  _or?: Maybe<Array<TeacherViewGradesBySubjectsClassesSemesterYearBoolExp>>;
  assigment_date?: Maybe<TeacherTimestamptzComparisonExp>;
  assignment?: Maybe<TeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<TeacherUuidComparisonExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  comment?: Maybe<TeacherStringComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  mark?: Maybe<TeacherMarksBoolExp>;
  mark_id?: Maybe<TeacherUuidComparisonExp>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  student?: Maybe<TeacherStudentsBoolExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
  year_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.grades_by_subjects_classes_semester_year". */
export interface TeacherViewGradesBySubjectsClassesSemesterYearOrderBy {
  assigment_date?: Maybe<TeacherOrderBy>;
  assignment?: Maybe<TeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<TeacherOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  comment?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  mark?: Maybe<TeacherMarksOrderBy>;
  mark_id?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  student?: Maybe<TeacherStudentsOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
  year_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.grades_by_subjects_classes_semester_year" */
export const enum TeacherViewGradesBySubjectsClassesSemesterYearSelectColumn {
  /** column name */
  ASSIGMENT_DATE = 'assigment_date',
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id',
  /** column name */
  YEAR_ID = 'year_id'
};

/** aggregate max on columns */
export interface TeacherViewGradesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "view.grades" */
export interface TeacherViewGradesMaxOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  created_date?: Maybe<TeacherOrderBy>;
  grade_type?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate min on columns */
export interface TeacherViewGradesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "view.grades" */
export interface TeacherViewGradesMinOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  created_date?: Maybe<TeacherOrderBy>;
  grade_type?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "view.grades". */
export interface TeacherViewGradesOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  created_date?: Maybe<TeacherOrderBy>;
  grade_type?: Maybe<TeacherOrderBy>;
  grade_type_id?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  semester?: Maybe<TeacherSemestersOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  student_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.grades" */
export const enum TeacherViewGradesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_DATE = 'created_date',
  /** column name */
  GRADE_TYPE = 'grade_type',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  VALUE = 'value',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface TeacherViewGradesStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "view.grades" */
export interface TeacherViewGradesStddevOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeacherViewGradesStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "view.grades" */
export interface TeacherViewGradesStddevPopOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeacherViewGradesStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "view.grades" */
export interface TeacherViewGradesStddevSampOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate sum on columns */
export interface TeacherViewGradesSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "view.grades" */
export interface TeacherViewGradesSumOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface TeacherViewGradesVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "view.grades" */
export interface TeacherViewGradesVarPopOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface TeacherViewGradesVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "view.grades" */
export interface TeacherViewGradesVarSampOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** aggregate variance on columns */
export interface TeacherViewGradesVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "view.grades" */
export interface TeacherViewGradesVarianceOrderBy {
  value?: Maybe<TeacherOrderBy>;
  weight?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "view.latest_chat_messages" */
export interface TeacherViewLatestChatMessages {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<TeacherChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user?: EntireFieldWrapper<Maybe<TeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "view.latest_chat_messages" */
export interface TeacherViewLatestChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherViewLatestChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherViewLatestChatMessages>>;
}

/** aggregate fields of "view.latest_chat_messages" */
export interface TeacherViewLatestChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherViewLatestChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherViewLatestChatMessagesMinFields>>;
}


/** aggregate fields of "view.latest_chat_messages" */
export interface TeacherViewLatestChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherViewLatestChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "view.latest_chat_messages". All fields are combined with a logical 'AND'. */
export interface TeacherViewLatestChatMessagesBoolExp {
  _and?: Maybe<Array<TeacherViewLatestChatMessagesBoolExp>>;
  _not?: Maybe<TeacherViewLatestChatMessagesBoolExp>;
  _or?: Maybe<Array<TeacherViewLatestChatMessagesBoolExp>>;
  body?: Maybe<TeacherStringComparisonExp>;
  chat?: Maybe<TeacherChatsBoolExp>;
  chat_id?: Maybe<TeacherUuidComparisonExp>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  user_id?: Maybe<TeacherUuidComparisonExp>;
}

/** aggregate max on columns */
export interface TeacherViewLatestChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TeacherViewLatestChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "view.latest_chat_messages". */
export interface TeacherViewLatestChatMessagesOrderBy {
  body?: Maybe<TeacherOrderBy>;
  chat?: Maybe<TeacherChatsOrderBy>;
  chat_id?: Maybe<TeacherOrderBy>;
  created_at?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  user_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.latest_chat_messages" */
export const enum TeacherViewLatestChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMark {
  avg?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
  count?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  max?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  min?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkAggregateOrderBy {
  avg?: Maybe<TeacherViewStatisticsSemesterSubjectMarkAvgOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherViewStatisticsSemesterSubjectMarkMaxOrderBy>;
  min?: Maybe<TeacherViewStatisticsSemesterSubjectMarkMinOrderBy>;
  stddev?: Maybe<TeacherViewStatisticsSemesterSubjectMarkStddevOrderBy>;
  stddev_pop?: Maybe<TeacherViewStatisticsSemesterSubjectMarkStddevPopOrderBy>;
  stddev_samp?: Maybe<TeacherViewStatisticsSemesterSubjectMarkStddevSampOrderBy>;
  sum?: Maybe<TeacherViewStatisticsSemesterSubjectMarkSumOrderBy>;
  var_pop?: Maybe<TeacherViewStatisticsSemesterSubjectMarkVarPopOrderBy>;
  var_samp?: Maybe<TeacherViewStatisticsSemesterSubjectMarkVarSampOrderBy>;
  variance?: Maybe<TeacherViewStatisticsSemesterSubjectMarkVarianceOrderBy>;
}

/** order by avg() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkAvgOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "view.statistics_semester_subject_mark". All fields are combined with a logical 'AND'. */
export interface TeacherViewStatisticsSemesterSubjectMarkBoolExp {
  _and?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkBoolExp>>;
  _not?: Maybe<TeacherViewStatisticsSemesterSubjectMarkBoolExp>;
  _or?: Maybe<Array<TeacherViewStatisticsSemesterSubjectMarkBoolExp>>;
  avg?: Maybe<TeacherNumericComparisonExp>;
  count?: Maybe<TeacherBigintComparisonExp>;
  max?: Maybe<TeacherIntComparisonExp>;
  min?: Maybe<TeacherIntComparisonExp>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkMaxOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** order by min() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkMinOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** Ordering options when selecting data from "view.statistics_semester_subject_mark". */
export interface TeacherViewStatisticsSemesterSubjectMarkOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
  semester_id?: Maybe<TeacherOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.statistics_semester_subject_mark" */
export const enum TeacherViewStatisticsSemesterSubjectMarkSelectColumn {
  /** column name */
  AVG = 'avg',
  /** column name */
  COUNT = 'count',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** order by stddev() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkStddevOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkStddevPopOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkStddevSampOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by sum() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkSumOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by var_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkVarPopOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by var_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkVarSampOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** order by variance() on columns of table "view.statistics_semester_subject_mark" */
export interface TeacherViewStatisticsSemesterSubjectMarkVarianceOrderBy {
  avg?: Maybe<TeacherOrderBy>;
  count?: Maybe<TeacherOrderBy>;
  max?: Maybe<TeacherOrderBy>;
  min?: Maybe<TeacherOrderBy>;
}

/** columns and relationships of "view.subject_semester" */
export interface TeacherViewSubjectSemester {
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.subject_semester". All fields are combined with a logical 'AND'. */
export interface TeacherViewSubjectSemesterBoolExp {
  _and?: Maybe<Array<TeacherViewSubjectSemesterBoolExp>>;
  _not?: Maybe<TeacherViewSubjectSemesterBoolExp>;
  _or?: Maybe<Array<TeacherViewSubjectSemesterBoolExp>>;
  semester_id?: Maybe<TeacherUuidComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.subject_semester". */
export interface TeacherViewSubjectSemesterOrderBy {
  semester_id?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.subject_semester" */
export const enum TeacherViewSubjectSemesterSelectColumn {
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.teacher_class_subject" */
export interface TeacherViewTeacherClassSubject {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<TeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<TeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.teacher_class_subject". All fields are combined with a logical 'AND'. */
export interface TeacherViewTeacherClassSubjectBoolExp {
  _and?: Maybe<Array<TeacherViewTeacherClassSubjectBoolExp>>;
  _not?: Maybe<TeacherViewTeacherClassSubjectBoolExp>;
  _or?: Maybe<Array<TeacherViewTeacherClassSubjectBoolExp>>;
  class?: Maybe<TeacherClassesBoolExp>;
  class_id?: Maybe<TeacherUuidComparisonExp>;
  subject?: Maybe<TeacherSubjectsBoolExp>;
  subject_id?: Maybe<TeacherUuidComparisonExp>;
  teacher_id?: Maybe<TeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.teacher_class_subject". */
export interface TeacherViewTeacherClassSubjectOrderBy {
  class?: Maybe<TeacherClassesOrderBy>;
  class_id?: Maybe<TeacherOrderBy>;
  subject?: Maybe<TeacherSubjectsOrderBy>;
  subject_id?: Maybe<TeacherOrderBy>;
  teacher_id?: Maybe<TeacherOrderBy>;
}

/** select columns of table "view.teacher_class_subject" */
export const enum TeacherViewTeacherClassSubjectSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "years" */
export interface TeacherYears {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "year_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<TeacherPromotions>>;
  start_date: EntireFieldWrapper<Scalars['date']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "years" */
export interface TeacherYearsPromotionsArgs {
  distinct_on?: Maybe<Array<TeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherPromotionsOrderBy>>;
  where?: Maybe<TeacherPromotionsBoolExp>;
}

/** aggregated selection of "years" */
export interface TeacherYearsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeacherYearsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeacherYears>>;
}

/** aggregate fields of "years" */
export interface TeacherYearsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeacherYearsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeacherYearsMinFields>>;
}


/** aggregate fields of "years" */
export interface TeacherYearsAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeacherYearsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "years". All fields are combined with a logical 'AND'. */
export interface TeacherYearsBoolExp {
  _and?: Maybe<Array<TeacherYearsBoolExp>>;
  _not?: Maybe<TeacherYearsBoolExp>;
  _or?: Maybe<Array<TeacherYearsBoolExp>>;
  created_at?: Maybe<TeacherTimestamptzComparisonExp>;
  end_date?: Maybe<TeacherDateComparisonExp>;
  id?: Maybe<TeacherUuidComparisonExp>;
  name?: Maybe<TeacherStringComparisonExp>;
  promotions?: Maybe<TeacherPromotionsBoolExp>;
  start_date?: Maybe<TeacherDateComparisonExp>;
  updated_at?: Maybe<TeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface TeacherYearsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface TeacherYearsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** Ordering options when selecting data from "years". */
export interface TeacherYearsOrderBy {
  created_at?: Maybe<TeacherOrderBy>;
  end_date?: Maybe<TeacherOrderBy>;
  id?: Maybe<TeacherOrderBy>;
  name?: Maybe<TeacherOrderBy>;
  promotions_aggregate?: Maybe<TeacherPromotionsAggregateOrderBy>;
  start_date?: Maybe<TeacherOrderBy>;
  updated_at?: Maybe<TeacherOrderBy>;
}

/** select columns of table "years" */
export const enum TeacherYearsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_DATE = 'end_date',
  /** column name */
  ID = 'id',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export type TeacherAdressFragment = { street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string };

export type TeacherAssignmentFragment = { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> };

export type TeacherAggregateAssignmentFragment = { aggregate?: Maybe<{ count: number }> };

export type TeacherAssignmentClassFragment = { class?: Maybe<{ name?: Maybe<string>, id: string }> };

export type TeacherAssignmentGradeFragment = { id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> };

export type TeacherAssignmentStudentFragment = { user?: Maybe<{ id: string, full_name?: Maybe<string> }>, assignment: { id: string } };

export type TeacherAssignmentStudentGradeFragment = { student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> };

export type TeacherAssignmentTotalCountFragment = { aggregate?: Maybe<{ count: number }> };

export type TeacherAssignmentTypeFragment = { name: string, icon?: Maybe<string> };

export type TeacherBookFragment = { id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> };

export type TeacherChapterFragment = { id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type TeacherChatFragment = { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type TeacherChatMessageFragment = { id: string, body: string, user_id: string, chat_id: string, created_at: string };

export type TeacherKClassFragment = { name?: Maybe<string>, id: string };

export type TeacherClassStudentFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type TeacherChatTypeFragment = { name: string, description: string };

export type TeacherFileFragment = { id: string, file_name: string, foreign_id: string, path: string };

export type TeacherGradeFragment = { id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } };

export type TeacherLessonFragment = { id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } };

export type TeacherMarkFragment = { name: string, value: number };

export type TeacherMessageFragment = { id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type TeacherMessageAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type TeacherNoteFragment = { id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type TeacherPhoneNumberFragment = { country_code: string, number: string, created_at: string, updated_at: string };

export type TeacherPrivateChatFragment = { id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type TeacherSectionFragment = { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> };

export type TeacherSectionTypeFragment = { name: string, icon?: Maybe<string> };

export type TeacherSemesterFragment = { id: string, start_at: any, end_at: any };

export type TeacherStudentFragment = { id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> };

export type TeacherSubjectFragment = { id: string, name: string, icon?: Maybe<string> };

export type TeacherTaskFragment = { id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean };

export type TeacherTasksAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type TeacherTeacherFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type TeacherUserFragment = { id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> };

export type TeacherYearFragment = { id: string, name?: Maybe<string>, start_date: any, end_date: any };

export type TeacherLatestActivityQueryVariables = Exact<{
  with_body?: Maybe<Scalars['Boolean']>;
  with_notes?: Maybe<Scalars['Boolean']>;
}>;


export type TeacherLatestActivityQuery = { assignment_submits: Array<{ user_id: string, completed_at?: Maybe<string>, is_submited: boolean, assignment: { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, assignment_type: { name: string, icon?: Maybe<string> } } }>, chapter_section_submits: Array<{ chapter_section: { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> } }> };

export type TeacherCreateAssignmentFilesMutationVariables = Exact<{
  objects?: Maybe<Array<TeacherAssignmentFilesInsertInput> | TeacherAssignmentFilesInsertInput>;
}>;


export type TeacherCreateAssignmentFilesMutation = { insert_assignment_files?: Maybe<{ affected_rows: number }> };

export type TeacherDeleteAssignmentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TeacherDeleteAssignmentMutation = { delete_assignments_by_pk?: Maybe<{ id: string }> };

export type TeacherDeleteAssignmentFilesMutationVariables = Exact<{
  _in?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type TeacherDeleteAssignmentFilesMutation = { delete_assignment_files?: Maybe<{ affected_rows: number }> };

export type TeacherDeleteAssignmentUserMutationVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherDeleteAssignmentUserMutation = { delete_assignment_user?: Maybe<{ affected_rows: number }> };

export type TeacherGetMarksListQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetMarksListQuery = { marks: Array<{ id: string, name: string, value: number }> };

export type TeacherGetStudentsForAssignmentQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetStudentsForAssignmentQuery = { assignment_user: Array<{ mark_id?: Maybe<string>, id: string, comment?: Maybe<string>, user?: Maybe<{ full_name?: Maybe<string>, id: string }>, mark?: Maybe<{ name: string }> }> };

export type TeacherGetSubmitsForAssignmentQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetSubmitsForAssignmentQuery = { assignment_submits: Array<{ user_id: string, file?: Maybe<string>, content?: Maybe<string>, completed_at?: Maybe<string>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type TeacherAssignmentInsertMutationVariables = Exact<{
  title: Scalars['String'];
  type?: Maybe<TeacherAssignmentTypeEnum>;
  due_at?: Maybe<Scalars['timestamptz']>;
  duration: Scalars['Int'];
}>;


export type TeacherAssignmentInsertMutation = { insert_assignments_one?: Maybe<{ id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type TeacherInsertAssigmentWithTeachingStructureMutationVariables = Exact<{
  is_gradeable?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  teaching_structure_id?: Maybe<Scalars['uuid']>;
  due_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  is_everybody?: Maybe<Scalars['Boolean']>;
  type?: Maybe<TeacherAssignmentTypeEnum>;
  chat_id?: Maybe<Scalars['uuid']>;
  assignment_grade_weight_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherInsertAssigmentWithTeachingStructureMutation = { insert_assignments_one?: Maybe<{ id: string }> };

export type TeacherStudentsToAssignmentMutationVariables = Exact<{
  objects?: Maybe<Array<TeacherAssignmentUserInsertInput> | TeacherAssignmentUserInsertInput>;
}>;


export type TeacherStudentsToAssignmentMutation = { insert_assignment_user?: Maybe<{ affected_rows: number }> };

export type TeacherInsertAssigmentMarkMutationVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
  mark_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type TeacherInsertAssigmentMarkMutation = { update_assignment_user?: Maybe<{ affected_rows: number }> };

export type TeacherUpdateMarksForStudentMutationVariables = Exact<{
  id?: Maybe<TeacherUuidComparisonExp>;
  mark_id?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
}>;


export type TeacherUpdateMarksForStudentMutation = { update_assignment_user?: Maybe<{ affected_rows: number, returning: Array<{ comment?: Maybe<string>, id: string, mark?: Maybe<{ id: string, name: string, value: number }> }> }> };

export type TeacherAssignmentStudentGradesQueryVariables = Exact<{
  assignment_id: Scalars['uuid'];
}>;


export type TeacherAssignmentStudentGradesQuery = { assigment_student_grade: Array<{ student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> }> };

export type TeacherUpdateAssignmentMutationVariables = Exact<{
  _set: TeacherAssignmentsSetInput;
  id: Scalars['uuid'];
}>;


export type TeacherUpdateAssignmentMutation = { update_assignments_by_pk?: Maybe<{ id: string }> };

export type TeacherCreateAttendanceMutationVariables = Exact<{
  attendances: Array<TeacherAttendancesInsertInput> | TeacherAttendancesInsertInput;
}>;


export type TeacherCreateAttendanceMutation = { insert_attendances?: Maybe<{ returning: Array<{ id: string }> }> };

export type TeacherDeleteAttendancesMutationVariables = Exact<{
  where: TeacherAttendancesBoolExp;
}>;


export type TeacherDeleteAttendancesMutation = { delete_attendances?: Maybe<{ affected_rows: number }> };

export type TeacherGetAttendanceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetAttendanceTypesQuery = { attendance_types: Array<{ value: string, text: string, icon: string }> };

export type TeacherGetAttendancesQueryVariables = Exact<{
  where?: Maybe<TeacherAttendancesBoolExp>;
}>;


export type TeacherGetAttendancesQuery = { attendances: Array<{ attendance_type?: Maybe<string>, comment?: Maybe<string>, date: string, id: string, student_id: string, subject_id: string, teacher_id?: Maybe<string>, student?: Maybe<{ id: string, full_name?: Maybe<string> }>, type?: Maybe<{ value: string, text: string, icon: string }> }> };

export type TeacherChatByTypePrivateQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type TeacherChatByTypePrivateQuery = { chat_user: Array<{ chat_id: string }> };

export type TeacherChatDeleteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TeacherChatDeleteMutation = { delete_chats_by_pk?: Maybe<{ id: string }> };

export type TeacherChatInsertPrivateUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type TeacherChatInsertPrivateUserMutation = { insert_chat_user_one?: Maybe<{ id: string }> };

export type TeacherChatUpdateMutationVariables = Exact<{
  id: Scalars['uuid'];
  title: Scalars['String'];
  avatar_url: Scalars['String'];
}>;


export type TeacherChatUpdateMutation = { update_chats_by_pk?: Maybe<{ id: string }> };

export type TeacherClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherClassesQuery = { classes: Array<{ id: string, name?: Maybe<string>, identifier?: Maybe<string>, level: { name: string, number: number } }> };

export type TeacherClassStudentsQueryVariables = Exact<{
  class_id: Scalars['uuid'];
}>;


export type TeacherClassStudentsQuery = { student_class: Array<{ user: Array<{ full_name?: Maybe<string>, id: string }> }> };

export type TeacherClassSubjectQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherClassSubjectQuery = { subjects: Array<{ subject?: Maybe<{ id: string, name: string }>, class?: Maybe<{ id: string, name?: Maybe<string> }> }> };

export type TeacherGetTeachingStructureTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetTeachingStructureTreeQuery = { teaching_structures: Array<{ id: string, created_at: string, updated_at: string, depth: number, title: string, rtl: number, ltr: number, semester?: Maybe<{ id: string, start_at: any, end_at: any }>, teaching_structure_type?: Maybe<{ id: string, title: string }>, teacher_subjects: Array<{ id: string, teacher_id: string, created_at: string, teaching_structure_id: string }>, assignments: Array<{ id: string, title: string }>, teaching_structures: Array<{ id: string }> }> };

export type TeacherGetMyTeacherEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetMyTeacherEventsQuery = { events: Array<{ created_at?: Maybe<string>, date: string, description?: Maybe<string>, id: string, title: string }> };

export type TeacherGradesByAssignmentQueryVariables = Exact<{
  assignment_id: Scalars['uuid'];
}>;


export type TeacherGradesByAssignmentQuery = { grades: Array<{ id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> }> };

export type TeacherStudentGradesBySemesterQueryVariables = Exact<{
  semester_id: Scalars['uuid'];
  student_id: Scalars['uuid'];
}>;


export type TeacherStudentGradesBySemesterQuery = { subjects: Array<{ id: string, name: string, icon?: Maybe<string>, statistics: Array<{ max?: Maybe<number>, min?: Maybe<number>, avg?: Maybe<any> }>, grades: { aggregate?: Maybe<{ max?: Maybe<{ value?: Maybe<number> }> }> }, parent_types: Array<{ parent_type?: Maybe<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> }, child_types: Array<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> }> }> }> };

export type TeacherGetGradeForStudentByAssigmentQueryVariables = Exact<{
  student_id?: Maybe<Scalars['uuid']>;
  assignment_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetGradeForStudentByAssigmentQuery = { assignments: Array<{ title: string, assignment_submits: Array<{ id: string, file?: Maybe<string>, content?: Maybe<string>, completed_at?: Maybe<string>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }>, assignment_users: Array<{ comment?: Maybe<string>, mark_id?: Maybe<string>, id: string, mark?: Maybe<{ id: string, name: string }> }> }> };

export type TeacherGetGradeDetailsQueryVariables = Exact<{
  assignment_id?: Maybe<Scalars['uuid']>;
  student_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetGradeDetailsQuery = { assignments: Array<{ title: string, created_at: string, assignment_files: Array<{ id: string, title: string, path: string }>, assignment_type: { name: string }, user?: Maybe<{ full_name?: Maybe<string> }>, assignment_users: Array<{ id: string, comment?: Maybe<string>, mark?: Maybe<{ id: string }> }> }> };

export type TeacherGetGradeDataQueryVariables = Exact<{
  subject?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  class_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetGradeDataQuery = { view_grades_by_subjects_and_classes: Array<{ assigment_date?: Maybe<string>, class_id?: Maybe<string>, subject?: Maybe<string>, mark?: Maybe<{ name: string, value: number, id: string }>, student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, assignment?: Maybe<{ id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> }> };

export type TeacherGradeInsertMutationVariables = Exact<{
  grades: Array<TeacherGradesInsertInput> | TeacherGradesInsertInput;
}>;


export type TeacherGradeInsertMutation = { insert_grades?: Maybe<{ returning: Array<{ id: string }> }> };

export type TeacherGradeUpdateMarkMutationVariables = Exact<{
  id: Scalars['uuid'];
  mark_id: Scalars['uuid'];
  comment?: Maybe<Scalars['String']>;
}>;


export type TeacherGradeUpdateMarkMutation = { update_grades_by_pk?: Maybe<{ id: string }> };

export type TeacherInviteParentMutationVariables = Exact<{
  email: Scalars['String'];
  user_data: TeacherUserInsertInput;
  school_options?: Maybe<TeacherInviteParentInput>;
  password?: Maybe<Scalars['String']>;
}>;


export type TeacherInviteParentMutation = { invite_parent?: Maybe<{ jwt_expires_in?: Maybe<string>, jwt_token?: Maybe<string>, refresh_token?: Maybe<string> }> };

export type TeacherInviteStudentMutationVariables = Exact<{
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options: TeacherInviteStudentClassInsertInput;
  user_data: TeacherUserInsertInput;
}>;


export type TeacherInviteStudentMutation = { invite_student?: Maybe<{ jwt_token?: Maybe<string>, jwt_expires_in?: Maybe<string>, refresh_token?: Maybe<string> }> };

export type TeacherInviteTeacherMutationVariables = Exact<{
  password?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  school_options: TeacherTeacherSkillInsertInput;
  user_data: TeacherUserInsertInput;
}>;


export type TeacherInviteTeacherMutation = { invite_teacher?: Maybe<{ jwt_expires_in?: Maybe<string>, jwt_token?: Maybe<string>, refresh_token?: Maybe<string> }> };

export type TeacherGetMarksQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetMarksQuery = { marks: Array<{ id: string, name: string }> };

export type TeacherMeetingCreateMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['String']>;
  teacher_name?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  starting_at?: Maybe<Scalars['String']>;
}>;


export type TeacherMeetingCreateMutation = { create_live_class?: Maybe<{ url: string, id: string }> };

export type TeacherMeetingDeleteMutationVariables = Exact<{
  lesson_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherMeetingDeleteMutation = { delete_live_class?: Maybe<{ data?: Maybe<string> }> };

export type TeacherDeleteLiveClassByPkMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type TeacherDeleteLiveClassByPkMutation = { delete_live_classes_by_pk?: Maybe<{ id: string }> };

export type TeacherGetMyLiveClassesQueryVariables = Exact<{
  _in?: Maybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type TeacherGetMyLiveClassesQuery = { live_classes: Array<{ id: string, name: string, duration: number, description?: Maybe<string>, starting_at?: Maybe<string>, status?: Maybe<string> }> };

export type TeacherGetStudentsByLiveClassIdQueryVariables = Exact<{
  liveClassId?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetStudentsByLiveClassIdQuery = { live_class_attendees: Array<{ id: string, is_present: boolean, students?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }> }> };

export type TeacherGetLiveClassGroupsQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetLiveClassGroupsQuery = { student_groups: Array<{ id: string, name: string }> };

export type TeacherDeleteLiveClassGroupsMutationVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherDeleteLiveClassGroupsMutation = { delete_student_groups?: Maybe<{ affected_rows: number }> };

export type TeacherGetStudentsForGroupByGroupIdQueryVariables = Exact<{
  _eq1?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetStudentsForGroupByGroupIdQuery = { student_group_users: Array<{ user_id: string }> };

export type TeacherTeacherInsertLiveClassGroupMutationVariables = Exact<{
  object?: Maybe<TeacherStudentGroupsInsertInput>;
}>;


export type TeacherTeacherInsertLiveClassGroupMutation = { insert_student_groups_one?: Maybe<{ id: string }> };

export type TeacherInsertStudentsForLiveClassMutationVariables = Exact<{
  objects?: Maybe<Array<TeacherLiveClassAttendeesInsertInput> | TeacherLiveClassAttendeesInsertInput>;
}>;


export type TeacherInsertStudentsForLiveClassMutation = { insert_live_class_attendees?: Maybe<{ affected_rows: number }> };

export type TeacherMeetingJoinMutationVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  lesson_id?: Maybe<Scalars['String']>;
}>;


export type TeacherMeetingJoinMutation = { teacherJoin?: Maybe<{ url: string, id: string }> };

export type TeacherLiveClassGetStudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherLiveClassGetStudentsQuery = { students: Array<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }> };

export type TeacherLiveClassesQueryVariables = Exact<{
  _or?: Maybe<Array<TeacherLiveClassesBoolExp> | TeacherLiveClassesBoolExp>;
  upcoming_sunday: Scalars['timestamptz'];
  last_sunday: Scalars['timestamptz'];
}>;


export type TeacherLiveClassesQuery = { live_classes: Array<{ id: string, name: string, duration: number, description?: Maybe<string>, starting_at?: Maybe<string>, status?: Maybe<string> }> };

export type TeacherPresentStudentsLiveClassMutationVariables = Exact<{
  is_present?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherPresentStudentsLiveClassMutation = { update_live_class_attendees_by_pk?: Maybe<{ id: string }> };

export type TeacherUpdateLiveClassesMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: Scalars['String'];
}>;


export type TeacherUpdateLiveClassesMutation = { update_live_classes_by_pk?: Maybe<{ id: string }> };

export type TeacherDeleteRoleMutationVariables = Exact<{
  deleteRolesByPkId: Scalars['uuid'];
}>;


export type TeacherDeleteRoleMutation = { delete_roles_by_pk?: Maybe<{ id: string }> };

export type TeacherGetPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetPermissionsQuery = { permissions: Array<{ id: string, title: string }> };

export type TeacherGetRolePermissionsQueryVariables = Exact<{
  rolesByPkId: Scalars['uuid'];
}>;


export type TeacherGetRolePermissionsQuery = { roles_by_pk?: Maybe<{ id: string, title: string, colour?: Maybe<string>, permissions: Array<{ id: string, permission_id: string, role_id: string }> }> };

export type TeacherGetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherGetRolesQuery = { roles: Array<{ id: string, colour?: Maybe<string>, title: string }> };

export type TeacherGetUsersQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type TeacherGetUsersQuery = { roles: Array<{ id: string, title: string, colour?: Maybe<string>, permissions: Array<{ id: string, permission_id: string, role_id: string }> }> };

export type TeacherInsertRoleMutationVariables = Exact<{
  object: TeacherRolesInsertInput;
}>;


export type TeacherInsertRoleMutation = { insert_roles_one?: Maybe<{ id: string }> };

export type TeacherUpdateRoleMutationVariables = Exact<{
  pkColumns: TeacherRolesPkColumnsInput;
  set?: Maybe<TeacherRolesSetInput>;
}>;


export type TeacherUpdateRoleMutation = { update_roles_by_pk?: Maybe<{ id: string }> };

export type TeacherInsertQuizMutationVariables = Exact<{
  quiz: TeacherAssignmentsInsertInput;
}>;


export type TeacherInsertQuizMutation = { insert_assignments_one?: Maybe<{ id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> }> };

export type TeacherCreateQuestionWithOptionsMutationVariables = Exact<{
  object: TeacherAssignmentQuestionsInsertInput;
}>;


export type TeacherCreateQuestionWithOptionsMutation = { insert_assignment_questions_one?: Maybe<{ title: string, id: string, type: TeacherAssignmentQuestionTypesEnum, content?: Maybe<string>, assignment_question_options: Array<{ is_correct?: Maybe<boolean>, id: string, order?: Maybe<number>, title: string, group?: Maybe<number>, created_at?: Maybe<string>, score?: Maybe<number>, comment?: Maybe<string> }> }> };

export type TeacherCreateQuizMutationVariables = Exact<{
  quiz: TeacherAssignmentQuizInsertInput;
}>;


export type TeacherCreateQuizMutation = { insert_assignment_quiz_one?: Maybe<{ assignment: { id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> } }> };

export type TeacherDeleteQuizQuestionWithAllRelationsMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherDeleteQuizQuestionWithAllRelationsMutation = { delete_assignment_question_option_relations?: Maybe<{ affected_rows: number }>, delete_assignment_question_options?: Maybe<{ affected_rows: number }>, delete_assignment_questions_by_pk?: Maybe<{ id: string }> };

export type TeacherGetQuestionByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetQuestionByIdQuery = { assignment_questions_by_pk?: Maybe<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> };

export type TeacherGetQuestionsByAssignmentIdQueryVariables = Exact<{
  assignmentId?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetQuestionsByAssignmentIdQuery = { assignment_questions: Array<{ assignment_id: string, content?: Maybe<string>, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, updated_at: string, assignment_question_options: Array<{ group?: Maybe<number>, id: string, order?: Maybe<number>, title: string, updated_at?: Maybe<string>, is_correct?: Maybe<boolean>, assignment_question_option_relations: Array<{ assignment_question_option_matching_id?: Maybe<string> }>, assignment_question_answers: Array<{ id: string, assignment_question_option_id?: Maybe<string>, content?: Maybe<string>, is_correct?: Maybe<boolean>, user?: Maybe<{ full_name?: Maybe<string>, id: string, title?: Maybe<string>, avatar_url?: Maybe<string> }> }> }> }> };

export type TeacherGetQuizByIdQueryVariables = Exact<{
  quizId?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetQuizByIdQuery = { assignments_by_pk?: Maybe<{ id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> }> };

export type TeacherGetTeachersQuizzAssignmentsQueryVariables = Exact<{
  user_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetTeachersQuizzAssignmentsQuery = { assignments: Array<{ id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> }> };

export type TeacherUpdateQuestionByPkMutationVariables = Exact<{
  questionId?: Maybe<Scalars['uuid']>;
  question?: Maybe<TeacherAssignmentQuestionsSetInput>;
  question_options?: Maybe<Array<TeacherAssignmentQuestionOptionsInsertInput> | TeacherAssignmentQuestionOptionsInsertInput>;
}>;


export type TeacherUpdateQuestionByPkMutation = { update_assignment_questions_by_pk?: Maybe<{ id: string }>, insert_assignment_question_options?: Maybe<{ returning: Array<{ id: string }> }> };

export type TeacherUpdateQuestionOptionByPkMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
  object?: Maybe<TeacherAssignmentQuestionOptionsSetInput>;
}>;


export type TeacherUpdateQuestionOptionByPkMutation = { update_assignment_question_options_by_pk?: Maybe<{ id: string }> };

export type TeacherUpdateQuizMutationVariables = Exact<{
  assignment_id: Scalars['uuid'];
  assignment: TeacherAssignmentsSetInput;
  assignment_quiz: TeacherAssignmentQuizSetInput;
}>;


export type TeacherUpdateQuizMutation = { update_assignment_quiz?: Maybe<{ returning: Array<{ id: string }> }>, update_assignments_by_pk?: Maybe<{ id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> }> };

export type TeacherStudentsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeacherStudentsQuery = { students: Array<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }> };

export type TeacherCheckNumberOfLeafsQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherCheckNumberOfLeafsQuery = { teaching_structures_by_pk?: Maybe<{ rtl: number, ltr: number }> };

export type TeacherDeleteAssignmentsWithTeachingStructureMutationVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherDeleteAssignmentsWithTeachingStructureMutation = { delete_assignments?: Maybe<{ affected_rows: number }> };

export type TeacherDeleteTeachingStructureLeafMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherDeleteTeachingStructureLeafMutation = { delete_teaching_structures_by_pk?: Maybe<{ id: string }> };

export type TeacherGetAssigmentByIdQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetAssigmentByIdQuery = { assignments: Array<{ type: TeacherAssignmentTypeEnum, title: string, id: string, description?: Maybe<string>, duration: number, teaching_structure_id?: Maybe<string>, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_type: { name: string, icon?: Maybe<string> }, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, assignment_users: Array<{ id: string, mark_id?: Maybe<string>, comment?: Maybe<string>, user?: Maybe<{ full_name?: Maybe<string>, id: string }> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type TeacherGetAllMyLeafsQueryVariables = Exact<{
  teaching_structure_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetAllMyLeafsQuery = { teaching_structure_leafs: Array<{ id: string, title: string, parent_id?: Maybe<string>, updated_at: string, ltr: number, rtl: number, assignments: Array<{ id: string, title: string, type: TeacherAssignmentTypeEnum, duration: number, created_at: string }> }> };

export type TeacherGetMyTeachingStructureItemsQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetMyTeachingStructureItemsQuery = { teacher_subject: Array<{ teaching_structure_id: string, subject_id: string, teaching_structure: { subject_icon?: Maybe<string>, title: string, id: string, parent?: Maybe<{ title: string, id: string, created_at: string, parent?: Maybe<{ id: string, title: string }> }>, assignments_aggregate: { aggregate?: Maybe<{ count: number }> } } }> };

export type TeacherGetParentSubjectForTeachingStructureIdQueryVariables = Exact<{
  leaf_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherGetParentSubjectForTeachingStructureIdQuery = { teaching_structure_parents: Array<{ id: string, title: string, rtl: number, ltr: number, parent?: Maybe<{ id: string, title: string }> }> };

export type TeacherInsertTeachingStructureItemMutationVariables = Exact<{
  title?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherInsertTeachingStructureItemMutation = { insert_teaching_structures_one?: Maybe<{ id: string }> };

export type TeacherUpdateAssignmentsWithTeachingStructureMutationVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
  assignment?: Maybe<TeacherAssignmentsSetInput>;
}>;


export type TeacherUpdateAssignmentsWithTeachingStructureMutation = { update_assignments?: Maybe<{ affected_rows: number }> };

export type TeacherUpdateTeachingStructureItemMutationVariables = Exact<{
  title?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
}>;


export type TeacherUpdateTeachingStructureItemMutation = { update_teaching_structures_by_pk?: Maybe<{ title: string }> };

export type TeacherAssignmentQuestionOptionsFragment = { comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string };

export type TeacherAssignmentQuestionsFragment = { content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> };

export type TeacherAssignmentQuizFragment = { attempts?: Maybe<number>, pass_percentage: number, time_control: boolean };

export type TeacherClassFragment = { id: string, name?: Maybe<string>, identifier?: Maybe<string>, level: { name: string, number: number } };

export type TeacherClassSubjectFragment = { subject?: Maybe<{ id: string, name: string }>, class?: Maybe<{ id: string, name?: Maybe<string> }> };

export type TeacherQuizFragment = { id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: TeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> };

export type TeacherStudentGradesSemesterFragment = { id: string, name: string, icon?: Maybe<string>, statistics: Array<{ max?: Maybe<number>, min?: Maybe<number>, avg?: Maybe<any> }>, grades: { aggregate?: Maybe<{ max?: Maybe<{ value?: Maybe<number> }> }> }, parent_types: Array<{ parent_type?: Maybe<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> }, child_types: Array<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> }> }> };

export const TeacherAdressFragmentDoc = gql`
    fragment Adress on private_adresses {
  street
  area
  city
  postal_code
  country
  created_at
  updated_at
}
    `;
export const TeacherAssignmentTypeFragmentDoc = gql`
    fragment AssignmentType on assignment_type {
  name
  icon
}
    `;
export const TeacherFileFragmentDoc = gql`
    fragment File on files {
  id
  file_name
  foreign_id
  path
}
    `;
export const TeacherAssignmentFragmentDoc = gql`
    fragment Assignment on assignments {
  id
  title
  description
  duration
  due_at
  due_at_filter
  created_at
  assignment_users {
    user_id
    id
  }
  chat {
    title
    id
  }
  teaching_structure {
    subject_icon
    subject_icon
    id
    ltr
    rtl
  }
  assignment_type {
    ...AssignmentType
  }
  lesson {
    course {
      subject {
        name
      }
    }
  }
  is_gradeable
  is_completed
  lesson {
    course {
      subject {
        name
      }
    }
  }
  user {
    full_name
  }
  grade_weight: assignment_grade_weight {
    id
    value
    comment
  }
  files {
    ...File
  }
}
    ${TeacherAssignmentTypeFragmentDoc}
${TeacherFileFragmentDoc}`;
export const TeacherAggregateAssignmentFragmentDoc = gql`
    fragment AggregateAssignment on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const TeacherKClassFragmentDoc = gql`
    fragment KClass on classes {
  name
  id
}
    `;
export const TeacherAssignmentClassFragmentDoc = gql`
    fragment AssignmentClass on view_assignment_class {
  class {
    ...KClass
  }
}
    ${TeacherKClassFragmentDoc}`;
export const TeacherAssignmentGradeFragmentDoc = gql`
    fragment AssignmentGrade on grades {
  id
  student {
    id
    user {
      full_name
    }
  }
  mark {
    id
    value
  }
}
    `;
export const TeacherAssignmentStudentFragmentDoc = gql`
    fragment AssignmentStudent on assignment_user {
  user {
    id
    full_name
  }
  assignment {
    id
  }
}
    `;
export const TeacherAssignmentStudentGradeFragmentDoc = gql`
    fragment AssignmentStudentGrade on view_assignment_student_grade {
  student {
    id
    user {
      full_name
    }
  }
  grade {
    id
    mark {
      id
      value
    }
  }
}
    `;
export const TeacherAssignmentTotalCountFragmentDoc = gql`
    fragment AssignmentTotalCount on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const TeacherSectionTypeFragmentDoc = gql`
    fragment SectionType on chapter_section_type {
  name
  icon
}
    `;
export const TeacherNoteFragmentDoc = gql`
    fragment Note on chapter_section_notes {
  id
  body
  created_at
  user {
    full_name
    avatar_url
  }
}
    `;
export const TeacherSectionFragmentDoc = gql`
    fragment Section on chapter_sections {
  id
  title
  body @include(if: $with_body)
  duration_left
  duration_total: duration
  is_completed
  type: chapter_section_type {
    ...SectionType
  }
  notes: chapter_section_notes @include(if: $with_notes) {
    ...Note
  }
}
    ${TeacherSectionTypeFragmentDoc}
${TeacherNoteFragmentDoc}`;
export const TeacherChapterFragmentDoc = gql`
    fragment Chapter on book_chapters {
  id
  title
  duration_left
  due_at
  type: book_chapter_type {
    name
    description
  }
  sections: chapter_sections(order_by: {sort: asc}) {
    ...Section
  }
}
    ${TeacherSectionFragmentDoc}`;
export const TeacherBookFragmentDoc = gql`
    fragment Book on books {
  id
  title
  book_chapters {
    ...Chapter
  }
}
    ${TeacherChapterFragmentDoc}`;
export const TeacherChatFragmentDoc = gql`
    fragment Chat on chats {
  id
  title
  avatar_url
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const TeacherChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_messages {
  id
  body
  user_id
  chat_id
  created_at
}
    `;
export const TeacherClassStudentFragmentDoc = gql`
    fragment ClassStudent on students {
  id
  user {
    full_name
  }
}
    `;
export const TeacherChatTypeFragmentDoc = gql`
    fragment ChatType on chat_type {
  name
  description
}
    `;
export const TeacherGradeFragmentDoc = gql`
    fragment Grade on grades {
  id
  weight
  comment
  mark {
    id
    name
    value
  }
  assignment {
    title
    type: assignment_type {
      name
      icon
    }
    lesson {
      course {
        subject {
          id
          name
        }
      }
    }
  }
}
    `;
export const TeacherTeacherFragmentDoc = gql`
    fragment Teacher on teachers {
  id
  user {
    full_name
  }
}
    `;
export const TeacherLessonFragmentDoc = gql`
    fragment Lesson on lessons {
  id
  start_at
  start_date
  course {
    id
    subject {
      id
      name
    }
    course_teachers {
      teacher {
        ...Teacher
      }
    }
  }
  description
}
    ${TeacherTeacherFragmentDoc}`;
export const TeacherMarkFragmentDoc = gql`
    fragment Mark on marks {
  name
  value
}
    `;
export const TeacherMessageFragmentDoc = gql`
    fragment Message on chat_messages {
  id
  body
  user_id
  chat_id
  is_pinned
  created_at
  replys {
    id
    body
    user_id
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  likes: chat_message_likes {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
  responding: chat_message {
    id
    body
    user_id
    chat_id
    is_pinned
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  user {
    first_name
    last_name
    avatar_url
  }
}
    `;
export const TeacherMessageAggregateFragmentDoc = gql`
    fragment MessageAggregate on chat_messages_aggregate {
  aggregate {
    count
  }
}
    `;
export const TeacherPhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on private_phone_numbers {
  country_code
  number
  created_at
  updated_at
}
    `;
export const TeacherPrivateChatFragmentDoc = gql`
    fragment PrivateChat on chats {
  id
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const TeacherSemesterFragmentDoc = gql`
    fragment Semester on semesters {
  id
  start_at
  end_at
}
    `;
export const TeacherStudentFragmentDoc = gql`
    fragment Student on students {
  id
  user {
    avatar_url
    full_name
  }
}
    `;
export const TeacherSubjectFragmentDoc = gql`
    fragment Subject on subjects {
  id
  name
  icon
}
    `;
export const TeacherTaskFragmentDoc = gql`
    fragment Task on tasks {
  id
  body
  title
  is_completed
}
    `;
export const TeacherTasksAggregateFragmentDoc = gql`
    fragment TasksAggregate on tasks_aggregate {
  aggregate {
    count
  }
}
    `;
export const TeacherUserFragmentDoc = gql`
    fragment User on UserData {
  id
  last_name
  first_name
  email
  birthday_at
  avatar_url
  mobile
  street_address
  title
  role
  is_verified
  assignments
  live_class
  grading
  chat
}
    `;
export const TeacherYearFragmentDoc = gql`
    fragment Year on years {
  id
  name
  start_date
  end_date
}
    `;
export const TeacherClassFragmentDoc = gql`
    fragment Class on classes {
  id
  name
  identifier
  level {
    name
    number
  }
}
    `;
export const TeacherClassSubjectFragmentDoc = gql`
    fragment ClassSubject on view_teacher_class_subject {
  subject {
    id
    name
  }
  class {
    id
    name
  }
}
    `;
export const TeacherAssignmentQuizFragmentDoc = gql`
    fragment AssignmentQuiz on assignment_quiz {
  attempts
  pass_percentage
  time_control
}
    `;
export const TeacherAssignmentQuestionOptionsFragmentDoc = gql`
    fragment AssignmentQuestionOptions on assignment_question_options {
  comment
  created_at
  id
  is_correct
  order
  score
  title
}
    `;
export const TeacherAssignmentQuestionsFragmentDoc = gql`
    fragment AssignmentQuestions on assignment_questions {
  content
  assignment_id
  id
  title
  type
  created_at
  assignment_question_options {
    ...AssignmentQuestionOptions
  }
}
    ${TeacherAssignmentQuestionOptionsFragmentDoc}`;
export const TeacherQuizFragmentDoc = gql`
    fragment Quiz on assignments {
  id
  title
  is_completed
  duration
  description
  created_at
  due_at
  teaching_structure_id
  assignment_quiz {
    ...AssignmentQuiz
  }
  teaching_structure {
    id
    title
  }
  assignment_questions {
    ...AssignmentQuestions
  }
}
    ${TeacherAssignmentQuizFragmentDoc}
${TeacherAssignmentQuestionsFragmentDoc}`;
export const TeacherStudentGradesSemesterFragmentDoc = gql`
    fragment StudentGradesSemester on subjects {
  id
  name
  icon
  statistics(where: {semester_id: {_eq: $semester_id}}) {
    max
    min
    avg
  }
  grades: view_grades_aggregate(where: {semester_id: {_eq: $semester_id}}) {
    aggregate {
      max {
        value
      }
    }
  }
  parent_types: grade_types(
    where: {grade_type: {grade_type_id: {_is_null: true}}}
  ) {
    parent_type: grade_type {
      id
      name
      grades: view_grades_aggregate(
        where: {semester_id: {_eq: $semester_id}, student_id: {_eq: $student_id}}
      ) {
        aggregate {
          avg {
            value
          }
        }
      }
      child_types: grade_types {
        id
        name
        grades: view_grades_aggregate(
          where: {semester_id: {_eq: $semester_id}, student_id: {_eq: $student_id}}
        ) {
          aggregate {
            avg {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const TeacherLatestActivityDocument = gql`
    query LatestActivity($with_body: Boolean = false, $with_notes: Boolean = false) {
  assignment_submits {
    assignment {
      id
      title
      description
      duration
      due_at
      due_at_filter
      assignment_type {
        ...AssignmentType
      }
    }
    user_id
    completed_at
    is_submited
  }
  chapter_section_submits {
    chapter_section {
      ...Section
    }
  }
}
    ${TeacherAssignmentTypeFragmentDoc}
${TeacherSectionFragmentDoc}`;

/**
 * __useLatestActivityQuery__
 *
 * To run a query within a React component, call `useLatestActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestActivityQuery({
 *   variables: {
 *      with_body: // value for 'with_body'
 *      with_notes: // value for 'with_notes'
 *   },
 * });
 */
export function useLatestActivityQuery(baseOptions?: Apollo.QueryHookOptions<TeacherLatestActivityQuery, TeacherLatestActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherLatestActivityQuery, TeacherLatestActivityQueryVariables>(TeacherLatestActivityDocument, options);
      }
export function useLatestActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherLatestActivityQuery, TeacherLatestActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherLatestActivityQuery, TeacherLatestActivityQueryVariables>(TeacherLatestActivityDocument, options);
        }
export type LatestActivityQueryHookResult = ReturnType<typeof useLatestActivityQuery>;
export type LatestActivityLazyQueryHookResult = ReturnType<typeof useLatestActivityLazyQuery>;
export type LatestActivityQueryResult = Apollo.QueryResult<TeacherLatestActivityQuery, TeacherLatestActivityQueryVariables>;
export const TeacherCreateAssignmentFilesDocument = gql`
    mutation CreateAssignmentFiles($objects: [assignment_files_insert_input!] = {}) {
  insert_assignment_files(objects: $objects) {
    affected_rows
  }
}
    `;
export type TeacherCreateAssignmentFilesMutationFn = Apollo.MutationFunction<TeacherCreateAssignmentFilesMutation, TeacherCreateAssignmentFilesMutationVariables>;

/**
 * __useCreateAssignmentFilesMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentFilesMutation, { data, loading, error }] = useCreateAssignmentFilesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreateAssignmentFilesMutation(baseOptions?: Apollo.MutationHookOptions<TeacherCreateAssignmentFilesMutation, TeacherCreateAssignmentFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherCreateAssignmentFilesMutation, TeacherCreateAssignmentFilesMutationVariables>(TeacherCreateAssignmentFilesDocument, options);
      }
export type CreateAssignmentFilesMutationHookResult = ReturnType<typeof useCreateAssignmentFilesMutation>;
export type CreateAssignmentFilesMutationResult = Apollo.MutationResult<TeacherCreateAssignmentFilesMutation>;
export type CreateAssignmentFilesMutationOptions = Apollo.BaseMutationOptions<TeacherCreateAssignmentFilesMutation, TeacherCreateAssignmentFilesMutationVariables>;
export const TeacherDeleteAssignmentDocument = gql`
    mutation DeleteAssignment($id: uuid!) {
  delete_assignments_by_pk(id: $id) {
    id
  }
}
    `;
export type TeacherDeleteAssignmentMutationFn = Apollo.MutationFunction<TeacherDeleteAssignmentMutation, TeacherDeleteAssignmentMutationVariables>;

/**
 * __useDeleteAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentMutation, { data, loading, error }] = useDeleteAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteAssignmentMutation, TeacherDeleteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteAssignmentMutation, TeacherDeleteAssignmentMutationVariables>(TeacherDeleteAssignmentDocument, options);
      }
export type DeleteAssignmentMutationHookResult = ReturnType<typeof useDeleteAssignmentMutation>;
export type DeleteAssignmentMutationResult = Apollo.MutationResult<TeacherDeleteAssignmentMutation>;
export type DeleteAssignmentMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteAssignmentMutation, TeacherDeleteAssignmentMutationVariables>;
export const TeacherDeleteAssignmentFilesDocument = gql`
    mutation DeleteAssignmentFiles($_in: [String!] = "") {
  delete_assignment_files(where: {hash: {_in: $_in}}) {
    affected_rows
  }
}
    `;
export type TeacherDeleteAssignmentFilesMutationFn = Apollo.MutationFunction<TeacherDeleteAssignmentFilesMutation, TeacherDeleteAssignmentFilesMutationVariables>;

/**
 * __useDeleteAssignmentFilesMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentFilesMutation, { data, loading, error }] = useDeleteAssignmentFilesMutation({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useDeleteAssignmentFilesMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteAssignmentFilesMutation, TeacherDeleteAssignmentFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteAssignmentFilesMutation, TeacherDeleteAssignmentFilesMutationVariables>(TeacherDeleteAssignmentFilesDocument, options);
      }
export type DeleteAssignmentFilesMutationHookResult = ReturnType<typeof useDeleteAssignmentFilesMutation>;
export type DeleteAssignmentFilesMutationResult = Apollo.MutationResult<TeacherDeleteAssignmentFilesMutation>;
export type DeleteAssignmentFilesMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteAssignmentFilesMutation, TeacherDeleteAssignmentFilesMutationVariables>;
export const TeacherdeleteAssignmentUserDocument = gql`
    mutation deleteAssignmentUser($_eq: uuid = "") {
  delete_assignment_user(where: {assignment_id: {_eq: $_eq}}) {
    affected_rows
  }
}
    `;
export type TeacherDeleteAssignmentUserMutationFn = Apollo.MutationFunction<TeacherDeleteAssignmentUserMutation, TeacherDeleteAssignmentUserMutationVariables>;

/**
 * __useDeleteAssignmentUserMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentUserMutation, { data, loading, error }] = useDeleteAssignmentUserMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useDeleteAssignmentUserMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteAssignmentUserMutation, TeacherDeleteAssignmentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteAssignmentUserMutation, TeacherDeleteAssignmentUserMutationVariables>(TeacherdeleteAssignmentUserDocument, options);
      }
export type DeleteAssignmentUserMutationHookResult = ReturnType<typeof useDeleteAssignmentUserMutation>;
export type DeleteAssignmentUserMutationResult = Apollo.MutationResult<TeacherDeleteAssignmentUserMutation>;
export type DeleteAssignmentUserMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteAssignmentUserMutation, TeacherDeleteAssignmentUserMutationVariables>;
export const TeachergetMarksListDocument = gql`
    query getMarksList {
  marks {
    id
    name
    value
  }
}
    `;

/**
 * __useGetMarksListQuery__
 *
 * To run a query within a React component, call `useGetMarksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarksListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarksListQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetMarksListQuery, TeacherGetMarksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetMarksListQuery, TeacherGetMarksListQueryVariables>(TeachergetMarksListDocument, options);
      }
export function useGetMarksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetMarksListQuery, TeacherGetMarksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetMarksListQuery, TeacherGetMarksListQueryVariables>(TeachergetMarksListDocument, options);
        }
export type GetMarksListQueryHookResult = ReturnType<typeof useGetMarksListQuery>;
export type GetMarksListLazyQueryHookResult = ReturnType<typeof useGetMarksListLazyQuery>;
export type GetMarksListQueryResult = Apollo.QueryResult<TeacherGetMarksListQuery, TeacherGetMarksListQueryVariables>;
export const TeachergetStudentsForAssignmentDocument = gql`
    query getStudentsForAssignment($_eq: uuid = "") {
  assignment_user(where: {assignment_id: {_eq: $_eq}}) {
    user {
      full_name
      id
    }
    mark_id
    id
    comment
    mark {
      name
    }
  }
}
    `;

/**
 * __useGetStudentsForAssignmentQuery__
 *
 * To run a query within a React component, call `useGetStudentsForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsForAssignmentQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetStudentsForAssignmentQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetStudentsForAssignmentQuery, TeacherGetStudentsForAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetStudentsForAssignmentQuery, TeacherGetStudentsForAssignmentQueryVariables>(TeachergetStudentsForAssignmentDocument, options);
      }
export function useGetStudentsForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetStudentsForAssignmentQuery, TeacherGetStudentsForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetStudentsForAssignmentQuery, TeacherGetStudentsForAssignmentQueryVariables>(TeachergetStudentsForAssignmentDocument, options);
        }
export type GetStudentsForAssignmentQueryHookResult = ReturnType<typeof useGetStudentsForAssignmentQuery>;
export type GetStudentsForAssignmentLazyQueryHookResult = ReturnType<typeof useGetStudentsForAssignmentLazyQuery>;
export type GetStudentsForAssignmentQueryResult = Apollo.QueryResult<TeacherGetStudentsForAssignmentQuery, TeacherGetStudentsForAssignmentQueryVariables>;
export const TeachergetSubmitsForAssignmentDocument = gql`
    query getSubmitsForAssignment($_eq: uuid = "") {
  assignment_submits(
    where: {assignment_id: {_eq: $_eq}, is_submited: {_eq: true}}
  ) {
    user_id
    file
    content
    completed_at
    files {
      ...File
    }
  }
}
    ${TeacherFileFragmentDoc}`;

/**
 * __useGetSubmitsForAssignmentQuery__
 *
 * To run a query within a React component, call `useGetSubmitsForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmitsForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmitsForAssignmentQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetSubmitsForAssignmentQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetSubmitsForAssignmentQuery, TeacherGetSubmitsForAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetSubmitsForAssignmentQuery, TeacherGetSubmitsForAssignmentQueryVariables>(TeachergetSubmitsForAssignmentDocument, options);
      }
export function useGetSubmitsForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetSubmitsForAssignmentQuery, TeacherGetSubmitsForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetSubmitsForAssignmentQuery, TeacherGetSubmitsForAssignmentQueryVariables>(TeachergetSubmitsForAssignmentDocument, options);
        }
export type GetSubmitsForAssignmentQueryHookResult = ReturnType<typeof useGetSubmitsForAssignmentQuery>;
export type GetSubmitsForAssignmentLazyQueryHookResult = ReturnType<typeof useGetSubmitsForAssignmentLazyQuery>;
export type GetSubmitsForAssignmentQueryResult = Apollo.QueryResult<TeacherGetSubmitsForAssignmentQuery, TeacherGetSubmitsForAssignmentQueryVariables>;
export const TeacherAssignmentInsertDocument = gql`
    mutation AssignmentInsert($title: String!, $type: assignment_type_enum, $due_at: timestamptz, $duration: Int!) {
  insert_assignments_one(
    object: {title: $title, type: $type, due_at: $due_at, duration: $duration}
  ) {
    ...Assignment
  }
}
    ${TeacherAssignmentFragmentDoc}`;
export type TeacherAssignmentInsertMutationFn = Apollo.MutationFunction<TeacherAssignmentInsertMutation, TeacherAssignmentInsertMutationVariables>;

/**
 * __useAssignmentInsertMutation__
 *
 * To run a mutation, you first call `useAssignmentInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignmentInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignmentInsertMutation, { data, loading, error }] = useAssignmentInsertMutation({
 *   variables: {
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      due_at: // value for 'due_at'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAssignmentInsertMutation(baseOptions?: Apollo.MutationHookOptions<TeacherAssignmentInsertMutation, TeacherAssignmentInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherAssignmentInsertMutation, TeacherAssignmentInsertMutationVariables>(TeacherAssignmentInsertDocument, options);
      }
export type AssignmentInsertMutationHookResult = ReturnType<typeof useAssignmentInsertMutation>;
export type AssignmentInsertMutationResult = Apollo.MutationResult<TeacherAssignmentInsertMutation>;
export type AssignmentInsertMutationOptions = Apollo.BaseMutationOptions<TeacherAssignmentInsertMutation, TeacherAssignmentInsertMutationVariables>;
export const TeacherinsertAssigmentWithTeachingStructureDocument = gql`
    mutation insertAssigmentWithTeachingStructure($is_gradeable: Boolean = false, $title: String = "", $teaching_structure_id: uuid = "", $due_at: timestamptz = "", $description: String = "", $duration: Int = 10, $is_everybody: Boolean = false, $type: assignment_type_enum = HAUSAUFGABE, $chat_id: uuid, $assignment_grade_weight_id: uuid) {
  insert_assignments_one(
    object: {teaching_structure_id: $teaching_structure_id, title: $title, type: $type, is_gradeable: $is_gradeable, duration: $duration, description: $description, due_at: $due_at, is_everybody: $is_everybody, chat_id: $chat_id, assignment_grade_weight_id: $assignment_grade_weight_id}
  ) {
    id
  }
}
    `;
export type TeacherInsertAssigmentWithTeachingStructureMutationFn = Apollo.MutationFunction<TeacherInsertAssigmentWithTeachingStructureMutation, TeacherInsertAssigmentWithTeachingStructureMutationVariables>;

/**
 * __useInsertAssigmentWithTeachingStructureMutation__
 *
 * To run a mutation, you first call `useInsertAssigmentWithTeachingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAssigmentWithTeachingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAssigmentWithTeachingStructureMutation, { data, loading, error }] = useInsertAssigmentWithTeachingStructureMutation({
 *   variables: {
 *      is_gradeable: // value for 'is_gradeable'
 *      title: // value for 'title'
 *      teaching_structure_id: // value for 'teaching_structure_id'
 *      due_at: // value for 'due_at'
 *      description: // value for 'description'
 *      duration: // value for 'duration'
 *      is_everybody: // value for 'is_everybody'
 *      type: // value for 'type'
 *      chat_id: // value for 'chat_id'
 *      assignment_grade_weight_id: // value for 'assignment_grade_weight_id'
 *   },
 * });
 */
export function useInsertAssigmentWithTeachingStructureMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertAssigmentWithTeachingStructureMutation, TeacherInsertAssigmentWithTeachingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertAssigmentWithTeachingStructureMutation, TeacherInsertAssigmentWithTeachingStructureMutationVariables>(TeacherinsertAssigmentWithTeachingStructureDocument, options);
      }
export type InsertAssigmentWithTeachingStructureMutationHookResult = ReturnType<typeof useInsertAssigmentWithTeachingStructureMutation>;
export type InsertAssigmentWithTeachingStructureMutationResult = Apollo.MutationResult<TeacherInsertAssigmentWithTeachingStructureMutation>;
export type InsertAssigmentWithTeachingStructureMutationOptions = Apollo.BaseMutationOptions<TeacherInsertAssigmentWithTeachingStructureMutation, TeacherInsertAssigmentWithTeachingStructureMutationVariables>;
export const TeacherStudentsToAssignmentDocument = gql`
    mutation StudentsToAssignment($objects: [assignment_user_insert_input!] = {}) {
  insert_assignment_user(objects: $objects) {
    affected_rows
  }
}
    `;
export type TeacherStudentsToAssignmentMutationFn = Apollo.MutationFunction<TeacherStudentsToAssignmentMutation, TeacherStudentsToAssignmentMutationVariables>;

/**
 * __useStudentsToAssignmentMutation__
 *
 * To run a mutation, you first call `useStudentsToAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentsToAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentsToAssignmentMutation, { data, loading, error }] = useStudentsToAssignmentMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useStudentsToAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherStudentsToAssignmentMutation, TeacherStudentsToAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherStudentsToAssignmentMutation, TeacherStudentsToAssignmentMutationVariables>(TeacherStudentsToAssignmentDocument, options);
      }
export type StudentsToAssignmentMutationHookResult = ReturnType<typeof useStudentsToAssignmentMutation>;
export type StudentsToAssignmentMutationResult = Apollo.MutationResult<TeacherStudentsToAssignmentMutation>;
export type StudentsToAssignmentMutationOptions = Apollo.BaseMutationOptions<TeacherStudentsToAssignmentMutation, TeacherStudentsToAssignmentMutationVariables>;
export const TeacherinsertAssigmentMarkDocument = gql`
    mutation insertAssigmentMark($_eq: uuid = "", $mark_id: uuid = "", $comment: String = "") {
  update_assignment_user(
    where: {id: {_eq: $_eq}}
    _set: {mark_id: $mark_id, comment: $comment}
  ) {
    affected_rows
  }
}
    `;
export type TeacherInsertAssigmentMarkMutationFn = Apollo.MutationFunction<TeacherInsertAssigmentMarkMutation, TeacherInsertAssigmentMarkMutationVariables>;

/**
 * __useInsertAssigmentMarkMutation__
 *
 * To run a mutation, you first call `useInsertAssigmentMarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAssigmentMarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAssigmentMarkMutation, { data, loading, error }] = useInsertAssigmentMarkMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *      mark_id: // value for 'mark_id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useInsertAssigmentMarkMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertAssigmentMarkMutation, TeacherInsertAssigmentMarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertAssigmentMarkMutation, TeacherInsertAssigmentMarkMutationVariables>(TeacherinsertAssigmentMarkDocument, options);
      }
export type InsertAssigmentMarkMutationHookResult = ReturnType<typeof useInsertAssigmentMarkMutation>;
export type InsertAssigmentMarkMutationResult = Apollo.MutationResult<TeacherInsertAssigmentMarkMutation>;
export type InsertAssigmentMarkMutationOptions = Apollo.BaseMutationOptions<TeacherInsertAssigmentMarkMutation, TeacherInsertAssigmentMarkMutationVariables>;
export const TeacherupdateMarksForStudentDocument = gql`
    mutation updateMarksForStudent($id: uuid_comparison_exp = {}, $mark_id: uuid = "", $comment: String = "") {
  update_assignment_user(
    where: {id: $id}
    _set: {mark_id: $mark_id, comment: $comment}
  ) {
    affected_rows
    returning {
      comment
      id
      mark {
        id
        name
        value
      }
    }
  }
}
    `;
export type TeacherUpdateMarksForStudentMutationFn = Apollo.MutationFunction<TeacherUpdateMarksForStudentMutation, TeacherUpdateMarksForStudentMutationVariables>;

/**
 * __useUpdateMarksForStudentMutation__
 *
 * To run a mutation, you first call `useUpdateMarksForStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarksForStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarksForStudentMutation, { data, loading, error }] = useUpdateMarksForStudentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mark_id: // value for 'mark_id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateMarksForStudentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateMarksForStudentMutation, TeacherUpdateMarksForStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateMarksForStudentMutation, TeacherUpdateMarksForStudentMutationVariables>(TeacherupdateMarksForStudentDocument, options);
      }
export type UpdateMarksForStudentMutationHookResult = ReturnType<typeof useUpdateMarksForStudentMutation>;
export type UpdateMarksForStudentMutationResult = Apollo.MutationResult<TeacherUpdateMarksForStudentMutation>;
export type UpdateMarksForStudentMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateMarksForStudentMutation, TeacherUpdateMarksForStudentMutationVariables>;
export const TeacherAssignmentStudentGradesDocument = gql`
    query AssignmentStudentGrades($assignment_id: uuid!) {
  assigment_student_grade: view_assignment_student_grade(
    where: {assignment_id: {_eq: $assignment_id}}
  ) {
    ...AssignmentStudentGrade
  }
}
    ${TeacherAssignmentStudentGradeFragmentDoc}`;

/**
 * __useAssignmentStudentGradesQuery__
 *
 * To run a query within a React component, call `useAssignmentStudentGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentStudentGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentStudentGradesQuery({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useAssignmentStudentGradesQuery(baseOptions: Apollo.QueryHookOptions<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>(TeacherAssignmentStudentGradesDocument, options);
      }
export function useAssignmentStudentGradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>(TeacherAssignmentStudentGradesDocument, options);
        }
export type AssignmentStudentGradesQueryHookResult = ReturnType<typeof useAssignmentStudentGradesQuery>;
export type AssignmentStudentGradesLazyQueryHookResult = ReturnType<typeof useAssignmentStudentGradesLazyQuery>;
export type AssignmentStudentGradesQueryResult = Apollo.QueryResult<TeacherAssignmentStudentGradesQuery, TeacherAssignmentStudentGradesQueryVariables>;
export const TeacherUpdateAssignmentDocument = gql`
    mutation UpdateAssignment($_set: assignments_set_input!, $id: uuid!) {
  update_assignments_by_pk(_set: $_set, pk_columns: {id: $id}) {
    id
  }
}
    `;
export type TeacherUpdateAssignmentMutationFn = Apollo.MutationFunction<TeacherUpdateAssignmentMutation, TeacherUpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateAssignmentMutation, TeacherUpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateAssignmentMutation, TeacherUpdateAssignmentMutationVariables>(TeacherUpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<TeacherUpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateAssignmentMutation, TeacherUpdateAssignmentMutationVariables>;
export const TeacherCreateAttendanceDocument = gql`
    mutation CreateAttendance($attendances: [attendances_insert_input!]!) {
  insert_attendances(objects: $attendances) {
    returning {
      id
    }
  }
}
    `;
export type TeacherCreateAttendanceMutationFn = Apollo.MutationFunction<TeacherCreateAttendanceMutation, TeacherCreateAttendanceMutationVariables>;

/**
 * __useCreateAttendanceMutation__
 *
 * To run a mutation, you first call `useCreateAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttendanceMutation, { data, loading, error }] = useCreateAttendanceMutation({
 *   variables: {
 *      attendances: // value for 'attendances'
 *   },
 * });
 */
export function useCreateAttendanceMutation(baseOptions?: Apollo.MutationHookOptions<TeacherCreateAttendanceMutation, TeacherCreateAttendanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherCreateAttendanceMutation, TeacherCreateAttendanceMutationVariables>(TeacherCreateAttendanceDocument, options);
      }
export type CreateAttendanceMutationHookResult = ReturnType<typeof useCreateAttendanceMutation>;
export type CreateAttendanceMutationResult = Apollo.MutationResult<TeacherCreateAttendanceMutation>;
export type CreateAttendanceMutationOptions = Apollo.BaseMutationOptions<TeacherCreateAttendanceMutation, TeacherCreateAttendanceMutationVariables>;
export const TeacherDeleteAttendancesDocument = gql`
    mutation DeleteAttendances($where: attendances_bool_exp!) {
  delete_attendances(where: $where) {
    affected_rows
  }
}
    `;
export type TeacherDeleteAttendancesMutationFn = Apollo.MutationFunction<TeacherDeleteAttendancesMutation, TeacherDeleteAttendancesMutationVariables>;

/**
 * __useDeleteAttendancesMutation__
 *
 * To run a mutation, you first call `useDeleteAttendancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendancesMutation, { data, loading, error }] = useDeleteAttendancesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteAttendancesMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteAttendancesMutation, TeacherDeleteAttendancesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteAttendancesMutation, TeacherDeleteAttendancesMutationVariables>(TeacherDeleteAttendancesDocument, options);
      }
export type DeleteAttendancesMutationHookResult = ReturnType<typeof useDeleteAttendancesMutation>;
export type DeleteAttendancesMutationResult = Apollo.MutationResult<TeacherDeleteAttendancesMutation>;
export type DeleteAttendancesMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteAttendancesMutation, TeacherDeleteAttendancesMutationVariables>;
export const TeachergetAttendanceTypesDocument = gql`
    query getAttendanceTypes {
  attendance_types {
    value
    text
    icon
  }
}
    `;

/**
 * __useGetAttendanceTypesQuery__
 *
 * To run a query within a React component, call `useGetAttendanceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendanceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendanceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAttendanceTypesQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetAttendanceTypesQuery, TeacherGetAttendanceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetAttendanceTypesQuery, TeacherGetAttendanceTypesQueryVariables>(TeachergetAttendanceTypesDocument, options);
      }
export function useGetAttendanceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetAttendanceTypesQuery, TeacherGetAttendanceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetAttendanceTypesQuery, TeacherGetAttendanceTypesQueryVariables>(TeachergetAttendanceTypesDocument, options);
        }
export type GetAttendanceTypesQueryHookResult = ReturnType<typeof useGetAttendanceTypesQuery>;
export type GetAttendanceTypesLazyQueryHookResult = ReturnType<typeof useGetAttendanceTypesLazyQuery>;
export type GetAttendanceTypesQueryResult = Apollo.QueryResult<TeacherGetAttendanceTypesQuery, TeacherGetAttendanceTypesQueryVariables>;
export const TeachergetAttendancesDocument = gql`
    query getAttendances($where: attendances_bool_exp) {
  attendances(where: $where) {
    attendance_type
    comment
    date
    id
    student_id
    subject_id
    student {
      id
      full_name
    }
    teacher_id
    type {
      value
      text
      icon
    }
  }
}
    `;

/**
 * __useGetAttendancesQuery__
 *
 * To run a query within a React component, call `useGetAttendancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttendancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttendancesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAttendancesQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetAttendancesQuery, TeacherGetAttendancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetAttendancesQuery, TeacherGetAttendancesQueryVariables>(TeachergetAttendancesDocument, options);
      }
export function useGetAttendancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetAttendancesQuery, TeacherGetAttendancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetAttendancesQuery, TeacherGetAttendancesQueryVariables>(TeachergetAttendancesDocument, options);
        }
export type GetAttendancesQueryHookResult = ReturnType<typeof useGetAttendancesQuery>;
export type GetAttendancesLazyQueryHookResult = ReturnType<typeof useGetAttendancesLazyQuery>;
export type GetAttendancesQueryResult = Apollo.QueryResult<TeacherGetAttendancesQuery, TeacherGetAttendancesQueryVariables>;
export const TeacherChatByTypePrivateDocument = gql`
    query ChatByTypePrivate($user_id: uuid!) {
  chat_user(where: {user_id: {_eq: $user_id}, chat: {type: {_eq: PRIVATE}}}) {
    chat_id
  }
}
    `;

/**
 * __useChatByTypePrivateQuery__
 *
 * To run a query within a React component, call `useChatByTypePrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatByTypePrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatByTypePrivateQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useChatByTypePrivateQuery(baseOptions: Apollo.QueryHookOptions<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>(TeacherChatByTypePrivateDocument, options);
      }
export function useChatByTypePrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>(TeacherChatByTypePrivateDocument, options);
        }
export type ChatByTypePrivateQueryHookResult = ReturnType<typeof useChatByTypePrivateQuery>;
export type ChatByTypePrivateLazyQueryHookResult = ReturnType<typeof useChatByTypePrivateLazyQuery>;
export type ChatByTypePrivateQueryResult = Apollo.QueryResult<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>;
export const TeacherChatDeleteDocument = gql`
    mutation ChatDelete($id: uuid!) {
  delete_chats_by_pk(id: $id) {
    id
  }
}
    `;
export type TeacherChatDeleteMutationFn = Apollo.MutationFunction<TeacherChatDeleteMutation, TeacherChatDeleteMutationVariables>;

/**
 * __useChatDeleteMutation__
 *
 * To run a mutation, you first call `useChatDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatDeleteMutation, { data, loading, error }] = useChatDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TeacherChatDeleteMutation, TeacherChatDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherChatDeleteMutation, TeacherChatDeleteMutationVariables>(TeacherChatDeleteDocument, options);
      }
export type ChatDeleteMutationHookResult = ReturnType<typeof useChatDeleteMutation>;
export type ChatDeleteMutationResult = Apollo.MutationResult<TeacherChatDeleteMutation>;
export type ChatDeleteMutationOptions = Apollo.BaseMutationOptions<TeacherChatDeleteMutation, TeacherChatDeleteMutationVariables>;
export const TeacherChatInsertPrivateUserDocument = gql`
    mutation ChatInsertPrivateUser($user_id: uuid!) {
  insert_chat_user_one(object: {user_id: $user_id, chat: {data: {type: PRIVATE}}}) {
    id: chat_id
  }
}
    `;
export type TeacherChatInsertPrivateUserMutationFn = Apollo.MutationFunction<TeacherChatInsertPrivateUserMutation, TeacherChatInsertPrivateUserMutationVariables>;

/**
 * __useChatInsertPrivateUserMutation__
 *
 * To run a mutation, you first call `useChatInsertPrivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatInsertPrivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatInsertPrivateUserMutation, { data, loading, error }] = useChatInsertPrivateUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useChatInsertPrivateUserMutation(baseOptions?: Apollo.MutationHookOptions<TeacherChatInsertPrivateUserMutation, TeacherChatInsertPrivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherChatInsertPrivateUserMutation, TeacherChatInsertPrivateUserMutationVariables>(TeacherChatInsertPrivateUserDocument, options);
      }
export type ChatInsertPrivateUserMutationHookResult = ReturnType<typeof useChatInsertPrivateUserMutation>;
export type ChatInsertPrivateUserMutationResult = Apollo.MutationResult<TeacherChatInsertPrivateUserMutation>;
export type ChatInsertPrivateUserMutationOptions = Apollo.BaseMutationOptions<TeacherChatInsertPrivateUserMutation, TeacherChatInsertPrivateUserMutationVariables>;
export const TeacherChatUpdateDocument = gql`
    mutation ChatUpdate($id: uuid!, $title: String!, $avatar_url: String!) {
  update_chats_by_pk(
    pk_columns: {id: $id}
    _set: {avatar_url: $avatar_url, title: $title}
  ) {
    id
  }
}
    `;
export type TeacherChatUpdateMutationFn = Apollo.MutationFunction<TeacherChatUpdateMutation, TeacherChatUpdateMutationVariables>;

/**
 * __useChatUpdateMutation__
 *
 * To run a mutation, you first call `useChatUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatUpdateMutation, { data, loading, error }] = useChatUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      avatar_url: // value for 'avatar_url'
 *   },
 * });
 */
export function useChatUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TeacherChatUpdateMutation, TeacherChatUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherChatUpdateMutation, TeacherChatUpdateMutationVariables>(TeacherChatUpdateDocument, options);
      }
export type ChatUpdateMutationHookResult = ReturnType<typeof useChatUpdateMutation>;
export type ChatUpdateMutationResult = Apollo.MutationResult<TeacherChatUpdateMutation>;
export type ChatUpdateMutationOptions = Apollo.BaseMutationOptions<TeacherChatUpdateMutation, TeacherChatUpdateMutationVariables>;
export const TeacherClassesDocument = gql`
    query Classes {
  classes {
    ...Class
  }
}
    ${TeacherClassFragmentDoc}`;

/**
 * __useClassesQuery__
 *
 * To run a query within a React component, call `useClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassesQuery(baseOptions?: Apollo.QueryHookOptions<TeacherClassesQuery, TeacherClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherClassesQuery, TeacherClassesQueryVariables>(TeacherClassesDocument, options);
      }
export function useClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherClassesQuery, TeacherClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherClassesQuery, TeacherClassesQueryVariables>(TeacherClassesDocument, options);
        }
export type ClassesQueryHookResult = ReturnType<typeof useClassesQuery>;
export type ClassesLazyQueryHookResult = ReturnType<typeof useClassesLazyQuery>;
export type ClassesQueryResult = Apollo.QueryResult<TeacherClassesQuery, TeacherClassesQueryVariables>;
export const TeacherClassStudentsDocument = gql`
    query ClassStudents($class_id: uuid!) {
  student_class(where: {class_id: {_eq: $class_id}}) {
    user {
      full_name
      id
    }
  }
}
    `;

/**
 * __useClassStudentsQuery__
 *
 * To run a query within a React component, call `useClassStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassStudentsQuery({
 *   variables: {
 *      class_id: // value for 'class_id'
 *   },
 * });
 */
export function useClassStudentsQuery(baseOptions: Apollo.QueryHookOptions<TeacherClassStudentsQuery, TeacherClassStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherClassStudentsQuery, TeacherClassStudentsQueryVariables>(TeacherClassStudentsDocument, options);
      }
export function useClassStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherClassStudentsQuery, TeacherClassStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherClassStudentsQuery, TeacherClassStudentsQueryVariables>(TeacherClassStudentsDocument, options);
        }
export type ClassStudentsQueryHookResult = ReturnType<typeof useClassStudentsQuery>;
export type ClassStudentsLazyQueryHookResult = ReturnType<typeof useClassStudentsLazyQuery>;
export type ClassStudentsQueryResult = Apollo.QueryResult<TeacherClassStudentsQuery, TeacherClassStudentsQueryVariables>;
export const TeacherClassSubjectDocument = gql`
    query ClassSubject {
  subjects: view_teacher_class_subject {
    ...ClassSubject
  }
}
    ${TeacherClassSubjectFragmentDoc}`;

/**
 * __useClassSubjectQuery__
 *
 * To run a query within a React component, call `useClassSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassSubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassSubjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassSubjectQuery(baseOptions?: Apollo.QueryHookOptions<TeacherClassSubjectQuery, TeacherClassSubjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherClassSubjectQuery, TeacherClassSubjectQueryVariables>(TeacherClassSubjectDocument, options);
      }
export function useClassSubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherClassSubjectQuery, TeacherClassSubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherClassSubjectQuery, TeacherClassSubjectQueryVariables>(TeacherClassSubjectDocument, options);
        }
export type ClassSubjectQueryHookResult = ReturnType<typeof useClassSubjectQuery>;
export type ClassSubjectLazyQueryHookResult = ReturnType<typeof useClassSubjectLazyQuery>;
export type ClassSubjectQueryResult = Apollo.QueryResult<TeacherClassSubjectQuery, TeacherClassSubjectQueryVariables>;
export const TeachergetTeachingStructureTreeDocument = gql`
    query getTeachingStructureTree {
  teaching_structures {
    id
    created_at
    updated_at
    depth
    semester {
      id
      start_at
      end_at
    }
    title
    teaching_structure_type {
      id
      title
    }
    rtl
    ltr
    teacher_subjects {
      id
      teacher_id
      created_at
      teaching_structure_id
    }
    assignments {
      id
      title
    }
    teaching_structures {
      id
    }
  }
}
    `;

/**
 * __useGetTeachingStructureTreeQuery__
 *
 * To run a query within a React component, call `useGetTeachingStructureTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeachingStructureTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeachingStructureTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeachingStructureTreeQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetTeachingStructureTreeQuery, TeacherGetTeachingStructureTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetTeachingStructureTreeQuery, TeacherGetTeachingStructureTreeQueryVariables>(TeachergetTeachingStructureTreeDocument, options);
      }
export function useGetTeachingStructureTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetTeachingStructureTreeQuery, TeacherGetTeachingStructureTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetTeachingStructureTreeQuery, TeacherGetTeachingStructureTreeQueryVariables>(TeachergetTeachingStructureTreeDocument, options);
        }
export type GetTeachingStructureTreeQueryHookResult = ReturnType<typeof useGetTeachingStructureTreeQuery>;
export type GetTeachingStructureTreeLazyQueryHookResult = ReturnType<typeof useGetTeachingStructureTreeLazyQuery>;
export type GetTeachingStructureTreeQueryResult = Apollo.QueryResult<TeacherGetTeachingStructureTreeQuery, TeacherGetTeachingStructureTreeQueryVariables>;
export const TeacherGetMyTeacherEventsDocument = gql`
    query GetMyTeacherEvents {
  events {
    created_at
    date
    description
    id
    title
  }
}
    `;

/**
 * __useGetMyTeacherEventsQuery__
 *
 * To run a query within a React component, call `useGetMyTeacherEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeacherEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeacherEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeacherEventsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetMyTeacherEventsQuery, TeacherGetMyTeacherEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetMyTeacherEventsQuery, TeacherGetMyTeacherEventsQueryVariables>(TeacherGetMyTeacherEventsDocument, options);
      }
export function useGetMyTeacherEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetMyTeacherEventsQuery, TeacherGetMyTeacherEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetMyTeacherEventsQuery, TeacherGetMyTeacherEventsQueryVariables>(TeacherGetMyTeacherEventsDocument, options);
        }
export type GetMyTeacherEventsQueryHookResult = ReturnType<typeof useGetMyTeacherEventsQuery>;
export type GetMyTeacherEventsLazyQueryHookResult = ReturnType<typeof useGetMyTeacherEventsLazyQuery>;
export type GetMyTeacherEventsQueryResult = Apollo.QueryResult<TeacherGetMyTeacherEventsQuery, TeacherGetMyTeacherEventsQueryVariables>;
export const TeacherGradesByAssignmentDocument = gql`
    query GradesByAssignment($assignment_id: uuid!) {
  grades(where: {assignment_id: {_eq: $assignment_id}}, order_by: {id: desc}) {
    ...AssignmentGrade
  }
}
    ${TeacherAssignmentGradeFragmentDoc}`;

/**
 * __useGradesByAssignmentQuery__
 *
 * To run a query within a React component, call `useGradesByAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradesByAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradesByAssignmentQuery({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useGradesByAssignmentQuery(baseOptions: Apollo.QueryHookOptions<TeacherGradesByAssignmentQuery, TeacherGradesByAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGradesByAssignmentQuery, TeacherGradesByAssignmentQueryVariables>(TeacherGradesByAssignmentDocument, options);
      }
export function useGradesByAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGradesByAssignmentQuery, TeacherGradesByAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGradesByAssignmentQuery, TeacherGradesByAssignmentQueryVariables>(TeacherGradesByAssignmentDocument, options);
        }
export type GradesByAssignmentQueryHookResult = ReturnType<typeof useGradesByAssignmentQuery>;
export type GradesByAssignmentLazyQueryHookResult = ReturnType<typeof useGradesByAssignmentLazyQuery>;
export type GradesByAssignmentQueryResult = Apollo.QueryResult<TeacherGradesByAssignmentQuery, TeacherGradesByAssignmentQueryVariables>;
export const TeacherStudentGradesBySemesterDocument = gql`
    query StudentGradesBySemester($semester_id: uuid!, $student_id: uuid!) {
  subjects {
    ...StudentGradesSemester
  }
}
    ${TeacherStudentGradesSemesterFragmentDoc}`;

/**
 * __useStudentGradesBySemesterQuery__
 *
 * To run a query within a React component, call `useStudentGradesBySemesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentGradesBySemesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentGradesBySemesterQuery({
 *   variables: {
 *      semester_id: // value for 'semester_id'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useStudentGradesBySemesterQuery(baseOptions: Apollo.QueryHookOptions<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>(TeacherStudentGradesBySemesterDocument, options);
      }
export function useStudentGradesBySemesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>(TeacherStudentGradesBySemesterDocument, options);
        }
export type StudentGradesBySemesterQueryHookResult = ReturnType<typeof useStudentGradesBySemesterQuery>;
export type StudentGradesBySemesterLazyQueryHookResult = ReturnType<typeof useStudentGradesBySemesterLazyQuery>;
export type StudentGradesBySemesterQueryResult = Apollo.QueryResult<TeacherStudentGradesBySemesterQuery, TeacherStudentGradesBySemesterQueryVariables>;
export const TeacherGetGradeForStudentByAssigmentDocument = gql`
    query GetGradeForStudentByAssigment($student_id: uuid = "", $assignment_id: uuid = "") {
  assignments(where: {id: {_eq: $assignment_id}}, limit: 1) {
    title
    assignment_submits(where: {user_id: {_eq: $student_id}}) {
      id
      file
      content
      completed_at
      files {
        ...File
      }
    }
    assignment_users(where: {user_id: {_eq: $student_id}}) {
      comment
      mark_id
      id
      mark {
        id
        name
      }
    }
  }
}
    ${TeacherFileFragmentDoc}`;

/**
 * __useGetGradeForStudentByAssigmentQuery__
 *
 * To run a query within a React component, call `useGetGradeForStudentByAssigmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradeForStudentByAssigmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradeForStudentByAssigmentQuery({
 *   variables: {
 *      student_id: // value for 'student_id'
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useGetGradeForStudentByAssigmentQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetGradeForStudentByAssigmentQuery, TeacherGetGradeForStudentByAssigmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetGradeForStudentByAssigmentQuery, TeacherGetGradeForStudentByAssigmentQueryVariables>(TeacherGetGradeForStudentByAssigmentDocument, options);
      }
export function useGetGradeForStudentByAssigmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetGradeForStudentByAssigmentQuery, TeacherGetGradeForStudentByAssigmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetGradeForStudentByAssigmentQuery, TeacherGetGradeForStudentByAssigmentQueryVariables>(TeacherGetGradeForStudentByAssigmentDocument, options);
        }
export type GetGradeForStudentByAssigmentQueryHookResult = ReturnType<typeof useGetGradeForStudentByAssigmentQuery>;
export type GetGradeForStudentByAssigmentLazyQueryHookResult = ReturnType<typeof useGetGradeForStudentByAssigmentLazyQuery>;
export type GetGradeForStudentByAssigmentQueryResult = Apollo.QueryResult<TeacherGetGradeForStudentByAssigmentQuery, TeacherGetGradeForStudentByAssigmentQueryVariables>;
export const TeacherGetGradeDetailsDocument = gql`
    query GetGradeDetails($assignment_id: uuid = "", $student_id: uuid = "") {
  assignments(where: {id: {_eq: $assignment_id}}, limit: 1) {
    title
    created_at
    assignment_files {
      id
      title
      path
    }
    assignment_type {
      name
    }
    user {
      full_name
    }
    assignment_users(where: {user_id: {_eq: $student_id}}) {
      id
      comment
      mark {
        id
      }
    }
  }
}
    `;

/**
 * __useGetGradeDetailsQuery__
 *
 * To run a query within a React component, call `useGetGradeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradeDetailsQuery({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *      student_id: // value for 'student_id'
 *   },
 * });
 */
export function useGetGradeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetGradeDetailsQuery, TeacherGetGradeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetGradeDetailsQuery, TeacherGetGradeDetailsQueryVariables>(TeacherGetGradeDetailsDocument, options);
      }
export function useGetGradeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetGradeDetailsQuery, TeacherGetGradeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetGradeDetailsQuery, TeacherGetGradeDetailsQueryVariables>(TeacherGetGradeDetailsDocument, options);
        }
export type GetGradeDetailsQueryHookResult = ReturnType<typeof useGetGradeDetailsQuery>;
export type GetGradeDetailsLazyQueryHookResult = ReturnType<typeof useGetGradeDetailsLazyQuery>;
export type GetGradeDetailsQueryResult = Apollo.QueryResult<TeacherGetGradeDetailsQuery, TeacherGetGradeDetailsQueryVariables>;
export const TeacherGetGradeDataDocument = gql`
    query GetGradeData($subject: [uuid!] = "", $class_id: uuid = "") {
  view_grades_by_subjects_and_classes(
    where: {subject: {_in: $subject}, class_id: {_eq: $class_id}}
  ) {
    assigment_date
    class_id
    mark {
      name
      value
      id
    }
    student {
      user {
        full_name
      }
      id
    }
    assignment {
      ...Assignment
    }
    subject
  }
}
    ${TeacherAssignmentFragmentDoc}`;

/**
 * __useGetGradeDataQuery__
 *
 * To run a query within a React component, call `useGetGradeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradeDataQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      class_id: // value for 'class_id'
 *   },
 * });
 */
export function useGetGradeDataQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetGradeDataQuery, TeacherGetGradeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetGradeDataQuery, TeacherGetGradeDataQueryVariables>(TeacherGetGradeDataDocument, options);
      }
export function useGetGradeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetGradeDataQuery, TeacherGetGradeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetGradeDataQuery, TeacherGetGradeDataQueryVariables>(TeacherGetGradeDataDocument, options);
        }
export type GetGradeDataQueryHookResult = ReturnType<typeof useGetGradeDataQuery>;
export type GetGradeDataLazyQueryHookResult = ReturnType<typeof useGetGradeDataLazyQuery>;
export type GetGradeDataQueryResult = Apollo.QueryResult<TeacherGetGradeDataQuery, TeacherGetGradeDataQueryVariables>;
export const TeacherGradeInsertDocument = gql`
    mutation GradeInsert($grades: [grades_insert_input!]!) {
  insert_grades(objects: $grades) {
    returning {
      id
    }
  }
}
    `;
export type TeacherGradeInsertMutationFn = Apollo.MutationFunction<TeacherGradeInsertMutation, TeacherGradeInsertMutationVariables>;

/**
 * __useGradeInsertMutation__
 *
 * To run a mutation, you first call `useGradeInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeInsertMutation, { data, loading, error }] = useGradeInsertMutation({
 *   variables: {
 *      grades: // value for 'grades'
 *   },
 * });
 */
export function useGradeInsertMutation(baseOptions?: Apollo.MutationHookOptions<TeacherGradeInsertMutation, TeacherGradeInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherGradeInsertMutation, TeacherGradeInsertMutationVariables>(TeacherGradeInsertDocument, options);
      }
export type GradeInsertMutationHookResult = ReturnType<typeof useGradeInsertMutation>;
export type GradeInsertMutationResult = Apollo.MutationResult<TeacherGradeInsertMutation>;
export type GradeInsertMutationOptions = Apollo.BaseMutationOptions<TeacherGradeInsertMutation, TeacherGradeInsertMutationVariables>;
export const TeacherGradeUpdateMarkDocument = gql`
    mutation GradeUpdateMark($id: uuid!, $mark_id: uuid!, $comment: String = "") {
  update_grades_by_pk(
    _set: {mark_id: $mark_id, comment: $comment}
    pk_columns: {id: $id}
  ) {
    id
  }
}
    `;
export type TeacherGradeUpdateMarkMutationFn = Apollo.MutationFunction<TeacherGradeUpdateMarkMutation, TeacherGradeUpdateMarkMutationVariables>;

/**
 * __useGradeUpdateMarkMutation__
 *
 * To run a mutation, you first call `useGradeUpdateMarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeUpdateMarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeUpdateMarkMutation, { data, loading, error }] = useGradeUpdateMarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mark_id: // value for 'mark_id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useGradeUpdateMarkMutation(baseOptions?: Apollo.MutationHookOptions<TeacherGradeUpdateMarkMutation, TeacherGradeUpdateMarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherGradeUpdateMarkMutation, TeacherGradeUpdateMarkMutationVariables>(TeacherGradeUpdateMarkDocument, options);
      }
export type GradeUpdateMarkMutationHookResult = ReturnType<typeof useGradeUpdateMarkMutation>;
export type GradeUpdateMarkMutationResult = Apollo.MutationResult<TeacherGradeUpdateMarkMutation>;
export type GradeUpdateMarkMutationOptions = Apollo.BaseMutationOptions<TeacherGradeUpdateMarkMutation, TeacherGradeUpdateMarkMutationVariables>;
export const TeacherInviteParentDocument = gql`
    mutation InviteParent($email: String!, $user_data: UserInsertInput!, $school_options: InviteParentInput = {}, $password: String) {
  invite_parent(
    email: $email
    user_data: $user_data
    school_options: $school_options
    password: $password
  ) {
    jwt_expires_in
    jwt_token
    refresh_token
  }
}
    `;
export type TeacherInviteParentMutationFn = Apollo.MutationFunction<TeacherInviteParentMutation, TeacherInviteParentMutationVariables>;

/**
 * __useInviteParentMutation__
 *
 * To run a mutation, you first call `useInviteParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteParentMutation, { data, loading, error }] = useInviteParentMutation({
 *   variables: {
 *      email: // value for 'email'
 *      user_data: // value for 'user_data'
 *      school_options: // value for 'school_options'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useInviteParentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInviteParentMutation, TeacherInviteParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInviteParentMutation, TeacherInviteParentMutationVariables>(TeacherInviteParentDocument, options);
      }
export type InviteParentMutationHookResult = ReturnType<typeof useInviteParentMutation>;
export type InviteParentMutationResult = Apollo.MutationResult<TeacherInviteParentMutation>;
export type InviteParentMutationOptions = Apollo.BaseMutationOptions<TeacherInviteParentMutation, TeacherInviteParentMutationVariables>;
export const TeacherInviteStudentDocument = gql`
    mutation InviteStudent($email: String!, $password: String, $school_options: InviteStudentClassInsertInput!, $user_data: UserInsertInput!) {
  invite_student(
    email: $email
    user_data: $user_data
    school_options: $school_options
    password: $password
  ) {
    jwt_token
    jwt_expires_in
    refresh_token
  }
}
    `;
export type TeacherInviteStudentMutationFn = Apollo.MutationFunction<TeacherInviteStudentMutation, TeacherInviteStudentMutationVariables>;

/**
 * __useInviteStudentMutation__
 *
 * To run a mutation, you first call `useInviteStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteStudentMutation, { data, loading, error }] = useInviteStudentMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      school_options: // value for 'school_options'
 *      user_data: // value for 'user_data'
 *   },
 * });
 */
export function useInviteStudentMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInviteStudentMutation, TeacherInviteStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInviteStudentMutation, TeacherInviteStudentMutationVariables>(TeacherInviteStudentDocument, options);
      }
export type InviteStudentMutationHookResult = ReturnType<typeof useInviteStudentMutation>;
export type InviteStudentMutationResult = Apollo.MutationResult<TeacherInviteStudentMutation>;
export type InviteStudentMutationOptions = Apollo.BaseMutationOptions<TeacherInviteStudentMutation, TeacherInviteStudentMutationVariables>;
export const TeacherInviteTeacherDocument = gql`
    mutation InviteTeacher($password: String, $email: String!, $school_options: TeacherSkillInsertInput!, $user_data: UserInsertInput!) {
  invite_teacher(
    email: $email
    school_options: $school_options
    user_data: $user_data
    password: $password
  ) {
    jwt_expires_in
    jwt_token
    refresh_token
  }
}
    `;
export type TeacherInviteTeacherMutationFn = Apollo.MutationFunction<TeacherInviteTeacherMutation, TeacherInviteTeacherMutationVariables>;

/**
 * __useInviteTeacherMutation__
 *
 * To run a mutation, you first call `useInviteTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTeacherMutation, { data, loading, error }] = useInviteTeacherMutation({
 *   variables: {
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      school_options: // value for 'school_options'
 *      user_data: // value for 'user_data'
 *   },
 * });
 */
export function useInviteTeacherMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInviteTeacherMutation, TeacherInviteTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInviteTeacherMutation, TeacherInviteTeacherMutationVariables>(TeacherInviteTeacherDocument, options);
      }
export type InviteTeacherMutationHookResult = ReturnType<typeof useInviteTeacherMutation>;
export type InviteTeacherMutationResult = Apollo.MutationResult<TeacherInviteTeacherMutation>;
export type InviteTeacherMutationOptions = Apollo.BaseMutationOptions<TeacherInviteTeacherMutation, TeacherInviteTeacherMutationVariables>;
export const TeachergetMarksDocument = gql`
    query getMarks {
  marks {
    id
    name
  }
}
    `;

/**
 * __useGetMarksQuery__
 *
 * To run a query within a React component, call `useGetMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarksQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetMarksQuery, TeacherGetMarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetMarksQuery, TeacherGetMarksQueryVariables>(TeachergetMarksDocument, options);
      }
export function useGetMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetMarksQuery, TeacherGetMarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetMarksQuery, TeacherGetMarksQueryVariables>(TeachergetMarksDocument, options);
        }
export type GetMarksQueryHookResult = ReturnType<typeof useGetMarksQuery>;
export type GetMarksLazyQueryHookResult = ReturnType<typeof useGetMarksLazyQuery>;
export type GetMarksQueryResult = Apollo.QueryResult<TeacherGetMarksQuery, TeacherGetMarksQueryVariables>;
export const TeacherMeetingCreateDocument = gql`
    mutation MeetingCreate($name: String, $lesson_id: String, $teacher_name: String, $duration: Int, $description: String, $starting_at: String) {
  create_live_class(
    name: $name
    lesson_id: $lesson_id
    teacher_name: $teacher_name
    duration: $duration
    description: $description
    starting_at: $starting_at
  ) {
    url
    id
  }
}
    `;
export type TeacherMeetingCreateMutationFn = Apollo.MutationFunction<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>;

/**
 * __useMeetingCreateMutation__
 *
 * To run a mutation, you first call `useMeetingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeetingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meetingCreateMutation, { data, loading, error }] = useMeetingCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      lesson_id: // value for 'lesson_id'
 *      teacher_name: // value for 'teacher_name'
 *      duration: // value for 'duration'
 *      description: // value for 'description'
 *      starting_at: // value for 'starting_at'
 *   },
 * });
 */
export function useMeetingCreateMutation(baseOptions?: Apollo.MutationHookOptions<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>(TeacherMeetingCreateDocument, options);
      }
export type MeetingCreateMutationHookResult = ReturnType<typeof useMeetingCreateMutation>;
export type MeetingCreateMutationResult = Apollo.MutationResult<TeacherMeetingCreateMutation>;
export type MeetingCreateMutationOptions = Apollo.BaseMutationOptions<TeacherMeetingCreateMutation, TeacherMeetingCreateMutationVariables>;
export const TeacherMeetingDeleteDocument = gql`
    mutation MeetingDelete($lesson_id: uuid) {
  delete_live_class(lesson_id: $lesson_id) {
    data
  }
}
    `;
export type TeacherMeetingDeleteMutationFn = Apollo.MutationFunction<TeacherMeetingDeleteMutation, TeacherMeetingDeleteMutationVariables>;

/**
 * __useMeetingDeleteMutation__
 *
 * To run a mutation, you first call `useMeetingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeetingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meetingDeleteMutation, { data, loading, error }] = useMeetingDeleteMutation({
 *   variables: {
 *      lesson_id: // value for 'lesson_id'
 *   },
 * });
 */
export function useMeetingDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TeacherMeetingDeleteMutation, TeacherMeetingDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherMeetingDeleteMutation, TeacherMeetingDeleteMutationVariables>(TeacherMeetingDeleteDocument, options);
      }
export type MeetingDeleteMutationHookResult = ReturnType<typeof useMeetingDeleteMutation>;
export type MeetingDeleteMutationResult = Apollo.MutationResult<TeacherMeetingDeleteMutation>;
export type MeetingDeleteMutationOptions = Apollo.BaseMutationOptions<TeacherMeetingDeleteMutation, TeacherMeetingDeleteMutationVariables>;
export const TeacherDeleteLiveClassByPkDocument = gql`
    mutation DeleteLiveClassByPk($id: uuid!) {
  delete_live_classes_by_pk(id: $id) {
    id
  }
}
    `;
export type TeacherDeleteLiveClassByPkMutationFn = Apollo.MutationFunction<TeacherDeleteLiveClassByPkMutation, TeacherDeleteLiveClassByPkMutationVariables>;

/**
 * __useDeleteLiveClassByPkMutation__
 *
 * To run a mutation, you first call `useDeleteLiveClassByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLiveClassByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLiveClassByPkMutation, { data, loading, error }] = useDeleteLiveClassByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLiveClassByPkMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteLiveClassByPkMutation, TeacherDeleteLiveClassByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteLiveClassByPkMutation, TeacherDeleteLiveClassByPkMutationVariables>(TeacherDeleteLiveClassByPkDocument, options);
      }
export type DeleteLiveClassByPkMutationHookResult = ReturnType<typeof useDeleteLiveClassByPkMutation>;
export type DeleteLiveClassByPkMutationResult = Apollo.MutationResult<TeacherDeleteLiveClassByPkMutation>;
export type DeleteLiveClassByPkMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteLiveClassByPkMutation, TeacherDeleteLiveClassByPkMutationVariables>;
export const TeacherGetMyLiveClassesDocument = gql`
    query GetMyLiveClasses($_in: [uuid!] = "") {
  live_classes(where: {lesson_id: {_in: $_in}}, order_by: {starting_at: desc}) {
    id
    name
    duration
    description
    starting_at
    status
  }
}
    `;

/**
 * __useGetMyLiveClassesQuery__
 *
 * To run a query within a React component, call `useGetMyLiveClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLiveClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLiveClassesQuery({
 *   variables: {
 *      _in: // value for '_in'
 *   },
 * });
 */
export function useGetMyLiveClassesQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetMyLiveClassesQuery, TeacherGetMyLiveClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetMyLiveClassesQuery, TeacherGetMyLiveClassesQueryVariables>(TeacherGetMyLiveClassesDocument, options);
      }
export function useGetMyLiveClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetMyLiveClassesQuery, TeacherGetMyLiveClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetMyLiveClassesQuery, TeacherGetMyLiveClassesQueryVariables>(TeacherGetMyLiveClassesDocument, options);
        }
export type GetMyLiveClassesQueryHookResult = ReturnType<typeof useGetMyLiveClassesQuery>;
export type GetMyLiveClassesLazyQueryHookResult = ReturnType<typeof useGetMyLiveClassesLazyQuery>;
export type GetMyLiveClassesQueryResult = Apollo.QueryResult<TeacherGetMyLiveClassesQuery, TeacherGetMyLiveClassesQueryVariables>;
export const TeachergetStudentsByLiveClassIdDocument = gql`
    query getStudentsByLiveClassId($liveClassId: uuid = "") {
  live_class_attendees(where: {live_class_id: {_eq: $liveClassId}}) {
    id
    is_present
    students {
      id
      user {
        full_name
      }
    }
  }
}
    `;

/**
 * __useGetStudentsByLiveClassIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsByLiveClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByLiveClassIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByLiveClassIdQuery({
 *   variables: {
 *      liveClassId: // value for 'liveClassId'
 *   },
 * });
 */
export function useGetStudentsByLiveClassIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetStudentsByLiveClassIdQuery, TeacherGetStudentsByLiveClassIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetStudentsByLiveClassIdQuery, TeacherGetStudentsByLiveClassIdQueryVariables>(TeachergetStudentsByLiveClassIdDocument, options);
      }
export function useGetStudentsByLiveClassIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetStudentsByLiveClassIdQuery, TeacherGetStudentsByLiveClassIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetStudentsByLiveClassIdQuery, TeacherGetStudentsByLiveClassIdQueryVariables>(TeachergetStudentsByLiveClassIdDocument, options);
        }
export type GetStudentsByLiveClassIdQueryHookResult = ReturnType<typeof useGetStudentsByLiveClassIdQuery>;
export type GetStudentsByLiveClassIdLazyQueryHookResult = ReturnType<typeof useGetStudentsByLiveClassIdLazyQuery>;
export type GetStudentsByLiveClassIdQueryResult = Apollo.QueryResult<TeacherGetStudentsByLiveClassIdQuery, TeacherGetStudentsByLiveClassIdQueryVariables>;
export const TeacherGetLiveClassGroupsDocument = gql`
    query GetLiveClassGroups($_eq: uuid = "") {
  student_groups(where: {teacher_id: {_eq: $_eq}}) {
    id
    name
  }
}
    `;

/**
 * __useGetLiveClassGroupsQuery__
 *
 * To run a query within a React component, call `useGetLiveClassGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveClassGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveClassGroupsQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetLiveClassGroupsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>(TeacherGetLiveClassGroupsDocument, options);
      }
export function useGetLiveClassGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>(TeacherGetLiveClassGroupsDocument, options);
        }
export type GetLiveClassGroupsQueryHookResult = ReturnType<typeof useGetLiveClassGroupsQuery>;
export type GetLiveClassGroupsLazyQueryHookResult = ReturnType<typeof useGetLiveClassGroupsLazyQuery>;
export type GetLiveClassGroupsQueryResult = Apollo.QueryResult<TeacherGetLiveClassGroupsQuery, TeacherGetLiveClassGroupsQueryVariables>;
export const TeacherDeleteLiveClassGroupsDocument = gql`
    mutation DeleteLiveClassGroups($_eq: uuid = "") {
  delete_student_groups(where: {id: {_eq: $_eq}}) {
    affected_rows
  }
}
    `;
export type TeacherDeleteLiveClassGroupsMutationFn = Apollo.MutationFunction<TeacherDeleteLiveClassGroupsMutation, TeacherDeleteLiveClassGroupsMutationVariables>;

/**
 * __useDeleteLiveClassGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteLiveClassGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLiveClassGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLiveClassGroupsMutation, { data, loading, error }] = useDeleteLiveClassGroupsMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useDeleteLiveClassGroupsMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteLiveClassGroupsMutation, TeacherDeleteLiveClassGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteLiveClassGroupsMutation, TeacherDeleteLiveClassGroupsMutationVariables>(TeacherDeleteLiveClassGroupsDocument, options);
      }
export type DeleteLiveClassGroupsMutationHookResult = ReturnType<typeof useDeleteLiveClassGroupsMutation>;
export type DeleteLiveClassGroupsMutationResult = Apollo.MutationResult<TeacherDeleteLiveClassGroupsMutation>;
export type DeleteLiveClassGroupsMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteLiveClassGroupsMutation, TeacherDeleteLiveClassGroupsMutationVariables>;
export const TeacherGetStudentsForGroupByGroupIdDocument = gql`
    query GetStudentsForGroupByGroupId($_eq1: uuid = "") {
  student_group_users(where: {student_group_id: {_eq: $_eq1}}) {
    user_id
  }
}
    `;

/**
 * __useGetStudentsForGroupByGroupIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsForGroupByGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsForGroupByGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsForGroupByGroupIdQuery({
 *   variables: {
 *      _eq1: // value for '_eq1'
 *   },
 * });
 */
export function useGetStudentsForGroupByGroupIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>(TeacherGetStudentsForGroupByGroupIdDocument, options);
      }
export function useGetStudentsForGroupByGroupIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>(TeacherGetStudentsForGroupByGroupIdDocument, options);
        }
export type GetStudentsForGroupByGroupIdQueryHookResult = ReturnType<typeof useGetStudentsForGroupByGroupIdQuery>;
export type GetStudentsForGroupByGroupIdLazyQueryHookResult = ReturnType<typeof useGetStudentsForGroupByGroupIdLazyQuery>;
export type GetStudentsForGroupByGroupIdQueryResult = Apollo.QueryResult<TeacherGetStudentsForGroupByGroupIdQuery, TeacherGetStudentsForGroupByGroupIdQueryVariables>;
export const TeacherteacherInsertLiveClassGroupDocument = gql`
    mutation teacherInsertLiveClassGroup($object: student_groups_insert_input = {}) {
  insert_student_groups_one(object: $object) {
    id
  }
}
    `;
export type TeacherTeacherInsertLiveClassGroupMutationFn = Apollo.MutationFunction<TeacherTeacherInsertLiveClassGroupMutation, TeacherTeacherInsertLiveClassGroupMutationVariables>;

/**
 * __useTeacherInsertLiveClassGroupMutation__
 *
 * To run a mutation, you first call `useTeacherInsertLiveClassGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherInsertLiveClassGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherInsertLiveClassGroupMutation, { data, loading, error }] = useTeacherInsertLiveClassGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useTeacherInsertLiveClassGroupMutation(baseOptions?: Apollo.MutationHookOptions<TeacherTeacherInsertLiveClassGroupMutation, TeacherTeacherInsertLiveClassGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherTeacherInsertLiveClassGroupMutation, TeacherTeacherInsertLiveClassGroupMutationVariables>(TeacherteacherInsertLiveClassGroupDocument, options);
      }
export type TeacherInsertLiveClassGroupMutationHookResult = ReturnType<typeof useTeacherInsertLiveClassGroupMutation>;
export type TeacherInsertLiveClassGroupMutationResult = Apollo.MutationResult<TeacherTeacherInsertLiveClassGroupMutation>;
export type TeacherInsertLiveClassGroupMutationOptions = Apollo.BaseMutationOptions<TeacherTeacherInsertLiveClassGroupMutation, TeacherTeacherInsertLiveClassGroupMutationVariables>;
export const TeacherInsertStudentsForLiveClassDocument = gql`
    mutation InsertStudentsForLiveClass($objects: [live_class_attendees_insert_input!] = {}) {
  insert_live_class_attendees(objects: $objects) {
    affected_rows
  }
}
    `;
export type TeacherInsertStudentsForLiveClassMutationFn = Apollo.MutationFunction<TeacherInsertStudentsForLiveClassMutation, TeacherInsertStudentsForLiveClassMutationVariables>;

/**
 * __useInsertStudentsForLiveClassMutation__
 *
 * To run a mutation, you first call `useInsertStudentsForLiveClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertStudentsForLiveClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertStudentsForLiveClassMutation, { data, loading, error }] = useInsertStudentsForLiveClassMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertStudentsForLiveClassMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertStudentsForLiveClassMutation, TeacherInsertStudentsForLiveClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertStudentsForLiveClassMutation, TeacherInsertStudentsForLiveClassMutationVariables>(TeacherInsertStudentsForLiveClassDocument, options);
      }
export type InsertStudentsForLiveClassMutationHookResult = ReturnType<typeof useInsertStudentsForLiveClassMutation>;
export type InsertStudentsForLiveClassMutationResult = Apollo.MutationResult<TeacherInsertStudentsForLiveClassMutation>;
export type InsertStudentsForLiveClassMutationOptions = Apollo.BaseMutationOptions<TeacherInsertStudentsForLiveClassMutation, TeacherInsertStudentsForLiveClassMutationVariables>;
export const TeacherMeetingJoinDocument = gql`
    mutation MeetingJoin($name: String, $lesson_id: String) {
  teacherJoin(name: $name, meeting_id: $lesson_id) {
    url
    id
  }
}
    `;
export type TeacherMeetingJoinMutationFn = Apollo.MutationFunction<TeacherMeetingJoinMutation, TeacherMeetingJoinMutationVariables>;

/**
 * __useMeetingJoinMutation__
 *
 * To run a mutation, you first call `useMeetingJoinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeetingJoinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meetingJoinMutation, { data, loading, error }] = useMeetingJoinMutation({
 *   variables: {
 *      name: // value for 'name'
 *      lesson_id: // value for 'lesson_id'
 *   },
 * });
 */
export function useMeetingJoinMutation(baseOptions?: Apollo.MutationHookOptions<TeacherMeetingJoinMutation, TeacherMeetingJoinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherMeetingJoinMutation, TeacherMeetingJoinMutationVariables>(TeacherMeetingJoinDocument, options);
      }
export type MeetingJoinMutationHookResult = ReturnType<typeof useMeetingJoinMutation>;
export type MeetingJoinMutationResult = Apollo.MutationResult<TeacherMeetingJoinMutation>;
export type MeetingJoinMutationOptions = Apollo.BaseMutationOptions<TeacherMeetingJoinMutation, TeacherMeetingJoinMutationVariables>;
export const TeacherLiveClassGetStudentsDocument = gql`
    query LiveClassGetStudents {
  students {
    id
    user {
      full_name
    }
  }
}
    `;

/**
 * __useLiveClassGetStudentsQuery__
 *
 * To run a query within a React component, call `useLiveClassGetStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveClassGetStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveClassGetStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiveClassGetStudentsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherLiveClassGetStudentsQuery, TeacherLiveClassGetStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherLiveClassGetStudentsQuery, TeacherLiveClassGetStudentsQueryVariables>(TeacherLiveClassGetStudentsDocument, options);
      }
export function useLiveClassGetStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherLiveClassGetStudentsQuery, TeacherLiveClassGetStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherLiveClassGetStudentsQuery, TeacherLiveClassGetStudentsQueryVariables>(TeacherLiveClassGetStudentsDocument, options);
        }
export type LiveClassGetStudentsQueryHookResult = ReturnType<typeof useLiveClassGetStudentsQuery>;
export type LiveClassGetStudentsLazyQueryHookResult = ReturnType<typeof useLiveClassGetStudentsLazyQuery>;
export type LiveClassGetStudentsQueryResult = Apollo.QueryResult<TeacherLiveClassGetStudentsQuery, TeacherLiveClassGetStudentsQueryVariables>;
export const TeacherLiveClassesDocument = gql`
    query LiveClasses($_or: [live_classes_bool_exp!] = {}, $upcoming_sunday: timestamptz!, $last_sunday: timestamptz!) {
  live_classes(
    limit: 7
    where: {_or: $_or, _and: [{starting_at: {_lte: $upcoming_sunday}}, {starting_at: {_gte: $last_sunday}}]}
    order_by: {starting_at: desc}
  ) {
    id
    name
    duration
    description
    starting_at
    status
  }
}
    `;

/**
 * __useLiveClassesQuery__
 *
 * To run a query within a React component, call `useLiveClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveClassesQuery({
 *   variables: {
 *      _or: // value for '_or'
 *      upcoming_sunday: // value for 'upcoming_sunday'
 *      last_sunday: // value for 'last_sunday'
 *   },
 * });
 */
export function useLiveClassesQuery(baseOptions: Apollo.QueryHookOptions<TeacherLiveClassesQuery, TeacherLiveClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherLiveClassesQuery, TeacherLiveClassesQueryVariables>(TeacherLiveClassesDocument, options);
      }
export function useLiveClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherLiveClassesQuery, TeacherLiveClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherLiveClassesQuery, TeacherLiveClassesQueryVariables>(TeacherLiveClassesDocument, options);
        }
export type LiveClassesQueryHookResult = ReturnType<typeof useLiveClassesQuery>;
export type LiveClassesLazyQueryHookResult = ReturnType<typeof useLiveClassesLazyQuery>;
export type LiveClassesQueryResult = Apollo.QueryResult<TeacherLiveClassesQuery, TeacherLiveClassesQueryVariables>;
export const TeacherpresentStudentsLiveClassDocument = gql`
    mutation presentStudentsLiveClass($is_present: Boolean = false, $id: uuid = "") {
  update_live_class_attendees_by_pk(
    pk_columns: {id: $id}
    _set: {is_present: $is_present}
  ) {
    id
  }
}
    `;
export type TeacherPresentStudentsLiveClassMutationFn = Apollo.MutationFunction<TeacherPresentStudentsLiveClassMutation, TeacherPresentStudentsLiveClassMutationVariables>;

/**
 * __usePresentStudentsLiveClassMutation__
 *
 * To run a mutation, you first call `usePresentStudentsLiveClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresentStudentsLiveClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presentStudentsLiveClassMutation, { data, loading, error }] = usePresentStudentsLiveClassMutation({
 *   variables: {
 *      is_present: // value for 'is_present'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePresentStudentsLiveClassMutation(baseOptions?: Apollo.MutationHookOptions<TeacherPresentStudentsLiveClassMutation, TeacherPresentStudentsLiveClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherPresentStudentsLiveClassMutation, TeacherPresentStudentsLiveClassMutationVariables>(TeacherpresentStudentsLiveClassDocument, options);
      }
export type PresentStudentsLiveClassMutationHookResult = ReturnType<typeof usePresentStudentsLiveClassMutation>;
export type PresentStudentsLiveClassMutationResult = Apollo.MutationResult<TeacherPresentStudentsLiveClassMutation>;
export type PresentStudentsLiveClassMutationOptions = Apollo.BaseMutationOptions<TeacherPresentStudentsLiveClassMutation, TeacherPresentStudentsLiveClassMutationVariables>;
export const TeacherUpdateLiveClassesDocument = gql`
    mutation UpdateLiveClasses($id: uuid!, $status: String!) {
  update_live_classes_by_pk(_set: {status: $status}, pk_columns: {id: $id}) {
    id
  }
}
    `;
export type TeacherUpdateLiveClassesMutationFn = Apollo.MutationFunction<TeacherUpdateLiveClassesMutation, TeacherUpdateLiveClassesMutationVariables>;

/**
 * __useUpdateLiveClassesMutation__
 *
 * To run a mutation, you first call `useUpdateLiveClassesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiveClassesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiveClassesMutation, { data, loading, error }] = useUpdateLiveClassesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateLiveClassesMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateLiveClassesMutation, TeacherUpdateLiveClassesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateLiveClassesMutation, TeacherUpdateLiveClassesMutationVariables>(TeacherUpdateLiveClassesDocument, options);
      }
export type UpdateLiveClassesMutationHookResult = ReturnType<typeof useUpdateLiveClassesMutation>;
export type UpdateLiveClassesMutationResult = Apollo.MutationResult<TeacherUpdateLiveClassesMutation>;
export type UpdateLiveClassesMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateLiveClassesMutation, TeacherUpdateLiveClassesMutationVariables>;
export const TeacherDeleteRoleDocument = gql`
    mutation DeleteRole($deleteRolesByPkId: uuid!) {
  delete_roles_by_pk(id: $deleteRolesByPkId) {
    id
  }
}
    `;
export type TeacherDeleteRoleMutationFn = Apollo.MutationFunction<TeacherDeleteRoleMutation, TeacherDeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      deleteRolesByPkId: // value for 'deleteRolesByPkId'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteRoleMutation, TeacherDeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteRoleMutation, TeacherDeleteRoleMutationVariables>(TeacherDeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<TeacherDeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteRoleMutation, TeacherDeleteRoleMutationVariables>;
export const TeacherGetPermissionsDocument = gql`
    query GetPermissions {
  permissions {
    id
    title
  }
}
    `;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetPermissionsQuery, TeacherGetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetPermissionsQuery, TeacherGetPermissionsQueryVariables>(TeacherGetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetPermissionsQuery, TeacherGetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetPermissionsQuery, TeacherGetPermissionsQueryVariables>(TeacherGetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<TeacherGetPermissionsQuery, TeacherGetPermissionsQueryVariables>;
export const TeacherGetRolePermissionsDocument = gql`
    query GetRolePermissions($rolesByPkId: uuid!) {
  roles_by_pk(id: $rolesByPkId) {
    id
    title
    colour
    permissions {
      id
      permission_id
      role_id
    }
  }
}
    `;

/**
 * __useGetRolePermissionsQuery__
 *
 * To run a query within a React component, call `useGetRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolePermissionsQuery({
 *   variables: {
 *      rolesByPkId: // value for 'rolesByPkId'
 *   },
 * });
 */
export function useGetRolePermissionsQuery(baseOptions: Apollo.QueryHookOptions<TeacherGetRolePermissionsQuery, TeacherGetRolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetRolePermissionsQuery, TeacherGetRolePermissionsQueryVariables>(TeacherGetRolePermissionsDocument, options);
      }
export function useGetRolePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetRolePermissionsQuery, TeacherGetRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetRolePermissionsQuery, TeacherGetRolePermissionsQueryVariables>(TeacherGetRolePermissionsDocument, options);
        }
export type GetRolePermissionsQueryHookResult = ReturnType<typeof useGetRolePermissionsQuery>;
export type GetRolePermissionsLazyQueryHookResult = ReturnType<typeof useGetRolePermissionsLazyQuery>;
export type GetRolePermissionsQueryResult = Apollo.QueryResult<TeacherGetRolePermissionsQuery, TeacherGetRolePermissionsQueryVariables>;
export const TeacherGetRolesDocument = gql`
    query GetRoles {
  roles(order_by: {title: asc}) {
    id
    colour
    title
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetRolesQuery, TeacherGetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetRolesQuery, TeacherGetRolesQueryVariables>(TeacherGetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetRolesQuery, TeacherGetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetRolesQuery, TeacherGetRolesQueryVariables>(TeacherGetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<TeacherGetRolesQuery, TeacherGetRolesQueryVariables>;
export const TeacherGetUsersDocument = gql`
    query GetUsers($limit: Int = 2, $offset: Int = 0) {
  roles(limit: $limit, offset: $offset, order_by: {title: desc}) {
    id
    title
    colour
    permissions {
      id
      permission_id
      role_id
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetUsersQuery, TeacherGetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetUsersQuery, TeacherGetUsersQueryVariables>(TeacherGetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetUsersQuery, TeacherGetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetUsersQuery, TeacherGetUsersQueryVariables>(TeacherGetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<TeacherGetUsersQuery, TeacherGetUsersQueryVariables>;
export const TeacherInsertRoleDocument = gql`
    mutation InsertRole($object: roles_insert_input!) {
  insert_roles_one(object: $object) {
    id
  }
}
    `;
export type TeacherInsertRoleMutationFn = Apollo.MutationFunction<TeacherInsertRoleMutation, TeacherInsertRoleMutationVariables>;

/**
 * __useInsertRoleMutation__
 *
 * To run a mutation, you first call `useInsertRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoleMutation, { data, loading, error }] = useInsertRoleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertRoleMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertRoleMutation, TeacherInsertRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertRoleMutation, TeacherInsertRoleMutationVariables>(TeacherInsertRoleDocument, options);
      }
export type InsertRoleMutationHookResult = ReturnType<typeof useInsertRoleMutation>;
export type InsertRoleMutationResult = Apollo.MutationResult<TeacherInsertRoleMutation>;
export type InsertRoleMutationOptions = Apollo.BaseMutationOptions<TeacherInsertRoleMutation, TeacherInsertRoleMutationVariables>;
export const TeacherUpdateRoleDocument = gql`
    mutation UpdateRole($pkColumns: roles_pk_columns_input!, $set: roles_set_input) {
  update_roles_by_pk(pk_columns: $pkColumns, _set: $set) {
    id
  }
}
    `;
export type TeacherUpdateRoleMutationFn = Apollo.MutationFunction<TeacherUpdateRoleMutation, TeacherUpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      pkColumns: // value for 'pkColumns'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateRoleMutation, TeacherUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateRoleMutation, TeacherUpdateRoleMutationVariables>(TeacherUpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<TeacherUpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateRoleMutation, TeacherUpdateRoleMutationVariables>;
export const TeacherInsertQuizDocument = gql`
    mutation InsertQuiz($quiz: assignments_insert_input!) {
  insert_assignments_one(object: $quiz) {
    ...Quiz
  }
}
    ${TeacherQuizFragmentDoc}`;
export type TeacherInsertQuizMutationFn = Apollo.MutationFunction<TeacherInsertQuizMutation, TeacherInsertQuizMutationVariables>;

/**
 * __useInsertQuizMutation__
 *
 * To run a mutation, you first call `useInsertQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertQuizMutation, { data, loading, error }] = useInsertQuizMutation({
 *   variables: {
 *      quiz: // value for 'quiz'
 *   },
 * });
 */
export function useInsertQuizMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertQuizMutation, TeacherInsertQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertQuizMutation, TeacherInsertQuizMutationVariables>(TeacherInsertQuizDocument, options);
      }
export type InsertQuizMutationHookResult = ReturnType<typeof useInsertQuizMutation>;
export type InsertQuizMutationResult = Apollo.MutationResult<TeacherInsertQuizMutation>;
export type InsertQuizMutationOptions = Apollo.BaseMutationOptions<TeacherInsertQuizMutation, TeacherInsertQuizMutationVariables>;
export const TeacherCreateQuestionWithOptionsDocument = gql`
    mutation CreateQuestionWithOptions($object: assignment_questions_insert_input!) {
  insert_assignment_questions_one(object: $object) {
    title
    id
    type
    content
    assignment_question_options {
      is_correct
      id
      order
      title
      group
      created_at
      score
      comment
    }
  }
}
    `;
export type TeacherCreateQuestionWithOptionsMutationFn = Apollo.MutationFunction<TeacherCreateQuestionWithOptionsMutation, TeacherCreateQuestionWithOptionsMutationVariables>;

/**
 * __useCreateQuestionWithOptionsMutation__
 *
 * To run a mutation, you first call `useCreateQuestionWithOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionWithOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionWithOptionsMutation, { data, loading, error }] = useCreateQuestionWithOptionsMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateQuestionWithOptionsMutation(baseOptions?: Apollo.MutationHookOptions<TeacherCreateQuestionWithOptionsMutation, TeacherCreateQuestionWithOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherCreateQuestionWithOptionsMutation, TeacherCreateQuestionWithOptionsMutationVariables>(TeacherCreateQuestionWithOptionsDocument, options);
      }
export type CreateQuestionWithOptionsMutationHookResult = ReturnType<typeof useCreateQuestionWithOptionsMutation>;
export type CreateQuestionWithOptionsMutationResult = Apollo.MutationResult<TeacherCreateQuestionWithOptionsMutation>;
export type CreateQuestionWithOptionsMutationOptions = Apollo.BaseMutationOptions<TeacherCreateQuestionWithOptionsMutation, TeacherCreateQuestionWithOptionsMutationVariables>;
export const TeacherCreateQuizDocument = gql`
    mutation CreateQuiz($quiz: assignment_quiz_insert_input!) {
  insert_assignment_quiz_one(object: $quiz) {
    assignment {
      ...Quiz
    }
  }
}
    ${TeacherQuizFragmentDoc}`;
export type TeacherCreateQuizMutationFn = Apollo.MutationFunction<TeacherCreateQuizMutation, TeacherCreateQuizMutationVariables>;

/**
 * __useCreateQuizMutation__
 *
 * To run a mutation, you first call `useCreateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuizMutation, { data, loading, error }] = useCreateQuizMutation({
 *   variables: {
 *      quiz: // value for 'quiz'
 *   },
 * });
 */
export function useCreateQuizMutation(baseOptions?: Apollo.MutationHookOptions<TeacherCreateQuizMutation, TeacherCreateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherCreateQuizMutation, TeacherCreateQuizMutationVariables>(TeacherCreateQuizDocument, options);
      }
export type CreateQuizMutationHookResult = ReturnType<typeof useCreateQuizMutation>;
export type CreateQuizMutationResult = Apollo.MutationResult<TeacherCreateQuizMutation>;
export type CreateQuizMutationOptions = Apollo.BaseMutationOptions<TeacherCreateQuizMutation, TeacherCreateQuizMutationVariables>;
export const TeacherDeleteQuizQuestionWithAllRelationsDocument = gql`
    mutation DeleteQuizQuestionWithAllRelations($id: uuid = "") {
  delete_assignment_question_option_relations(
    where: {assignment_question_option: {assignment_question_id: {_eq: $id}}}
  ) {
    affected_rows
  }
  delete_assignment_question_options(where: {assignment_question_id: {_eq: $id}}) {
    affected_rows
  }
  delete_assignment_questions_by_pk(id: $id) {
    id
  }
}
    `;
export type TeacherDeleteQuizQuestionWithAllRelationsMutationFn = Apollo.MutationFunction<TeacherDeleteQuizQuestionWithAllRelationsMutation, TeacherDeleteQuizQuestionWithAllRelationsMutationVariables>;

/**
 * __useDeleteQuizQuestionWithAllRelationsMutation__
 *
 * To run a mutation, you first call `useDeleteQuizQuestionWithAllRelationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuizQuestionWithAllRelationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuizQuestionWithAllRelationsMutation, { data, loading, error }] = useDeleteQuizQuestionWithAllRelationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuizQuestionWithAllRelationsMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteQuizQuestionWithAllRelationsMutation, TeacherDeleteQuizQuestionWithAllRelationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteQuizQuestionWithAllRelationsMutation, TeacherDeleteQuizQuestionWithAllRelationsMutationVariables>(TeacherDeleteQuizQuestionWithAllRelationsDocument, options);
      }
export type DeleteQuizQuestionWithAllRelationsMutationHookResult = ReturnType<typeof useDeleteQuizQuestionWithAllRelationsMutation>;
export type DeleteQuizQuestionWithAllRelationsMutationResult = Apollo.MutationResult<TeacherDeleteQuizQuestionWithAllRelationsMutation>;
export type DeleteQuizQuestionWithAllRelationsMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteQuizQuestionWithAllRelationsMutation, TeacherDeleteQuizQuestionWithAllRelationsMutationVariables>;
export const TeacherGetQuestionByIdDocument = gql`
    query GetQuestionById($id: uuid = "") {
  assignment_questions_by_pk(id: $id) {
    ...AssignmentQuestions
  }
}
    ${TeacherAssignmentQuestionsFragmentDoc}`;

/**
 * __useGetQuestionByIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuestionByIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetQuestionByIdQuery, TeacherGetQuestionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetQuestionByIdQuery, TeacherGetQuestionByIdQueryVariables>(TeacherGetQuestionByIdDocument, options);
      }
export function useGetQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetQuestionByIdQuery, TeacherGetQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetQuestionByIdQuery, TeacherGetQuestionByIdQueryVariables>(TeacherGetQuestionByIdDocument, options);
        }
export type GetQuestionByIdQueryHookResult = ReturnType<typeof useGetQuestionByIdQuery>;
export type GetQuestionByIdLazyQueryHookResult = ReturnType<typeof useGetQuestionByIdLazyQuery>;
export type GetQuestionByIdQueryResult = Apollo.QueryResult<TeacherGetQuestionByIdQuery, TeacherGetQuestionByIdQueryVariables>;
export const TeacherGetQuestionsByAssignmentIdDocument = gql`
    query GetQuestionsByAssignmentId($assignmentId: uuid = "") {
  assignment_questions(where: {assignment_id: {_eq: $assignmentId}}) {
    assignment_id
    content
    id
    title
    type
    updated_at
    assignment_question_options {
      group
      id
      order
      title
      updated_at
      is_correct
      assignment_question_option_relations {
        assignment_question_option_matching_id
      }
      assignment_question_answers {
        id
        assignment_question_option_id
        content
        is_correct
        user {
          full_name
          id
          title
          avatar_url
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionsByAssignmentIdQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByAssignmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByAssignmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByAssignmentIdQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetQuestionsByAssignmentIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetQuestionsByAssignmentIdQuery, TeacherGetQuestionsByAssignmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetQuestionsByAssignmentIdQuery, TeacherGetQuestionsByAssignmentIdQueryVariables>(TeacherGetQuestionsByAssignmentIdDocument, options);
      }
export function useGetQuestionsByAssignmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetQuestionsByAssignmentIdQuery, TeacherGetQuestionsByAssignmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetQuestionsByAssignmentIdQuery, TeacherGetQuestionsByAssignmentIdQueryVariables>(TeacherGetQuestionsByAssignmentIdDocument, options);
        }
export type GetQuestionsByAssignmentIdQueryHookResult = ReturnType<typeof useGetQuestionsByAssignmentIdQuery>;
export type GetQuestionsByAssignmentIdLazyQueryHookResult = ReturnType<typeof useGetQuestionsByAssignmentIdLazyQuery>;
export type GetQuestionsByAssignmentIdQueryResult = Apollo.QueryResult<TeacherGetQuestionsByAssignmentIdQuery, TeacherGetQuestionsByAssignmentIdQueryVariables>;
export const TeacherGetQuizByIdDocument = gql`
    query GetQuizById($quizId: uuid = "") {
  assignments_by_pk(id: $quizId) {
    ...Quiz
  }
}
    ${TeacherQuizFragmentDoc}`;

/**
 * __useGetQuizByIdQuery__
 *
 * To run a query within a React component, call `useGetQuizByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizByIdQuery({
 *   variables: {
 *      quizId: // value for 'quizId'
 *   },
 * });
 */
export function useGetQuizByIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetQuizByIdQuery, TeacherGetQuizByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetQuizByIdQuery, TeacherGetQuizByIdQueryVariables>(TeacherGetQuizByIdDocument, options);
      }
export function useGetQuizByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetQuizByIdQuery, TeacherGetQuizByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetQuizByIdQuery, TeacherGetQuizByIdQueryVariables>(TeacherGetQuizByIdDocument, options);
        }
export type GetQuizByIdQueryHookResult = ReturnType<typeof useGetQuizByIdQuery>;
export type GetQuizByIdLazyQueryHookResult = ReturnType<typeof useGetQuizByIdLazyQuery>;
export type GetQuizByIdQueryResult = Apollo.QueryResult<TeacherGetQuizByIdQuery, TeacherGetQuizByIdQueryVariables>;
export const TeachergetTeachersQuizzAssignmentsDocument = gql`
    query getTeachersQuizzAssignments($user_id: uuid = "") {
  assignments(where: {type: {_eq: QUIZ}, user_id: {_eq: $user_id}}) {
    ...Quiz
  }
}
    ${TeacherQuizFragmentDoc}`;

/**
 * __useGetTeachersQuizzAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetTeachersQuizzAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeachersQuizzAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeachersQuizzAssignmentsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetTeachersQuizzAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetTeachersQuizzAssignmentsQuery, TeacherGetTeachersQuizzAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetTeachersQuizzAssignmentsQuery, TeacherGetTeachersQuizzAssignmentsQueryVariables>(TeachergetTeachersQuizzAssignmentsDocument, options);
      }
export function useGetTeachersQuizzAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetTeachersQuizzAssignmentsQuery, TeacherGetTeachersQuizzAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetTeachersQuizzAssignmentsQuery, TeacherGetTeachersQuizzAssignmentsQueryVariables>(TeachergetTeachersQuizzAssignmentsDocument, options);
        }
export type GetTeachersQuizzAssignmentsQueryHookResult = ReturnType<typeof useGetTeachersQuizzAssignmentsQuery>;
export type GetTeachersQuizzAssignmentsLazyQueryHookResult = ReturnType<typeof useGetTeachersQuizzAssignmentsLazyQuery>;
export type GetTeachersQuizzAssignmentsQueryResult = Apollo.QueryResult<TeacherGetTeachersQuizzAssignmentsQuery, TeacherGetTeachersQuizzAssignmentsQueryVariables>;
export const TeacherUpdateQuestionByPkDocument = gql`
    mutation UpdateQuestionByPk($questionId: uuid = "", $question: assignment_questions_set_input = {}, $question_options: [assignment_question_options_insert_input!] = {}) {
  update_assignment_questions_by_pk(
    pk_columns: {id: $questionId}
    _set: $question
  ) {
    id
  }
  insert_assignment_question_options(
    objects: $question_options
    on_conflict: {constraint: assignment_question_options_pkey, update_columns: [title, comment, order, score, is_correct]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type TeacherUpdateQuestionByPkMutationFn = Apollo.MutationFunction<TeacherUpdateQuestionByPkMutation, TeacherUpdateQuestionByPkMutationVariables>;

/**
 * __useUpdateQuestionByPkMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionByPkMutation, { data, loading, error }] = useUpdateQuestionByPkMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      question: // value for 'question'
 *      question_options: // value for 'question_options'
 *   },
 * });
 */
export function useUpdateQuestionByPkMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateQuestionByPkMutation, TeacherUpdateQuestionByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateQuestionByPkMutation, TeacherUpdateQuestionByPkMutationVariables>(TeacherUpdateQuestionByPkDocument, options);
      }
export type UpdateQuestionByPkMutationHookResult = ReturnType<typeof useUpdateQuestionByPkMutation>;
export type UpdateQuestionByPkMutationResult = Apollo.MutationResult<TeacherUpdateQuestionByPkMutation>;
export type UpdateQuestionByPkMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateQuestionByPkMutation, TeacherUpdateQuestionByPkMutationVariables>;
export const TeacherUpdateQuestionOptionByPkDocument = gql`
    mutation UpdateQuestionOptionByPk($id: uuid = "", $object: assignment_question_options_set_input = {}) {
  update_assignment_question_options_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;
export type TeacherUpdateQuestionOptionByPkMutationFn = Apollo.MutationFunction<TeacherUpdateQuestionOptionByPkMutation, TeacherUpdateQuestionOptionByPkMutationVariables>;

/**
 * __useUpdateQuestionOptionByPkMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionOptionByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionOptionByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionOptionByPkMutation, { data, loading, error }] = useUpdateQuestionOptionByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateQuestionOptionByPkMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateQuestionOptionByPkMutation, TeacherUpdateQuestionOptionByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateQuestionOptionByPkMutation, TeacherUpdateQuestionOptionByPkMutationVariables>(TeacherUpdateQuestionOptionByPkDocument, options);
      }
export type UpdateQuestionOptionByPkMutationHookResult = ReturnType<typeof useUpdateQuestionOptionByPkMutation>;
export type UpdateQuestionOptionByPkMutationResult = Apollo.MutationResult<TeacherUpdateQuestionOptionByPkMutation>;
export type UpdateQuestionOptionByPkMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateQuestionOptionByPkMutation, TeacherUpdateQuestionOptionByPkMutationVariables>;
export const TeacherUpdateQuizDocument = gql`
    mutation UpdateQuiz($assignment_id: uuid!, $assignment: assignments_set_input!, $assignment_quiz: assignment_quiz_set_input!) {
  update_assignment_quiz(
    where: {assignment_id: {_eq: $assignment_id}}
    _set: $assignment_quiz
  ) {
    returning {
      id
    }
  }
  update_assignments_by_pk(pk_columns: {id: $assignment_id}, _set: $assignment) {
    ...Quiz
  }
}
    ${TeacherQuizFragmentDoc}`;
export type TeacherUpdateQuizMutationFn = Apollo.MutationFunction<TeacherUpdateQuizMutation, TeacherUpdateQuizMutationVariables>;

/**
 * __useUpdateQuizMutation__
 *
 * To run a mutation, you first call `useUpdateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuizMutation, { data, loading, error }] = useUpdateQuizMutation({
 *   variables: {
 *      assignment_id: // value for 'assignment_id'
 *      assignment: // value for 'assignment'
 *      assignment_quiz: // value for 'assignment_quiz'
 *   },
 * });
 */
export function useUpdateQuizMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateQuizMutation, TeacherUpdateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateQuizMutation, TeacherUpdateQuizMutationVariables>(TeacherUpdateQuizDocument, options);
      }
export type UpdateQuizMutationHookResult = ReturnType<typeof useUpdateQuizMutation>;
export type UpdateQuizMutationResult = Apollo.MutationResult<TeacherUpdateQuizMutation>;
export type UpdateQuizMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateQuizMutation, TeacherUpdateQuizMutationVariables>;
export const TeacherStudentsDocument = gql`
    query Students {
  students {
    ...ClassStudent
  }
}
    ${TeacherClassStudentFragmentDoc}`;

/**
 * __useStudentsQuery__
 *
 * To run a query within a React component, call `useStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherStudentsQuery, TeacherStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherStudentsQuery, TeacherStudentsQueryVariables>(TeacherStudentsDocument, options);
      }
export function useStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherStudentsQuery, TeacherStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherStudentsQuery, TeacherStudentsQueryVariables>(TeacherStudentsDocument, options);
        }
export type StudentsQueryHookResult = ReturnType<typeof useStudentsQuery>;
export type StudentsLazyQueryHookResult = ReturnType<typeof useStudentsLazyQuery>;
export type StudentsQueryResult = Apollo.QueryResult<TeacherStudentsQuery, TeacherStudentsQueryVariables>;
export const TeachercheckNumberOfLeafsDocument = gql`
    query checkNumberOfLeafs($id: uuid = "") {
  teaching_structures_by_pk(id: $id) {
    rtl
    ltr
  }
}
    `;

/**
 * __useCheckNumberOfLeafsQuery__
 *
 * To run a query within a React component, call `useCheckNumberOfLeafsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNumberOfLeafsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNumberOfLeafsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckNumberOfLeafsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherCheckNumberOfLeafsQuery, TeacherCheckNumberOfLeafsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherCheckNumberOfLeafsQuery, TeacherCheckNumberOfLeafsQueryVariables>(TeachercheckNumberOfLeafsDocument, options);
      }
export function useCheckNumberOfLeafsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherCheckNumberOfLeafsQuery, TeacherCheckNumberOfLeafsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherCheckNumberOfLeafsQuery, TeacherCheckNumberOfLeafsQueryVariables>(TeachercheckNumberOfLeafsDocument, options);
        }
export type CheckNumberOfLeafsQueryHookResult = ReturnType<typeof useCheckNumberOfLeafsQuery>;
export type CheckNumberOfLeafsLazyQueryHookResult = ReturnType<typeof useCheckNumberOfLeafsLazyQuery>;
export type CheckNumberOfLeafsQueryResult = Apollo.QueryResult<TeacherCheckNumberOfLeafsQuery, TeacherCheckNumberOfLeafsQueryVariables>;
export const TeacherdeleteAssignmentsWithTeachingStructureDocument = gql`
    mutation deleteAssignmentsWithTeachingStructure($_eq: uuid = "") {
  delete_assignments(where: {id: {_eq: $_eq}}) {
    affected_rows
  }
}
    `;
export type TeacherDeleteAssignmentsWithTeachingStructureMutationFn = Apollo.MutationFunction<TeacherDeleteAssignmentsWithTeachingStructureMutation, TeacherDeleteAssignmentsWithTeachingStructureMutationVariables>;

/**
 * __useDeleteAssignmentsWithTeachingStructureMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentsWithTeachingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentsWithTeachingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentsWithTeachingStructureMutation, { data, loading, error }] = useDeleteAssignmentsWithTeachingStructureMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useDeleteAssignmentsWithTeachingStructureMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteAssignmentsWithTeachingStructureMutation, TeacherDeleteAssignmentsWithTeachingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteAssignmentsWithTeachingStructureMutation, TeacherDeleteAssignmentsWithTeachingStructureMutationVariables>(TeacherdeleteAssignmentsWithTeachingStructureDocument, options);
      }
export type DeleteAssignmentsWithTeachingStructureMutationHookResult = ReturnType<typeof useDeleteAssignmentsWithTeachingStructureMutation>;
export type DeleteAssignmentsWithTeachingStructureMutationResult = Apollo.MutationResult<TeacherDeleteAssignmentsWithTeachingStructureMutation>;
export type DeleteAssignmentsWithTeachingStructureMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteAssignmentsWithTeachingStructureMutation, TeacherDeleteAssignmentsWithTeachingStructureMutationVariables>;
export const TeacherdeleteTeachingStructureLeafDocument = gql`
    mutation deleteTeachingStructureLeaf($id: uuid = "") {
  delete_teaching_structures_by_pk(id: $id) {
    id
  }
}
    `;
export type TeacherDeleteTeachingStructureLeafMutationFn = Apollo.MutationFunction<TeacherDeleteTeachingStructureLeafMutation, TeacherDeleteTeachingStructureLeafMutationVariables>;

/**
 * __useDeleteTeachingStructureLeafMutation__
 *
 * To run a mutation, you first call `useDeleteTeachingStructureLeafMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeachingStructureLeafMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeachingStructureLeafMutation, { data, loading, error }] = useDeleteTeachingStructureLeafMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeachingStructureLeafMutation(baseOptions?: Apollo.MutationHookOptions<TeacherDeleteTeachingStructureLeafMutation, TeacherDeleteTeachingStructureLeafMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherDeleteTeachingStructureLeafMutation, TeacherDeleteTeachingStructureLeafMutationVariables>(TeacherdeleteTeachingStructureLeafDocument, options);
      }
export type DeleteTeachingStructureLeafMutationHookResult = ReturnType<typeof useDeleteTeachingStructureLeafMutation>;
export type DeleteTeachingStructureLeafMutationResult = Apollo.MutationResult<TeacherDeleteTeachingStructureLeafMutation>;
export type DeleteTeachingStructureLeafMutationOptions = Apollo.BaseMutationOptions<TeacherDeleteTeachingStructureLeafMutation, TeacherDeleteTeachingStructureLeafMutationVariables>;
export const TeacherGetAssigmentByIdDocument = gql`
    query GetAssigmentById($_eq: uuid) {
  assignments(where: {id: {_eq: $_eq}}) {
    type
    title
    id
    description
    duration
    teaching_structure_id
    due_at
    due_at_filter
    created_at
    is_gradeable
    is_completed
    assignment_type {
      ...AssignmentType
    }
    user {
      full_name
    }
    grade_weight: assignment_grade_weight {
      id
      value
      comment
    }
    assignment_users {
      user {
        full_name
        id
      }
      id
      mark_id
      comment
    }
    files {
      ...File
    }
  }
}
    ${TeacherAssignmentTypeFragmentDoc}
${TeacherFileFragmentDoc}`;

/**
 * __useGetAssigmentByIdQuery__
 *
 * To run a query within a React component, call `useGetAssigmentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssigmentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssigmentByIdQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetAssigmentByIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>(TeacherGetAssigmentByIdDocument, options);
      }
export function useGetAssigmentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>(TeacherGetAssigmentByIdDocument, options);
        }
export type GetAssigmentByIdQueryHookResult = ReturnType<typeof useGetAssigmentByIdQuery>;
export type GetAssigmentByIdLazyQueryHookResult = ReturnType<typeof useGetAssigmentByIdLazyQuery>;
export type GetAssigmentByIdQueryResult = Apollo.QueryResult<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>;
export const TeacherGetAllMyLeafsDocument = gql`
    query GetAllMyLeafs($teaching_structure_id: uuid = "") {
  teaching_structure_leafs(args: {leaf_id: $teaching_structure_id}) {
    id
    title
    parent_id
    updated_at
    ltr
    rtl
    assignments {
      id
      title
      type
      duration
      created_at
    }
  }
}
    `;

/**
 * __useGetAllMyLeafsQuery__
 *
 * To run a query within a React component, call `useGetAllMyLeafsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMyLeafsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMyLeafsQuery({
 *   variables: {
 *      teaching_structure_id: // value for 'teaching_structure_id'
 *   },
 * });
 */
export function useGetAllMyLeafsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>(TeacherGetAllMyLeafsDocument, options);
      }
export function useGetAllMyLeafsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>(TeacherGetAllMyLeafsDocument, options);
        }
export type GetAllMyLeafsQueryHookResult = ReturnType<typeof useGetAllMyLeafsQuery>;
export type GetAllMyLeafsLazyQueryHookResult = ReturnType<typeof useGetAllMyLeafsLazyQuery>;
export type GetAllMyLeafsQueryResult = Apollo.QueryResult<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>;
export const TeacherGetMyTeachingStructureItemsDocument = gql`
    query GetMyTeachingStructureItems($_eq: uuid = "") {
  teacher_subject(where: {teacher_id: {_eq: $_eq}}) {
    teaching_structure_id
    subject_id
    teaching_structure {
      subject_icon
      title
      id
      parent {
        title
        id
        created_at
        parent {
          id
          title
        }
      }
      assignments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyTeachingStructureItemsQuery__
 *
 * To run a query within a React component, call `useGetMyTeachingStructureItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeachingStructureItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeachingStructureItemsQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetMyTeachingStructureItemsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>(TeacherGetMyTeachingStructureItemsDocument, options);
      }
export function useGetMyTeachingStructureItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>(TeacherGetMyTeachingStructureItemsDocument, options);
        }
export type GetMyTeachingStructureItemsQueryHookResult = ReturnType<typeof useGetMyTeachingStructureItemsQuery>;
export type GetMyTeachingStructureItemsLazyQueryHookResult = ReturnType<typeof useGetMyTeachingStructureItemsLazyQuery>;
export type GetMyTeachingStructureItemsQueryResult = Apollo.QueryResult<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>;
export const TeachergetParentSubjectForTeachingStructureIdDocument = gql`
    query getParentSubjectForTeachingStructureId($leaf_id: uuid = "") {
  teaching_structure_parents(
    args: {leaf_id: $leaf_id}
    where: {type_id: {_eq: "e74e23b7-70ba-4d1d-af59-96d31b09742e"}}
  ) {
    id
    title
    rtl
    ltr
    parent {
      id
      title
    }
  }
}
    `;

/**
 * __useGetParentSubjectForTeachingStructureIdQuery__
 *
 * To run a query within a React component, call `useGetParentSubjectForTeachingStructureIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentSubjectForTeachingStructureIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentSubjectForTeachingStructureIdQuery({
 *   variables: {
 *      leaf_id: // value for 'leaf_id'
 *   },
 * });
 */
export function useGetParentSubjectForTeachingStructureIdQuery(baseOptions?: Apollo.QueryHookOptions<TeacherGetParentSubjectForTeachingStructureIdQuery, TeacherGetParentSubjectForTeachingStructureIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherGetParentSubjectForTeachingStructureIdQuery, TeacherGetParentSubjectForTeachingStructureIdQueryVariables>(TeachergetParentSubjectForTeachingStructureIdDocument, options);
      }
export function useGetParentSubjectForTeachingStructureIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherGetParentSubjectForTeachingStructureIdQuery, TeacherGetParentSubjectForTeachingStructureIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherGetParentSubjectForTeachingStructureIdQuery, TeacherGetParentSubjectForTeachingStructureIdQueryVariables>(TeachergetParentSubjectForTeachingStructureIdDocument, options);
        }
export type GetParentSubjectForTeachingStructureIdQueryHookResult = ReturnType<typeof useGetParentSubjectForTeachingStructureIdQuery>;
export type GetParentSubjectForTeachingStructureIdLazyQueryHookResult = ReturnType<typeof useGetParentSubjectForTeachingStructureIdLazyQuery>;
export type GetParentSubjectForTeachingStructureIdQueryResult = Apollo.QueryResult<TeacherGetParentSubjectForTeachingStructureIdQuery, TeacherGetParentSubjectForTeachingStructureIdQueryVariables>;
export const TeacherInsertTeachingStructureItemDocument = gql`
    mutation InsertTeachingStructureItem($title: String = "", $parent_id: uuid = "") {
  insert_teaching_structures_one(object: {title: $title, parent_id: $parent_id}) {
    id
  }
}
    `;
export type TeacherInsertTeachingStructureItemMutationFn = Apollo.MutationFunction<TeacherInsertTeachingStructureItemMutation, TeacherInsertTeachingStructureItemMutationVariables>;

/**
 * __useInsertTeachingStructureItemMutation__
 *
 * To run a mutation, you first call `useInsertTeachingStructureItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTeachingStructureItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTeachingStructureItemMutation, { data, loading, error }] = useInsertTeachingStructureItemMutation({
 *   variables: {
 *      title: // value for 'title'
 *      parent_id: // value for 'parent_id'
 *   },
 * });
 */
export function useInsertTeachingStructureItemMutation(baseOptions?: Apollo.MutationHookOptions<TeacherInsertTeachingStructureItemMutation, TeacherInsertTeachingStructureItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherInsertTeachingStructureItemMutation, TeacherInsertTeachingStructureItemMutationVariables>(TeacherInsertTeachingStructureItemDocument, options);
      }
export type InsertTeachingStructureItemMutationHookResult = ReturnType<typeof useInsertTeachingStructureItemMutation>;
export type InsertTeachingStructureItemMutationResult = Apollo.MutationResult<TeacherInsertTeachingStructureItemMutation>;
export type InsertTeachingStructureItemMutationOptions = Apollo.BaseMutationOptions<TeacherInsertTeachingStructureItemMutation, TeacherInsertTeachingStructureItemMutationVariables>;
export const TeacherupdateAssignmentsWithTeachingStructureDocument = gql`
    mutation updateAssignmentsWithTeachingStructure($_eq: uuid = "", $assignment: assignments_set_input) {
  update_assignments(_set: $assignment, where: {id: {_eq: $_eq}}) {
    affected_rows
  }
}
    `;
export type TeacherUpdateAssignmentsWithTeachingStructureMutationFn = Apollo.MutationFunction<TeacherUpdateAssignmentsWithTeachingStructureMutation, TeacherUpdateAssignmentsWithTeachingStructureMutationVariables>;

/**
 * __useUpdateAssignmentsWithTeachingStructureMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentsWithTeachingStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentsWithTeachingStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentsWithTeachingStructureMutation, { data, loading, error }] = useUpdateAssignmentsWithTeachingStructureMutation({
 *   variables: {
 *      _eq: // value for '_eq'
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useUpdateAssignmentsWithTeachingStructureMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateAssignmentsWithTeachingStructureMutation, TeacherUpdateAssignmentsWithTeachingStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateAssignmentsWithTeachingStructureMutation, TeacherUpdateAssignmentsWithTeachingStructureMutationVariables>(TeacherupdateAssignmentsWithTeachingStructureDocument, options);
      }
export type UpdateAssignmentsWithTeachingStructureMutationHookResult = ReturnType<typeof useUpdateAssignmentsWithTeachingStructureMutation>;
export type UpdateAssignmentsWithTeachingStructureMutationResult = Apollo.MutationResult<TeacherUpdateAssignmentsWithTeachingStructureMutation>;
export type UpdateAssignmentsWithTeachingStructureMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateAssignmentsWithTeachingStructureMutation, TeacherUpdateAssignmentsWithTeachingStructureMutationVariables>;
export const TeacherupdateTeachingStructureItemDocument = gql`
    mutation updateTeachingStructureItem($title: String = "", $id: uuid = "") {
  update_teaching_structures_by_pk(_set: {title: $title}, pk_columns: {id: $id}) {
    title
  }
}
    `;
export type TeacherUpdateTeachingStructureItemMutationFn = Apollo.MutationFunction<TeacherUpdateTeachingStructureItemMutation, TeacherUpdateTeachingStructureItemMutationVariables>;

/**
 * __useUpdateTeachingStructureItemMutation__
 *
 * To run a mutation, you first call `useUpdateTeachingStructureItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeachingStructureItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeachingStructureItemMutation, { data, loading, error }] = useUpdateTeachingStructureItemMutation({
 *   variables: {
 *      title: // value for 'title'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTeachingStructureItemMutation(baseOptions?: Apollo.MutationHookOptions<TeacherUpdateTeachingStructureItemMutation, TeacherUpdateTeachingStructureItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeacherUpdateTeachingStructureItemMutation, TeacherUpdateTeachingStructureItemMutationVariables>(TeacherupdateTeachingStructureItemDocument, options);
      }
export type UpdateTeachingStructureItemMutationHookResult = ReturnType<typeof useUpdateTeachingStructureItemMutation>;
export type UpdateTeachingStructureItemMutationResult = Apollo.MutationResult<TeacherUpdateTeachingStructureItemMutation>;
export type UpdateTeachingStructureItemMutationOptions = Apollo.BaseMutationOptions<TeacherUpdateTeachingStructureItemMutation, TeacherUpdateTeachingStructureItemMutationVariables>;